import { CompressedEmojiData } from './data.interfaces';
export const emojis: CompressedEmojiData[] = [
  {
    name: 'Earth Globe Europe-Africa',
    unified: '1F30D',
    keywords: [
      'globe',
      'world',
      'international'
    ],
    sheet: [5, 27],
    shortName: 'earth_africa'
  },
  {
    name: 'Grapes',
    unified: '1F347',
    keywords: ['fruit', 'food', 'wine'],
    sheet: [6, 25],
    shortName: 'grapes'
  },
  {
    name: 'Jack-O-Lantern',
    unified: '1F383',
    keywords: [
      'halloween',
      'light',
      'pumpkin',
      'creepy',
      'fall'
    ],
    sheet: [7, 27],
    shortName: 'jack_o_lantern'
  },
  {
    name: 'Chequered Flag',
    unified: '1F3C1',
    keywords: [
      'contest',
      'finishline',
      'race',
      'gokart'
    ],
    sheet: [8, 31],
    shortName: 'checkered_flag'
  },
  {
    name: 'Automated Teller Machine',
    unified: '1F3E7',
    keywords: [
      'money',
      'sales',
      'cash',
      'blue-square',
      'payment',
      'bank'
    ],
    sheet: [10, 48],
    shortName: 'atm'
  },
  {
    name: 'Emoji Modifier Fitzpatrick Type-1-2',
    unified: '1F3FB',
    sheet: [11, 13],
    shortName: 'skin-tone-2'
  },
  {
    name: 'Monkey Face',
    unified: '1F435',
    emoticons: [':o)'],
    keywords: [
      'animal',
      'nature',
      'circus'
    ],
    sheet: [12, 15],
    shortName: 'monkey_face'
  },
  {
    name: 'Waving Hand Sign',
    unified: '1F44B',
    keywords: [
      'hands',
      'gesture',
      'goodbye',
      'solong',
      'farewell',
      'hello',
      'hi',
      'palm'
    ],
    sheet: [13, 16],
    skinVariations: [
      {
        unified: '1F44B-1F3FB',
        sheet: [13, 17]
      },
      {
        unified: '1F44B-1F3FC',
        sheet: [13, 18]
      },
      {
        unified: '1F44B-1F3FD',
        sheet: [13, 19]
      },
      {
        unified: '1F44B-1F3FE',
        sheet: [13, 20]
      },
      {
        unified: '1F44B-1F3FF',
        sheet: [13, 21]
      }
    ],
    shortName: 'wave'
  },
  {
    name: 'Eyeglasses',
    unified: '1F453',
    keywords: [
      'fashion',
      'accessories',
      'eyesight',
      'nerdy',
      'dork',
      'geek'
    ],
    sheet: [13, 54],
    shortName: 'eyeglasses'
  },
  {
    name: 'Grinning Face',
    unified: '1F600',
    text: ':D',
    keywords: [
      'face',
      'smile',
      'happy',
      'joy',
      ':D',
      'grin'
    ],
    sheet: [30, 32],
    shortName: 'grinning'
  },
  {
    name: 'Earth Globe Americas',
    unified: '1F30E',
    keywords: [
      'globe',
      'world',
      'USA',
      'international'
    ],
    sheet: [5, 28],
    shortName: 'earth_americas'
  },
  {
    name: 'Melon',
    unified: '1F348',
    keywords: [
      'fruit',
      'nature',
      'food'
    ],
    sheet: [6, 26],
    shortName: 'melon'
  },
  {
    name: 'Christmas Tree',
    unified: '1F384',
    keywords: [
      'festival',
      'vacation',
      'december',
      'xmas',
      'celebration'
    ],
    sheet: [7, 28],
    shortName: 'christmas_tree'
  },
  {
    name: 'Emoji Modifier Fitzpatrick Type-3',
    unified: '1F3FC',
    sheet: [11, 14],
    shortName: 'skin-tone-3'
  },
  {
    name: 'Monkey',
    unified: '1F412',
    keywords: [
      'animal',
      'nature',
      'banana',
      'circus'
    ],
    sheet: [11, 37],
    shortName: 'monkey'
  },
  {
    name: 'Dark Sunglasses',
    unified: '1F576-FE0F',
    keywords: [
      'face',
      'cool',
      'accessories'
    ],
    sheet: [29, 31],
    shortName: 'dark_sunglasses'
  },
  {
    name: 'Smiling Face with Open Mouth',
    unified: '1F603',
    text: ':)',
    emoticons: ['=)', '=-)'],
    keywords: [
      'face',
      'happy',
      'joy',
      'haha',
      ':D',
      ':)',
      'smile',
      'funny'
    ],
    sheet: [30, 35],
    shortName: 'smiley'
  },
  {
    name: 'Triangular Flag on Post',
    unified: '1F6A9',
    keywords: [
      'mark',
      'milestone',
      'place'
    ],
    sheet: [34, 50],
    shortName: 'triangular_flag_on_post'
  },
  {
    name: 'Put Litter in Its Place Symbol',
    unified: '1F6AE',
    keywords: [
      'blue-square',
      'sign',
      'human',
      'info'
    ],
    sheet: [34, 55],
    shortName: 'put_litter_in_its_place'
  },
  {
    name: 'Raised Back of Hand',
    unified: '1F91A',
    keywords: [
      'fingers',
      'raised',
      'backhand'
    ],
    sheet: [37, 43],
    skinVariations: [
      {
        unified: '1F91A-1F3FB',
        sheet: [37, 44]
      },
      {
        unified: '1F91A-1F3FC',
        sheet: [37, 45]
      },
      {
        unified: '1F91A-1F3FD',
        sheet: [37, 46]
      },
      {
        unified: '1F91A-1F3FE',
        sheet: [37, 47]
      },
      {
        unified: '1F91A-1F3FF',
        sheet: [37, 48]
      }
    ],
    shortName: 'raised_back_of_hand'
  },
  {
    name: 'Earth Globe Asia-Australia',
    unified: '1F30F',
    keywords: [
      'globe',
      'world',
      'east',
      'international'
    ],
    sheet: [5, 29],
    shortName: 'earth_asia'
  },
  {
    name: 'Watermelon',
    unified: '1F349',
    keywords: [
      'fruit',
      'food',
      'picnic',
      'summer'
    ],
    sheet: [6, 27],
    shortName: 'watermelon'
  },
  {
    name: 'Fireworks',
    unified: '1F386',
    keywords: [
      'photo',
      'festival',
      'carnival',
      'congratulations'
    ],
    sheet: [7, 35],
    shortName: 'fireworks'
  },
  {
    name: 'Crossed Flags',
    unified: '1F38C',
    keywords: [
      'japanese',
      'nation',
      'country',
      'border'
    ],
    sheet: [7, 41],
    shortName: 'crossed_flags'
  },
  {
    name: 'Emoji Modifier Fitzpatrick Type-4',
    unified: '1F3FD',
    sheet: [11, 15],
    shortName: 'skin-tone-4'
  },
  {
    name: 'Raised Hand with Fingers Splayed',
    unified: '1F590-FE0F',
    keywords: [
      'hand',
      'fingers',
      'palm'
    ],
    sheet: [29, 46],
    skinVariations: [
      {
        unified: '1F590-1F3FB',
        sheet: [29, 47]
      },
      {
        unified: '1F590-1F3FC',
        sheet: [29, 48]
      },
      {
        unified: '1F590-1F3FD',
        sheet: [29, 49]
      },
      {
        unified: '1F590-1F3FE',
        sheet: [29, 50]
      },
      {
        unified: '1F590-1F3FF',
        sheet: [29, 51]
      }
    ],
    shortName: 'raised_hand_with_fingers_splayed'
  },
  {
    name: 'Smiling Face with Open Mouth and Smiling Eyes',
    unified: '1F604',
    text: ':)',
    emoticons: ['C:', 'c:', ':D', ':-D'],
    keywords: [
      'face',
      'happy',
      'joy',
      'funny',
      'haha',
      'laugh',
      'like',
      ':D',
      ':)'
    ],
    sheet: [30, 36],
    shortName: 'smile'
  },
  {
    name: 'Potable Water Symbol',
    unified: '1F6B0',
    keywords: [
      'blue-square',
      'liquid',
      'restroom',
      'cleaning',
      'faucet'
    ],
    sheet: [34, 57],
    shortName: 'potable_water'
  },
  {
    name: 'Goggles',
    unified: '1F97D',
    keywords: [
      'eyes',
      'protection',
      'safety'
    ],
    sheet: [42, 30],
    shortName: 'goggles'
  },
  {
    name: 'Gorilla',
    unified: '1F98D',
    keywords: [
      'animal',
      'nature',
      'circus'
    ],
    sheet: [42, 46],
    shortName: 'gorilla'
  },
  {
    name: 'Globe with Meridians',
    unified: '1F310',
    keywords: [
      'earth',
      'international',
      'world',
      'internet',
      'interweb',
      'i18n'
    ],
    sheet: [5, 30],
    shortName: 'globe_with_meridians'
  },
  {
    name: 'Tangerine',
    unified: '1F34A',
    keywords: [
      'food',
      'fruit',
      'nature',
      'orange'
    ],
    sheet: [6, 28],
    shortName: 'tangerine'
  },
  {
    name: 'Firework Sparkler',
    unified: '1F387',
    keywords: [
      'stars',
      'night',
      'shine'
    ],
    sheet: [7, 36],
    shortName: 'sparkler'
  },
  {
    name: 'Waving Black Flag',
    unified: '1F3F4',
    sheet: [11, 7],
    shortName: 'waving_black_flag'
  },
  {
    name: 'Emoji Modifier Fitzpatrick Type-5',
    unified: '1F3FE',
    sheet: [11, 16],
    shortName: 'skin-tone-5'
  },
  {
    name: 'Grinning Face with Smiling Eyes',
    unified: '1F601',
    keywords: [
      'face',
      'happy',
      'smile',
      'joy',
      'kawaii'
    ],
    sheet: [30, 33],
    shortName: 'grin'
  },
  {
    name: 'Lab Coat',
    unified: '1F97C',
    sheet: [42, 29],
    shortName: 'lab_coat'
  },
  {
    name: 'Orangutan',
    unified: '1F9A7',
    sheet: [43, 14],
    shortName: 'orangutan'
  },
  {
    name: 'Wheelchair Symbol',
    unified: '267F',
    keywords: [
      'blue-square',
      'disabled',
      'a11y',
      'accessibility'
    ],
    sheet: [54, 45],
    shortName: 'wheelchair'
  },
  {
    name: 'Raised Hand',
    unified: '270B',
    sheet: [55, 54],
    skinVariations: [
      {
        unified: '270B-1F3FB',
        sheet: [55, 55]
      },
      {
        unified: '270B-1F3FC',
        sheet: [55, 56]
      },
      {
        unified: '270B-1F3FD',
        sheet: [55, 57]
      },
      {
        unified: '270B-1F3FE',
        sheet: [56, 0]
      },
      {
        unified: '270B-1F3FF',
        sheet: [56, 1]
      }
    ],
    shortNames: ['raised_hand'],
    shortName: 'hand'
  },
  {
    name: 'Lemon',
    unified: '1F34B',
    keywords: ['fruit', 'nature'],
    sheet: [6, 29],
    shortName: 'lemon'
  },
  {
    name: 'Waving White Flag',
    unified: '1F3F3-FE0F',
    sheet: [11, 2],
    shortName: 'waving_white_flag'
  },
  {
    name: 'Emoji Modifier Fitzpatrick Type-6',
    unified: '1F3FF',
    sheet: [11, 17],
    shortName: 'skin-tone-6'
  },
  {
    name: 'Dog Face',
    unified: '1F436',
    keywords: [
      'animal',
      'friend',
      'nature',
      'woof',
      'puppy',
      'pet',
      'faithful'
    ],
    sheet: [12, 16],
    shortName: 'dog'
  },
  {
    name: 'Raised Hand with Part Between Middle and Ring Fingers',
    unified: '1F596',
    sheet: [30, 0],
    skinVariations: [
      {
        unified: '1F596-1F3FB',
        sheet: [30, 1]
      },
      {
        unified: '1F596-1F3FC',
        sheet: [30, 2]
      },
      {
        unified: '1F596-1F3FD',
        sheet: [30, 3]
      },
      {
        unified: '1F596-1F3FE',
        sheet: [30, 4]
      },
      {
        unified: '1F596-1F3FF',
        sheet: [30, 5]
      }
    ],
    shortName: 'spock-hand'
  },
  {
    name: 'World Map',
    unified: '1F5FA-FE0F',
    keywords: ['location', 'direction'],
    sheet: [30, 26],
    shortName: 'world_map'
  },
  {
    name: 'Smiling Face with Open Mouth and Tightly-Closed Eyes',
    unified: '1F606',
    emoticons: [':>', ':->'],
    keywords: [
      'happy',
      'joy',
      'lol',
      'satisfied',
      'haha',
      'face',
      'glad',
      'XD',
      'laugh'
    ],
    sheet: [30, 38],
    shortNames: ['satisfied'],
    shortName: 'laughing'
  },
  {
    name: 'Mens Symbol',
    unified: '1F6B9',
    keywords: [
      'toilet',
      'restroom',
      'wc',
      'blue-square',
      'gender',
      'male'
    ],
    sheet: [36, 1],
    shortName: 'mens'
  },
  {
    name: 'Safety Vest',
    unified: '1F9BA',
    sheet: [44, 15],
    shortName: 'safety_vest'
  },
  {
    name: 'Firecracker',
    unified: '1F9E8',
    keywords: [
      'dynamite',
      'boom',
      'explode',
      'explosion',
      'explosive'
    ],
    sheet: [51, 51],
    shortName: 'firecracker'
  },
  {
    name: 'Banana',
    unified: '1F34C',
    keywords: [
      'fruit',
      'food',
      'monkey'
    ],
    sheet: [6, 30],
    shortName: 'banana'
  },
  {
    name: 'Rainbow Flag',
    unified: '1F3F3-FE0F-200D-1F308',
    sheet: [11, 0],
    shortName: 'rainbow-flag'
  },
  {
    name: 'Dog',
    unified: '1F415',
    keywords: [
      'animal',
      'nature',
      'friend',
      'doge',
      'pet',
      'faithful'
    ],
    sheet: [11, 41],
    shortName: 'dog2'
  },
  {
    name: 'Ok Hand Sign',
    unified: '1F44C',
    keywords: [
      'fingers',
      'limbs',
      'perfect',
      'ok',
      'okay'
    ],
    sheet: [13, 22],
    skinVariations: [
      {
        unified: '1F44C-1F3FB',
        sheet: [13, 23]
      },
      {
        unified: '1F44C-1F3FC',
        sheet: [13, 24]
      },
      {
        unified: '1F44C-1F3FD',
        sheet: [13, 25]
      },
      {
        unified: '1F44C-1F3FE',
        sheet: [13, 26]
      },
      {
        unified: '1F44C-1F3FF',
        sheet: [13, 27]
      }
    ],
    shortName: 'ok_hand'
  },
  {
    name: 'Necktie',
    unified: '1F454',
    keywords: [
      'shirt',
      'suitup',
      'formal',
      'fashion',
      'cloth',
      'business'
    ],
    sheet: [13, 55],
    shortName: 'necktie'
  },
  {
    name: 'Silhouette of Japan',
    unified: '1F5FE',
    keywords: [
      'nation',
      'country',
      'japanese',
      'asia'
    ],
    sheet: [30, 30],
    shortName: 'japan'
  },
  {
    name: 'Smiling Face with Open Mouth and Cold Sweat',
    unified: '1F605',
    keywords: [
      'face',
      'hot',
      'happy',
      'laugh',
      'sweat',
      'smile',
      'relief'
    ],
    sheet: [30, 37],
    shortName: 'sweat_smile'
  },
  {
    name: 'Womens Symbol',
    unified: '1F6BA',
    keywords: [
      'purple-square',
      'woman',
      'female',
      'toilet',
      'loo',
      'restroom',
      'gender'
    ],
    sheet: [36, 2],
    shortName: 'womens'
  },
  {
    name: 'Sparkles',
    unified: '2728',
    keywords: [
      'stars',
      'shine',
      'shiny',
      'cool',
      'awesome',
      'good',
      'magic'
    ],
    sheet: [56, 20],
    shortName: 'sparkles'
  },
  {
    name: 'Pineapple',
    unified: '1F34D',
    keywords: [
      'fruit',
      'nature',
      'food'
    ],
    sheet: [6, 31],
    shortName: 'pineapple'
  },
  {
    name: 'Balloon',
    unified: '1F388',
    keywords: [
      'party',
      'celebration',
      'birthday',
      'circus'
    ],
    sheet: [7, 37],
    shortName: 'balloon'
  },
  {
    name: 'Transgender Flag',
    unified: '1F3F3-FE0F-200D-26A7-FE0F',
    sheet: [11, 1],
    hidden: ['facebook'],
    shortName: 'transgender_flag'
  },
  {
    name: 'T-Shirt',
    unified: '1F455',
    sheet: [13, 56],
    shortNames: ['tshirt'],
    shortName: 'shirt'
  },
  {
    name: 'Restroom',
    unified: '1F6BB',
    keywords: [
      'blue-square',
      'toilet',
      'refresh',
      'wc',
      'gender'
    ],
    sheet: [36, 3],
    shortName: 'restroom'
  },
  {
    name: 'Pinched Fingers',
    unified: '1F90C',
    sheet: [37, 9],
    skinVariations: [
      {
        unified: '1F90C-1F3FB',
        sheet: [37, 10]
      },
      {
        unified: '1F90C-1F3FC',
        sheet: [37, 11]
      },
      {
        unified: '1F90C-1F3FD',
        sheet: [37, 12]
      },
      {
        unified: '1F90C-1F3FE',
        sheet: [37, 13]
      },
      {
        unified: '1F90C-1F3FF',
        sheet: [37, 14]
      }
    ],
    shortName: 'pinched_fingers'
  },
  {
    name: 'Rolling on the Floor Laughing',
    unified: '1F923',
    sheet: [38, 19],
    shortName: 'rolling_on_the_floor_laughing'
  },
  {
    name: 'Guide Dog',
    unified: '1F9AE',
    sheet: [43, 21],
    shortName: 'guide_dog'
  },
  {
    name: 'Compass',
    unified: '1F9ED',
    keywords: [
      'magnetic',
      'navigation',
      'orienteering'
    ],
    sheet: [51, 56],
    shortName: 'compass'
  },
  {
    name: 'Party Popper',
    unified: '1F389',
    keywords: [
      'party',
      'congratulations',
      'birthday',
      'magic',
      'circus',
      'celebration'
    ],
    sheet: [7, 38],
    shortName: 'tada'
  },
  {
    name: 'Snow Capped Mountain',
    unified: '1F3D4-FE0F',
    sheet: [10, 29],
    shortName: 'snow_capped_mountain'
  },
  {
    name: 'Pirate Flag',
    unified: '1F3F4-200D-2620-FE0F',
    keywords: [
      'skull',
      'crossbones',
      'flag',
      'banner'
    ],
    sheet: [11, 3],
    shortName: 'pirate_flag'
  },
  {
    name: 'Service Dog',
    unified: '1F415-200D-1F9BA',
    sheet: [11, 40],
    shortName: 'service_dog'
  },
  {
    name: 'Jeans',
    unified: '1F456',
    keywords: ['fashion', 'shopping'],
    sheet: [13, 57],
    shortName: 'jeans'
  },
  {
    name: 'Face with Tears of Joy',
    unified: '1F602',
    keywords: [
      'face',
      'cry',
      'tears',
      'weep',
      'happy',
      'happytears',
      'haha'
    ],
    sheet: [30, 34],
    shortName: 'joy'
  },
  {
    name: 'Baby Symbol',
    unified: '1F6BC',
    keywords: [
      'orange-square',
      'child'
    ],
    sheet: [36, 4],
    shortName: 'baby_symbol'
  },
  {
    name: 'Pinching Hand',
    unified: '1F90F',
    sheet: [37, 17],
    skinVariations: [
      {
        unified: '1F90F-1F3FB',
        sheet: [37, 18]
      },
      {
        unified: '1F90F-1F3FC',
        sheet: [37, 19]
      },
      {
        unified: '1F90F-1F3FD',
        sheet: [37, 20]
      },
      {
        unified: '1F90F-1F3FE',
        sheet: [37, 21]
      },
      {
        unified: '1F90F-1F3FF',
        sheet: [37, 22]
      }
    ],
    shortName: 'pinching_hand'
  },
  {
    name: 'Mango',
    unified: '1F96D',
    keywords: [
      'fruit',
      'food',
      'tropical'
    ],
    sheet: [42, 10],
    shortName: 'mango'
  },
  {
    name: 'Ascension Island Flag',
    unified: '1F1E6-1F1E8',
    sheet: [0, 31],
    shortName: 'flag-ac'
  },
  {
    name: 'Red Apple',
    unified: '1F34E',
    keywords: [
      'fruit',
      'mac',
      'school'
    ],
    sheet: [6, 32],
    shortName: 'apple'
  },
  {
    name: 'Confetti Ball',
    unified: '1F38A',
    keywords: [
      'festival',
      'party',
      'birthday',
      'circus'
    ],
    sheet: [7, 39],
    shortName: 'confetti_ball'
  },
  {
    name: 'Poodle',
    unified: '1F429',
    keywords: [
      'dog',
      'animal',
      '101',
      'nature',
      'pet'
    ],
    sheet: [12, 3],
    shortName: 'poodle'
  },
  {
    name: 'Slightly Smiling Face',
    unified: '1F642',
    emoticons: [':)', '(:', ':-)'],
    keywords: ['face', 'smile'],
    sheet: [31, 40],
    shortName: 'slightly_smiling_face'
  },
  {
    name: 'Water Closet',
    unified: '1F6BE',
    keywords: [
      'toilet',
      'restroom',
      'blue-square'
    ],
    sheet: [36, 6],
    shortName: 'wc'
  },
  {
    name: 'Scarf',
    unified: '1F9E3',
    keywords: [
      'neck',
      'winter',
      'clothes'
    ],
    sheet: [51, 46],
    shortName: 'scarf'
  },
  {
    name: 'Mountain',
    unified: '26F0-FE0F',
    keywords: [
      'photo',
      'nature',
      'environment'
    ],
    sheet: [55, 16],
    shortName: 'mountain'
  },
  {
    name: 'Victory Hand',
    unified: '270C-FE0F',
    keywords: [
      'fingers',
      'ohyeah',
      'hand',
      'peace',
      'victory',
      'two'
    ],
    sheet: [56, 2],
    skinVariations: [
      {
        unified: '270C-1F3FB',
        sheet: [56, 3]
      },
      {
        unified: '270C-1F3FC',
        sheet: [56, 4]
      },
      {
        unified: '270C-1F3FD',
        sheet: [56, 5]
      },
      {
        unified: '270C-1F3FE',
        sheet: [56, 6]
      },
      {
        unified: '270C-1F3FF',
        sheet: [56, 7]
      }
    ],
    shortName: 'v'
  },
  {
    name: 'Andorra Flag',
    unified: '1F1E6-1F1E9',
    sheet: [0, 32],
    shortName: 'flag-ad'
  },
  {
    name: 'Volcano',
    unified: '1F30B',
    keywords: [
      'photo',
      'nature',
      'disaster'
    ],
    sheet: [5, 25],
    shortName: 'volcano'
  },
  {
    name: 'Green Apple',
    unified: '1F34F',
    keywords: ['fruit', 'nature'],
    sheet: [6, 33],
    shortName: 'green_apple'
  },
  {
    name: 'Tanabata Tree',
    unified: '1F38B',
    keywords: [
      'plant',
      'nature',
      'branch',
      'summer'
    ],
    sheet: [7, 40],
    shortName: 'tanabata_tree'
  },
  {
    name: 'Wolf Face',
    unified: '1F43A',
    keywords: [
      'animal',
      'nature',
      'wild'
    ],
    sheet: [12, 20],
    shortName: 'wolf'
  },
  {
    name: 'Upside-Down Face',
    unified: '1F643',
    keywords: [
      'face',
      'flipped',
      'silly',
      'smile'
    ],
    sheet: [31, 41],
    shortName: 'upside_down_face'
  },
  {
    name: 'Passport Control',
    unified: '1F6C2',
    keywords: ['custom', 'blue-square'],
    sheet: [36, 15],
    shortName: 'passport_control'
  },
  {
    name: 'Hand with Index and Middle Fingers Crossed',
    unified: '1F91E',
    keywords: ['good', 'lucky'],
    sheet: [38, 4],
    skinVariations: [
      {
        unified: '1F91E-1F3FB',
        sheet: [38, 5]
      },
      {
        unified: '1F91E-1F3FC',
        sheet: [38, 6]
      },
      {
        unified: '1F91E-1F3FD',
        sheet: [38, 7]
      },
      {
        unified: '1F91E-1F3FE',
        sheet: [38, 8]
      },
      {
        unified: '1F91E-1F3FF',
        sheet: [38, 9]
      }
    ],
    shortNames: [
      'hand_with_index_and_middle_fingers_crossed'
    ],
    shortName: 'crossed_fingers'
  },
  {
    name: 'Gloves',
    unified: '1F9E4',
    keywords: [
      'hands',
      'winter',
      'clothes'
    ],
    sheet: [51, 47],
    shortName: 'gloves'
  },
  {
    name: 'United Arab Emirates Flag',
    unified: '1F1E6-1F1EA',
    sheet: [0, 33],
    shortName: 'flag-ae'
  },
  {
    name: 'Pear',
    unified: '1F350',
    keywords: [
      'fruit',
      'nature',
      'food'
    ],
    sheet: [6, 34],
    shortName: 'pear'
  },
  {
    name: 'Pine Decoration',
    unified: '1F38D',
    keywords: [
      'plant',
      'nature',
      'vegetable',
      'panda',
      'pine_decoration'
    ],
    sheet: [7, 42],
    shortName: 'bamboo'
  },
  {
    name: 'Mount Fuji',
    unified: '1F5FB',
    keywords: [
      'photo',
      'mountain',
      'nature',
      'japanese'
    ],
    sheet: [30, 27],
    shortName: 'mount_fuji'
  },
  {
    name: 'Winking Face',
    unified: '1F609',
    text: ';)',
    emoticons: [';)', ';-)'],
    keywords: [
      'face',
      'happy',
      'mischievous',
      'secret',
      ';)',
      'smile',
      'eye'
    ],
    sheet: [30, 41],
    shortName: 'wink'
  },
  {
    name: 'Customs',
    unified: '1F6C3',
    keywords: [
      'passport',
      'border',
      'blue-square'
    ],
    sheet: [36, 16],
    shortName: 'customs'
  },
  {
    name: 'I Love You Hand Sign',
    unified: '1F91F',
    sheet: [38, 10],
    skinVariations: [
      {
        unified: '1F91F-1F3FB',
        sheet: [38, 11]
      },
      {
        unified: '1F91F-1F3FC',
        sheet: [38, 12]
      },
      {
        unified: '1F91F-1F3FD',
        sheet: [38, 13]
      },
      {
        unified: '1F91F-1F3FE',
        sheet: [38, 14]
      },
      {
        unified: '1F91F-1F3FF',
        sheet: [38, 15]
      }
    ],
    shortName: 'i_love_you_hand_sign'
  },
  {
    name: 'Fox Face',
    unified: '1F98A',
    keywords: [
      'animal',
      'nature',
      'face'
    ],
    sheet: [42, 43],
    shortName: 'fox_face'
  },
  {
    name: 'Coat',
    unified: '1F9E5',
    keywords: ['jacket'],
    sheet: [51, 48],
    shortName: 'coat'
  },
  {
    name: 'Afghanistan Flag',
    unified: '1F1E6-1F1EB',
    sheet: [0, 34],
    shortName: 'flag-af'
  },
  {
    name: 'Peach',
    unified: '1F351',
    keywords: [
      'fruit',
      'nature',
      'food'
    ],
    sheet: [6, 35],
    shortName: 'peach'
  },
  {
    name: 'Japanese Dolls',
    unified: '1F38E',
    keywords: [
      'japanese',
      'toy',
      'kimono'
    ],
    sheet: [7, 43],
    shortName: 'dolls'
  },
  {
    name: 'Camping',
    unified: '1F3D5-FE0F',
    keywords: [
      'photo',
      'outdoors',
      'tent'
    ],
    sheet: [10, 30],
    shortName: 'camping'
  },
  {
    name: 'Smiling Face with Smiling Eyes',
    unified: '1F60A',
    text: ':)',
    keywords: [
      'face',
      'smile',
      'happy',
      'flushed',
      'crush',
      'embarrassed',
      'shy',
      'joy'
    ],
    sheet: [30, 42],
    shortName: 'blush'
  },
  {
    name: 'Baggage Claim',
    unified: '1F6C4',
    keywords: [
      'blue-square',
      'airport',
      'transport'
    ],
    sheet: [36, 17],
    shortName: 'baggage_claim'
  },
  {
    name: 'Sign of the Horns',
    unified: '1F918',
    sheet: [37, 31],
    skinVariations: [
      {
        unified: '1F918-1F3FB',
        sheet: [37, 32]
      },
      {
        unified: '1F918-1F3FC',
        sheet: [37, 33]
      },
      {
        unified: '1F918-1F3FD',
        sheet: [37, 34]
      },
      {
        unified: '1F918-1F3FE',
        sheet: [37, 35]
      },
      {
        unified: '1F918-1F3FF',
        sheet: [37, 36]
      }
    ],
    shortNames: ['sign_of_the_horns'],
    shortName: 'the_horns'
  },
  {
    name: 'Raccoon',
    unified: '1F99D',
    keywords: ['animal', 'nature'],
    sheet: [43, 4],
    shortName: 'raccoon'
  },
  {
    name: 'Socks',
    unified: '1F9E6',
    keywords: ['stockings', 'clothes'],
    sheet: [51, 49],
    shortName: 'socks'
  },
  {
    name: 'Antigua & Barbuda Flag',
    unified: '1F1E6-1F1EC',
    sheet: [0, 35],
    shortName: 'flag-ag'
  },
  {
    name: 'Cherries',
    unified: '1F352',
    keywords: ['food', 'fruit'],
    sheet: [6, 36],
    shortName: 'cherries'
  },
  {
    name: 'Carp Streamer',
    unified: '1F38F',
    keywords: [
      'fish',
      'japanese',
      'koinobori',
      'carp',
      'banner'
    ],
    sheet: [7, 44],
    shortName: 'flags'
  },
  {
    name: 'Beach with Umbrella',
    unified: '1F3D6-FE0F',
    sheet: [10, 31],
    shortName: 'beach_with_umbrella'
  },
  {
    name: 'Cat Face',
    unified: '1F431',
    keywords: [
      'animal',
      'meow',
      'nature',
      'pet',
      'kitten'
    ],
    sheet: [12, 11],
    shortName: 'cat'
  },
  {
    name: 'Dress',
    unified: '1F457',
    keywords: [
      'clothes',
      'fashion',
      'shopping'
    ],
    sheet: [14, 0],
    shortName: 'dress'
  },
  {
    name: 'Smiling Face with Halo',
    unified: '1F607',
    keywords: [
      'face',
      'angel',
      'heaven',
      'halo'
    ],
    sheet: [30, 39],
    shortName: 'innocent'
  },
  {
    name: 'Left Luggage',
    unified: '1F6C5',
    keywords: ['blue-square', 'travel'],
    sheet: [36, 18],
    shortName: 'left_luggage'
  },
  {
    name: 'Call Me Hand',
    unified: '1F919',
    keywords: ['hands', 'gesture'],
    sheet: [37, 37],
    skinVariations: [
      {
        unified: '1F919-1F3FB',
        sheet: [37, 38]
      },
      {
        unified: '1F919-1F3FC',
        sheet: [37, 39]
      },
      {
        unified: '1F919-1F3FD',
        sheet: [37, 40]
      },
      {
        unified: '1F919-1F3FE',
        sheet: [37, 41]
      },
      {
        unified: '1F919-1F3FF',
        sheet: [37, 42]
      }
    ],
    shortName: 'call_me_hand'
  },
  {
    name: 'Anguilla Flag',
    unified: '1F1E6-1F1EE',
    sheet: [0, 36],
    shortName: 'flag-ai'
  },
  {
    name: 'Strawberry',
    unified: '1F353',
    keywords: [
      'fruit',
      'food',
      'nature'
    ],
    sheet: [6, 37],
    shortName: 'strawberry'
  },
  {
    name: 'Wind Chime',
    unified: '1F390',
    keywords: [
      'nature',
      'ding',
      'spring',
      'bell'
    ],
    sheet: [7, 45],
    shortName: 'wind_chime'
  },
  {
    name: 'Desert',
    unified: '1F3DC-FE0F',
    keywords: [
      'photo',
      'warm',
      'saharah'
    ],
    sheet: [10, 37],
    shortName: 'desert'
  },
  {
    name: 'Cat',
    unified: '1F408',
    keywords: [
      'animal',
      'meow',
      'pet',
      'cats'
    ],
    sheet: [11, 27],
    shortName: 'cat2'
  },
  {
    name: 'White Left Pointing Backhand Index',
    unified: '1F448',
    keywords: [
      'direction',
      'fingers',
      'hand',
      'left'
    ],
    sheet: [12, 56],
    skinVariations: [
      {
        unified: '1F448-1F3FB',
        sheet: [12, 57]
      },
      {
        unified: '1F448-1F3FC',
        sheet: [13, 0]
      },
      {
        unified: '1F448-1F3FD',
        sheet: [13, 1]
      },
      {
        unified: '1F448-1F3FE',
        sheet: [13, 2]
      },
      {
        unified: '1F448-1F3FF',
        sheet: [13, 3]
      }
    ],
    shortName: 'point_left'
  },
  {
    name: 'Kimono',
    unified: '1F458',
    keywords: [
      'dress',
      'fashion',
      'women',
      'female',
      'japanese'
    ],
    sheet: [14, 1],
    shortName: 'kimono'
  },
  {
    name: 'Smiling Face with Smiling Eyes and Three Hearts',
    unified: '1F970',
    sheet: [42, 13],
    shortName: 'smiling_face_with_3_hearts'
  },
  {
    name: 'Warning Sign',
    unified: '26A0-FE0F',
    keywords: [
      'exclamation',
      'wip',
      'alert',
      'error',
      'problem',
      'issue'
    ],
    sheet: [54, 55],
    shortName: 'warning'
  },
  {
    name: 'Albania Flag',
    unified: '1F1E6-1F1F1',
    sheet: [0, 37],
    shortName: 'flag-al'
  },
  {
    name: 'Moon Viewing Ceremony',
    unified: '1F391',
    keywords: [
      'photo',
      'japan',
      'asia',
      'tsukimi'
    ],
    sheet: [7, 46],
    shortName: 'rice_scene'
  },
  {
    name: 'Desert Island',
    unified: '1F3DD-FE0F',
    keywords: [
      'photo',
      'tropical',
      'mojito'
    ],
    sheet: [10, 38],
    shortName: 'desert_island'
  },
  {
    name: 'Black Cat',
    unified: '1F408-200D-2B1B',
    sheet: [11, 26],
    shortName: 'black_cat'
  },
  {
    name: 'White Right Pointing Backhand Index',
    unified: '1F449',
    keywords: [
      'fingers',
      'hand',
      'direction',
      'right'
    ],
    sheet: [13, 4],
    skinVariations: [
      {
        unified: '1F449-1F3FB',
        sheet: [13, 5]
      },
      {
        unified: '1F449-1F3FC',
        sheet: [13, 6]
      },
      {
        unified: '1F449-1F3FD',
        sheet: [13, 7]
      },
      {
        unified: '1F449-1F3FE',
        sheet: [13, 8]
      },
      {
        unified: '1F449-1F3FF',
        sheet: [13, 9]
      }
    ],
    shortName: 'point_right'
  },
  {
    name: 'Smiling Face with Heart-Shaped Eyes',
    unified: '1F60D',
    keywords: [
      'face',
      'love',
      'like',
      'affection',
      'valentines',
      'infatuation',
      'crush',
      'heart'
    ],
    sheet: [30, 45],
    shortName: 'heart_eyes'
  },
  {
    name: 'Children Crossing',
    unified: '1F6B8',
    keywords: [
      'school',
      'warning',
      'danger',
      'sign',
      'driving',
      'yellow-diamond'
    ],
    sheet: [36, 0],
    shortName: 'children_crossing'
  },
  {
    name: 'Sari',
    unified: '1F97B',
    sheet: [42, 28],
    shortName: 'sari'
  },
  {
    name: 'Blueberries',
    unified: '1FAD0',
    sheet: [53, 9],
    shortName: 'blueberries'
  },
  {
    name: 'Armenia Flag',
    unified: '1F1E6-1F1F2',
    sheet: [0, 38],
    shortName: 'flag-am'
  },
  {
    name: 'National Park',
    unified: '1F3DE-FE0F',
    keywords: [
      'photo',
      'environment',
      'nature'
    ],
    sheet: [10, 39],
    shortName: 'national_park'
  },
  {
    name: 'White Up Pointing Backhand Index',
    unified: '1F446',
    keywords: [
      'fingers',
      'hand',
      'direction',
      'up'
    ],
    sheet: [12, 44],
    skinVariations: [
      {
        unified: '1F446-1F3FB',
        sheet: [12, 45]
      },
      {
        unified: '1F446-1F3FC',
        sheet: [12, 46]
      },
      {
        unified: '1F446-1F3FD',
        sheet: [12, 47]
      },
      {
        unified: '1F446-1F3FE',
        sheet: [12, 48]
      },
      {
        unified: '1F446-1F3FF',
        sheet: [12, 49]
      }
    ],
    shortName: 'point_up_2'
  },
  {
    name: 'Grinning Face with Star Eyes',
    unified: '1F929',
    sheet: [38, 42],
    shortNames: [
      'grinning_face_with_star_eyes'
    ],
    shortName: 'star-struck'
  },
  {
    name: 'Kiwifruit',
    unified: '1F95D',
    sheet: [41, 52],
    shortName: 'kiwifruit'
  },
  {
    name: 'Lion Face',
    unified: '1F981',
    sheet: [42, 34],
    shortName: 'lion_face'
  },
  {
    name: 'Red Gift Envelope',
    unified: '1F9E7',
    keywords: ['gift'],
    sheet: [51, 50],
    shortName: 'red_envelope'
  },
  {
    name: 'One-Piece Swimsuit',
    unified: '1FA71',
    sheet: [52, 18],
    shortName: 'one-piece_swimsuit'
  },
  {
    name: 'No Entry',
    unified: '26D4',
    keywords: [
      'limit',
      'security',
      'privacy',
      'bad',
      'denied',
      'stop',
      'circle'
    ],
    sheet: [55, 13],
    shortName: 'no_entry'
  },
  {
    name: 'Angola Flag',
    unified: '1F1E6-1F1F4',
    sheet: [0, 39],
    shortName: 'flag-ao'
  },
  {
    name: 'Tomato',
    unified: '1F345',
    keywords: [
      'fruit',
      'vegetable',
      'nature',
      'food'
    ],
    sheet: [6, 23],
    shortName: 'tomato'
  },
  {
    name: 'Ribbon',
    unified: '1F380',
    keywords: [
      'decoration',
      'pink',
      'girl',
      'bowtie'
    ],
    sheet: [7, 24],
    shortName: 'ribbon'
  },
  {
    name: 'Stadium',
    unified: '1F3DF-FE0F',
    keywords: [
      'photo',
      'place',
      'sports',
      'concert',
      'venue'
    ],
    sheet: [10, 40],
    shortName: 'stadium'
  },
  {
    name: 'Tiger Face',
    unified: '1F42F',
    keywords: [
      'animal',
      'cat',
      'danger',
      'wild',
      'nature',
      'roar'
    ],
    sheet: [12, 9],
    shortName: 'tiger'
  },
  {
    name: 'Reversed Hand with Middle Finger Extended',
    unified: '1F595',
    sheet: [29, 52],
    skinVariations: [
      {
        unified: '1F595-1F3FB',
        sheet: [29, 53]
      },
      {
        unified: '1F595-1F3FC',
        sheet: [29, 54]
      },
      {
        unified: '1F595-1F3FD',
        sheet: [29, 55]
      },
      {
        unified: '1F595-1F3FE',
        sheet: [29, 56]
      },
      {
        unified: '1F595-1F3FF',
        sheet: [29, 57]
      }
    ],
    shortNames: [
      'reversed_hand_with_middle_finger_extended'
    ],
    shortName: 'middle_finger'
  },
  {
    name: 'Face Throwing a Kiss',
    unified: '1F618',
    emoticons: [':*', ':-*'],
    keywords: [
      'face',
      'love',
      'like',
      'affection',
      'valentines',
      'infatuation',
      'kiss'
    ],
    sheet: [30, 56],
    shortName: 'kissing_heart'
  },
  {
    name: 'No Entry Sign',
    unified: '1F6AB',
    keywords: [
      'forbid',
      'stop',
      'limit',
      'denied',
      'disallow',
      'circle'
    ],
    sheet: [34, 52],
    shortName: 'no_entry_sign'
  },
  {
    name: 'Briefs',
    unified: '1FA72',
    sheet: [52, 19],
    shortName: 'briefs'
  },
  {
    name: 'Antarctica Flag',
    unified: '1F1E6-1F1F6',
    sheet: [0, 40],
    shortName: 'flag-aq'
  },
  {
    name: 'Wrapped Present',
    unified: '1F381',
    keywords: [
      'present',
      'birthday',
      'christmas',
      'xmas'
    ],
    sheet: [7, 25],
    shortName: 'gift'
  },
  {
    name: 'Classical Building',
    unified: '1F3DB-FE0F',
    keywords: [
      'art',
      'culture',
      'history'
    ],
    sheet: [10, 36],
    shortName: 'classical_building'
  },
  {
    name: 'Tiger',
    unified: '1F405',
    keywords: [
      'animal',
      'nature',
      'roar'
    ],
    sheet: [11, 23],
    shortName: 'tiger2'
  },
  {
    name: 'White Down Pointing Backhand Index',
    unified: '1F447',
    keywords: [
      'fingers',
      'hand',
      'direction',
      'down'
    ],
    sheet: [12, 50],
    skinVariations: [
      {
        unified: '1F447-1F3FB',
        sheet: [12, 51]
      },
      {
        unified: '1F447-1F3FC',
        sheet: [12, 52]
      },
      {
        unified: '1F447-1F3FD',
        sheet: [12, 53]
      },
      {
        unified: '1F447-1F3FE',
        sheet: [12, 54]
      },
      {
        unified: '1F447-1F3FF',
        sheet: [12, 55]
      }
    ],
    shortName: 'point_down'
  },
  {
    name: 'Kissing Face',
    unified: '1F617',
    keywords: [
      'love',
      'like',
      'face',
      '3',
      'valentines',
      'infatuation',
      'kiss'
    ],
    sheet: [30, 55],
    shortName: 'kissing'
  },
  {
    name: 'No Bicycles',
    unified: '1F6B3',
    keywords: [
      'cyclist',
      'prohibited',
      'circle'
    ],
    sheet: [35, 2],
    shortName: 'no_bicycles'
  },
  {
    name: 'Shorts',
    unified: '1FA73',
    sheet: [52, 20],
    shortName: 'shorts'
  },
  {
    name: 'Olive',
    unified: '1FAD2',
    sheet: [53, 11],
    shortName: 'olive'
  },
  {
    name: 'Argentina Flag',
    unified: '1F1E6-1F1F7',
    sheet: [0, 41],
    shortName: 'flag-ar'
  },
  {
    name: 'Reminder Ribbon',
    unified: '1F397-FE0F',
    keywords: [
      'sports',
      'cause',
      'support',
      'awareness'
    ],
    sheet: [7, 50],
    shortName: 'reminder_ribbon'
  },
  {
    name: 'Building Construction',
    unified: '1F3D7-FE0F',
    keywords: [
      'wip',
      'working',
      'progress'
    ],
    sheet: [10, 32],
    shortName: 'building_construction'
  },
  {
    name: 'Leopard',
    unified: '1F406',
    keywords: ['animal', 'nature'],
    sheet: [11, 24],
    shortName: 'leopard'
  },
  {
    name: 'Bikini',
    unified: '1F459',
    keywords: [
      'swimming',
      'female',
      'woman',
      'girl',
      'fashion',
      'beach',
      'summer'
    ],
    sheet: [14, 2],
    shortName: 'bikini'
  },
  {
    name: 'No Smoking Symbol',
    unified: '1F6AD',
    keywords: [
      'cigarette',
      'blue-square',
      'smell',
      'smoke'
    ],
    sheet: [34, 54],
    shortName: 'no_smoking'
  },
  {
    name: 'Coconut',
    unified: '1F965',
    keywords: [
      'fruit',
      'nature',
      'food',
      'palm'
    ],
    sheet: [42, 2],
    shortName: 'coconut'
  },
  {
    name: 'White Up Pointing Index',
    unified: '261D-FE0F',
    keywords: [
      'hand',
      'fingers',
      'direction',
      'up'
    ],
    sheet: [54, 7],
    skinVariations: [
      {
        unified: '261D-1F3FB',
        sheet: [54, 8]
      },
      {
        unified: '261D-1F3FC',
        sheet: [54, 9]
      },
      {
        unified: '261D-1F3FD',
        sheet: [54, 10]
      },
      {
        unified: '261D-1F3FE',
        sheet: [54, 11]
      },
      {
        unified: '261D-1F3FF',
        sheet: [54, 12]
      }
    ],
    shortName: 'point_up'
  },
  {
    name: 'White Smiling Face',
    unified: '263A-FE0F',
    keywords: [
      'face',
      'blush',
      'massage',
      'happiness'
    ],
    sheet: [54, 22],
    shortName: 'relaxed'
  },
  {
    name: 'American Samoa Flag',
    unified: '1F1E6-1F1F8',
    sheet: [0, 42],
    shortName: 'flag-as'
  },
  {
    name: 'Admission Tickets',
    unified: '1F39F-FE0F',
    sheet: [7, 55],
    shortName: 'admission_tickets'
  },
  {
    name: 'Horse Face',
    unified: '1F434',
    keywords: [
      'animal',
      'brown',
      'nature'
    ],
    sheet: [12, 14],
    shortName: 'horse'
  },
  {
    name: 'Thumbs Up Sign',
    unified: '1F44D',
    keywords: [
      'thumbsup',
      'yes',
      'awesome',
      'good',
      'agree',
      'accept',
      'cool',
      'hand',
      'like'
    ],
    sheet: [13, 28],
    skinVariations: [
      {
        unified: '1F44D-1F3FB',
        sheet: [13, 29]
      },
      {
        unified: '1F44D-1F3FC',
        sheet: [13, 30]
      },
      {
        unified: '1F44D-1F3FD',
        sheet: [13, 31]
      },
      {
        unified: '1F44D-1F3FE',
        sheet: [13, 32]
      },
      {
        unified: '1F44D-1F3FF',
        sheet: [13, 33]
      }
    ],
    shortNames: ['thumbsup'],
    shortName: '+1'
  },
  {
    name: 'Womans Clothes',
    unified: '1F45A',
    keywords: [
      'fashion',
      'shopping_bags',
      'female'
    ],
    sheet: [14, 3],
    shortName: 'womans_clothes'
  },
  {
    name: 'Kissing Face with Closed Eyes',
    unified: '1F61A',
    keywords: [
      'face',
      'love',
      'like',
      'affection',
      'valentines',
      'infatuation',
      'kiss'
    ],
    sheet: [31, 0],
    shortName: 'kissing_closed_eyes'
  },
  {
    name: 'Do Not Litter Symbol',
    unified: '1F6AF',
    keywords: [
      'trash',
      'bin',
      'garbage',
      'circle'
    ],
    sheet: [34, 56],
    shortName: 'do_not_litter'
  },
  {
    name: 'Avocado',
    unified: '1F951',
    keywords: ['fruit', 'food'],
    sheet: [41, 40],
    shortName: 'avocado'
  },
  {
    name: 'Brick',
    unified: '1F9F1',
    sheet: [52, 2],
    shortName: 'bricks'
  },
  {
    name: 'Austria Flag',
    unified: '1F1E6-1F1F9',
    sheet: [0, 43],
    shortName: 'flag-at'
  },
  {
    name: 'Aubergine',
    unified: '1F346',
    keywords: [
      'vegetable',
      'nature',
      'food',
      'aubergine'
    ],
    sheet: [6, 24],
    shortName: 'eggplant'
  },
  {
    name: 'Ticket',
    unified: '1F3AB',
    keywords: [
      'event',
      'concert',
      'pass'
    ],
    sheet: [8, 9],
    shortName: 'ticket'
  },
  {
    name: 'Horse',
    unified: '1F40E',
    keywords: [
      'animal',
      'gamble',
      'luck'
    ],
    sheet: [11, 33],
    shortName: 'racehorse'
  },
  {
    name: 'Thumbs Down Sign',
    unified: '1F44E',
    keywords: [
      'thumbsdown',
      'no',
      'dislike',
      'hand'
    ],
    sheet: [13, 34],
    skinVariations: [
      {
        unified: '1F44E-1F3FB',
        sheet: [13, 35]
      },
      {
        unified: '1F44E-1F3FC',
        sheet: [13, 36]
      },
      {
        unified: '1F44E-1F3FD',
        sheet: [13, 37]
      },
      {
        unified: '1F44E-1F3FE',
        sheet: [13, 38]
      },
      {
        unified: '1F44E-1F3FF',
        sheet: [13, 39]
      }
    ],
    shortNames: ['thumbsdown'],
    shortName: '-1'
  },
  {
    name: 'Purse',
    unified: '1F45B',
    keywords: [
      'fashion',
      'accessories',
      'money',
      'sales',
      'shopping'
    ],
    sheet: [14, 4],
    shortName: 'purse'
  },
  {
    name: 'Kissing Face with Smiling Eyes',
    unified: '1F619',
    keywords: [
      'face',
      'affection',
      'valentines',
      'infatuation',
      'kiss'
    ],
    sheet: [30, 57],
    shortName: 'kissing_smiling_eyes'
  },
  {
    name: 'Non-Potable Water Symbol',
    unified: '1F6B1',
    keywords: [
      'drink',
      'faucet',
      'tap',
      'circle'
    ],
    sheet: [35, 0],
    shortName: 'non-potable_water'
  },
  {
    name: 'Rock',
    unified: '1FAA8',
    sheet: [52, 56],
    shortName: 'rock'
  },
  {
    name: 'Australia Flag',
    unified: '1F1E6-1F1FA',
    sheet: [0, 44],
    shortName: 'flag-au'
  },
  {
    name: 'Medal',
    unified: '1F396-FE0F',
    sheet: [7, 49],
    shortName: 'medal'
  },
  {
    name: 'Handbag',
    unified: '1F45C',
    keywords: [
      'fashion',
      'accessory',
      'accessories',
      'shopping'
    ],
    sheet: [14, 5],
    shortName: 'handbag'
  },
  {
    name: 'No Pedestrians',
    unified: '1F6B7',
    keywords: [
      'rules',
      'crossing',
      'walking',
      'circle'
    ],
    sheet: [35, 57],
    shortName: 'no_pedestrians'
  },
  {
    name: 'Potato',
    unified: '1F954',
    keywords: [
      'food',
      'tuber',
      'vegatable',
      'starch'
    ],
    sheet: [41, 43],
    shortName: 'potato'
  },
  {
    name: 'Smiling Face with Tear',
    unified: '1F972',
    sheet: [42, 15],
    shortName: 'smiling_face_with_tear'
  },
  {
    name: 'Unicorn Face',
    unified: '1F984',
    sheet: [42, 37],
    shortName: 'unicorn_face'
  },
  {
    name: 'Wood',
    unified: '1FAB5',
    sheet: [53, 4],
    shortName: 'wood'
  },
  {
    name: 'Raised Fist',
    unified: '270A',
    keywords: [
      'fingers',
      'hand',
      'grasp'
    ],
    sheet: [55, 48],
    skinVariations: [
      {
        unified: '270A-1F3FB',
        sheet: [55, 49]
      },
      {
        unified: '270A-1F3FC',
        sheet: [55, 50]
      },
      {
        unified: '270A-1F3FD',
        sheet: [55, 51]
      },
      {
        unified: '270A-1F3FE',
        sheet: [55, 52]
      },
      {
        unified: '270A-1F3FF',
        sheet: [55, 53]
      }
    ],
    shortName: 'fist'
  },
  {
    name: 'Aruba Flag',
    unified: '1F1E6-1F1FC',
    sheet: [0, 45],
    shortName: 'flag-aw'
  },
  {
    name: 'Trophy',
    unified: '1F3C6',
    keywords: [
      'win',
      'award',
      'contest',
      'place',
      'ftw',
      'ceremony'
    ],
    sheet: [9, 17],
    shortName: 'trophy'
  },
  {
    name: 'Fisted Hand Sign',
    unified: '1F44A',
    keywords: [
      'angry',
      'violence',
      'fist',
      'hit',
      'attack',
      'hand'
    ],
    sheet: [13, 10],
    skinVariations: [
      {
        unified: '1F44A-1F3FB',
        sheet: [13, 11]
      },
      {
        unified: '1F44A-1F3FC',
        sheet: [13, 12]
      },
      {
        unified: '1F44A-1F3FD',
        sheet: [13, 13]
      },
      {
        unified: '1F44A-1F3FE',
        sheet: [13, 14]
      },
      {
        unified: '1F44A-1F3FF',
        sheet: [13, 15]
      }
    ],
    shortNames: ['punch'],
    shortName: 'facepunch'
  },
  {
    name: 'Pouch',
    unified: '1F45D',
    keywords: [
      'bag',
      'accessories',
      'shopping'
    ],
    sheet: [14, 6],
    shortName: 'pouch'
  },
  {
    name: 'No Mobile Phones',
    unified: '1F4F5',
    keywords: [
      'iphone',
      'mute',
      'circle'
    ],
    sheet: [27, 18],
    shortName: 'no_mobile_phones'
  },
  {
    name: 'Face Savouring Delicious Food',
    unified: '1F60B',
    keywords: [
      'happy',
      'joy',
      'tongue',
      'smile',
      'face',
      'silly',
      'yummy',
      'nom',
      'delicious',
      'savouring'
    ],
    sheet: [30, 43],
    shortName: 'yum'
  },
  {
    name: 'Hut',
    unified: '1F6D6',
    sheet: [36, 33],
    shortName: 'hut'
  },
  {
    name: 'Carrot',
    unified: '1F955',
    keywords: [
      'vegetable',
      'food',
      'orange'
    ],
    sheet: [41, 44],
    shortName: 'carrot'
  },
  {
    name: 'Zebra Face',
    unified: '1F993',
    sheet: [42, 52],
    shortName: 'zebra_face'
  },
  {
    name: 'Åland Islands Flag',
    unified: '1F1E6-1F1FD',
    sheet: [0, 46],
    shortName: 'flag-ax'
  },
  {
    name: 'Ear of Maize',
    unified: '1F33D',
    keywords: [
      'food',
      'vegetable',
      'plant'
    ],
    sheet: [6, 15],
    shortName: 'corn'
  },
  {
    name: 'Sports Medal',
    unified: '1F3C5',
    sheet: [9, 16],
    shortName: 'sports_medal'
  },
  {
    name: 'House Buildings',
    unified: '1F3D8-FE0F',
    sheet: [10, 33],
    shortName: 'house_buildings'
  },
  {
    name: 'No One Under Eighteen Symbol',
    unified: '1F51E',
    keywords: [
      '18',
      'drink',
      'pub',
      'night',
      'minor',
      'circle'
    ],
    sheet: [28, 0],
    shortName: 'underage'
  },
  {
    name: 'Face with Stuck-out Tongue',
    unified: '1F61B',
    text: ':p',
    emoticons: [
      ':p',
      ':-p',
      ':P',
      ':-P',
      ':b',
      ':-b'
    ],
    keywords: [
      'face',
      'prank',
      'childish',
      'playful',
      'mischievous',
      'smile',
      'tongue'
    ],
    sheet: [31, 1],
    shortName: 'stuck_out_tongue'
  },
  {
    name: 'Shopping Bags',
    unified: '1F6CD-FE0F',
    sheet: [36, 26],
    shortName: 'shopping_bags'
  },
  {
    name: 'Left-Facing Fist',
    unified: '1F91B',
    sheet: [37, 49],
    skinVariations: [
      {
        unified: '1F91B-1F3FB',
        sheet: [37, 50]
      },
      {
        unified: '1F91B-1F3FC',
        sheet: [37, 51]
      },
      {
        unified: '1F91B-1F3FD',
        sheet: [37, 52]
      },
      {
        unified: '1F91B-1F3FE',
        sheet: [37, 53]
      },
      {
        unified: '1F91B-1F3FF',
        sheet: [37, 54]
      }
    ],
    shortName: 'left-facing_fist'
  },
  {
    name: 'Deer',
    unified: '1F98C',
    keywords: [
      'animal',
      'nature',
      'horns',
      'venison'
    ],
    sheet: [42, 45],
    shortName: 'deer'
  },
  {
    name: 'Azerbaijan Flag',
    unified: '1F1E6-1F1FF',
    sheet: [0, 47],
    shortName: 'flag-az'
  },
  {
    name: 'Hot Pepper',
    unified: '1F336-FE0F',
    keywords: [
      'food',
      'spicy',
      'chilli',
      'chili'
    ],
    sheet: [6, 8],
    shortName: 'hot_pepper'
  },
  {
    name: 'School Satchel',
    unified: '1F392',
    keywords: [
      'student',
      'education',
      'bag',
      'backpack'
    ],
    sheet: [7, 47],
    shortName: 'school_satchel'
  },
  {
    name: 'Derelict House Building',
    unified: '1F3DA-FE0F',
    sheet: [10, 35],
    shortName: 'derelict_house_building'
  },
  {
    name: 'Face with Stuck-out Tongue and Winking Eye',
    unified: '1F61C',
    text: ';p',
    emoticons: [
      ';p',
      ';-p',
      ';b',
      ';-b',
      ';P',
      ';-P'
    ],
    keywords: [
      'face',
      'prank',
      'childish',
      'playful',
      'mischievous',
      'smile',
      'wink',
      'tongue'
    ],
    sheet: [31, 2],
    shortName: 'stuck_out_tongue_winking_eye'
  },
  {
    name: 'Right-Facing Fist',
    unified: '1F91C',
    sheet: [37, 55],
    skinVariations: [
      {
        unified: '1F91C-1F3FB',
        sheet: [37, 56]
      },
      {
        unified: '1F91C-1F3FC',
        sheet: [37, 57]
      },
      {
        unified: '1F91C-1F3FD',
        sheet: [38, 0]
      },
      {
        unified: '1F91C-1F3FE',
        sheet: [38, 1]
      },
      {
        unified: '1F91C-1F3FF',
        sheet: [38, 2]
      }
    ],
    shortName: 'right-facing_fist'
  },
  {
    name: 'First Place Medal',
    unified: '1F947',
    sheet: [41, 30],
    shortName: 'first_place_medal'
  },
  {
    name: 'Bison',
    unified: '1F9AC',
    sheet: [43, 19],
    shortName: 'bison'
  },
  {
    name: 'Radioactive Sign',
    unified: '2622-FE0F',
    sheet: [54, 14],
    shortName: 'radioactive_sign'
  },
  {
    name: 'Bosnia & Herzegovina Flag',
    unified: '1F1E7-1F1E6',
    sheet: [0, 48],
    shortName: 'flag-ba'
  },
  {
    name: 'House Building',
    unified: '1F3E0',
    keywords: ['building', 'home'],
    sheet: [10, 41],
    shortName: 'house'
  },
  {
    name: 'Cow Face',
    unified: '1F42E',
    keywords: [
      'beef',
      'ox',
      'animal',
      'nature',
      'moo',
      'milk'
    ],
    sheet: [12, 8],
    shortName: 'cow'
  },
  {
    name: 'Clapping Hands Sign',
    unified: '1F44F',
    keywords: [
      'hands',
      'praise',
      'applause',
      'congrats',
      'yay'
    ],
    sheet: [13, 40],
    skinVariations: [
      {
        unified: '1F44F-1F3FB',
        sheet: [13, 41]
      },
      {
        unified: '1F44F-1F3FC',
        sheet: [13, 42]
      },
      {
        unified: '1F44F-1F3FD',
        sheet: [13, 43]
      },
      {
        unified: '1F44F-1F3FE',
        sheet: [13, 44]
      },
      {
        unified: '1F44F-1F3FF',
        sheet: [13, 45]
      }
    ],
    shortName: 'clap'
  },
  {
    name: 'Grinning Face with One Large and One Small Eye',
    unified: '1F92A',
    sheet: [38, 43],
    shortNames: [
      'grinning_face_with_one_large_and_one_small_eye'
    ],
    shortName: 'zany_face'
  },
  {
    name: 'Second Place Medal',
    unified: '1F948',
    sheet: [41, 31],
    shortName: 'second_place_medal'
  },
  {
    name: 'Thong Sandal',
    unified: '1FA74',
    sheet: [52, 21],
    shortName: 'thong_sandal'
  },
  {
    name: 'Bell Pepper',
    unified: '1FAD1',
    sheet: [53, 10],
    shortName: 'bell_pepper'
  },
  {
    name: 'Biohazard Sign',
    unified: '2623-FE0F',
    sheet: [54, 15],
    shortName: 'biohazard_sign'
  },
  {
    name: 'Barbados Flag',
    unified: '1F1E7-1F1E7',
    sheet: [0, 49],
    shortName: 'flag-bb'
  },
  {
    name: 'House with Garden',
    unified: '1F3E1',
    keywords: [
      'home',
      'plant',
      'nature'
    ],
    sheet: [10, 42],
    shortName: 'house_with_garden'
  },
  {
    name: 'Ox',
    unified: '1F402',
    keywords: ['animal', 'cow', 'beef'],
    sheet: [11, 20],
    shortName: 'ox'
  },
  {
    name: 'Mans Shoe',
    unified: '1F45E',
    keywords: ['fashion', 'male'],
    sheet: [14, 7],
    shortNames: ['shoe'],
    shortName: 'mans_shoe'
  },
  {
    name: 'Face with Stuck-out Tongue and Tightly-Closed Eyes',
    unified: '1F61D',
    keywords: [
      'face',
      'prank',
      'playful',
      'mischievous',
      'smile',
      'tongue'
    ],
    sheet: [31, 3],
    shortName: 'stuck_out_tongue_closed_eyes'
  },
  {
    name: 'Person Raising Both Hands in Celebration',
    unified: '1F64C',
    keywords: [
      'gesture',
      'hooray',
      'yea',
      'celebration',
      'hands'
    ],
    sheet: [33, 2],
    skinVariations: [
      {
        unified: '1F64C-1F3FB',
        sheet: [33, 3]
      },
      {
        unified: '1F64C-1F3FC',
        sheet: [33, 4]
      },
      {
        unified: '1F64C-1F3FD',
        sheet: [33, 5]
      },
      {
        unified: '1F64C-1F3FE',
        sheet: [33, 6]
      },
      {
        unified: '1F64C-1F3FF',
        sheet: [33, 7]
      }
    ],
    shortName: 'raised_hands'
  },
  {
    name: 'Third Place Medal',
    unified: '1F949',
    sheet: [41, 32],
    shortName: 'third_place_medal'
  },
  {
    name: 'Cucumber',
    unified: '1F952',
    keywords: [
      'fruit',
      'food',
      'pickle'
    ],
    sheet: [41, 41],
    shortName: 'cucumber'
  },
  {
    name: 'Upwards Black Arrow',
    unified: '2B06-FE0F',
    keywords: [
      'blue-square',
      'continue',
      'top',
      'direction'
    ],
    sheet: [56, 42],
    shortName: 'arrow_up'
  },
  {
    name: 'Bangladesh Flag',
    unified: '1F1E7-1F1E9',
    sheet: [0, 50],
    shortName: 'flag-bd'
  },
  {
    name: 'Office Building',
    unified: '1F3E2',
    keywords: [
      'building',
      'bureau',
      'work'
    ],
    sheet: [10, 43],
    shortName: 'office'
  },
  {
    name: 'Water Buffalo',
    unified: '1F403',
    keywords: [
      'animal',
      'nature',
      'ox',
      'cow'
    ],
    sheet: [11, 21],
    shortName: 'water_buffalo'
  },
  {
    name: 'Open Hands Sign',
    unified: '1F450',
    keywords: [
      'fingers',
      'butterfly',
      'hands',
      'open'
    ],
    sheet: [13, 46],
    skinVariations: [
      {
        unified: '1F450-1F3FB',
        sheet: [13, 47]
      },
      {
        unified: '1F450-1F3FC',
        sheet: [13, 48]
      },
      {
        unified: '1F450-1F3FD',
        sheet: [13, 49]
      },
      {
        unified: '1F450-1F3FE',
        sheet: [13, 50]
      },
      {
        unified: '1F450-1F3FF',
        sheet: [13, 51]
      }
    ],
    shortName: 'open_hands'
  },
  {
    name: 'Athletic Shoe',
    unified: '1F45F',
    keywords: [
      'shoes',
      'sports',
      'sneakers'
    ],
    sheet: [14, 8],
    shortName: 'athletic_shoe'
  },
  {
    name: 'Money-Mouth Face',
    unified: '1F911',
    keywords: [
      'face',
      'rich',
      'dollar',
      'money'
    ],
    sheet: [37, 24],
    shortName: 'money_mouth_face'
  },
  {
    name: 'Leafy Green',
    unified: '1F96C',
    sheet: [42, 9],
    shortName: 'leafy_green'
  },
  {
    name: 'North East Arrow',
    unified: '2197-FE0F',
    keywords: [
      'blue-square',
      'point',
      'direction',
      'diagonal',
      'northeast'
    ],
    sheet: [53, 23],
    shortName: 'arrow_upper_right'
  },
  {
    name: 'Soccer Ball',
    unified: '26BD',
    keywords: ['sports', 'football'],
    sheet: [55, 4],
    shortName: 'soccer'
  },
  {
    name: 'Belgium Flag',
    unified: '1F1E7-1F1EA',
    sheet: [0, 51],
    shortName: 'flag-be'
  },
  {
    name: 'Japanese Post Office',
    unified: '1F3E3',
    keywords: [
      'building',
      'envelope',
      'communication'
    ],
    sheet: [10, 44],
    shortName: 'post_office'
  },
  {
    name: 'Cow',
    unified: '1F404',
    keywords: [
      'beef',
      'ox',
      'animal',
      'nature',
      'moo',
      'milk'
    ],
    sheet: [11, 22],
    shortName: 'cow2'
  },
  {
    name: 'Hugging Face',
    unified: '1F917',
    sheet: [37, 30],
    shortName: 'hugging_face'
  },
  {
    name: 'Palms Up Together',
    unified: '1F932',
    sheet: [39, 3],
    skinVariations: [
      {
        unified: '1F932-1F3FB',
        sheet: [39, 4]
      },
      {
        unified: '1F932-1F3FC',
        sheet: [39, 5]
      },
      {
        unified: '1F932-1F3FD',
        sheet: [39, 6]
      },
      {
        unified: '1F932-1F3FE',
        sheet: [39, 7]
      },
      {
        unified: '1F932-1F3FF',
        sheet: [39, 8]
      }
    ],
    shortName: 'palms_up_together'
  },
  {
    name: 'Broccoli',
    unified: '1F966',
    keywords: [
      'fruit',
      'food',
      'vegetable'
    ],
    sheet: [42, 3],
    shortName: 'broccoli'
  },
  {
    name: 'Hiking Boot',
    unified: '1F97E',
    keywords: [
      'backpacking',
      'camping',
      'hiking'
    ],
    sheet: [42, 31],
    shortName: 'hiking_boot'
  },
  {
    name: 'Baseball',
    unified: '26BE',
    keywords: ['sports', 'balls'],
    sheet: [55, 5],
    shortName: 'baseball'
  },
  {
    name: 'Black Rightwards Arrow',
    unified: '27A1-FE0F',
    keywords: ['blue-square', 'next'],
    sheet: [56, 36],
    shortName: 'arrow_right'
  },
  {
    name: 'Burkina Faso Flag',
    unified: '1F1E7-1F1EB',
    sheet: [0, 52],
    shortName: 'flag-bf'
  },
  {
    name: 'European Post Office',
    unified: '1F3E4',
    keywords: ['building', 'email'],
    sheet: [10, 45],
    shortName: 'european_post_office'
  },
  {
    name: 'Pig Face',
    unified: '1F437',
    keywords: [
      'animal',
      'oink',
      'nature'
    ],
    sheet: [12, 17],
    shortName: 'pig'
  },
  {
    name: 'Handshake',
    unified: '1F91D',
    keywords: ['agreement', 'shake'],
    sheet: [38, 3],
    shortName: 'handshake'
  },
  {
    name: 'Smiling Face with Smiling Eyes and Hand Covering Mouth',
    unified: '1F92D',
    sheet: [38, 46],
    shortNames: [
      'smiling_face_with_smiling_eyes_and_hand_covering_mouth'
    ],
    shortName: 'face_with_hand_over_mouth'
  },
  {
    name: 'Softball',
    unified: '1F94E',
    keywords: ['sports', 'balls'],
    sheet: [41, 37],
    shortName: 'softball'
  },
  {
    name: 'Flat Shoe',
    unified: '1F97F',
    sheet: [42, 32],
    shortName: 'womans_flat_shoe'
  },
  {
    name: 'Garlic',
    unified: '1F9C4',
    sheet: [44, 30],
    shortName: 'garlic'
  },
  {
    name: 'South East Arrow',
    unified: '2198-FE0F',
    keywords: [
      'blue-square',
      'direction',
      'diagonal',
      'southeast'
    ],
    sheet: [53, 24],
    shortName: 'arrow_lower_right'
  },
  {
    name: 'Bulgaria Flag',
    unified: '1F1E7-1F1EC',
    sheet: [0, 53],
    shortName: 'flag-bg'
  },
  {
    name: 'Basketball and Hoop',
    unified: '1F3C0',
    keywords: [
      'sports',
      'balls',
      'NBA'
    ],
    sheet: [8, 30],
    shortName: 'basketball'
  },
  {
    name: 'Hospital',
    unified: '1F3E5',
    keywords: [
      'building',
      'health',
      'surgery',
      'doctor'
    ],
    sheet: [10, 46],
    shortName: 'hospital'
  },
  {
    name: 'Pig',
    unified: '1F416',
    keywords: ['animal', 'nature'],
    sheet: [11, 42],
    shortName: 'pig2'
  },
  {
    name: 'High-Heeled Shoe',
    unified: '1F460',
    keywords: [
      'fashion',
      'shoes',
      'female',
      'pumps',
      'stiletto'
    ],
    sheet: [14, 9],
    shortName: 'high_heel'
  },
  {
    name: 'Person with Folded Hands',
    unified: '1F64F',
    keywords: [
      'please',
      'hope',
      'wish',
      'namaste',
      'highfive'
    ],
    sheet: [33, 44],
    skinVariations: [
      {
        unified: '1F64F-1F3FB',
        sheet: [33, 45]
      },
      {
        unified: '1F64F-1F3FC',
        sheet: [33, 46]
      },
      {
        unified: '1F64F-1F3FD',
        sheet: [33, 47]
      },
      {
        unified: '1F64F-1F3FE',
        sheet: [33, 48]
      },
      {
        unified: '1F64F-1F3FF',
        sheet: [33, 49]
      }
    ],
    shortName: 'pray'
  },
  {
    name: 'Face with Finger Covering Closed Lips',
    unified: '1F92B',
    sheet: [38, 44],
    shortNames: [
      'face_with_finger_covering_closed_lips'
    ],
    shortName: 'shushing_face'
  },
  {
    name: 'Onion',
    unified: '1F9C5',
    sheet: [44, 31],
    shortName: 'onion'
  },
  {
    name: 'Downwards Black Arrow',
    unified: '2B07-FE0F',
    keywords: [
      'blue-square',
      'direction',
      'bottom'
    ],
    sheet: [56, 43],
    shortName: 'arrow_down'
  },
  {
    name: 'Bahrain Flag',
    unified: '1F1E7-1F1ED',
    sheet: [0, 54],
    shortName: 'flag-bh'
  },
  {
    name: 'Mushroom',
    unified: '1F344',
    keywords: ['plant', 'vegetable'],
    sheet: [6, 22],
    shortName: 'mushroom'
  },
  {
    name: 'Volleyball',
    unified: '1F3D0',
    keywords: ['sports', 'balls'],
    sheet: [10, 25],
    shortName: 'volleyball'
  },
  {
    name: 'Bank',
    unified: '1F3E6',
    keywords: [
      'building',
      'money',
      'sales',
      'cash',
      'business',
      'enterprise'
    ],
    sheet: [10, 47],
    shortName: 'bank'
  },
  {
    name: 'Boar',
    unified: '1F417',
    keywords: ['animal', 'nature'],
    sheet: [11, 43],
    shortName: 'boar'
  },
  {
    name: 'Womans Sandal',
    unified: '1F461',
    keywords: [
      'shoes',
      'fashion',
      'flip flops'
    ],
    sheet: [14, 10],
    shortName: 'sandal'
  },
  {
    name: 'Thinking Face',
    unified: '1F914',
    sheet: [37, 27],
    shortName: 'thinking_face'
  },
  {
    name: 'South West Arrow',
    unified: '2199-FE0F',
    keywords: [
      'blue-square',
      'direction',
      'diagonal',
      'southwest'
    ],
    sheet: [53, 25],
    shortName: 'arrow_lower_left'
  },
  {
    name: 'Writing Hand',
    unified: '270D-FE0F',
    keywords: [
      'lower_left_ballpoint_pen',
      'stationery',
      'write',
      'compose'
    ],
    sheet: [56, 8],
    skinVariations: [
      {
        unified: '270D-1F3FB',
        sheet: [56, 9]
      },
      {
        unified: '270D-1F3FC',
        sheet: [56, 10]
      },
      {
        unified: '270D-1F3FD',
        sheet: [56, 11]
      },
      {
        unified: '270D-1F3FE',
        sheet: [56, 12]
      },
      {
        unified: '270D-1F3FF',
        sheet: [56, 13]
      }
    ],
    shortName: 'writing_hand'
  },
  {
    name: 'Burundi Flag',
    unified: '1F1E7-1F1EE',
    sheet: [0, 55],
    shortName: 'flag-bi'
  },
  {
    name: 'American Football',
    unified: '1F3C8',
    keywords: [
      'sports',
      'balls',
      'NFL'
    ],
    sheet: [9, 24],
    shortName: 'football'
  },
  {
    name: 'Hotel',
    unified: '1F3E8',
    keywords: [
      'building',
      'accomodation',
      'checkin'
    ],
    sheet: [10, 49],
    shortName: 'hotel'
  },
  {
    name: 'Pig Nose',
    unified: '1F43D',
    keywords: ['animal', 'oink'],
    sheet: [12, 24],
    shortName: 'pig_nose'
  },
  {
    name: 'Nail Polish',
    unified: '1F485',
    keywords: [
      'beauty',
      'manicure',
      'finger',
      'fashion',
      'nail'
    ],
    sheet: [24, 36],
    skinVariations: [
      {
        unified: '1F485-1F3FB',
        sheet: [24, 37]
      },
      {
        unified: '1F485-1F3FC',
        sheet: [24, 38]
      },
      {
        unified: '1F485-1F3FD',
        sheet: [24, 39]
      },
      {
        unified: '1F485-1F3FE',
        sheet: [24, 40]
      },
      {
        unified: '1F485-1F3FF',
        sheet: [24, 41]
      }
    ],
    shortName: 'nail_care'
  },
  {
    name: 'Zipper-Mouth Face',
    unified: '1F910',
    keywords: [
      'face',
      'sealed',
      'zipper',
      'secret'
    ],
    sheet: [37, 23],
    shortName: 'zipper_mouth_face'
  },
  {
    name: 'Peanuts',
    unified: '1F95C',
    keywords: ['food', 'nut'],
    sheet: [41, 51],
    shortName: 'peanuts'
  },
  {
    name: 'Ballet Shoes',
    unified: '1FA70',
    sheet: [52, 17],
    shortName: 'ballet_shoes'
  },
  {
    name: 'Leftwards Black Arrow',
    unified: '2B05-FE0F',
    keywords: [
      'blue-square',
      'previous',
      'back'
    ],
    sheet: [56, 41],
    shortName: 'arrow_left'
  },
  {
    name: 'Benin Flag',
    unified: '1F1E7-1F1EF',
    sheet: [0, 56],
    shortName: 'flag-bj'
  },
  {
    name: 'Chestnut',
    unified: '1F330',
    keywords: ['food', 'squirrel'],
    sheet: [6, 2],
    shortName: 'chestnut'
  },
  {
    name: 'Rugby Football',
    unified: '1F3C9',
    keywords: ['sports', 'team'],
    sheet: [9, 25],
    shortName: 'rugby_football'
  },
  {
    name: 'Love Hotel',
    unified: '1F3E9',
    keywords: [
      'like',
      'affection',
      'dating'
    ],
    sheet: [10, 50],
    shortName: 'love_hotel'
  },
  {
    name: 'Ram',
    unified: '1F40F',
    keywords: [
      'animal',
      'sheep',
      'nature'
    ],
    sheet: [11, 34],
    shortName: 'ram'
  },
  {
    name: 'Womans Boots',
    unified: '1F462',
    keywords: ['shoes', 'fashion'],
    sheet: [14, 11],
    shortName: 'boot'
  },
  {
    name: 'Face with One Eyebrow Raised',
    unified: '1F928',
    sheet: [38, 41],
    shortNames: [
      'face_with_one_eyebrow_raised'
    ],
    shortName: 'face_with_raised_eyebrow'
  },
  {
    name: 'Selfie',
    unified: '1F933',
    keywords: ['camera', 'phone'],
    sheet: [39, 9],
    skinVariations: [
      {
        unified: '1F933-1F3FB',
        sheet: [39, 10]
      },
      {
        unified: '1F933-1F3FC',
        sheet: [39, 11]
      },
      {
        unified: '1F933-1F3FD',
        sheet: [39, 12]
      },
      {
        unified: '1F933-1F3FE',
        sheet: [39, 13]
      },
      {
        unified: '1F933-1F3FF',
        sheet: [39, 14]
      }
    ],
    shortName: 'selfie'
  },
  {
    name: 'North West Arrow',
    unified: '2196-FE0F',
    keywords: [
      'blue-square',
      'point',
      'direction',
      'diagonal',
      'northwest'
    ],
    sheet: [53, 22],
    shortName: 'arrow_upper_left'
  },
  {
    name: 'St. Barthélemy Flag',
    unified: '1F1E7-1F1F1',
    sheet: [0, 57],
    shortName: 'flag-bl'
  },
  {
    name: 'Bread',
    unified: '1F35E',
    keywords: [
      'food',
      'wheat',
      'breakfast',
      'toast'
    ],
    sheet: [6, 48],
    shortName: 'bread'
  },
  {
    name: 'Tennis Racquet and Ball',
    unified: '1F3BE',
    keywords: [
      'sports',
      'balls',
      'green'
    ],
    sheet: [8, 28],
    shortName: 'tennis'
  },
  {
    name: 'Convenience Store',
    unified: '1F3EA',
    keywords: [
      'building',
      'shopping',
      'groceries'
    ],
    sheet: [10, 51],
    shortName: 'convenience_store'
  },
  {
    name: 'Sheep',
    unified: '1F411',
    keywords: [
      'animal',
      'nature',
      'wool',
      'shipit'
    ],
    sheet: [11, 36],
    shortName: 'sheep'
  },
  {
    name: 'Crown',
    unified: '1F451',
    keywords: [
      'king',
      'kod',
      'leader',
      'royalty',
      'lord'
    ],
    sheet: [13, 52],
    shortName: 'crown'
  },
  {
    name: 'Flexed Biceps',
    unified: '1F4AA',
    keywords: [
      'arm',
      'flex',
      'hand',
      'summer',
      'strong',
      'biceps'
    ],
    sheet: [25, 54],
    skinVariations: [
      {
        unified: '1F4AA-1F3FB',
        sheet: [25, 55]
      },
      {
        unified: '1F4AA-1F3FC',
        sheet: [25, 56]
      },
      {
        unified: '1F4AA-1F3FD',
        sheet: [25, 57]
      },
      {
        unified: '1F4AA-1F3FE',
        sheet: [26, 0]
      },
      {
        unified: '1F4AA-1F3FF',
        sheet: [26, 1]
      }
    ],
    shortName: 'muscle'
  },
  {
    name: 'Neutral Face',
    unified: '1F610',
    emoticons: [':|', ':-|'],
    keywords: [
      'indifference',
      'meh',
      ':|',
      'neutral'
    ],
    sheet: [30, 48],
    shortName: 'neutral_face'
  },
  {
    name: 'Up Down Arrow',
    unified: '2195-FE0F',
    keywords: [
      'blue-square',
      'direction',
      'way',
      'vertical'
    ],
    sheet: [53, 21],
    shortName: 'arrow_up_down'
  },
  {
    name: 'Bermuda Flag',
    unified: '1F1E7-1F1F2',
    sheet: [1, 0],
    shortName: 'flag-bm'
  },
  {
    name: 'School',
    unified: '1F3EB',
    keywords: [
      'building',
      'student',
      'education',
      'learn',
      'teach'
    ],
    sheet: [10, 52],
    shortName: 'school'
  },
  {
    name: 'Goat',
    unified: '1F410',
    keywords: ['animal', 'nature'],
    sheet: [11, 35],
    shortName: 'goat'
  },
  {
    name: 'Womans Hat',
    unified: '1F452',
    keywords: [
      'fashion',
      'accessories',
      'female',
      'lady',
      'spring'
    ],
    sheet: [13, 53],
    shortName: 'womans_hat'
  },
  {
    name: 'Expressionless Face',
    unified: '1F611',
    keywords: [
      'face',
      'indifferent',
      '-_-',
      'meh',
      'deadpan'
    ],
    sheet: [30, 49],
    shortName: 'expressionless'
  },
  {
    name: 'Flying Disc',
    unified: '1F94F',
    keywords: [
      'sports',
      'frisbee',
      'ultimate'
    ],
    sheet: [41, 38],
    shortName: 'flying_disc'
  },
  {
    name: 'Croissant',
    unified: '1F950',
    keywords: [
      'food',
      'bread',
      'french'
    ],
    sheet: [41, 39],
    shortName: 'croissant'
  },
  {
    name: 'Mechanical Arm',
    unified: '1F9BE',
    sheet: [44, 24],
    shortName: 'mechanical_arm'
  },
  {
    name: 'Left Right Arrow',
    unified: '2194-FE0F',
    keywords: [
      'shape',
      'direction',
      'horizontal',
      'sideways'
    ],
    sheet: [53, 20],
    shortName: 'left_right_arrow'
  },
  {
    name: 'Brunei Flag',
    unified: '1F1E7-1F1F3',
    sheet: [1, 1],
    shortName: 'flag-bn'
  },
  {
    name: 'Top Hat',
    unified: '1F3A9',
    keywords: [
      'magic',
      'gentleman',
      'classy',
      'circus'
    ],
    sheet: [8, 7],
    shortName: 'tophat'
  },
  {
    name: 'Bowling',
    unified: '1F3B3',
    keywords: ['sports', 'fun', 'play'],
    sheet: [8, 17],
    shortName: 'bowling'
  },
  {
    name: 'Department Store',
    unified: '1F3EC',
    keywords: [
      'building',
      'shopping',
      'mall'
    ],
    sheet: [10, 53],
    shortName: 'department_store'
  },
  {
    name: 'Dromedary Camel',
    unified: '1F42A',
    keywords: [
      'animal',
      'hot',
      'desert',
      'hump'
    ],
    sheet: [12, 4],
    shortName: 'dromedary_camel'
  },
  {
    name: 'Face Without Mouth',
    unified: '1F636',
    keywords: ['face', 'hellokitty'],
    sheet: [31, 28],
    shortName: 'no_mouth'
  },
  {
    name: 'Baguette Bread',
    unified: '1F956',
    keywords: [
      'food',
      'bread',
      'french'
    ],
    sheet: [41, 45],
    shortName: 'baguette_bread'
  },
  {
    name: 'Mechanical Leg',
    unified: '1F9BF',
    sheet: [44, 25],
    shortName: 'mechanical_leg'
  },
  {
    name: 'Leftwards Arrow with Hook',
    unified: '21A9-FE0F',
    keywords: [
      'back',
      'return',
      'blue-square',
      'undo',
      'enter'
    ],
    sheet: [53, 26],
    shortName: 'leftwards_arrow_with_hook'
  },
  {
    name: 'Bolivia Flag',
    unified: '1F1E7-1F1F4',
    sheet: [1, 2],
    shortName: 'flag-bo'
  },
  {
    name: 'Graduation Cap',
    unified: '1F393',
    keywords: [
      'school',
      'college',
      'degree',
      'university',
      'graduation',
      'cap',
      'hat',
      'legal',
      'learn',
      'education'
    ],
    sheet: [7, 48],
    shortName: 'mortar_board'
  },
  {
    name: 'Cricket Bat and Ball',
    unified: '1F3CF',
    sheet: [10, 24],
    shortName: 'cricket_bat_and_ball'
  },
  {
    name: 'Factory',
    unified: '1F3ED',
    keywords: [
      'building',
      'industry',
      'pollution',
      'smoke'
    ],
    sheet: [10, 54],
    shortName: 'factory'
  },
  {
    name: 'Bactrian Camel',
    unified: '1F42B',
    keywords: [
      'animal',
      'nature',
      'hot',
      'desert',
      'hump'
    ],
    sheet: [12, 5],
    shortName: 'camel'
  },
  {
    name: 'Smirking Face',
    unified: '1F60F',
    keywords: [
      'face',
      'smile',
      'mean',
      'prank',
      'smug',
      'sarcasm'
    ],
    sheet: [30, 47],
    shortName: 'smirk'
  },
  {
    name: 'Leg',
    unified: '1F9B5',
    keywords: ['kick', 'limb'],
    sheet: [43, 24],
    skinVariations: [
      {
        unified: '1F9B5-1F3FB',
        sheet: [43, 25]
      },
      {
        unified: '1F9B5-1F3FC',
        sheet: [43, 26]
      },
      {
        unified: '1F9B5-1F3FD',
        sheet: [43, 27]
      },
      {
        unified: '1F9B5-1F3FE',
        sheet: [43, 28]
      },
      {
        unified: '1F9B5-1F3FF',
        sheet: [43, 29]
      }
    ],
    shortName: 'leg'
  },
  {
    name: 'Flatbread',
    unified: '1FAD3',
    sheet: [53, 12],
    shortName: 'flatbread'
  },
  {
    name: 'Rightwards Arrow with Hook',
    unified: '21AA-FE0F',
    keywords: [
      'blue-square',
      'return',
      'rotate',
      'direction'
    ],
    sheet: [53, 27],
    shortName: 'arrow_right_hook'
  },
  {
    name: 'Caribbean Netherlands Flag',
    unified: '1F1E7-1F1F6',
    sheet: [1, 3],
    shortName: 'flag-bq'
  },
  {
    name: 'Field Hockey Stick and Ball',
    unified: '1F3D1',
    sheet: [10, 26],
    shortName: 'field_hockey_stick_and_ball'
  },
  {
    name: 'Japanese Castle',
    unified: '1F3EF',
    keywords: ['photo', 'building'],
    sheet: [10, 56],
    shortName: 'japanese_castle'
  },
  {
    name: 'Unamused Face',
    unified: '1F612',
    text: ':(',
    keywords: [
      'indifference',
      'bored',
      'straight face',
      'serious',
      'sarcasm',
      'unimpressed',
      'skeptical',
      'dubious',
      'side_eye'
    ],
    sheet: [30, 50],
    shortName: 'unamused'
  },
  {
    name: 'Pretzel',
    unified: '1F968',
    keywords: [
      'food',
      'bread',
      'twisted'
    ],
    sheet: [42, 5],
    shortName: 'pretzel'
  },
  {
    name: 'Llama',
    unified: '1F999',
    keywords: [
      'animal',
      'nature',
      'alpaca'
    ],
    sheet: [43, 0],
    shortName: 'llama'
  },
  {
    name: 'Foot',
    unified: '1F9B6',
    keywords: ['kick', 'stomp'],
    sheet: [43, 30],
    skinVariations: [
      {
        unified: '1F9B6-1F3FB',
        sheet: [43, 31]
      },
      {
        unified: '1F9B6-1F3FC',
        sheet: [43, 32]
      },
      {
        unified: '1F9B6-1F3FD',
        sheet: [43, 33]
      },
      {
        unified: '1F9B6-1F3FE',
        sheet: [43, 34]
      },
      {
        unified: '1F9B6-1F3FF',
        sheet: [43, 35]
      }
    ],
    shortName: 'foot'
  },
  {
    name: 'Billed Cap',
    unified: '1F9E2',
    sheet: [51, 45],
    shortName: 'billed_cap'
  },
  {
    name: 'Arrow Pointing Rightwards Then Curving Upwards',
    unified: '2934-FE0F',
    keywords: [
      'blue-square',
      'direction',
      'top'
    ],
    sheet: [56, 39],
    shortName: 'arrow_heading_up'
  },
  {
    name: 'Brazil Flag',
    unified: '1F1E7-1F1F7',
    sheet: [1, 4],
    shortName: 'flag-br'
  },
  {
    name: 'Ice Hockey Stick and Puck',
    unified: '1F3D2',
    sheet: [10, 27],
    shortName: 'ice_hockey_stick_and_puck'
  },
  {
    name: 'European Castle',
    unified: '1F3F0',
    keywords: [
      'building',
      'royalty',
      'history'
    ],
    sheet: [10, 57],
    shortName: 'european_castle'
  },
  {
    name: 'Ear',
    unified: '1F442',
    keywords: [
      'face',
      'hear',
      'sound',
      'listen'
    ],
    sheet: [12, 30],
    skinVariations: [
      {
        unified: '1F442-1F3FB',
        sheet: [12, 31]
      },
      {
        unified: '1F442-1F3FC',
        sheet: [12, 32]
      },
      {
        unified: '1F442-1F3FD',
        sheet: [12, 33]
      },
      {
        unified: '1F442-1F3FE',
        sheet: [12, 34]
      },
      {
        unified: '1F442-1F3FF',
        sheet: [12, 35]
      }
    ],
    shortName: 'ear'
  },
  {
    name: 'Face with Rolling Eyes',
    unified: '1F644',
    sheet: [31, 42],
    shortName: 'face_with_rolling_eyes'
  },
  {
    name: 'Bagel',
    unified: '1F96F',
    keywords: [
      'food',
      'bread',
      'bakery',
      'schmear'
    ],
    sheet: [42, 12],
    shortName: 'bagel'
  },
  {
    name: 'Giraffe Face',
    unified: '1F992',
    sheet: [42, 51],
    shortName: 'giraffe_face'
  },
  {
    name: 'Military Helmet',
    unified: '1FA96',
    sheet: [52, 38],
    shortName: 'military_helmet'
  },
  {
    name: 'Arrow Pointing Rightwards Then Curving Downwards',
    unified: '2935-FE0F',
    keywords: [
      'blue-square',
      'direction',
      'bottom'
    ],
    sheet: [56, 40],
    shortName: 'arrow_heading_down'
  },
  {
    name: 'Bahamas Flag',
    unified: '1F1E7-1F1F8',
    sheet: [1, 5],
    shortName: 'flag-bs'
  },
  {
    name: 'Elephant',
    unified: '1F418',
    keywords: [
      'animal',
      'nature',
      'nose',
      'th',
      'circus'
    ],
    sheet: [11, 44],
    shortName: 'elephant'
  },
  {
    name: 'Wedding',
    unified: '1F492',
    keywords: [
      'love',
      'like',
      'affection',
      'couple',
      'marriage',
      'bride',
      'groom'
    ],
    sheet: [25, 30],
    shortName: 'wedding'
  },
  {
    name: 'Clockwise Downwards and Upwards Open Circle Arrows',
    unified: '1F503',
    keywords: [
      'sync',
      'cycle',
      'round',
      'repeat'
    ],
    sheet: [27, 31],
    shortName: 'arrows_clockwise'
  },
  {
    name: 'Grimacing Face',
    unified: '1F62C',
    keywords: [
      'face',
      'grimace',
      'teeth'
    ],
    sheet: [31, 18],
    shortName: 'grimacing'
  },
  {
    name: 'Lacrosse Stick and Ball',
    unified: '1F94D',
    keywords: [
      'sports',
      'ball',
      'stick'
    ],
    sheet: [41, 36],
    shortName: 'lacrosse'
  },
  {
    name: 'Pancakes',
    unified: '1F95E',
    keywords: [
      'food',
      'breakfast',
      'flapjacks',
      'hotcakes'
    ],
    sheet: [41, 53],
    shortName: 'pancakes'
  },
  {
    name: 'Ear with Hearing Aid',
    unified: '1F9BB',
    sheet: [44, 16],
    skinVariations: [
      {
        unified: '1F9BB-1F3FB',
        sheet: [44, 17]
      },
      {
        unified: '1F9BB-1F3FC',
        sheet: [44, 18]
      },
      {
        unified: '1F9BB-1F3FD',
        sheet: [44, 19]
      },
      {
        unified: '1F9BB-1F3FE',
        sheet: [44, 20]
      },
      {
        unified: '1F9BB-1F3FF',
        sheet: [44, 21]
      }
    ],
    shortName: 'ear_with_hearing_aid'
  },
  {
    name: 'Helmet with White Cross',
    unified: '26D1-FE0F',
    sheet: [55, 11],
    shortName: 'helmet_with_white_cross'
  },
  {
    name: 'Bhutan Flag',
    unified: '1F1E7-1F1F9',
    sheet: [1, 6],
    shortName: 'flag-bt'
  },
  {
    name: 'Table Tennis Paddle and Ball',
    unified: '1F3D3',
    sheet: [10, 28],
    shortName: 'table_tennis_paddle_and_ball'
  },
  {
    name: 'Nose',
    unified: '1F443',
    keywords: ['smell', 'sniff'],
    sheet: [12, 36],
    skinVariations: [
      {
        unified: '1F443-1F3FB',
        sheet: [12, 37]
      },
      {
        unified: '1F443-1F3FC',
        sheet: [12, 38]
      },
      {
        unified: '1F443-1F3FD',
        sheet: [12, 39]
      },
      {
        unified: '1F443-1F3FE',
        sheet: [12, 40]
      },
      {
        unified: '1F443-1F3FF',
        sheet: [12, 41]
      }
    ],
    shortName: 'nose'
  },
  {
    name: 'Prayer Beads',
    unified: '1F4FF',
    keywords: ['dhikr', 'religious'],
    sheet: [27, 27],
    shortName: 'prayer_beads'
  },
  {
    name: 'Anticlockwise Downwards and Upwards Open Circle Arrows',
    unified: '1F504',
    keywords: [
      'blue-square',
      'sync',
      'cycle'
    ],
    sheet: [27, 32],
    shortName: 'arrows_counterclockwise'
  },
  {
    name: 'Tokyo Tower',
    unified: '1F5FC',
    keywords: ['photo', 'japanese'],
    sheet: [30, 28],
    shortName: 'tokyo_tower'
  },
  {
    name: 'Lying Face',
    unified: '1F925',
    keywords: [
      'face',
      'lie',
      'pinocchio'
    ],
    sheet: [38, 21],
    shortName: 'lying_face'
  },
  {
    name: 'Mammoth',
    unified: '1F9A3',
    sheet: [43, 10],
    shortName: 'mammoth'
  },
  {
    name: 'Waffle',
    unified: '1F9C7',
    sheet: [44, 33],
    shortName: 'waffle'
  },
  {
    name: 'Bouvet Island Flag',
    unified: '1F1E7-1F1FB',
    sheet: [1, 7],
    shortName: 'flag-bv'
  },
  {
    name: 'Badminton Racquet and Shuttlecock',
    unified: '1F3F8',
    sheet: [11, 10],
    shortName: 'badminton_racquet_and_shuttlecock'
  },
  {
    name: 'Lipstick',
    unified: '1F484',
    keywords: [
      'female',
      'girl',
      'fashion',
      'woman'
    ],
    sheet: [24, 35],
    shortName: 'lipstick'
  },
  {
    name: 'Back with Leftwards Arrow Above',
    unified: '1F519',
    keywords: [
      'arrow',
      'words',
      'return'
    ],
    sheet: [27, 53],
    shortName: 'back'
  },
  {
    name: 'Statue of Liberty',
    unified: '1F5FD',
    keywords: ['american', 'newyork'],
    sheet: [30, 29],
    shortName: 'statue_of_liberty'
  },
  {
    name: 'Relieved Face',
    unified: '1F60C',
    keywords: [
      'face',
      'relaxed',
      'phew',
      'massage',
      'happiness'
    ],
    sheet: [30, 44],
    shortName: 'relieved'
  },
  {
    name: 'Rhinoceros',
    unified: '1F98F',
    keywords: [
      'animal',
      'nature',
      'horn'
    ],
    sheet: [42, 48],
    shortName: 'rhinoceros'
  },
  {
    name: 'Cheese Wedge',
    unified: '1F9C0',
    sheet: [44, 26],
    shortName: 'cheese_wedge'
  },
  {
    name: 'Brain',
    unified: '1F9E0',
    keywords: ['smart', 'intelligent'],
    sheet: [51, 43],
    shortName: 'brain'
  },
  {
    name: 'Botswana Flag',
    unified: '1F1E7-1F1FC',
    sheet: [1, 8],
    shortName: 'flag-bw'
  },
  {
    name: 'Meat on Bone',
    unified: '1F356',
    keywords: [
      'good',
      'food',
      'drumstick'
    ],
    sheet: [6, 40],
    shortName: 'meat_on_bone'
  },
  {
    name: 'Ring',
    unified: '1F48D',
    keywords: [
      'wedding',
      'propose',
      'marriage',
      'valentines',
      'diamond',
      'fashion',
      'jewelry',
      'gem',
      'engagement'
    ],
    sheet: [25, 25],
    shortName: 'ring'
  },
  {
    name: 'End with Leftwards Arrow Above',
    unified: '1F51A',
    keywords: ['words', 'arrow'],
    sheet: [27, 54],
    shortName: 'end'
  },
  {
    name: 'Pensive Face',
    unified: '1F614',
    keywords: [
      'face',
      'sad',
      'depressed',
      'upset'
    ],
    sheet: [30, 52],
    shortName: 'pensive'
  },
  {
    name: 'Boxing Glove',
    unified: '1F94A',
    keywords: ['sports', 'fighting'],
    sheet: [41, 33],
    shortName: 'boxing_glove'
  },
  {
    name: 'Hippopotamus',
    unified: '1F99B',
    keywords: ['animal', 'nature'],
    sheet: [43, 2],
    shortName: 'hippopotamus'
  },
  {
    name: 'Anatomical Heart',
    unified: '1FAC0',
    sheet: [53, 6],
    shortName: 'anatomical_heart'
  },
  {
    name: 'Church',
    unified: '26EA',
    keywords: [
      'building',
      'religion',
      'christ'
    ],
    sheet: [55, 15],
    shortName: 'church'
  },
  {
    name: 'Belarus Flag',
    unified: '1F1E7-1F1FE',
    sheet: [1, 9],
    shortName: 'flag-by'
  },
  {
    name: 'Poultry Leg',
    unified: '1F357',
    keywords: [
      'food',
      'meat',
      'drumstick',
      'bird',
      'chicken',
      'turkey'
    ],
    sheet: [6, 41],
    shortName: 'poultry_leg'
  },
  {
    name: 'Mouse Face',
    unified: '1F42D',
    keywords: [
      'animal',
      'nature',
      'cheese_wedge',
      'rodent'
    ],
    sheet: [12, 7],
    shortName: 'mouse'
  },
  {
    name: 'Gem Stone',
    unified: '1F48E',
    keywords: [
      'blue',
      'ruby',
      'diamond',
      'jewelry'
    ],
    sheet: [25, 26],
    shortName: 'gem'
  },
  {
    name: 'On with Exclamation Mark with Left Right Arrow Above',
    unified: '1F51B',
    keywords: ['arrow', 'words'],
    sheet: [27, 55],
    shortName: 'on'
  },
  {
    name: 'Mosque',
    unified: '1F54C',
    keywords: [
      'islam',
      'worship',
      'minaret'
    ],
    sheet: [28, 35],
    shortName: 'mosque'
  },
  {
    name: 'Sleepy Face',
    unified: '1F62A',
    keywords: [
      'face',
      'tired',
      'rest',
      'nap'
    ],
    sheet: [31, 16],
    shortName: 'sleepy'
  },
  {
    name: 'Martial Arts Uniform',
    unified: '1F94B',
    keywords: [
      'judo',
      'karate',
      'taekwondo'
    ],
    sheet: [41, 34],
    shortName: 'martial_arts_uniform'
  },
  {
    name: 'Lungs',
    unified: '1FAC1',
    sheet: [53, 7],
    shortName: 'lungs'
  },
  {
    name: 'Belize Flag',
    unified: '1F1E7-1F1FF',
    sheet: [1, 10],
    shortName: 'flag-bz'
  },
  {
    name: 'Mouse',
    unified: '1F401',
    keywords: [
      'animal',
      'nature',
      'rodent'
    ],
    sheet: [11, 19],
    shortName: 'mouse2'
  },
  {
    name: 'Speaker with Cancellation Stroke',
    unified: '1F507',
    keywords: [
      'sound',
      'volume',
      'silence',
      'quiet'
    ],
    sheet: [27, 35],
    shortName: 'mute'
  },
  {
    name: 'Soon with Rightwards Arrow Above',
    unified: '1F51C',
    keywords: ['arrow', 'words'],
    sheet: [27, 56],
    shortName: 'soon'
  },
  {
    name: 'Hindu Temple',
    unified: '1F6D5',
    sheet: [36, 32],
    shortName: 'hindu_temple'
  },
  {
    name: 'Drooling Face',
    unified: '1F924',
    keywords: ['face'],
    sheet: [38, 20],
    shortName: 'drooling_face'
  },
  {
    name: 'Goal Net',
    unified: '1F945',
    keywords: ['sports'],
    sheet: [41, 29],
    shortName: 'goal_net'
  },
  {
    name: 'Cut of Meat',
    unified: '1F969',
    sheet: [42, 6],
    shortName: 'cut_of_meat'
  },
  {
    name: 'Tooth',
    unified: '1F9B7',
    keywords: ['teeth', 'dentist'],
    sheet: [43, 36],
    shortName: 'tooth'
  },
  {
    name: 'Canada Flag',
    unified: '1F1E8-1F1E6',
    sheet: [1, 11],
    shortName: 'flag-ca'
  },
  {
    name: 'Rat',
    unified: '1F400',
    keywords: [
      'animal',
      'mouse',
      'rodent'
    ],
    sheet: [11, 18],
    shortName: 'rat'
  },
  {
    name: 'Speaker',
    unified: '1F508',
    keywords: [
      'sound',
      'volume',
      'silence',
      'broadcast'
    ],
    sheet: [27, 36],
    shortName: 'speaker'
  },
  {
    name: 'Top with Upwards Arrow Above',
    unified: '1F51D',
    keywords: ['words', 'blue-square'],
    sheet: [27, 57],
    shortName: 'top'
  },
  {
    name: 'Synagogue',
    unified: '1F54D',
    keywords: [
      'judaism',
      'worship',
      'temple',
      'jewish'
    ],
    sheet: [28, 36],
    shortName: 'synagogue'
  },
  {
    name: 'Sleeping Face',
    unified: '1F634',
    keywords: [
      'face',
      'tired',
      'sleepy',
      'night',
      'zzz'
    ],
    sheet: [31, 26],
    shortName: 'sleeping'
  },
  {
    name: 'Bacon',
    unified: '1F953',
    keywords: [
      'food',
      'breakfast',
      'pork',
      'pig',
      'meat'
    ],
    sheet: [41, 42],
    shortName: 'bacon'
  },
  {
    name: 'Bone',
    unified: '1F9B4',
    keywords: ['skeleton'],
    sheet: [43, 23],
    shortName: 'bone'
  },
  {
    name: 'Flag in Hole',
    unified: '26F3',
    keywords: [
      'sports',
      'business',
      'flag',
      'hole',
      'summer'
    ],
    sheet: [55, 19],
    shortName: 'golf'
  },
  {
    name: 'Cocos (keeling) Islands Flag',
    unified: '1F1E8-1F1E8',
    sheet: [1, 12],
    shortName: 'flag-cc'
  },
  {
    name: 'Hamburger',
    unified: '1F354',
    keywords: [
      'meat',
      'fast food',
      'beef',
      'cheeseburger',
      'mcdonalds',
      'burger king'
    ],
    sheet: [6, 38],
    shortName: 'hamburger'
  },
  {
    name: 'Hamster Face',
    unified: '1F439',
    keywords: ['animal', 'nature'],
    sheet: [12, 19],
    shortName: 'hamster'
  },
  {
    name: 'Eyes',
    unified: '1F440',
    keywords: [
      'look',
      'watch',
      'stalk',
      'peek',
      'see'
    ],
    sheet: [12, 27],
    shortName: 'eyes'
  },
  {
    name: 'Speaker with One Sound Wave',
    unified: '1F509',
    keywords: [
      'volume',
      'speaker',
      'broadcast'
    ],
    sheet: [27, 37],
    shortName: 'sound'
  },
  {
    name: 'Face with Medical Mask',
    unified: '1F637',
    keywords: [
      'face',
      'sick',
      'ill',
      'disease'
    ],
    sheet: [31, 29],
    shortName: 'mask'
  },
  {
    name: 'Place of Worship',
    unified: '1F6D0',
    keywords: [
      'religion',
      'church',
      'temple',
      'prayer'
    ],
    sheet: [36, 29],
    shortName: 'place_of_worship'
  },
  {
    name: 'Shinto Shrine',
    unified: '26E9-FE0F',
    keywords: [
      'temple',
      'japan',
      'kyoto'
    ],
    sheet: [55, 14],
    shortName: 'shinto_shrine'
  },
  {
    name: 'Ice Skate',
    unified: '26F8-FE0F',
    keywords: ['sports'],
    sheet: [55, 23],
    shortName: 'ice_skate'
  },
  {
    name: 'Congo - Kinshasa Flag',
    unified: '1F1E8-1F1E9',
    sheet: [1, 13],
    shortName: 'flag-cd'
  },
  {
    name: 'French Fries',
    unified: '1F35F',
    keywords: [
      'chips',
      'snack',
      'fast food'
    ],
    sheet: [6, 49],
    shortName: 'fries'
  },
  {
    name: 'Fishing Pole and Fish',
    unified: '1F3A3',
    keywords: [
      'food',
      'hobby',
      'summer'
    ],
    sheet: [8, 1],
    shortName: 'fishing_pole_and_fish'
  },
  {
    name: 'Rabbit Face',
    unified: '1F430',
    keywords: [
      'animal',
      'nature',
      'pet',
      'spring',
      'magic',
      'bunny'
    ],
    sheet: [12, 10],
    shortName: 'rabbit'
  },
  {
    name: 'Eye',
    unified: '1F441-FE0F',
    keywords: [
      'face',
      'look',
      'see',
      'watch',
      'stare'
    ],
    sheet: [12, 29],
    shortName: 'eye'
  },
  {
    name: 'Speaker with Three Sound Waves',
    unified: '1F50A',
    keywords: [
      'volume',
      'noise',
      'noisy',
      'speaker',
      'broadcast'
    ],
    sheet: [27, 38],
    shortName: 'loud_sound'
  },
  {
    name: 'Kaaba',
    unified: '1F54B',
    keywords: [
      'mecca',
      'mosque',
      'islam'
    ],
    sheet: [28, 34],
    shortName: 'kaaba'
  },
  {
    name: 'Face with Thermometer',
    unified: '1F912',
    keywords: [
      'sick',
      'temperature',
      'thermometer',
      'cold',
      'fever'
    ],
    sheet: [37, 25],
    shortName: 'face_with_thermometer'
  },
  {
    name: 'Atom Symbol',
    unified: '269B-FE0F',
    keywords: [
      'science',
      'physics',
      'chemistry'
    ],
    sheet: [54, 53],
    shortName: 'atom_symbol'
  },
  {
    name: 'Central African Republic Flag',
    unified: '1F1E8-1F1EB',
    sheet: [1, 14],
    shortName: 'flag-cf'
  },
  {
    name: 'Slice of Pizza',
    unified: '1F355',
    keywords: ['food', 'party'],
    sheet: [6, 39],
    shortName: 'pizza'
  },
  {
    name: 'Rabbit',
    unified: '1F407',
    keywords: [
      'animal',
      'nature',
      'pet',
      'magic',
      'spring'
    ],
    sheet: [11, 25],
    shortName: 'rabbit2'
  },
  {
    name: 'Tongue',
    unified: '1F445',
    keywords: ['mouth', 'playful'],
    sheet: [12, 43],
    shortName: 'tongue'
  },
  {
    name: 'Public Address Loudspeaker',
    unified: '1F4E2',
    keywords: ['volume', 'sound'],
    sheet: [26, 57],
    shortName: 'loudspeaker'
  },
  {
    name: 'Om Symbol',
    unified: '1F549-FE0F',
    sheet: [28, 32],
    shortName: 'om_symbol'
  },
  {
    name: 'Face with Head-Bandage',
    unified: '1F915',
    keywords: [
      'injured',
      'clumsy',
      'bandage',
      'hurt'
    ],
    sheet: [37, 28],
    shortName: 'face_with_head_bandage'
  },
  {
    name: 'Diving Mask',
    unified: '1F93F',
    sheet: [41, 23],
    shortName: 'diving_mask'
  },
  {
    name: 'Fountain',
    unified: '26F2',
    keywords: [
      'photo',
      'summer',
      'water',
      'fresh'
    ],
    sheet: [55, 18],
    shortName: 'fountain'
  },
  {
    name: 'Congo - Brazzaville Flag',
    unified: '1F1E8-1F1EC',
    sheet: [1, 15],
    shortName: 'flag-cg'
  },
  {
    name: 'Hot Dog',
    unified: '1F32D',
    keywords: ['food', 'frankfurter'],
    sheet: [5, 57],
    shortName: 'hotdog'
  },
  {
    name: 'Running Shirt with Sash',
    unified: '1F3BD',
    keywords: ['play', 'pageant'],
    sheet: [8, 27],
    shortName: 'running_shirt_with_sash'
  },
  {
    name: 'Chipmunk',
    unified: '1F43F-FE0F',
    keywords: [
      'animal',
      'nature',
      'rodent',
      'squirrel'
    ],
    sheet: [12, 26],
    shortName: 'chipmunk'
  },
  {
    name: 'Mouth',
    unified: '1F444',
    keywords: ['mouth', 'kiss'],
    sheet: [12, 42],
    shortName: 'lips'
  },
  {
    name: 'Cheering Megaphone',
    unified: '1F4E3',
    keywords: [
      'sound',
      'speaker',
      'volume'
    ],
    sheet: [27, 0],
    shortName: 'mega'
  },
  {
    name: 'Nauseated Face',
    unified: '1F922',
    keywords: [
      'face',
      'vomit',
      'gross',
      'green',
      'sick',
      'throw up',
      'ill'
    ],
    sheet: [38, 18],
    shortName: 'nauseated_face'
  },
  {
    name: 'Tent',
    unified: '26FA',
    keywords: [
      'photo',
      'camping',
      'outdoors'
    ],
    sheet: [55, 42],
    shortName: 'tent'
  },
  {
    name: 'Star of David',
    unified: '2721-FE0F',
    keywords: ['judaism'],
    sheet: [56, 19],
    shortName: 'star_of_david'
  },
  {
    name: 'Switzerland Flag',
    unified: '1F1E8-1F1ED',
    sheet: [1, 16],
    shortName: 'flag-ch'
  },
  {
    name: 'Foggy',
    unified: '1F301',
    keywords: ['photo', 'mountain'],
    sheet: [5, 15],
    shortName: 'foggy'
  },
  {
    name: 'Ski and Ski Boot',
    unified: '1F3BF',
    keywords: [
      'sports',
      'winter',
      'cold',
      'snow'
    ],
    sheet: [8, 29],
    shortName: 'ski'
  },
  {
    name: 'Baby',
    unified: '1F476',
    keywords: [
      'child',
      'boy',
      'girl',
      'toddler'
    ],
    sheet: [23, 8],
    skinVariations: [
      {
        unified: '1F476-1F3FB',
        sheet: [23, 9]
      },
      {
        unified: '1F476-1F3FC',
        sheet: [23, 10]
      },
      {
        unified: '1F476-1F3FD',
        sheet: [23, 11]
      },
      {
        unified: '1F476-1F3FE',
        sheet: [23, 12]
      },
      {
        unified: '1F476-1F3FF',
        sheet: [23, 13]
      }
    ],
    shortName: 'baby'
  },
  {
    name: 'Postal Horn',
    unified: '1F4EF',
    keywords: ['instrument', 'music'],
    sheet: [27, 12],
    shortName: 'postal_horn'
  },
  {
    name: 'Face with Open Mouth Vomiting',
    unified: '1F92E',
    sheet: [38, 47],
    shortNames: [
      'face_with_open_mouth_vomiting'
    ],
    shortName: 'face_vomiting'
  },
  {
    name: 'Sandwich',
    unified: '1F96A',
    keywords: [
      'food',
      'lunch',
      'bread'
    ],
    sheet: [42, 7],
    shortName: 'sandwich'
  },
  {
    name: 'Beaver',
    unified: '1F9AB',
    sheet: [43, 18],
    shortName: 'beaver'
  },
  {
    name: 'Wheel of Dharma',
    unified: '2638-FE0F',
    keywords: [
      'hinduism',
      'buddhism',
      'sikhism',
      'jainism'
    ],
    sheet: [54, 20],
    shortName: 'wheel_of_dharma'
  },
  {
    name: 'Côte D’ivoire Flag',
    unified: '1F1E8-1F1EE',
    sheet: [1, 17],
    shortName: 'flag-ci'
  },
  {
    name: 'Night with Stars',
    unified: '1F303',
    keywords: [
      'evening',
      'city',
      'downtown'
    ],
    sheet: [5, 17],
    shortName: 'night_with_stars'
  },
  {
    name: 'Taco',
    unified: '1F32E',
    keywords: ['food', 'mexican'],
    sheet: [6, 0],
    shortName: 'taco'
  },
  {
    name: 'Bell',
    unified: '1F514',
    keywords: [
      'sound',
      'notification',
      'christmas',
      'xmas',
      'chime'
    ],
    sheet: [27, 48],
    shortName: 'bell'
  },
  {
    name: 'Sled',
    unified: '1F6F7',
    keywords: [
      'sleigh',
      'luge',
      'toboggan'
    ],
    sheet: [36, 49],
    shortName: 'sled'
  },
  {
    name: 'Sneezing Face',
    unified: '1F927',
    keywords: [
      'face',
      'gesundheit',
      'sneeze',
      'sick',
      'allergy'
    ],
    sheet: [38, 40],
    shortName: 'sneezing_face'
  },
  {
    name: 'Hedgehog',
    unified: '1F994',
    keywords: [
      'animal',
      'nature',
      'spiny'
    ],
    sheet: [42, 53],
    shortName: 'hedgehog'
  },
  {
    name: 'Child',
    unified: '1F9D2',
    keywords: [
      'gender-neutral',
      'young'
    ],
    sheet: [48, 43],
    skinVariations: [
      {
        unified: '1F9D2-1F3FB',
        sheet: [48, 44]
      },
      {
        unified: '1F9D2-1F3FC',
        sheet: [48, 45]
      },
      {
        unified: '1F9D2-1F3FD',
        sheet: [48, 46]
      },
      {
        unified: '1F9D2-1F3FE',
        sheet: [48, 47]
      },
      {
        unified: '1F9D2-1F3FF',
        sheet: [48, 48]
      }
    ],
    shortName: 'child'
  },
  {
    name: 'Yin Yang',
    unified: '262F-FE0F',
    keywords: ['balance'],
    sheet: [54, 19],
    shortName: 'yin_yang'
  },
  {
    name: 'Cook Islands Flag',
    unified: '1F1E8-1F1F0',
    sheet: [1, 18],
    shortName: 'flag-ck'
  },
  {
    name: 'Burrito',
    unified: '1F32F',
    keywords: ['food', 'mexican'],
    sheet: [6, 1],
    shortName: 'burrito'
  },
  {
    name: 'Cityscape',
    unified: '1F3D9-FE0F',
    keywords: [
      'photo',
      'night life',
      'urban'
    ],
    sheet: [10, 34],
    shortName: 'cityscape'
  },
  {
    name: 'Boy',
    unified: '1F466',
    keywords: [
      'man',
      'male',
      'guy',
      'teenager'
    ],
    sheet: [14, 15],
    skinVariations: [
      {
        unified: '1F466-1F3FB',
        sheet: [14, 16]
      },
      {
        unified: '1F466-1F3FC',
        sheet: [14, 17]
      },
      {
        unified: '1F466-1F3FD',
        sheet: [14, 18]
      },
      {
        unified: '1F466-1F3FE',
        sheet: [14, 19]
      },
      {
        unified: '1F466-1F3FF',
        sheet: [14, 20]
      }
    ],
    shortName: 'boy'
  },
  {
    name: 'Bell with Cancellation Stroke',
    unified: '1F515',
    keywords: [
      'sound',
      'volume',
      'mute',
      'quiet',
      'silent'
    ],
    sheet: [27, 49],
    shortName: 'no_bell'
  },
  {
    name: 'Curling Stone',
    unified: '1F94C',
    keywords: ['sports'],
    sheet: [41, 35],
    shortName: 'curling_stone'
  },
  {
    name: 'Overheated Face',
    unified: '1F975',
    sheet: [42, 18],
    shortName: 'hot_face'
  },
  {
    name: 'Bat',
    unified: '1F987',
    keywords: [
      'animal',
      'nature',
      'blind',
      'vampire'
    ],
    sheet: [42, 40],
    shortName: 'bat'
  },
  {
    name: 'Latin Cross',
    unified: '271D-FE0F',
    keywords: ['christianity'],
    sheet: [56, 18],
    shortName: 'latin_cross'
  },
  {
    name: 'Chile Flag',
    unified: '1F1E8-1F1F1',
    sheet: [1, 19],
    shortName: 'flag-cl'
  },
  {
    name: 'Sunrise over Mountains',
    unified: '1F304',
    keywords: [
      'view',
      'vacation',
      'photo'
    ],
    sheet: [5, 18],
    shortName: 'sunrise_over_mountains'
  },
  {
    name: 'Direct Hit',
    unified: '1F3AF',
    keywords: [
      'game',
      'play',
      'bar',
      'target',
      'bullseye'
    ],
    sheet: [8, 13],
    shortName: 'dart'
  },
  {
    name: 'Musical Score',
    unified: '1F3BC',
    keywords: [
      'treble',
      'clef',
      'compose'
    ],
    sheet: [8, 26],
    shortName: 'musical_score'
  },
  {
    name: 'Bear Face',
    unified: '1F43B',
    keywords: [
      'animal',
      'nature',
      'wild'
    ],
    sheet: [12, 22],
    shortName: 'bear'
  },
  {
    name: 'Girl',
    unified: '1F467',
    keywords: [
      'female',
      'woman',
      'teenager'
    ],
    sheet: [14, 21],
    skinVariations: [
      {
        unified: '1F467-1F3FB',
        sheet: [14, 22]
      },
      {
        unified: '1F467-1F3FC',
        sheet: [14, 23]
      },
      {
        unified: '1F467-1F3FD',
        sheet: [14, 24]
      },
      {
        unified: '1F467-1F3FE',
        sheet: [14, 25]
      },
      {
        unified: '1F467-1F3FF',
        sheet: [14, 26]
      }
    ],
    shortName: 'girl'
  },
  {
    name: 'Freezing Face',
    unified: '1F976',
    sheet: [42, 19],
    shortName: 'cold_face'
  },
  {
    name: 'Tamale',
    unified: '1FAD4',
    sheet: [53, 13],
    shortName: 'tamale'
  },
  {
    name: 'Orthodox Cross',
    unified: '2626-FE0F',
    keywords: [
      'suppedaneum',
      'religion'
    ],
    sheet: [54, 16],
    shortName: 'orthodox_cross'
  },
  {
    name: 'Cameroon Flag',
    unified: '1F1E8-1F1F2',
    sheet: [1, 20],
    shortName: 'flag-cm'
  },
  {
    name: 'Sunrise',
    unified: '1F305',
    keywords: [
      'morning',
      'view',
      'vacation',
      'photo'
    ],
    sheet: [5, 19],
    shortName: 'sunrise'
  },
  {
    name: 'Musical Note',
    unified: '1F3B5',
    keywords: [
      'score',
      'tone',
      'sound'
    ],
    sheet: [8, 19],
    shortName: 'musical_note'
  },
  {
    name: 'Polar Bear',
    unified: '1F43B-200D-2744-FE0F',
    sheet: [12, 21],
    shortName: 'polar_bear'
  },
  {
    name: 'Stuffed Flatbread',
    unified: '1F959',
    keywords: [
      'food',
      'flatbread',
      'stuffed',
      'gyro'
    ],
    sheet: [41, 48],
    shortName: 'stuffed_flatbread'
  },
  {
    name: 'Face with Uneven Eyes and Wavy Mouth',
    unified: '1F974',
    sheet: [42, 17],
    shortName: 'woozy_face'
  },
  {
    name: 'Adult',
    unified: '1F9D1',
    keywords: [
      'gender-neutral',
      'person'
    ],
    sheet: [48, 37],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB',
        sheet: [48, 38]
      },
      {
        unified: '1F9D1-1F3FC',
        sheet: [48, 39]
      },
      {
        unified: '1F9D1-1F3FD',
        sheet: [48, 40]
      },
      {
        unified: '1F9D1-1F3FE',
        sheet: [48, 41]
      },
      {
        unified: '1F9D1-1F3FF',
        sheet: [48, 42]
      }
    ],
    shortName: 'adult'
  },
  {
    name: 'Yo-Yo',
    unified: '1FA80',
    sheet: [52, 25],
    shortName: 'yo-yo'
  },
  {
    name: 'Star and Crescent',
    unified: '262A-FE0F',
    keywords: ['islam'],
    sheet: [54, 17],
    shortName: 'star_and_crescent'
  },
  {
    name: 'China Flag',
    unified: '1F1E8-1F1F3',
    keywords: [
      'china',
      'chinese',
      'prc',
      'flag',
      'country',
      'nation',
      'banner'
    ],
    sheet: [1, 21],
    shortNames: ['flag-cn'],
    shortName: 'cn'
  },
  {
    name: 'Cityscape at Dusk',
    unified: '1F306',
    keywords: [
      'photo',
      'evening',
      'sky',
      'buildings'
    ],
    sheet: [5, 20],
    shortName: 'city_sunset'
  },
  {
    name: 'Multiple Musical Notes',
    unified: '1F3B6',
    keywords: ['music', 'score'],
    sheet: [8, 20],
    shortName: 'notes'
  },
  {
    name: 'Koala',
    unified: '1F428',
    keywords: ['animal', 'nature'],
    sheet: [12, 2],
    shortName: 'koala'
  },
  {
    name: 'Person with Blond Hair',
    unified: '1F471',
    sheet: [22, 24],
    skinVariations: [
      {
        unified: '1F471-1F3FB',
        sheet: [22, 25]
      },
      {
        unified: '1F471-1F3FC',
        sheet: [22, 26]
      },
      {
        unified: '1F471-1F3FD',
        sheet: [22, 27]
      },
      {
        unified: '1F471-1F3FE',
        sheet: [22, 28]
      },
      {
        unified: '1F471-1F3FF',
        sheet: [22, 29]
      }
    ],
    shortName: 'person_with_blond_hair',
    obsoletedBy: '1F471-200D-2642-FE0F'
  },
  {
    name: 'Dizzy Face',
    unified: '1F635',
    keywords: [
      'spent',
      'unconscious',
      'xox',
      'dizzy'
    ],
    sheet: [31, 27],
    shortName: 'dizzy_face'
  },
  {
    name: 'Falafel',
    unified: '1F9C6',
    sheet: [44, 32],
    shortName: 'falafel'
  },
  {
    name: 'Kite',
    unified: '1FA81',
    sheet: [52, 26],
    shortName: 'kite'
  },
  {
    name: 'Peace Symbol',
    unified: '262E-FE0F',
    keywords: ['hippie'],
    sheet: [54, 18],
    shortName: 'peace_symbol'
  },
  {
    name: 'Colombia Flag',
    unified: '1F1E8-1F1F4',
    sheet: [1, 22],
    shortName: 'flag-co'
  },
  {
    name: 'Sunset over Buildings',
    unified: '1F307',
    keywords: [
      'photo',
      'good morning',
      'dawn'
    ],
    sheet: [5, 21],
    shortName: 'city_sunrise'
  },
  {
    name: 'Studio Microphone',
    unified: '1F399-FE0F',
    keywords: [
      'sing',
      'recording',
      'artist',
      'talkshow'
    ],
    sheet: [7, 51],
    shortName: 'studio_microphone'
  },
  {
    name: 'Billiards',
    unified: '1F3B1',
    keywords: [
      'pool',
      'hobby',
      'game',
      'luck',
      'magic'
    ],
    sheet: [8, 15],
    shortName: '8ball'
  },
  {
    name: 'Panda Face',
    unified: '1F43C',
    keywords: [
      'animal',
      'nature',
      'panda'
    ],
    sheet: [12, 23],
    shortName: 'panda_face'
  },
  {
    name: 'Man',
    unified: '1F468',
    keywords: [
      'mustache',
      'father',
      'dad',
      'guy',
      'classy',
      'sir',
      'moustache'
    ],
    sheet: [17, 14],
    skinVariations: [
      {
        unified: '1F468-1F3FB',
        sheet: [17, 15]
      },
      {
        unified: '1F468-1F3FC',
        sheet: [17, 16]
      },
      {
        unified: '1F468-1F3FD',
        sheet: [17, 17]
      },
      {
        unified: '1F468-1F3FE',
        sheet: [17, 18]
      },
      {
        unified: '1F468-1F3FF',
        sheet: [17, 19]
      }
    ],
    shortName: 'man'
  },
  {
    name: 'Menorah with Nine Branches',
    unified: '1F54E',
    sheet: [28, 37],
    shortName: 'menorah_with_nine_branches'
  },
  {
    name: 'Shocked Face with Exploding Head',
    unified: '1F92F',
    keywords: [
      'face',
      'shocked',
      'mind',
      'blown'
    ],
    sheet: [38, 48],
    shortNames: [
      'shocked_face_with_exploding_head'
    ],
    shortName: 'exploding_head'
  },
  {
    name: 'Egg',
    unified: '1F95A',
    keywords: [
      'food',
      'chicken',
      'breakfast'
    ],
    sheet: [41, 49],
    shortName: 'egg'
  },
  {
    name: 'Clipperton Island Flag',
    unified: '1F1E8-1F1F5',
    sheet: [1, 23],
    shortName: 'flag-cp'
  },
  {
    name: 'Bridge at Night',
    unified: '1F309',
    keywords: ['photo', 'sanfrancisco'],
    sheet: [5, 23],
    shortName: 'bridge_at_night'
  },
  {
    name: 'Cooking',
    unified: '1F373',
    keywords: [
      'food',
      'breakfast',
      'kitchen',
      'egg'
    ],
    sheet: [7, 11],
    shortNames: ['cooking'],
    shortName: 'fried_egg'
  },
  {
    name: 'Level Slider',
    unified: '1F39A-FE0F',
    keywords: ['scale'],
    sheet: [7, 52],
    shortName: 'level_slider'
  },
  {
    name: 'Crystal Ball',
    unified: '1F52E',
    keywords: [
      'disco',
      'party',
      'magic',
      'circus',
      'fortune_teller'
    ],
    sheet: [28, 16],
    shortName: 'crystal_ball'
  },
  {
    name: 'Six Pointed Star with Middle Dot',
    unified: '1F52F',
    keywords: [
      'purple-square',
      'religion',
      'jewish',
      'hexagram'
    ],
    sheet: [28, 17],
    shortName: 'six_pointed_star'
  },
  {
    name: 'Face with Cowboy Hat',
    unified: '1F920',
    sheet: [38, 16],
    shortName: 'face_with_cowboy_hat'
  },
  {
    name: 'Sloth',
    unified: '1F9A5',
    sheet: [43, 12],
    shortName: 'sloth'
  },
  {
    name: 'Bearded Person',
    unified: '1F9D4',
    keywords: ['person', 'bewhiskered'],
    sheet: [48, 55],
    skinVariations: [
      {
        unified: '1F9D4-1F3FB',
        sheet: [48, 56]
      },
      {
        unified: '1F9D4-1F3FC',
        sheet: [48, 57]
      },
      {
        unified: '1F9D4-1F3FD',
        sheet: [49, 0]
      },
      {
        unified: '1F9D4-1F3FE',
        sheet: [49, 1]
      },
      {
        unified: '1F9D4-1F3FF',
        sheet: [49, 2]
      }
    ],
    shortName: 'bearded_person'
  },
  {
    name: 'Costa Rica Flag',
    unified: '1F1E8-1F1F7',
    sheet: [1, 24],
    shortName: 'flag-cr'
  },
  {
    name: 'Control Knobs',
    unified: '1F39B-FE0F',
    keywords: ['dial'],
    sheet: [7, 53],
    shortName: 'control_knobs'
  },
  {
    name: 'Red Haired Man',
    unified: '1F468-200D-1F9B0',
    sheet: [16, 16],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F9B0',
        sheet: [16, 17]
      },
      {
        unified: '1F468-1F3FC-200D-1F9B0',
        sheet: [16, 18]
      },
      {
        unified: '1F468-1F3FD-200D-1F9B0',
        sheet: [16, 19]
      },
      {
        unified: '1F468-1F3FE-200D-1F9B0',
        sheet: [16, 20]
      },
      {
        unified: '1F468-1F3FF-200D-1F9B0',
        sheet: [16, 21]
      }
    ],
    shortName: 'red_haired_man'
  },
  {
    name: 'Shallow Pan of Food',
    unified: '1F958',
    keywords: [
      'food',
      'cooking',
      'casserole',
      'paella'
    ],
    sheet: [41, 47],
    shortName: 'shallow_pan_of_food'
  },
  {
    name: 'Face with Party Horn and Party Hat',
    unified: '1F973',
    sheet: [42, 16],
    shortName: 'partying_face'
  },
  {
    name: 'Otter',
    unified: '1F9A6',
    sheet: [43, 13],
    shortName: 'otter'
  },
  {
    name: 'Magic Wand',
    unified: '1FA84',
    sheet: [52, 29],
    shortName: 'magic_wand'
  },
  {
    name: 'Aries',
    unified: '2648',
    keywords: [
      'sign',
      'purple-square',
      'zodiac',
      'astrology'
    ],
    sheet: [54, 25],
    shortName: 'aries'
  },
  {
    name: 'Hot Springs',
    unified: '2668-FE0F',
    keywords: ['bath', 'warm', 'relax'],
    sheet: [54, 42],
    shortName: 'hotsprings'
  },
  {
    name: 'Cuba Flag',
    unified: '1F1E8-1F1FA',
    sheet: [1, 25],
    shortName: 'flag-cu'
  },
  {
    name: 'Pot of Food',
    unified: '1F372',
    keywords: ['food', 'meat', 'soup'],
    sheet: [7, 10],
    shortName: 'stew'
  },
  {
    name: 'Carousel Horse',
    unified: '1F3A0',
    keywords: ['photo', 'carnival'],
    sheet: [7, 56],
    shortName: 'carousel_horse'
  },
  {
    name: 'Microphone',
    unified: '1F3A4',
    keywords: [
      'sound',
      'music',
      'PA',
      'sing',
      'talkshow'
    ],
    sheet: [8, 2],
    shortName: 'microphone'
  },
  {
    name: 'Curly Haired Man',
    unified: '1F468-200D-1F9B1',
    sheet: [16, 22],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F9B1',
        sheet: [16, 23]
      },
      {
        unified: '1F468-1F3FC-200D-1F9B1',
        sheet: [16, 24]
      },
      {
        unified: '1F468-1F3FD-200D-1F9B1',
        sheet: [16, 25]
      },
      {
        unified: '1F468-1F3FE-200D-1F9B1',
        sheet: [16, 26]
      },
      {
        unified: '1F468-1F3FF-200D-1F9B1',
        sheet: [16, 27]
      }
    ],
    shortName: 'curly_haired_man'
  },
  {
    name: 'Disguised Face',
    unified: '1F978',
    sheet: [42, 26],
    shortName: 'disguised_face'
  },
  {
    name: 'Skunk',
    unified: '1F9A8',
    sheet: [43, 15],
    shortName: 'skunk'
  },
  {
    name: 'Nazar Amulet',
    unified: '1F9FF',
    keywords: ['bead', 'charm'],
    sheet: [52, 16],
    shortName: 'nazar_amulet'
  },
  {
    name: 'Taurus',
    unified: '2649',
    keywords: [
      'purple-square',
      'sign',
      'zodiac',
      'astrology'
    ],
    sheet: [54, 26],
    shortName: 'taurus'
  },
  {
    name: 'Cape Verde Flag',
    unified: '1F1E8-1F1FB',
    sheet: [1, 26],
    shortName: 'flag-cv'
  },
  {
    name: 'Ferris Wheel',
    unified: '1F3A1',
    keywords: [
      'photo',
      'carnival',
      'londoneye'
    ],
    sheet: [7, 57],
    shortName: 'ferris_wheel'
  },
  {
    name: 'Headphone',
    unified: '1F3A7',
    keywords: [
      'music',
      'score',
      'gadgets'
    ],
    sheet: [8, 5],
    shortName: 'headphones'
  },
  {
    name: 'Video Game',
    unified: '1F3AE',
    keywords: [
      'play',
      'console',
      'PS4',
      'controller'
    ],
    sheet: [8, 12],
    shortName: 'video_game'
  },
  {
    name: 'White Haired Man',
    unified: '1F468-200D-1F9B3',
    sheet: [16, 34],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F9B3',
        sheet: [16, 35]
      },
      {
        unified: '1F468-1F3FC-200D-1F9B3',
        sheet: [16, 36]
      },
      {
        unified: '1F468-1F3FD-200D-1F9B3',
        sheet: [16, 37]
      },
      {
        unified: '1F468-1F3FE-200D-1F9B3',
        sheet: [16, 38]
      },
      {
        unified: '1F468-1F3FF-200D-1F9B3',
        sheet: [16, 39]
      }
    ],
    shortName: 'white_haired_man'
  },
  {
    name: 'Smiling Face with Sunglasses',
    unified: '1F60E',
    emoticons: ['8)'],
    keywords: [
      'face',
      'cool',
      'smile',
      'summer',
      'beach',
      'sunglass'
    ],
    sheet: [30, 46],
    shortName: 'sunglasses'
  },
  {
    name: 'Kangaroo',
    unified: '1F998',
    keywords: [
      'animal',
      'nature',
      'australia',
      'joey',
      'hop',
      'marsupial'
    ],
    sheet: [42, 57],
    shortName: 'kangaroo'
  },
  {
    name: 'Fondue',
    unified: '1FAD5',
    sheet: [53, 14],
    shortName: 'fondue'
  },
  {
    name: 'Gemini',
    unified: '264A',
    keywords: [
      'sign',
      'zodiac',
      'purple-square',
      'astrology'
    ],
    sheet: [54, 27],
    shortName: 'gemini'
  },
  {
    name: 'Curaçao Flag',
    unified: '1F1E8-1F1FC',
    sheet: [1, 27],
    shortName: 'flag-cw'
  },
  {
    name: 'Roller Coaster',
    unified: '1F3A2',
    keywords: [
      'carnival',
      'playground',
      'photo',
      'fun'
    ],
    sheet: [8, 0],
    shortName: 'roller_coaster'
  },
  {
    name: 'Bald Man',
    unified: '1F468-200D-1F9B2',
    sheet: [16, 28],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F9B2',
        sheet: [16, 29]
      },
      {
        unified: '1F468-1F3FC-200D-1F9B2',
        sheet: [16, 30]
      },
      {
        unified: '1F468-1F3FD-200D-1F9B2',
        sheet: [16, 31]
      },
      {
        unified: '1F468-1F3FE-200D-1F9B2',
        sheet: [16, 32]
      },
      {
        unified: '1F468-1F3FF-200D-1F9B2',
        sheet: [16, 33]
      }
    ],
    shortName: 'bald_man'
  },
  {
    name: 'Radio',
    unified: '1F4FB',
    keywords: [
      'communication',
      'music',
      'podcast',
      'program'
    ],
    sheet: [27, 24],
    shortName: 'radio'
  },
  {
    name: 'Joystick',
    unified: '1F579-FE0F',
    keywords: ['game', 'play'],
    sheet: [29, 34],
    shortName: 'joystick'
  },
  {
    name: 'Nerd Face',
    unified: '1F913',
    keywords: [
      'face',
      'nerdy',
      'geek',
      'dork'
    ],
    sheet: [37, 26],
    shortName: 'nerd_face'
  },
  {
    name: 'Bowl with Spoon',
    unified: '1F963',
    keywords: [
      'food',
      'breakfast',
      'cereal',
      'oatmeal',
      'porridge'
    ],
    sheet: [42, 0],
    shortName: 'bowl_with_spoon'
  },
  {
    name: 'Badger',
    unified: '1F9A1',
    keywords: [
      'animal',
      'nature',
      'honey'
    ],
    sheet: [43, 8],
    shortName: 'badger'
  },
  {
    name: 'Cancer',
    unified: '264B',
    keywords: [
      'sign',
      'zodiac',
      'purple-square',
      'astrology'
    ],
    sheet: [54, 28],
    shortName: 'cancer'
  },
  {
    name: 'Christmas Island Flag',
    unified: '1F1E8-1F1FD',
    sheet: [1, 28],
    shortName: 'flag-cx'
  },
  {
    name: 'Slot Machine',
    unified: '1F3B0',
    keywords: [
      'bet',
      'gamble',
      'vegas',
      'fruit machine',
      'luck',
      'casino'
    ],
    sheet: [8, 14],
    shortName: 'slot_machine'
  },
  {
    name: 'Saxophone',
    unified: '1F3B7',
    keywords: [
      'music',
      'instrument',
      'jazz',
      'blues'
    ],
    sheet: [8, 21],
    shortName: 'saxophone'
  },
  {
    name: 'Paw Prints',
    unified: '1F43E',
    sheet: [12, 25],
    shortNames: ['paw_prints'],
    shortName: 'feet'
  },
  {
    name: 'Woman',
    unified: '1F469',
    keywords: [
      'female',
      'girls',
      'lady'
    ],
    sheet: [20, 4],
    skinVariations: [
      {
        unified: '1F469-1F3FB',
        sheet: [20, 5]
      },
      {
        unified: '1F469-1F3FC',
        sheet: [20, 6]
      },
      {
        unified: '1F469-1F3FD',
        sheet: [20, 7]
      },
      {
        unified: '1F469-1F3FE',
        sheet: [20, 8]
      },
      {
        unified: '1F469-1F3FF',
        sheet: [20, 9]
      }
    ],
    shortName: 'woman'
  },
  {
    name: 'Barber Pole',
    unified: '1F488',
    keywords: [
      'hair',
      'salon',
      'style'
    ],
    sheet: [25, 20],
    shortName: 'barber'
  },
  {
    name: 'Green Salad',
    unified: '1F957',
    keywords: [
      'food',
      'healthy',
      'lettuce'
    ],
    sheet: [41, 46],
    shortName: 'green_salad'
  },
  {
    name: 'Face with Monocle',
    unified: '1F9D0',
    sheet: [45, 34],
    shortName: 'face_with_monocle'
  },
  {
    name: 'Leo',
    unified: '264C',
    keywords: [
      'sign',
      'purple-square',
      'zodiac',
      'astrology'
    ],
    sheet: [54, 29],
    shortName: 'leo'
  },
  {
    name: 'Cyprus Flag',
    unified: '1F1E8-1F1FE',
    sheet: [1, 29],
    shortName: 'flag-cy'
  },
  {
    name: 'Popcorn',
    unified: '1F37F',
    keywords: [
      'food',
      'movie theater',
      'films',
      'snack'
    ],
    sheet: [7, 23],
    shortName: 'popcorn'
  },
  {
    name: 'Circus Tent',
    unified: '1F3AA',
    keywords: [
      'festival',
      'carnival',
      'party'
    ],
    sheet: [8, 8],
    shortName: 'circus_tent'
  },
  {
    name: 'Game Die',
    unified: '1F3B2',
    keywords: [
      'dice',
      'random',
      'tabletop',
      'play',
      'luck'
    ],
    sheet: [8, 16],
    shortName: 'game_die'
  },
  {
    name: 'Red Haired Woman',
    unified: '1F469-200D-1F9B0',
    sheet: [19, 4],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F9B0',
        sheet: [19, 5]
      },
      {
        unified: '1F469-1F3FC-200D-1F9B0',
        sheet: [19, 6]
      },
      {
        unified: '1F469-1F3FD-200D-1F9B0',
        sheet: [19, 7]
      },
      {
        unified: '1F469-1F3FE-200D-1F9B0',
        sheet: [19, 8]
      },
      {
        unified: '1F469-1F3FF-200D-1F9B0',
        sheet: [19, 9]
      }
    ],
    shortName: 'red_haired_woman'
  },
  {
    name: 'Confused Face',
    unified: '1F615',
    emoticons: [
      ':\\',
      ':-\\',
      ':/',
      ':-/'
    ],
    keywords: [
      'face',
      'indifference',
      'huh',
      'weird',
      'hmmm',
      ':/'
    ],
    sheet: [30, 53],
    shortName: 'confused'
  },
  {
    name: 'Turkey',
    unified: '1F983',
    keywords: ['animal', 'bird'],
    sheet: [42, 36],
    shortName: 'turkey'
  },
  {
    name: 'Accordion',
    unified: '1FA97',
    sheet: [52, 39],
    shortName: 'accordion'
  },
  {
    name: 'Virgo',
    unified: '264D',
    keywords: [
      'sign',
      'zodiac',
      'purple-square',
      'astrology'
    ],
    sheet: [54, 30],
    shortName: 'virgo'
  },
  {
    name: 'Czechia Flag',
    unified: '1F1E8-1F1FF',
    sheet: [1, 30],
    shortName: 'flag-cz'
  },
  {
    name: 'Guitar',
    unified: '1F3B8',
    keywords: ['music', 'instrument'],
    sheet: [8, 22],
    shortName: 'guitar'
  },
  {
    name: 'Chicken',
    unified: '1F414',
    keywords: [
      'animal',
      'cluck',
      'nature',
      'bird'
    ],
    sheet: [11, 39],
    shortName: 'chicken'
  },
  {
    name: 'Worried Face',
    unified: '1F61F',
    keywords: [
      'face',
      'concern',
      'nervous',
      ':('
    ],
    sheet: [31, 5],
    shortName: 'worried'
  },
  {
    name: 'Steam Locomotive',
    unified: '1F682',
    keywords: [
      'transportation',
      'vehicle',
      'train'
    ],
    sheet: [33, 52],
    shortName: 'steam_locomotive'
  },
  {
    name: 'Butter',
    unified: '1F9C8',
    sheet: [44, 34],
    shortName: 'butter'
  },
  {
    name: 'Red Haired Person',
    unified: '1F9D1-200D-1F9B0',
    sheet: [47, 41],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F9B0',
        sheet: [47, 42]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F9B0',
        sheet: [47, 43]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F9B0',
        sheet: [47, 44]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F9B0',
        sheet: [47, 45]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F9B0',
        sheet: [47, 46]
      }
    ],
    shortName: 'red_haired_person'
  },
  {
    name: 'Jigsaw Puzzle Piece',
    unified: '1F9E9',
    keywords: [
      'interlocking',
      'puzzle',
      'piece'
    ],
    sheet: [51, 52],
    shortName: 'jigsaw'
  },
  {
    name: 'Libra',
    unified: '264E',
    keywords: [
      'sign',
      'purple-square',
      'zodiac',
      'astrology'
    ],
    sheet: [54, 31],
    shortName: 'libra'
  },
  {
    name: 'Germany Flag',
    unified: '1F1E9-1F1EA',
    keywords: [
      'german',
      'nation',
      'flag',
      'country',
      'banner'
    ],
    sheet: [1, 31],
    shortNames: ['flag-de'],
    shortName: 'de'
  },
  {
    name: 'Musical Keyboard',
    unified: '1F3B9',
    keywords: [
      'piano',
      'instrument',
      'compose'
    ],
    sheet: [8, 23],
    shortName: 'musical_keyboard'
  },
  {
    name: 'Rooster',
    unified: '1F413',
    keywords: [
      'animal',
      'nature',
      'chicken'
    ],
    sheet: [11, 38],
    shortName: 'rooster'
  },
  {
    name: 'Curly Haired Woman',
    unified: '1F469-200D-1F9B1',
    sheet: [19, 10],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F9B1',
        sheet: [19, 11]
      },
      {
        unified: '1F469-1F3FC-200D-1F9B1',
        sheet: [19, 12]
      },
      {
        unified: '1F469-1F3FD-200D-1F9B1',
        sheet: [19, 13]
      },
      {
        unified: '1F469-1F3FE-200D-1F9B1',
        sheet: [19, 14]
      },
      {
        unified: '1F469-1F3FF-200D-1F9B1',
        sheet: [19, 15]
      }
    ],
    shortName: 'curly_haired_woman'
  },
  {
    name: 'Slightly Frowning Face',
    unified: '1F641',
    keywords: [
      'face',
      'frowning',
      'disappointed',
      'sad',
      'upset'
    ],
    sheet: [31, 39],
    shortName: 'slightly_frowning_face'
  },
  {
    name: 'Railway Car',
    unified: '1F683',
    keywords: [
      'transportation',
      'vehicle'
    ],
    sheet: [33, 53],
    shortName: 'railway_car'
  },
  {
    name: 'Salt Shaker',
    unified: '1F9C2',
    keywords: ['condiment', 'shaker'],
    sheet: [44, 28],
    shortName: 'salt'
  },
  {
    name: 'Teddy Bear',
    unified: '1F9F8',
    keywords: ['plush', 'stuffed'],
    sheet: [52, 9],
    shortName: 'teddy_bear'
  },
  {
    name: 'Scorpius',
    unified: '264F',
    keywords: [
      'sign',
      'zodiac',
      'purple-square',
      'astrology',
      'scorpio'
    ],
    sheet: [54, 32],
    shortName: 'scorpius'
  },
  {
    name: 'Diego Garcia Flag',
    unified: '1F1E9-1F1EC',
    sheet: [1, 32],
    shortName: 'flag-dg'
  },
  {
    name: 'Trumpet',
    unified: '1F3BA',
    keywords: ['music', 'brass'],
    sheet: [8, 24],
    shortName: 'trumpet'
  },
  {
    name: 'Hatching Chick',
    unified: '1F423',
    keywords: [
      'animal',
      'chicken',
      'egg',
      'born',
      'baby',
      'bird'
    ],
    sheet: [11, 55],
    shortName: 'hatching_chick'
  },
  {
    name: 'High-Speed Train',
    unified: '1F684',
    keywords: [
      'transportation',
      'vehicle'
    ],
    sheet: [33, 54],
    shortName: 'bullettrain_side'
  },
  {
    name: 'Canned Food',
    unified: '1F96B',
    keywords: ['food', 'soup'],
    sheet: [42, 8],
    shortName: 'canned_food'
  },
  {
    name: 'Curly Haired Person',
    unified: '1F9D1-200D-1F9B1',
    sheet: [47, 47],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F9B1',
        sheet: [47, 48]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F9B1',
        sheet: [47, 49]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F9B1',
        sheet: [47, 50]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F9B1',
        sheet: [47, 51]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F9B1',
        sheet: [47, 52]
      }
    ],
    shortName: 'curly_haired_person'
  },
  {
    name: 'Pinata',
    unified: '1FA85',
    sheet: [52, 30],
    shortName: 'pinata'
  },
  {
    name: 'White Frowning Face',
    unified: '2639-FE0F',
    sheet: [54, 21],
    shortName: 'white_frowning_face'
  },
  {
    name: 'Sagittarius',
    unified: '2650',
    keywords: [
      'sign',
      'zodiac',
      'purple-square',
      'astrology'
    ],
    sheet: [54, 33],
    shortName: 'sagittarius'
  },
  {
    name: 'Djibouti Flag',
    unified: '1F1E9-1F1EF',
    sheet: [1, 33],
    shortName: 'flag-dj'
  },
  {
    name: 'Bento Box',
    unified: '1F371',
    keywords: [
      'food',
      'japanese',
      'box'
    ],
    sheet: [7, 9],
    shortName: 'bento'
  },
  {
    name: 'Violin',
    unified: '1F3BB',
    keywords: [
      'music',
      'instrument',
      'orchestra',
      'symphony'
    ],
    sheet: [8, 25],
    shortName: 'violin'
  },
  {
    name: 'Baby Chick',
    unified: '1F424',
    keywords: [
      'animal',
      'chicken',
      'bird'
    ],
    sheet: [11, 56],
    shortName: 'baby_chick'
  },
  {
    name: 'White Haired Woman',
    unified: '1F469-200D-1F9B3',
    sheet: [19, 22],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F9B3',
        sheet: [19, 23]
      },
      {
        unified: '1F469-1F3FC-200D-1F9B3',
        sheet: [19, 24]
      },
      {
        unified: '1F469-1F3FD-200D-1F9B3',
        sheet: [19, 25]
      },
      {
        unified: '1F469-1F3FE-200D-1F9B3',
        sheet: [19, 26]
      },
      {
        unified: '1F469-1F3FF-200D-1F9B3',
        sheet: [19, 27]
      }
    ],
    shortName: 'white_haired_woman'
  },
  {
    name: 'Face with Open Mouth',
    unified: '1F62E',
    emoticons: [
      ':o',
      ':-o',
      ':O',
      ':-O'
    ],
    keywords: [
      'face',
      'surprise',
      'impressed',
      'wow',
      'whoa',
      ':O'
    ],
    sheet: [31, 20],
    shortName: 'open_mouth'
  },
  {
    name: 'High-Speed Train with Bullet Nose',
    unified: '1F685',
    keywords: [
      'transportation',
      'vehicle',
      'speed',
      'fast',
      'public',
      'travel'
    ],
    sheet: [33, 55],
    shortName: 'bullettrain_front'
  },
  {
    name: 'Nesting Dolls',
    unified: '1FA86',
    sheet: [52, 31],
    shortName: 'nesting_dolls'
  },
  {
    name: 'Capricorn',
    unified: '2651',
    keywords: [
      'sign',
      'zodiac',
      'purple-square',
      'astrology'
    ],
    sheet: [54, 34],
    shortName: 'capricorn'
  },
  {
    name: 'Denmark Flag',
    unified: '1F1E9-1F1F0',
    sheet: [1, 34],
    shortName: 'flag-dk'
  },
  {
    name: 'Rice Cracker',
    unified: '1F358',
    keywords: ['food', 'japanese'],
    sheet: [6, 42],
    shortName: 'rice_cracker'
  },
  {
    name: 'Front-Facing Baby Chick',
    unified: '1F425',
    keywords: [
      'animal',
      'chicken',
      'baby',
      'bird'
    ],
    sheet: [11, 57],
    shortName: 'hatched_chick'
  },
  {
    name: 'Hushed Face',
    unified: '1F62F',
    keywords: ['face', 'woo', 'shh'],
    sheet: [31, 21],
    shortName: 'hushed'
  },
  {
    name: 'Train',
    unified: '1F686',
    keywords: [
      'transportation',
      'vehicle'
    ],
    sheet: [33, 56],
    shortName: 'train2'
  },
  {
    name: 'White Haired Person',
    unified: '1F9D1-200D-1F9B3',
    sheet: [48, 1],
    hidden: ['facebook'],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F9B3',
        sheet: [48, 2],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FC-200D-1F9B3',
        sheet: [48, 3],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FD-200D-1F9B3',
        sheet: [48, 4],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FE-200D-1F9B3',
        sheet: [48, 5],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FF-200D-1F9B3',
        sheet: [48, 6],
        hidden: ['facebook']
      }
    ],
    shortName: 'white_haired_person'
  },
  {
    name: 'Banjo',
    unified: '1FA95',
    sheet: [52, 37],
    shortName: 'banjo'
  },
  {
    name: 'Aquarius',
    unified: '2652',
    keywords: [
      'sign',
      'purple-square',
      'zodiac',
      'astrology'
    ],
    sheet: [54, 35],
    shortName: 'aquarius'
  },
  {
    name: 'Black Spade Suit',
    unified: '2660-FE0F',
    keywords: [
      'poker',
      'cards',
      'suits',
      'magic'
    ],
    sheet: [54, 38],
    shortName: 'spades'
  },
  {
    name: 'Dominica Flag',
    unified: '1F1E9-1F1F2',
    sheet: [1, 35],
    shortName: 'flag-dm'
  },
  {
    name: 'Rice Ball',
    unified: '1F359',
    keywords: ['food', 'japanese'],
    sheet: [6, 43],
    shortName: 'rice_ball'
  },
  {
    name: 'Bird',
    unified: '1F426',
    keywords: [
      'animal',
      'nature',
      'fly',
      'tweet',
      'spring'
    ],
    sheet: [12, 0],
    shortName: 'bird'
  },
  {
    name: 'Bald Woman',
    unified: '1F469-200D-1F9B2',
    sheet: [19, 16],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F9B2',
        sheet: [19, 17]
      },
      {
        unified: '1F469-1F3FC-200D-1F9B2',
        sheet: [19, 18]
      },
      {
        unified: '1F469-1F3FD-200D-1F9B2',
        sheet: [19, 19]
      },
      {
        unified: '1F469-1F3FE-200D-1F9B2',
        sheet: [19, 20]
      },
      {
        unified: '1F469-1F3FF-200D-1F9B2',
        sheet: [19, 21]
      }
    ],
    shortName: 'bald_woman'
  },
  {
    name: 'Astonished Face',
    unified: '1F632',
    keywords: [
      'face',
      'xox',
      'surprised',
      'poisoned'
    ],
    sheet: [31, 24],
    shortName: 'astonished'
  },
  {
    name: 'Metro',
    unified: '1F687',
    keywords: [
      'transportation',
      'blue-square',
      'mrt',
      'underground',
      'tube'
    ],
    sheet: [33, 57],
    shortName: 'metro'
  },
  {
    name: 'Drum with Drumsticks',
    unified: '1F941',
    sheet: [41, 25],
    shortName: 'drum_with_drumsticks'
  },
  {
    name: 'Pisces',
    unified: '2653',
    keywords: [
      'purple-square',
      'sign',
      'zodiac',
      'astrology'
    ],
    sheet: [54, 36],
    shortName: 'pisces'
  },
  {
    name: 'Black Heart Suit',
    unified: '2665-FE0F',
    keywords: [
      'poker',
      'cards',
      'magic',
      'suits'
    ],
    sheet: [54, 40],
    shortName: 'hearts'
  },
  {
    name: 'Dominican Republic Flag',
    unified: '1F1E9-1F1F4',
    sheet: [1, 36],
    shortName: 'flag-do'
  },
  {
    name: 'Cooked Rice',
    unified: '1F35A',
    keywords: [
      'food',
      'china',
      'asian'
    ],
    sheet: [6, 44],
    shortName: 'rice'
  },
  {
    name: 'Penguin',
    unified: '1F427',
    keywords: ['animal', 'nature'],
    sheet: [12, 1],
    shortName: 'penguin'
  },
  {
    name: 'Flushed Face',
    unified: '1F633',
    keywords: [
      'face',
      'blush',
      'shy',
      'flattered'
    ],
    sheet: [31, 25],
    shortName: 'flushed'
  },
  {
    name: 'Light Rail',
    unified: '1F688',
    keywords: [
      'transportation',
      'vehicle'
    ],
    sheet: [34, 0],
    shortName: 'light_rail'
  },
  {
    name: 'Bald Person',
    unified: '1F9D1-200D-1F9B2',
    sheet: [47, 53],
    hidden: ['facebook'],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F9B2',
        sheet: [47, 54],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FC-200D-1F9B2',
        sheet: [47, 55],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FD-200D-1F9B2',
        sheet: [47, 56],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FE-200D-1F9B2',
        sheet: [47, 57],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FF-200D-1F9B2',
        sheet: [48, 0],
        hidden: ['facebook']
      }
    ],
    shortName: 'bald_person'
  },
  {
    name: 'Long Drum',
    unified: '1FA98',
    sheet: [52, 40],
    shortName: 'long_drum'
  },
  {
    name: 'Black Diamond Suit',
    unified: '2666-FE0F',
    keywords: [
      'poker',
      'cards',
      'magic',
      'suits'
    ],
    sheet: [54, 41],
    shortName: 'diamonds'
  },
  {
    name: 'Ophiuchus',
    unified: '26CE',
    keywords: [
      'sign',
      'purple-square',
      'constellation',
      'astrology'
    ],
    sheet: [55, 9],
    shortName: 'ophiuchus'
  },
  {
    name: 'Algeria Flag',
    unified: '1F1E9-1F1FF',
    sheet: [1, 37],
    shortName: 'flag-dz'
  },
  {
    name: 'Curry and Rice',
    unified: '1F35B',
    keywords: [
      'food',
      'spicy',
      'hot',
      'indian'
    ],
    sheet: [6, 45],
    shortName: 'curry'
  },
  {
    name: 'Blond Haired Woman',
    unified: '1F471-200D-2640-FE0F',
    sheet: [22, 12],
    skinVariations: [
      {
        unified: '1F471-1F3FB-200D-2640-FE0F',
        sheet: [22, 13]
      },
      {
        unified: '1F471-1F3FC-200D-2640-FE0F',
        sheet: [22, 14]
      },
      {
        unified: '1F471-1F3FD-200D-2640-FE0F',
        sheet: [22, 15]
      },
      {
        unified: '1F471-1F3FE-200D-2640-FE0F',
        sheet: [22, 16]
      },
      {
        unified: '1F471-1F3FF-200D-2640-FE0F',
        sheet: [22, 17]
      }
    ],
    shortName: 'blond-haired-woman'
  },
  {
    name: 'Mobile Phone',
    unified: '1F4F1',
    keywords: [
      'technology',
      'apple',
      'gadgets',
      'dial'
    ],
    sheet: [27, 14],
    shortName: 'iphone'
  },
  {
    name: 'Twisted Rightwards Arrows',
    unified: '1F500',
    keywords: [
      'blue-square',
      'shuffle',
      'music',
      'random'
    ],
    sheet: [27, 28],
    shortName: 'twisted_rightwards_arrows'
  },
  {
    name: 'Dove of Peace',
    unified: '1F54A-FE0F',
    sheet: [28, 33],
    shortName: 'dove_of_peace'
  },
  {
    name: 'Station',
    unified: '1F689',
    keywords: [
      'transportation',
      'vehicle',
      'public'
    ],
    sheet: [34, 1],
    shortName: 'station'
  },
  {
    name: 'Face with Pleading Eyes',
    unified: '1F97A',
    sheet: [42, 27],
    shortName: 'pleading_face'
  },
  {
    name: 'Black Club Suit',
    unified: '2663-FE0F',
    keywords: [
      'poker',
      'cards',
      'magic',
      'suits'
    ],
    sheet: [54, 39],
    shortName: 'clubs'
  },
  {
    name: 'Ceuta & Melilla Flag',
    unified: '1F1EA-1F1E6',
    sheet: [1, 38],
    shortName: 'flag-ea'
  },
  {
    name: 'Steaming Bowl',
    unified: '1F35C',
    keywords: [
      'food',
      'japanese',
      'noodle',
      'chopsticks'
    ],
    sheet: [6, 46],
    shortName: 'ramen'
  },
  {
    name: 'Blond Haired Man',
    unified: '1F471-200D-2642-FE0F',
    obsoletes: '1F471',
    sheet: [22, 18],
    skinVariations: [
      {
        unified: '1F471-1F3FB-200D-2642-FE0F',
        sheet: [22, 19]
      },
      {
        unified: '1F471-1F3FC-200D-2642-FE0F',
        sheet: [22, 20]
      },
      {
        unified: '1F471-1F3FD-200D-2642-FE0F',
        sheet: [22, 21]
      },
      {
        unified: '1F471-1F3FE-200D-2642-FE0F',
        sheet: [22, 22]
      },
      {
        unified: '1F471-1F3FF-200D-2642-FE0F',
        sheet: [22, 23]
      }
    ],
    shortName: 'blond-haired-man'
  },
  {
    name: 'Mobile Phone with Rightwards Arrow at Left',
    unified: '1F4F2',
    keywords: ['iphone', 'incoming'],
    sheet: [27, 15],
    shortName: 'calling'
  },
  {
    name: 'Clockwise Rightwards and Leftwards Open Circle Arrows',
    unified: '1F501',
    keywords: ['loop', 'record'],
    sheet: [27, 29],
    shortName: 'repeat'
  },
  {
    name: 'Frowning Face with Open Mouth',
    unified: '1F626',
    keywords: ['face', 'aw', 'what'],
    sheet: [31, 12],
    shortName: 'frowning'
  },
  {
    name: 'Tram',
    unified: '1F68A',
    keywords: [
      'transportation',
      'vehicle'
    ],
    sheet: [34, 2],
    shortName: 'tram'
  },
  {
    name: 'Eagle',
    unified: '1F985',
    keywords: [
      'animal',
      'nature',
      'bird'
    ],
    sheet: [42, 38],
    shortName: 'eagle'
  },
  {
    name: 'Chess Pawn',
    unified: '265F-FE0F',
    keywords: ['expendable'],
    sheet: [54, 37],
    shortName: 'chess_pawn'
  },
  {
    name: 'Playing Card Black Joker',
    unified: '1F0CF',
    keywords: [
      'poker',
      'cards',
      'game',
      'play',
      'magic'
    ],
    sheet: [0, 15],
    shortName: 'black_joker'
  },
  {
    name: 'Ecuador Flag',
    unified: '1F1EA-1F1E8',
    sheet: [1, 39],
    shortName: 'flag-ec'
  },
  {
    name: 'Spaghetti',
    unified: '1F35D',
    keywords: [
      'food',
      'italian',
      'noodle'
    ],
    sheet: [6, 47],
    shortName: 'spaghetti'
  },
  {
    name: 'Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay',
    unified: '1F502',
    keywords: ['blue-square', 'loop'],
    sheet: [27, 30],
    shortName: 'repeat_one'
  },
  {
    name: 'Anguished Face',
    unified: '1F627',
    emoticons: ['D:'],
    keywords: [
      'face',
      'stunned',
      'nervous'
    ],
    sheet: [31, 13],
    shortName: 'anguished'
  },
  {
    name: 'Monorail',
    unified: '1F69D',
    keywords: [
      'transportation',
      'vehicle'
    ],
    sheet: [34, 21],
    shortName: 'monorail'
  },
  {
    name: 'Duck',
    unified: '1F986',
    keywords: [
      'animal',
      'nature',
      'bird',
      'mallard'
    ],
    sheet: [42, 39],
    shortName: 'duck'
  },
  {
    name: 'Older Adult',
    unified: '1F9D3',
    keywords: [
      'human',
      'elder',
      'senior',
      'gender-neutral'
    ],
    sheet: [48, 49],
    skinVariations: [
      {
        unified: '1F9D3-1F3FB',
        sheet: [48, 50]
      },
      {
        unified: '1F9D3-1F3FC',
        sheet: [48, 51]
      },
      {
        unified: '1F9D3-1F3FD',
        sheet: [48, 52]
      },
      {
        unified: '1F9D3-1F3FE',
        sheet: [48, 53]
      },
      {
        unified: '1F9D3-1F3FF',
        sheet: [48, 54]
      }
    ],
    shortName: 'older_adult'
  },
  {
    name: 'Black Telephone',
    unified: '260E-FE0F',
    keywords: [
      'technology',
      'communication',
      'dial',
      'telephone'
    ],
    sheet: [54, 2],
    shortNames: ['telephone'],
    shortName: 'phone'
  },
  {
    name: 'Mahjong Tile Red Dragon',
    unified: '1F004',
    keywords: [
      'game',
      'play',
      'chinese',
      'kanji'
    ],
    sheet: [0, 14],
    shortName: 'mahjong'
  },
  {
    name: 'Estonia Flag',
    unified: '1F1EA-1F1EA',
    sheet: [1, 40],
    shortName: 'flag-ee'
  },
  {
    name: 'Roasted Sweet Potato',
    unified: '1F360',
    keywords: ['food', 'nature'],
    sheet: [6, 50],
    shortName: 'sweet_potato'
  },
  {
    name: 'Older Man',
    unified: '1F474',
    keywords: [
      'human',
      'male',
      'men',
      'old',
      'elder',
      'senior'
    ],
    sheet: [22, 54],
    skinVariations: [
      {
        unified: '1F474-1F3FB',
        sheet: [22, 55]
      },
      {
        unified: '1F474-1F3FC',
        sheet: [22, 56]
      },
      {
        unified: '1F474-1F3FD',
        sheet: [22, 57]
      },
      {
        unified: '1F474-1F3FE',
        sheet: [23, 0]
      },
      {
        unified: '1F474-1F3FF',
        sheet: [23, 1]
      }
    ],
    shortName: 'older_man'
  },
  {
    name: 'Telephone Receiver',
    unified: '1F4DE',
    keywords: [
      'technology',
      'communication',
      'dial'
    ],
    sheet: [26, 53],
    shortName: 'telephone_receiver'
  },
  {
    name: 'Fearful Face',
    unified: '1F628',
    keywords: [
      'face',
      'scared',
      'terrified',
      'nervous',
      'oops',
      'huh'
    ],
    sheet: [31, 14],
    shortName: 'fearful'
  },
  {
    name: 'Mountain Railway',
    unified: '1F69E',
    keywords: [
      'transportation',
      'vehicle'
    ],
    sheet: [34, 22],
    shortName: 'mountain_railway'
  },
  {
    name: 'Swan',
    unified: '1F9A2',
    keywords: [
      'animal',
      'nature',
      'bird'
    ],
    sheet: [43, 9],
    shortName: 'swan'
  },
  {
    name: 'Black Right-Pointing Triangle',
    unified: '25B6-FE0F',
    keywords: [
      'blue-square',
      'right',
      'direction',
      'play'
    ],
    sheet: [53, 49],
    shortName: 'arrow_forward'
  },
  {
    name: 'Egypt Flag',
    unified: '1F1EA-1F1EC',
    sheet: [1, 41],
    shortName: 'flag-eg'
  },
  {
    name: 'Oden',
    unified: '1F362',
    keywords: ['food', 'japanese'],
    sheet: [6, 52],
    shortName: 'oden'
  },
  {
    name: 'Flower Playing Cards',
    unified: '1F3B4',
    keywords: ['game', 'sunset', 'red'],
    sheet: [8, 18],
    shortName: 'flower_playing_cards'
  },
  {
    name: 'Older Woman',
    unified: '1F475',
    keywords: [
      'human',
      'female',
      'women',
      'lady',
      'old',
      'elder',
      'senior'
    ],
    sheet: [23, 2],
    skinVariations: [
      {
        unified: '1F475-1F3FB',
        sheet: [23, 3]
      },
      {
        unified: '1F475-1F3FC',
        sheet: [23, 4]
      },
      {
        unified: '1F475-1F3FD',
        sheet: [23, 5]
      },
      {
        unified: '1F475-1F3FE',
        sheet: [23, 6]
      },
      {
        unified: '1F475-1F3FF',
        sheet: [23, 7]
      }
    ],
    shortName: 'older_woman'
  },
  {
    name: 'Pager',
    unified: '1F4DF',
    keywords: [
      'bbcall',
      'oldschool',
      '90s'
    ],
    sheet: [26, 54],
    shortName: 'pager'
  },
  {
    name: 'Face with Open Mouth and Cold Sweat',
    unified: '1F630',
    keywords: [
      'face',
      'nervous',
      'sweat'
    ],
    sheet: [31, 22],
    shortName: 'cold_sweat'
  },
  {
    name: 'Tram Car',
    unified: '1F68B',
    keywords: [
      'transportation',
      'vehicle',
      'carriage',
      'public',
      'travel'
    ],
    sheet: [34, 3],
    shortName: 'train'
  },
  {
    name: 'Owl',
    unified: '1F989',
    keywords: [
      'animal',
      'nature',
      'bird',
      'hoot'
    ],
    sheet: [42, 42],
    shortName: 'owl'
  },
  {
    name: 'Black Right-Pointing Double Triangle',
    unified: '23E9',
    keywords: [
      'blue-square',
      'play',
      'speed',
      'continue'
    ],
    sheet: [53, 32],
    shortName: 'fast_forward'
  },
  {
    name: 'Western Sahara Flag',
    unified: '1F1EA-1F1ED',
    sheet: [1, 42],
    shortName: 'flag-eh'
  },
  {
    name: 'Sushi',
    unified: '1F363',
    keywords: [
      'food',
      'fish',
      'japanese',
      'rice'
    ],
    sheet: [6, 53],
    shortName: 'sushi'
  },
  {
    name: 'Performing Arts',
    unified: '1F3AD',
    keywords: [
      'acting',
      'theater',
      'drama'
    ],
    sheet: [8, 11],
    shortName: 'performing_arts'
  },
  {
    name: 'Fax Machine',
    unified: '1F4E0',
    keywords: [
      'communication',
      'technology'
    ],
    sheet: [26, 55],
    shortName: 'fax'
  },
  {
    name: 'Disappointed but Relieved Face',
    unified: '1F625',
    keywords: [
      'face',
      'phew',
      'sweat',
      'nervous'
    ],
    sheet: [31, 11],
    shortName: 'disappointed_relieved'
  },
  {
    name: 'Person Frowning',
    unified: '1F64D',
    sheet: [33, 20],
    skinVariations: [
      {
        unified: '1F64D-1F3FB',
        sheet: [33, 21]
      },
      {
        unified: '1F64D-1F3FC',
        sheet: [33, 22]
      },
      {
        unified: '1F64D-1F3FD',
        sheet: [33, 23]
      },
      {
        unified: '1F64D-1F3FE',
        sheet: [33, 24]
      },
      {
        unified: '1F64D-1F3FF',
        sheet: [33, 25]
      }
    ],
    shortName: 'person_frowning',
    obsoletedBy: '1F64D-200D-2640-FE0F'
  },
  {
    name: 'Bus',
    unified: '1F68C',
    keywords: [
      'car',
      'vehicle',
      'transportation'
    ],
    sheet: [34, 4],
    shortName: 'bus'
  },
  {
    name: 'Dodo',
    unified: '1F9A4',
    sheet: [43, 11],
    shortName: 'dodo'
  },
  {
    name: 'Black Right Pointing Double Triangle with Vertical Bar',
    unified: '23ED-FE0F',
    sheet: [53, 36],
    shortName: 'black_right_pointing_double_triangle_with_vertical_bar'
  },
  {
    name: 'Eritrea Flag',
    unified: '1F1EA-1F1F7',
    sheet: [1, 43],
    shortName: 'flag-er'
  },
  {
    name: 'Fried Shrimp',
    unified: '1F364',
    keywords: [
      'food',
      'animal',
      'appetizer',
      'summer'
    ],
    sheet: [6, 54],
    shortName: 'fried_shrimp'
  },
  {
    name: 'Battery',
    unified: '1F50B',
    keywords: [
      'power',
      'energy',
      'sustain'
    ],
    sheet: [27, 39],
    shortName: 'battery'
  },
  {
    name: 'Frame with Picture',
    unified: '1F5BC-FE0F',
    sheet: [30, 11],
    shortName: 'frame_with_picture'
  },
  {
    name: 'Crying Face',
    unified: '1F622',
    text: ':\'(',
    emoticons: [':\'('],
    keywords: [
      'face',
      'tears',
      'sad',
      'depressed',
      'upset',
      ':\'('
    ],
    sheet: [31, 8],
    shortName: 'cry'
  },
  {
    name: 'Man Frowning',
    unified: '1F64D-200D-2642-FE0F',
    sheet: [33, 14],
    skinVariations: [
      {
        unified: '1F64D-1F3FB-200D-2642-FE0F',
        sheet: [33, 15]
      },
      {
        unified: '1F64D-1F3FC-200D-2642-FE0F',
        sheet: [33, 16]
      },
      {
        unified: '1F64D-1F3FD-200D-2642-FE0F',
        sheet: [33, 17]
      },
      {
        unified: '1F64D-1F3FE-200D-2642-FE0F',
        sheet: [33, 18]
      },
      {
        unified: '1F64D-1F3FF-200D-2642-FE0F',
        sheet: [33, 19]
      }
    ],
    shortName: 'man-frowning'
  },
  {
    name: 'Oncoming Bus',
    unified: '1F68D',
    keywords: [
      'vehicle',
      'transportation'
    ],
    sheet: [34, 5],
    shortName: 'oncoming_bus'
  },
  {
    name: 'Feather',
    unified: '1FAB6',
    sheet: [53, 5],
    shortName: 'feather'
  },
  {
    name: 'Black Right Pointing Triangle with Double Vertical Bar',
    unified: '23EF-FE0F',
    sheet: [53, 38],
    shortName: 'black_right_pointing_triangle_with_double_vertical_bar'
  },
  {
    name: 'Spain Flag',
    unified: '1F1EA-1F1F8',
    keywords: [
      'spain',
      'flag',
      'nation',
      'country',
      'banner'
    ],
    sheet: [1, 44],
    shortNames: ['flag-es'],
    shortName: 'es'
  },
  {
    name: 'Fish Cake with Swirl Design',
    unified: '1F365',
    keywords: [
      'food',
      'japan',
      'sea',
      'beach',
      'narutomaki',
      'pink',
      'swirl',
      'kamaboko',
      'surimi',
      'ramen'
    ],
    sheet: [6, 55],
    shortName: 'fish_cake'
  },
  {
    name: 'Artist Palette',
    unified: '1F3A8',
    keywords: [
      'design',
      'paint',
      'draw',
      'colors'
    ],
    sheet: [8, 6],
    shortName: 'art'
  },
  {
    name: 'Electric Plug',
    unified: '1F50C',
    keywords: ['charger', 'power'],
    sheet: [27, 40],
    shortName: 'electric_plug'
  },
  {
    name: 'Loudly Crying Face',
    unified: '1F62D',
    text: ':\'(',
    keywords: [
      'face',
      'cry',
      'tears',
      'sad',
      'upset',
      'depressed'
    ],
    sheet: [31, 19],
    shortName: 'sob'
  },
  {
    name: 'Woman Frowning',
    unified: '1F64D-200D-2640-FE0F',
    obsoletes: '1F64D',
    sheet: [33, 8],
    skinVariations: [
      {
        unified: '1F64D-1F3FB-200D-2640-FE0F',
        sheet: [33, 9]
      },
      {
        unified: '1F64D-1F3FC-200D-2640-FE0F',
        sheet: [33, 10]
      },
      {
        unified: '1F64D-1F3FD-200D-2640-FE0F',
        sheet: [33, 11]
      },
      {
        unified: '1F64D-1F3FE-200D-2640-FE0F',
        sheet: [33, 12]
      },
      {
        unified: '1F64D-1F3FF-200D-2640-FE0F',
        sheet: [33, 13]
      }
    ],
    shortName: 'woman-frowning'
  },
  {
    name: 'Trolleybus',
    unified: '1F68E',
    keywords: [
      'bart',
      'transportation',
      'vehicle'
    ],
    sheet: [34, 6],
    shortName: 'trolleybus'
  },
  {
    name: 'Flamingo',
    unified: '1F9A9',
    sheet: [43, 16],
    shortName: 'flamingo'
  },
  {
    name: 'Black Left-Pointing Triangle',
    unified: '25C0-FE0F',
    keywords: [
      'blue-square',
      'left',
      'direction'
    ],
    sheet: [53, 50],
    shortName: 'arrow_backward'
  },
  {
    name: 'Ethiopia Flag',
    unified: '1F1EA-1F1F9',
    sheet: [1, 45],
    shortName: 'flag-et'
  },
  {
    name: 'Personal Computer',
    unified: '1F4BB',
    keywords: [
      'technology',
      'laptop',
      'screen',
      'display',
      'monitor'
    ],
    sheet: [26, 18],
    shortName: 'computer'
  },
  {
    name: 'Face Screaming in Fear',
    unified: '1F631',
    keywords: [
      'face',
      'munch',
      'scared',
      'omg'
    ],
    sheet: [31, 23],
    shortName: 'scream'
  },
  {
    name: 'Person with Pouting Face',
    unified: '1F64E',
    sheet: [33, 38],
    skinVariations: [
      {
        unified: '1F64E-1F3FB',
        sheet: [33, 39]
      },
      {
        unified: '1F64E-1F3FC',
        sheet: [33, 40]
      },
      {
        unified: '1F64E-1F3FD',
        sheet: [33, 41]
      },
      {
        unified: '1F64E-1F3FE',
        sheet: [33, 42]
      },
      {
        unified: '1F64E-1F3FF',
        sheet: [33, 43]
      }
    ],
    shortName: 'person_with_pouting_face',
    obsoletedBy: '1F64E-200D-2640-FE0F'
  },
  {
    name: 'Minibus',
    unified: '1F690',
    keywords: [
      'vehicle',
      'car',
      'transportation'
    ],
    sheet: [34, 8],
    shortName: 'minibus'
  },
  {
    name: 'Moon Cake',
    unified: '1F96E',
    keywords: ['food', 'autumn'],
    sheet: [42, 11],
    shortName: 'moon_cake'
  },
  {
    name: 'Peacock',
    unified: '1F99A',
    keywords: [
      'animal',
      'nature',
      'peahen',
      'bird'
    ],
    sheet: [43, 1],
    shortName: 'peacock'
  },
  {
    name: 'Spool of Thread',
    unified: '1F9F5',
    keywords: [
      'needle',
      'sewing',
      'spool',
      'string'
    ],
    sheet: [52, 6],
    shortName: 'thread'
  },
  {
    name: 'Black Left-Pointing Double Triangle',
    unified: '23EA',
    keywords: ['play', 'blue-square'],
    sheet: [53, 33],
    shortName: 'rewind'
  },
  {
    name: 'European Union Flag',
    unified: '1F1EA-1F1FA',
    sheet: [1, 46],
    shortName: 'flag-eu'
  },
  {
    name: 'Dango',
    unified: '1F361',
    keywords: [
      'food',
      'dessert',
      'sweet',
      'japanese',
      'barbecue',
      'meat'
    ],
    sheet: [6, 51],
    shortName: 'dango'
  },
  {
    name: 'Desktop Computer',
    unified: '1F5A5-FE0F',
    keywords: [
      'technology',
      'computing',
      'screen'
    ],
    sheet: [30, 7],
    shortName: 'desktop_computer'
  },
  {
    name: 'Confounded Face',
    unified: '1F616',
    keywords: [
      'face',
      'confused',
      'sick',
      'unwell',
      'oops',
      ':S'
    ],
    sheet: [30, 54],
    shortName: 'confounded'
  },
  {
    name: 'Man Pouting',
    unified: '1F64E-200D-2642-FE0F',
    sheet: [33, 32],
    skinVariations: [
      {
        unified: '1F64E-1F3FB-200D-2642-FE0F',
        sheet: [33, 33]
      },
      {
        unified: '1F64E-1F3FC-200D-2642-FE0F',
        sheet: [33, 34]
      },
      {
        unified: '1F64E-1F3FD-200D-2642-FE0F',
        sheet: [33, 35]
      },
      {
        unified: '1F64E-1F3FE-200D-2642-FE0F',
        sheet: [33, 36]
      },
      {
        unified: '1F64E-1F3FF-200D-2642-FE0F',
        sheet: [33, 37]
      }
    ],
    shortName: 'man-pouting'
  },
  {
    name: 'Ambulance',
    unified: '1F691',
    keywords: [
      'health',
      '911',
      'hospital'
    ],
    sheet: [34, 9],
    shortName: 'ambulance'
  },
  {
    name: 'Parrot',
    unified: '1F99C',
    keywords: [
      'animal',
      'nature',
      'bird',
      'pirate',
      'talk'
    ],
    sheet: [43, 3],
    shortName: 'parrot'
  },
  {
    name: 'Sewing Needle',
    unified: '1FAA1',
    sheet: [52, 49],
    shortName: 'sewing_needle'
  },
  {
    name: 'Black Left Pointing Double Triangle with Vertical Bar',
    unified: '23EE-FE0F',
    sheet: [53, 37],
    shortName: 'black_left_pointing_double_triangle_with_vertical_bar'
  },
  {
    name: 'Finland Flag',
    unified: '1F1EB-1F1EE',
    sheet: [1, 47],
    shortName: 'flag-fi'
  },
  {
    name: 'Frog Face',
    unified: '1F438',
    keywords: [
      'animal',
      'nature',
      'croak',
      'toad'
    ],
    sheet: [12, 18],
    shortName: 'frog'
  },
  {
    name: 'Up-Pointing Small Red Triangle',
    unified: '1F53C',
    keywords: [
      'blue-square',
      'triangle',
      'direction',
      'point',
      'forward',
      'top'
    ],
    sheet: [28, 30],
    shortName: 'arrow_up_small'
  },
  {
    name: 'Printer',
    unified: '1F5A8-FE0F',
    keywords: ['paper', 'ink'],
    sheet: [30, 8],
    shortName: 'printer'
  },
  {
    name: 'Persevering Face',
    unified: '1F623',
    keywords: [
      'face',
      'sick',
      'no',
      'upset',
      'oops'
    ],
    sheet: [31, 9],
    shortName: 'persevere'
  },
  {
    name: 'Woman Pouting',
    unified: '1F64E-200D-2640-FE0F',
    obsoletes: '1F64E',
    sheet: [33, 26],
    skinVariations: [
      {
        unified: '1F64E-1F3FB-200D-2640-FE0F',
        sheet: [33, 27]
      },
      {
        unified: '1F64E-1F3FC-200D-2640-FE0F',
        sheet: [33, 28]
      },
      {
        unified: '1F64E-1F3FD-200D-2640-FE0F',
        sheet: [33, 29]
      },
      {
        unified: '1F64E-1F3FE-200D-2640-FE0F',
        sheet: [33, 30]
      },
      {
        unified: '1F64E-1F3FF-200D-2640-FE0F',
        sheet: [33, 31]
      }
    ],
    shortName: 'woman-pouting'
  },
  {
    name: 'Fire Engine',
    unified: '1F692',
    keywords: [
      'transportation',
      'cars',
      'vehicle'
    ],
    sheet: [34, 10],
    shortName: 'fire_engine'
  },
  {
    name: 'Dumpling',
    unified: '1F95F',
    keywords: [
      'food',
      'empanada',
      'pierogi',
      'potsticker'
    ],
    sheet: [41, 54],
    shortName: 'dumpling'
  },
  {
    name: 'Ball of Yarn',
    unified: '1F9F6',
    keywords: [
      'ball',
      'crochet',
      'knit'
    ],
    sheet: [52, 7],
    shortName: 'yarn'
  },
  {
    name: 'Fiji Flag',
    unified: '1F1EB-1F1EF',
    sheet: [1, 48],
    shortName: 'flag-fj'
  },
  {
    name: 'Crocodile',
    unified: '1F40A',
    keywords: [
      'animal',
      'nature',
      'reptile',
      'lizard',
      'alligator'
    ],
    sheet: [11, 29],
    shortName: 'crocodile'
  },
  {
    name: 'Disappointed Face',
    unified: '1F61E',
    text: ':(',
    emoticons: ['):', ':(', ':-('],
    keywords: [
      'face',
      'sad',
      'upset',
      'depressed',
      ':('
    ],
    sheet: [31, 4],
    shortName: 'disappointed'
  },
  {
    name: 'Face with No Good Gesture',
    unified: '1F645',
    sheet: [31, 55],
    skinVariations: [
      {
        unified: '1F645-1F3FB',
        sheet: [31, 56]
      },
      {
        unified: '1F645-1F3FC',
        sheet: [31, 57]
      },
      {
        unified: '1F645-1F3FD',
        sheet: [32, 0]
      },
      {
        unified: '1F645-1F3FE',
        sheet: [32, 1]
      },
      {
        unified: '1F645-1F3FF',
        sheet: [32, 2]
      }
    ],
    shortName: 'no_good',
    obsoletedBy: '1F645-200D-2640-FE0F'
  },
  {
    name: 'Police Car',
    unified: '1F693',
    keywords: [
      'vehicle',
      'cars',
      'transportation',
      'law',
      'legal',
      'enforcement'
    ],
    sheet: [34, 11],
    shortName: 'police_car'
  },
  {
    name: 'Fortune Cookie',
    unified: '1F960',
    keywords: ['food', 'prophecy'],
    sheet: [41, 55],
    shortName: 'fortune_cookie'
  },
  {
    name: 'Knot',
    unified: '1FAA2',
    sheet: [52, 50],
    shortName: 'knot'
  },
  {
    name: 'Keyboard',
    unified: '2328-FE0F',
    keywords: [
      'technology',
      'computer',
      'type',
      'input',
      'text'
    ],
    sheet: [53, 30],
    shortName: 'keyboard'
  },
  {
    name: 'Black Up-Pointing Double Triangle',
    unified: '23EB',
    keywords: [
      'blue-square',
      'direction',
      'top'
    ],
    sheet: [53, 34],
    shortName: 'arrow_double_up'
  },
  {
    name: 'Falkland Islands Flag',
    unified: '1F1EB-1F1F0',
    sheet: [1, 49],
    shortName: 'flag-fk'
  },
  {
    name: 'Turtle',
    unified: '1F422',
    keywords: [
      'animal',
      'slow',
      'nature',
      'tortoise'
    ],
    sheet: [11, 54],
    shortName: 'turtle'
  },
  {
    name: 'Down-Pointing Small Red Triangle',
    unified: '1F53D',
    keywords: [
      'blue-square',
      'direction',
      'bottom'
    ],
    sheet: [28, 31],
    shortName: 'arrow_down_small'
  },
  {
    name: 'Three Button Mouse',
    unified: '1F5B1-FE0F',
    sheet: [30, 9],
    shortName: 'three_button_mouse'
  },
  {
    name: 'Face with Cold Sweat',
    unified: '1F613',
    keywords: [
      'face',
      'hot',
      'sad',
      'tired',
      'exercise'
    ],
    sheet: [30, 51],
    shortName: 'sweat'
  },
  {
    name: 'Man Gesturing No',
    unified: '1F645-200D-2642-FE0F',
    sheet: [31, 49],
    skinVariations: [
      {
        unified: '1F645-1F3FB-200D-2642-FE0F',
        sheet: [31, 50]
      },
      {
        unified: '1F645-1F3FC-200D-2642-FE0F',
        sheet: [31, 51]
      },
      {
        unified: '1F645-1F3FD-200D-2642-FE0F',
        sheet: [31, 52]
      },
      {
        unified: '1F645-1F3FE-200D-2642-FE0F',
        sheet: [31, 53]
      },
      {
        unified: '1F645-1F3FF-200D-2642-FE0F',
        sheet: [31, 54]
      }
    ],
    shortName: 'man-gesturing-no'
  },
  {
    name: 'Oncoming Police Car',
    unified: '1F694',
    keywords: [
      'vehicle',
      'law',
      'legal',
      'enforcement',
      '911'
    ],
    sheet: [34, 12],
    shortName: 'oncoming_police_car'
  },
  {
    name: 'Takeout Box',
    unified: '1F961',
    keywords: ['food', 'leftovers'],
    sheet: [41, 56],
    shortName: 'takeout_box'
  },
  {
    name: 'Micronesia Flag',
    unified: '1F1EB-1F1F2',
    sheet: [1, 50],
    shortName: 'flag-fm'
  },
  {
    name: 'Trackball',
    unified: '1F5B2-FE0F',
    keywords: [
      'technology',
      'trackpad'
    ],
    sheet: [30, 10],
    shortName: 'trackball'
  },
  {
    name: 'Weary Face',
    unified: '1F629',
    keywords: [
      'face',
      'tired',
      'sleepy',
      'sad',
      'frustrated',
      'upset'
    ],
    sheet: [31, 15],
    shortName: 'weary'
  },
  {
    name: 'Woman Gesturing No',
    unified: '1F645-200D-2640-FE0F',
    obsoletes: '1F645',
    sheet: [31, 43],
    skinVariations: [
      {
        unified: '1F645-1F3FB-200D-2640-FE0F',
        sheet: [31, 44]
      },
      {
        unified: '1F645-1F3FC-200D-2640-FE0F',
        sheet: [31, 45]
      },
      {
        unified: '1F645-1F3FD-200D-2640-FE0F',
        sheet: [31, 46]
      },
      {
        unified: '1F645-1F3FE-200D-2640-FE0F',
        sheet: [31, 47]
      },
      {
        unified: '1F645-1F3FF-200D-2640-FE0F',
        sheet: [31, 48]
      }
    ],
    shortName: 'woman-gesturing-no'
  },
  {
    name: 'Taxi',
    unified: '1F695',
    keywords: [
      'uber',
      'vehicle',
      'cars',
      'transportation'
    ],
    sheet: [34, 13],
    shortName: 'taxi'
  },
  {
    name: 'Crab',
    unified: '1F980',
    keywords: ['animal', 'crustacean'],
    sheet: [42, 33],
    shortName: 'crab'
  },
  {
    name: 'Lizard',
    unified: '1F98E',
    keywords: [
      'animal',
      'nature',
      'reptile'
    ],
    sheet: [42, 47],
    shortName: 'lizard'
  },
  {
    name: 'Black Down-Pointing Double Triangle',
    unified: '23EC',
    keywords: [
      'blue-square',
      'direction',
      'bottom'
    ],
    sheet: [53, 35],
    shortName: 'arrow_double_down'
  },
  {
    name: 'Faroe Islands Flag',
    unified: '1F1EB-1F1F4',
    sheet: [1, 51],
    shortName: 'flag-fo'
  },
  {
    name: 'Snake',
    unified: '1F40D',
    keywords: [
      'animal',
      'evil',
      'nature',
      'hiss',
      'python'
    ],
    sheet: [11, 32],
    shortName: 'snake'
  },
  {
    name: 'Minidisc',
    unified: '1F4BD',
    keywords: [
      'technology',
      'record',
      'data',
      'disk',
      '90s'
    ],
    sheet: [26, 20],
    shortName: 'minidisc'
  },
  {
    name: 'Tired Face',
    unified: '1F62B',
    keywords: [
      'sick',
      'whine',
      'upset',
      'frustrated'
    ],
    sheet: [31, 17],
    shortName: 'tired_face'
  },
  {
    name: 'Face with Ok Gesture',
    unified: '1F646',
    keywords: [
      'women',
      'girl',
      'female',
      'pink',
      'human',
      'woman'
    ],
    sheet: [32, 15],
    skinVariations: [
      {
        unified: '1F646-1F3FB',
        sheet: [32, 16]
      },
      {
        unified: '1F646-1F3FC',
        sheet: [32, 17]
      },
      {
        unified: '1F646-1F3FD',
        sheet: [32, 18]
      },
      {
        unified: '1F646-1F3FE',
        sheet: [32, 19]
      },
      {
        unified: '1F646-1F3FF',
        sheet: [32, 20]
      }
    ],
    shortName: 'ok_woman',
    obsoletedBy: '1F646-200D-2640-FE0F'
  },
  {
    name: 'Oncoming Taxi',
    unified: '1F696',
    keywords: [
      'vehicle',
      'cars',
      'uber'
    ],
    sheet: [34, 14],
    shortName: 'oncoming_taxi'
  },
  {
    name: 'Lobster',
    unified: '1F99E',
    keywords: [
      'animal',
      'nature',
      'bisque',
      'claws',
      'seafood'
    ],
    sheet: [43, 5],
    shortName: 'lobster'
  },
  {
    name: 'Double Vertical Bar',
    unified: '23F8-FE0F',
    sheet: [53, 43],
    shortName: 'double_vertical_bar'
  },
  {
    name: 'France Flag',
    unified: '1F1EB-1F1F7',
    keywords: [
      'banner',
      'flag',
      'nation',
      'france',
      'french',
      'country'
    ],
    sheet: [1, 52],
    shortNames: ['flag-fr'],
    shortName: 'fr'
  },
  {
    name: 'Dragon Face',
    unified: '1F432',
    keywords: [
      'animal',
      'myth',
      'nature',
      'chinese',
      'green'
    ],
    sheet: [12, 12],
    shortName: 'dragon_face'
  },
  {
    name: 'Floppy Disk',
    unified: '1F4BE',
    keywords: [
      'oldschool',
      'technology',
      'save',
      '90s',
      '80s'
    ],
    sheet: [26, 21],
    shortName: 'floppy_disk'
  },
  {
    name: 'Man Gesturing Ok',
    unified: '1F646-200D-2642-FE0F',
    sheet: [32, 9],
    skinVariations: [
      {
        unified: '1F646-1F3FB-200D-2642-FE0F',
        sheet: [32, 10]
      },
      {
        unified: '1F646-1F3FC-200D-2642-FE0F',
        sheet: [32, 11]
      },
      {
        unified: '1F646-1F3FD-200D-2642-FE0F',
        sheet: [32, 12]
      },
      {
        unified: '1F646-1F3FE-200D-2642-FE0F',
        sheet: [32, 13]
      },
      {
        unified: '1F646-1F3FF-200D-2642-FE0F',
        sheet: [32, 14]
      }
    ],
    shortName: 'man-gesturing-ok'
  },
  {
    name: 'Automobile',
    unified: '1F697',
    sheet: [34, 15],
    shortNames: ['red_car'],
    shortName: 'car'
  },
  {
    name: 'Yawning Face',
    unified: '1F971',
    sheet: [42, 14],
    shortName: 'yawning_face'
  },
  {
    name: 'Shrimp',
    unified: '1F990',
    keywords: [
      'animal',
      'ocean',
      'nature',
      'seafood'
    ],
    sheet: [42, 49],
    shortName: 'shrimp'
  },
  {
    name: 'Black Square for Stop',
    unified: '23F9-FE0F',
    sheet: [53, 44],
    shortName: 'black_square_for_stop'
  },
  {
    name: 'Gabon Flag',
    unified: '1F1EC-1F1E6',
    sheet: [1, 53],
    shortName: 'flag-ga'
  },
  {
    name: 'Dragon',
    unified: '1F409',
    keywords: [
      'animal',
      'myth',
      'nature',
      'chinese',
      'green'
    ],
    sheet: [11, 28],
    shortName: 'dragon'
  },
  {
    name: 'Optical Disc',
    unified: '1F4BF',
    keywords: [
      'technology',
      'dvd',
      'disk',
      'disc',
      '90s'
    ],
    sheet: [26, 22],
    shortName: 'cd'
  },
  {
    name: 'Face with Look of Triumph',
    unified: '1F624',
    keywords: [
      'face',
      'gas',
      'phew',
      'proud',
      'pride'
    ],
    sheet: [31, 10],
    shortName: 'triumph'
  },
  {
    name: 'Woman Gesturing Ok',
    unified: '1F646-200D-2640-FE0F',
    obsoletes: '1F646',
    sheet: [32, 3],
    skinVariations: [
      {
        unified: '1F646-1F3FB-200D-2640-FE0F',
        sheet: [32, 4]
      },
      {
        unified: '1F646-1F3FC-200D-2640-FE0F',
        sheet: [32, 5]
      },
      {
        unified: '1F646-1F3FD-200D-2640-FE0F',
        sheet: [32, 6]
      },
      {
        unified: '1F646-1F3FE-200D-2640-FE0F',
        sheet: [32, 7]
      },
      {
        unified: '1F646-1F3FF-200D-2640-FE0F',
        sheet: [32, 8]
      }
    ],
    shortName: 'woman-gesturing-ok'
  },
  {
    name: 'Oncoming Automobile',
    unified: '1F698',
    keywords: [
      'car',
      'vehicle',
      'transportation'
    ],
    sheet: [34, 16],
    shortName: 'oncoming_automobile'
  },
  {
    name: 'Squid',
    unified: '1F991',
    keywords: [
      'animal',
      'nature',
      'ocean',
      'sea'
    ],
    sheet: [42, 50],
    shortName: 'squid'
  },
  {
    name: 'Black Circle for Record',
    unified: '23FA-FE0F',
    sheet: [53, 45],
    shortName: 'black_circle_for_record'
  },
  {
    name: 'United Kingdom Flag',
    unified: '1F1EC-1F1E7',
    sheet: [1, 54],
    shortNames: ['uk', 'flag-gb'],
    shortName: 'gb'
  },
  {
    name: 'Information Desk Person',
    unified: '1F481',
    sheet: [24, 5],
    skinVariations: [
      {
        unified: '1F481-1F3FB',
        sheet: [24, 6]
      },
      {
        unified: '1F481-1F3FC',
        sheet: [24, 7]
      },
      {
        unified: '1F481-1F3FD',
        sheet: [24, 8]
      },
      {
        unified: '1F481-1F3FE',
        sheet: [24, 9]
      },
      {
        unified: '1F481-1F3FF',
        sheet: [24, 10]
      }
    ],
    shortName: 'information_desk_person',
    obsoletedBy: '1F481-200D-2640-FE0F'
  },
  {
    name: 'Dvd',
    unified: '1F4C0',
    keywords: ['cd', 'disk', 'disc'],
    sheet: [26, 23],
    shortName: 'dvd'
  },
  {
    name: 'Pouting Face',
    unified: '1F621',
    keywords: [
      'angry',
      'mad',
      'hate',
      'despise'
    ],
    sheet: [31, 7],
    shortName: 'rage'
  },
  {
    name: 'Recreational Vehicle',
    unified: '1F699',
    keywords: [
      'transportation',
      'vehicle'
    ],
    sheet: [34, 17],
    shortName: 'blue_car'
  },
  {
    name: 'Sauropod',
    unified: '1F995',
    keywords: [
      'animal',
      'nature',
      'dinosaur',
      'brachiosaurus',
      'brontosaurus',
      'diplodocus',
      'extinct'
    ],
    sheet: [42, 54],
    shortName: 'sauropod'
  },
  {
    name: 'Oyster',
    unified: '1F9AA',
    sheet: [43, 17],
    shortName: 'oyster'
  },
  {
    name: 'Eject',
    unified: '23CF-FE0F',
    sheet: [53, 31],
    shortName: 'eject'
  },
  {
    name: 'Grenada Flag',
    unified: '1F1EC-1F1E9',
    sheet: [1, 55],
    shortName: 'flag-gd'
  },
  {
    name: 'Soft Ice Cream',
    unified: '1F366',
    keywords: [
      'food',
      'hot',
      'dessert',
      'summer'
    ],
    sheet: [6, 56],
    shortName: 'icecream'
  },
  {
    name: 'Cinema',
    unified: '1F3A6',
    keywords: [
      'blue-square',
      'record',
      'film',
      'movie',
      'curtain',
      'stage',
      'theater'
    ],
    sheet: [8, 4],
    shortName: 'cinema'
  },
  {
    name: 'Man Tipping Hand',
    unified: '1F481-200D-2642-FE0F',
    sheet: [23, 57],
    skinVariations: [
      {
        unified: '1F481-1F3FB-200D-2642-FE0F',
        sheet: [24, 0]
      },
      {
        unified: '1F481-1F3FC-200D-2642-FE0F',
        sheet: [24, 1]
      },
      {
        unified: '1F481-1F3FD-200D-2642-FE0F',
        sheet: [24, 2]
      },
      {
        unified: '1F481-1F3FE-200D-2642-FE0F',
        sheet: [24, 3]
      },
      {
        unified: '1F481-1F3FF-200D-2642-FE0F',
        sheet: [24, 4]
      }
    ],
    shortName: 'man-tipping-hand'
  },
  {
    name: 'Angry Face',
    unified: '1F620',
    emoticons: ['>:(', '>:-('],
    keywords: [
      'mad',
      'face',
      'annoyed',
      'frustrated'
    ],
    sheet: [31, 6],
    shortName: 'angry'
  },
  {
    name: 'Pickup Truck',
    unified: '1F6FB',
    sheet: [36, 53],
    shortName: 'pickup_truck'
  },
  {
    name: 'T-Rex',
    unified: '1F996',
    keywords: [
      'animal',
      'nature',
      'dinosaur',
      'tyrannosaurus',
      'extinct'
    ],
    sheet: [42, 55],
    shortName: 't-rex'
  },
  {
    name: 'Abacus',
    unified: '1F9EE',
    keywords: ['calculation'],
    sheet: [51, 57],
    shortName: 'abacus'
  },
  {
    name: 'Georgia Flag',
    unified: '1F1EC-1F1EA',
    sheet: [1, 56],
    shortName: 'flag-ge'
  },
  {
    name: 'Shaved Ice',
    unified: '1F367',
    keywords: [
      'hot',
      'dessert',
      'summer'
    ],
    sheet: [6, 57],
    shortName: 'shaved_ice'
  },
  {
    name: 'Movie Camera',
    unified: '1F3A5',
    keywords: ['film', 'record'],
    sheet: [8, 3],
    shortName: 'movie_camera'
  },
  {
    name: 'Spouting Whale',
    unified: '1F433',
    keywords: [
      'animal',
      'nature',
      'sea',
      'ocean'
    ],
    sheet: [12, 13],
    shortName: 'whale'
  },
  {
    name: 'Woman Tipping Hand',
    unified: '1F481-200D-2640-FE0F',
    obsoletes: '1F481',
    sheet: [23, 51],
    skinVariations: [
      {
        unified: '1F481-1F3FB-200D-2640-FE0F',
        sheet: [23, 52]
      },
      {
        unified: '1F481-1F3FC-200D-2640-FE0F',
        sheet: [23, 53]
      },
      {
        unified: '1F481-1F3FD-200D-2640-FE0F',
        sheet: [23, 54]
      },
      {
        unified: '1F481-1F3FE-200D-2640-FE0F',
        sheet: [23, 55]
      },
      {
        unified: '1F481-1F3FF-200D-2640-FE0F',
        sheet: [23, 56]
      }
    ],
    shortName: 'woman-tipping-hand'
  },
  {
    name: 'Low Brightness Symbol',
    unified: '1F505',
    keywords: [
      'sun',
      'afternoon',
      'warm',
      'summer'
    ],
    sheet: [27, 33],
    shortName: 'low_brightness'
  },
  {
    name: 'Delivery Truck',
    unified: '1F69A',
    keywords: [
      'cars',
      'transportation'
    ],
    sheet: [34, 18],
    shortName: 'truck'
  },
  {
    name: 'Serious Face with Symbols Covering Mouth',
    unified: '1F92C',
    sheet: [38, 45],
    shortNames: [
      'serious_face_with_symbols_covering_mouth'
    ],
    shortName: 'face_with_symbols_on_mouth'
  },
  {
    name: 'French Guiana Flag',
    unified: '1F1EC-1F1EB',
    sheet: [1, 57],
    shortName: 'flag-gf'
  },
  {
    name: 'Ice Cream',
    unified: '1F368',
    keywords: [
      'food',
      'hot',
      'dessert'
    ],
    sheet: [7, 0],
    shortName: 'ice_cream'
  },
  {
    name: 'Film Frames',
    unified: '1F39E-FE0F',
    sheet: [7, 54],
    shortName: 'film_frames'
  },
  {
    name: 'Whale',
    unified: '1F40B',
    keywords: [
      'animal',
      'nature',
      'sea',
      'ocean'
    ],
    sheet: [11, 30],
    shortName: 'whale2'
  },
  {
    name: 'High Brightness Symbol',
    unified: '1F506',
    keywords: ['sun', 'light'],
    sheet: [27, 34],
    shortName: 'high_brightness'
  },
  {
    name: 'Smiling Face with Horns',
    unified: '1F608',
    keywords: ['devil', 'horns'],
    sheet: [30, 40],
    shortName: 'smiling_imp'
  },
  {
    name: 'Happy Person Raising One Hand',
    unified: '1F64B',
    sheet: [32, 54],
    skinVariations: [
      {
        unified: '1F64B-1F3FB',
        sheet: [32, 55]
      },
      {
        unified: '1F64B-1F3FC',
        sheet: [32, 56]
      },
      {
        unified: '1F64B-1F3FD',
        sheet: [32, 57]
      },
      {
        unified: '1F64B-1F3FE',
        sheet: [33, 0]
      },
      {
        unified: '1F64B-1F3FF',
        sheet: [33, 1]
      }
    ],
    shortName: 'raising_hand',
    obsoletedBy: '1F64B-200D-2640-FE0F'
  },
  {
    name: 'Articulated Lorry',
    unified: '1F69B',
    keywords: [
      'vehicle',
      'cars',
      'transportation',
      'express'
    ],
    sheet: [34, 19],
    shortName: 'articulated_lorry'
  },
  {
    name: 'Guernsey Flag',
    unified: '1F1EC-1F1EC',
    sheet: [2, 0],
    shortName: 'flag-gg'
  },
  {
    name: 'Doughnut',
    unified: '1F369',
    keywords: [
      'food',
      'dessert',
      'snack',
      'sweet',
      'donut'
    ],
    sheet: [7, 1],
    shortName: 'doughnut'
  },
  {
    name: 'Dolphin',
    unified: '1F42C',
    keywords: [
      'animal',
      'nature',
      'fish',
      'sea',
      'ocean',
      'flipper',
      'fins',
      'beach'
    ],
    sheet: [12, 6],
    shortNames: ['flipper'],
    shortName: 'dolphin'
  },
  {
    name: 'Imp',
    unified: '1F47F',
    keywords: [
      'devil',
      'angry',
      'horns'
    ],
    sheet: [23, 49],
    shortName: 'imp'
  },
  {
    name: 'Antenna with Bars',
    unified: '1F4F6',
    keywords: [
      'blue-square',
      'reception',
      'phone',
      'internet',
      'connection',
      'wifi',
      'bluetooth',
      'bars'
    ],
    sheet: [27, 19],
    shortName: 'signal_strength'
  },
  {
    name: 'Film Projector',
    unified: '1F4FD-FE0F',
    keywords: [
      'video',
      'tape',
      'record',
      'movie'
    ],
    sheet: [27, 26],
    shortName: 'film_projector'
  },
  {
    name: 'Man Raising Hand',
    unified: '1F64B-200D-2642-FE0F',
    sheet: [32, 48],
    skinVariations: [
      {
        unified: '1F64B-1F3FB-200D-2642-FE0F',
        sheet: [32, 49]
      },
      {
        unified: '1F64B-1F3FC-200D-2642-FE0F',
        sheet: [32, 50]
      },
      {
        unified: '1F64B-1F3FD-200D-2642-FE0F',
        sheet: [32, 51]
      },
      {
        unified: '1F64B-1F3FE-200D-2642-FE0F',
        sheet: [32, 52]
      },
      {
        unified: '1F64B-1F3FF-200D-2642-FE0F',
        sheet: [32, 53]
      }
    ],
    shortName: 'man-raising-hand'
  },
  {
    name: 'Tractor',
    unified: '1F69C',
    keywords: [
      'vehicle',
      'car',
      'farming',
      'agriculture'
    ],
    sheet: [34, 20],
    shortName: 'tractor'
  },
  {
    name: 'Ghana Flag',
    unified: '1F1EC-1F1ED',
    sheet: [2, 1],
    shortName: 'flag-gh'
  },
  {
    name: 'Cookie',
    unified: '1F36A',
    keywords: [
      'food',
      'snack',
      'oreo',
      'chocolate',
      'sweet',
      'dessert'
    ],
    sheet: [7, 2],
    shortName: 'cookie'
  },
  {
    name: 'Clapper Board',
    unified: '1F3AC',
    keywords: [
      'movie',
      'film',
      'record'
    ],
    sheet: [8, 10],
    shortName: 'clapper'
  },
  {
    name: 'Racing Car',
    unified: '1F3CE-FE0F',
    keywords: [
      'sports',
      'race',
      'fast',
      'formula',
      'f1'
    ],
    sheet: [10, 23],
    shortName: 'racing_car'
  },
  {
    name: 'Skull',
    unified: '1F480',
    keywords: [
      'dead',
      'skeleton',
      'creepy',
      'death'
    ],
    sheet: [23, 50],
    shortName: 'skull'
  },
  {
    name: 'Vibration Mode',
    unified: '1F4F3',
    keywords: [
      'orange-square',
      'phone'
    ],
    sheet: [27, 16],
    shortName: 'vibration_mode'
  },
  {
    name: 'Woman Raising Hand',
    unified: '1F64B-200D-2640-FE0F',
    obsoletes: '1F64B',
    sheet: [32, 42],
    skinVariations: [
      {
        unified: '1F64B-1F3FB-200D-2640-FE0F',
        sheet: [32, 43]
      },
      {
        unified: '1F64B-1F3FC-200D-2640-FE0F',
        sheet: [32, 44]
      },
      {
        unified: '1F64B-1F3FD-200D-2640-FE0F',
        sheet: [32, 45]
      },
      {
        unified: '1F64B-1F3FE-200D-2640-FE0F',
        sheet: [32, 46]
      },
      {
        unified: '1F64B-1F3FF-200D-2640-FE0F',
        sheet: [32, 47]
      }
    ],
    shortName: 'woman-raising-hand'
  },
  {
    name: 'Seal',
    unified: '1F9AD',
    sheet: [43, 20],
    shortName: 'seal'
  },
  {
    name: 'Gibraltar Flag',
    unified: '1F1EC-1F1EE',
    sheet: [2, 2],
    shortName: 'flag-gi'
  },
  {
    name: 'Birthday Cake',
    unified: '1F382',
    keywords: [
      'food',
      'dessert',
      'cake'
    ],
    sheet: [7, 26],
    shortName: 'birthday'
  },
  {
    name: 'Racing Motorcycle',
    unified: '1F3CD-FE0F',
    sheet: [10, 22],
    shortName: 'racing_motorcycle'
  },
  {
    name: 'Fish',
    unified: '1F41F',
    keywords: [
      'animal',
      'food',
      'nature'
    ],
    sheet: [11, 51],
    shortName: 'fish'
  },
  {
    name: 'Mobile Phone off',
    unified: '1F4F4',
    keywords: [
      'mute',
      'orange-square',
      'silence',
      'quiet'
    ],
    sheet: [27, 17],
    shortName: 'mobile_phone_off'
  },
  {
    name: 'Television',
    unified: '1F4FA',
    keywords: [
      'technology',
      'program',
      'oldschool',
      'show',
      'television'
    ],
    sheet: [27, 23],
    shortName: 'tv'
  },
  {
    name: 'Deaf Person',
    unified: '1F9CF',
    sheet: [45, 28],
    skinVariations: [
      {
        unified: '1F9CF-1F3FB',
        sheet: [45, 29]
      },
      {
        unified: '1F9CF-1F3FC',
        sheet: [45, 30]
      },
      {
        unified: '1F9CF-1F3FD',
        sheet: [45, 31]
      },
      {
        unified: '1F9CF-1F3FE',
        sheet: [45, 32]
      },
      {
        unified: '1F9CF-1F3FF',
        sheet: [45, 33]
      }
    ],
    shortName: 'deaf_person'
  },
  {
    name: 'Skull and Crossbones',
    unified: '2620-FE0F',
    keywords: [
      'poison',
      'danger',
      'deadly',
      'scary',
      'death',
      'pirate',
      'evil'
    ],
    sheet: [54, 13],
    shortName: 'skull_and_crossbones'
  },
  {
    name: 'Greenland Flag',
    unified: '1F1EC-1F1F1',
    sheet: [2, 3],
    shortName: 'flag-gl'
  },
  {
    name: 'Shortcake',
    unified: '1F370',
    keywords: ['food', 'dessert'],
    sheet: [7, 8],
    shortName: 'cake'
  },
  {
    name: 'Tropical Fish',
    unified: '1F420',
    keywords: [
      'animal',
      'swim',
      'ocean',
      'beach',
      'nemo'
    ],
    sheet: [11, 52],
    shortName: 'tropical_fish'
  },
  {
    name: 'Pile of Poo',
    unified: '1F4A9',
    sheet: [25, 53],
    shortNames: ['poop', 'shit'],
    shortName: 'hankey'
  },
  {
    name: 'Camera',
    unified: '1F4F7',
    keywords: [
      'gadgets',
      'photography'
    ],
    sheet: [27, 20],
    shortName: 'camera'
  },
  {
    name: 'Motor Scooter',
    unified: '1F6F5',
    keywords: [
      'vehicle',
      'vespa',
      'sasha'
    ],
    sheet: [36, 47],
    shortName: 'motor_scooter'
  },
  {
    name: 'Deaf Man',
    unified: '1F9CF-200D-2642-FE0F',
    sheet: [45, 22],
    skinVariations: [
      {
        unified: '1F9CF-1F3FB-200D-2642-FE0F',
        sheet: [45, 23]
      },
      {
        unified: '1F9CF-1F3FC-200D-2642-FE0F',
        sheet: [45, 24]
      },
      {
        unified: '1F9CF-1F3FD-200D-2642-FE0F',
        sheet: [45, 25]
      },
      {
        unified: '1F9CF-1F3FE-200D-2642-FE0F',
        sheet: [45, 26]
      },
      {
        unified: '1F9CF-1F3FF-200D-2642-FE0F',
        sheet: [45, 27]
      }
    ],
    shortName: 'deaf_man'
  },
  {
    name: 'Female Sign',
    unified: '2640-FE0F',
    sheet: [54, 23],
    hidden: ['apple'],
    shortName: 'female_sign'
  },
  {
    name: 'Gambia Flag',
    unified: '1F1EC-1F1F2',
    sheet: [2, 4],
    shortName: 'flag-gm'
  },
  {
    name: 'Blowfish',
    unified: '1F421',
    keywords: [
      'animal',
      'nature',
      'food',
      'sea',
      'ocean'
    ],
    sheet: [11, 53],
    shortName: 'blowfish'
  },
  {
    name: 'Camera with Flash',
    unified: '1F4F8',
    sheet: [27, 21],
    shortName: 'camera_with_flash'
  },
  {
    name: 'Clown Face',
    unified: '1F921',
    keywords: ['face'],
    sheet: [38, 17],
    shortName: 'clown_face'
  },
  {
    name: 'Manual Wheelchair',
    unified: '1F9BD',
    sheet: [44, 23],
    shortName: 'manual_wheelchair'
  },
  {
    name: 'Cupcake',
    unified: '1F9C1',
    keywords: [
      'food',
      'dessert',
      'bakery',
      'sweet'
    ],
    sheet: [44, 27],
    shortName: 'cupcake'
  },
  {
    name: 'Deaf Woman',
    unified: '1F9CF-200D-2640-FE0F',
    sheet: [45, 16],
    skinVariations: [
      {
        unified: '1F9CF-1F3FB-200D-2640-FE0F',
        sheet: [45, 17]
      },
      {
        unified: '1F9CF-1F3FC-200D-2640-FE0F',
        sheet: [45, 18]
      },
      {
        unified: '1F9CF-1F3FD-200D-2640-FE0F',
        sheet: [45, 19]
      },
      {
        unified: '1F9CF-1F3FE-200D-2640-FE0F',
        sheet: [45, 20]
      },
      {
        unified: '1F9CF-1F3FF-200D-2640-FE0F',
        sheet: [45, 21]
      }
    ],
    shortName: 'deaf_woman'
  },
  {
    name: 'Male Sign',
    unified: '2642-FE0F',
    sheet: [54, 24],
    hidden: ['apple'],
    shortName: 'male_sign'
  },
  {
    name: 'Guinea Flag',
    unified: '1F1EC-1F1F3',
    sheet: [2, 5],
    shortName: 'flag-gn'
  },
  {
    name: 'Japanese Ogre',
    unified: '1F479',
    keywords: [
      'monster',
      'red',
      'mask',
      'halloween',
      'scary',
      'creepy',
      'devil',
      'demon',
      'japanese',
      'ogre'
    ],
    sheet: [23, 38],
    shortName: 'japanese_ogre'
  },
  {
    name: 'Video Camera',
    unified: '1F4F9',
    keywords: ['film', 'record'],
    sheet: [27, 22],
    shortName: 'video_camera'
  },
  {
    name: 'Person Bowing Deeply',
    unified: '1F647',
    sheet: [32, 33],
    skinVariations: [
      {
        unified: '1F647-1F3FB',
        sheet: [32, 34]
      },
      {
        unified: '1F647-1F3FC',
        sheet: [32, 35]
      },
      {
        unified: '1F647-1F3FD',
        sheet: [32, 36]
      },
      {
        unified: '1F647-1F3FE',
        sheet: [32, 37]
      },
      {
        unified: '1F647-1F3FF',
        sheet: [32, 38]
      }
    ],
    shortName: 'bow',
    obsoletedBy: '1F647-200D-2642-FE0F'
  },
  {
    name: 'Pie',
    unified: '1F967',
    keywords: [
      'food',
      'dessert',
      'pastry'
    ],
    sheet: [42, 4],
    shortName: 'pie'
  },
  {
    name: 'Shark',
    unified: '1F988',
    keywords: [
      'animal',
      'nature',
      'fish',
      'sea',
      'ocean',
      'jaws',
      'fins',
      'beach'
    ],
    sheet: [42, 41],
    shortName: 'shark'
  },
  {
    name: 'Motorized Wheelchair',
    unified: '1F9BC',
    sheet: [44, 22],
    shortName: 'motorized_wheelchair'
  },
  {
    name: 'Transgender Symbol',
    unified: '26A7-FE0F',
    sheet: [54, 57],
    shortName: 'transgender_symbol'
  },
  {
    name: 'Guadeloupe Flag',
    unified: '1F1EC-1F1F5',
    sheet: [2, 6],
    shortName: 'flag-gp'
  },
  {
    name: 'Chocolate Bar',
    unified: '1F36B',
    keywords: [
      'food',
      'snack',
      'dessert',
      'sweet'
    ],
    sheet: [7, 3],
    shortName: 'chocolate_bar'
  },
  {
    name: 'Octopus',
    unified: '1F419',
    keywords: [
      'animal',
      'creature',
      'ocean',
      'sea',
      'nature',
      'beach'
    ],
    sheet: [11, 45],
    shortName: 'octopus'
  },
  {
    name: 'Japanese Goblin',
    unified: '1F47A',
    keywords: [
      'red',
      'evil',
      'mask',
      'monster',
      'scary',
      'creepy',
      'japanese',
      'goblin'
    ],
    sheet: [23, 39],
    shortName: 'japanese_goblin'
  },
  {
    name: 'Videocassette',
    unified: '1F4FC',
    keywords: [
      'record',
      'video',
      'oldschool',
      '90s',
      '80s'
    ],
    sheet: [27, 25],
    shortName: 'vhs'
  },
  {
    name: 'Man Bowing',
    unified: '1F647-200D-2642-FE0F',
    obsoletes: '1F647',
    sheet: [32, 27],
    skinVariations: [
      {
        unified: '1F647-1F3FB-200D-2642-FE0F',
        sheet: [32, 28]
      },
      {
        unified: '1F647-1F3FC-200D-2642-FE0F',
        sheet: [32, 29]
      },
      {
        unified: '1F647-1F3FD-200D-2642-FE0F',
        sheet: [32, 30]
      },
      {
        unified: '1F647-1F3FE-200D-2642-FE0F',
        sheet: [32, 31]
      },
      {
        unified: '1F647-1F3FF-200D-2642-FE0F',
        sheet: [32, 32]
      }
    ],
    shortName: 'man-bowing'
  },
  {
    name: 'Auto Rickshaw',
    unified: '1F6FA',
    sheet: [36, 52],
    shortName: 'auto_rickshaw'
  },
  {
    name: 'Heavy Multiplication X',
    unified: '2716-FE0F',
    keywords: ['math', 'calculation'],
    sheet: [56, 17],
    shortName: 'heavy_multiplication_x'
  },
  {
    name: 'Equatorial Guinea Flag',
    unified: '1F1EC-1F1F6',
    sheet: [2, 7],
    shortName: 'flag-gq'
  },
  {
    name: 'Candy',
    unified: '1F36C',
    keywords: [
      'snack',
      'dessert',
      'sweet',
      'lolly'
    ],
    sheet: [7, 4],
    shortName: 'candy'
  },
  {
    name: 'Spiral Shell',
    unified: '1F41A',
    keywords: [
      'nature',
      'sea',
      'beach'
    ],
    sheet: [11, 46],
    shortName: 'shell'
  },
  {
    name: 'Ghost',
    unified: '1F47B',
    keywords: [
      'halloween',
      'spooky',
      'scary'
    ],
    sheet: [23, 40],
    shortName: 'ghost'
  },
  {
    name: 'Left-Pointing Magnifying Glass',
    unified: '1F50D',
    keywords: [
      'search',
      'zoom',
      'find',
      'detective'
    ],
    sheet: [27, 41],
    shortName: 'mag'
  },
  {
    name: 'Woman Bowing',
    unified: '1F647-200D-2640-FE0F',
    sheet: [32, 21],
    skinVariations: [
      {
        unified: '1F647-1F3FB-200D-2640-FE0F',
        sheet: [32, 22]
      },
      {
        unified: '1F647-1F3FC-200D-2640-FE0F',
        sheet: [32, 23]
      },
      {
        unified: '1F647-1F3FD-200D-2640-FE0F',
        sheet: [32, 24]
      },
      {
        unified: '1F647-1F3FE-200D-2640-FE0F',
        sheet: [32, 25]
      },
      {
        unified: '1F647-1F3FF-200D-2640-FE0F',
        sheet: [32, 26]
      }
    ],
    shortName: 'woman-bowing'
  },
  {
    name: 'Bicycle',
    unified: '1F6B2',
    keywords: [
      'sports',
      'bicycle',
      'exercise',
      'hipster'
    ],
    sheet: [35, 1],
    shortName: 'bike'
  },
  {
    name: 'Heavy Plus Sign',
    unified: '2795',
    keywords: [
      'math',
      'calculation',
      'addition',
      'more',
      'increase'
    ],
    sheet: [56, 33],
    shortName: 'heavy_plus_sign'
  },
  {
    name: 'Greece Flag',
    unified: '1F1EC-1F1F7',
    sheet: [2, 8],
    shortName: 'flag-gr'
  },
  {
    name: 'Lollipop',
    unified: '1F36D',
    keywords: [
      'food',
      'snack',
      'candy',
      'sweet'
    ],
    sheet: [7, 5],
    shortName: 'lollipop'
  },
  {
    name: 'Snail',
    unified: '1F40C',
    keywords: [
      'slow',
      'animal',
      'shell'
    ],
    sheet: [11, 31],
    shortName: 'snail'
  },
  {
    name: 'Extraterrestrial Alien',
    unified: '1F47D',
    keywords: [
      'UFO',
      'paul',
      'weird',
      'outer_space'
    ],
    sheet: [23, 47],
    shortName: 'alien'
  },
  {
    name: 'Right-Pointing Magnifying Glass',
    unified: '1F50E',
    keywords: [
      'search',
      'zoom',
      'find',
      'detective'
    ],
    sheet: [27, 42],
    shortName: 'mag_right'
  },
  {
    name: 'Scooter',
    unified: '1F6F4',
    sheet: [36, 46],
    shortName: 'scooter'
  },
  {
    name: 'Face Palm',
    unified: '1F926',
    sheet: [38, 34],
    skinVariations: [
      {
        unified: '1F926-1F3FB',
        sheet: [38, 35]
      },
      {
        unified: '1F926-1F3FC',
        sheet: [38, 36]
      },
      {
        unified: '1F926-1F3FD',
        sheet: [38, 37]
      },
      {
        unified: '1F926-1F3FE',
        sheet: [38, 38]
      },
      {
        unified: '1F926-1F3FF',
        sheet: [38, 39]
      }
    ],
    shortName: 'face_palm'
  },
  {
    name: 'Heavy Minus Sign',
    unified: '2796',
    keywords: [
      'math',
      'calculation',
      'subtract',
      'less'
    ],
    sheet: [56, 34],
    shortName: 'heavy_minus_sign'
  },
  {
    name: 'South Georgia & South Sandwich Islands Flag',
    unified: '1F1EC-1F1F8',
    sheet: [2, 9],
    shortName: 'flag-gs'
  },
  {
    name: 'Custard',
    unified: '1F36E',
    keywords: ['dessert', 'food'],
    sheet: [7, 6],
    shortName: 'custard'
  },
  {
    name: 'Alien Monster',
    unified: '1F47E',
    keywords: [
      'game',
      'arcade',
      'play'
    ],
    sheet: [23, 48],
    shortName: 'space_invader'
  },
  {
    name: 'Candle',
    unified: '1F56F-FE0F',
    keywords: ['fire', 'wax'],
    sheet: [29, 4],
    shortName: 'candle'
  },
  {
    name: 'Skateboard',
    unified: '1F6F9',
    keywords: ['board'],
    sheet: [36, 51],
    shortName: 'skateboard'
  },
  {
    name: 'Man Facepalming',
    unified: '1F926-200D-2642-FE0F',
    sheet: [38, 28],
    skinVariations: [
      {
        unified: '1F926-1F3FB-200D-2642-FE0F',
        sheet: [38, 29]
      },
      {
        unified: '1F926-1F3FC-200D-2642-FE0F',
        sheet: [38, 30]
      },
      {
        unified: '1F926-1F3FD-200D-2642-FE0F',
        sheet: [38, 31]
      },
      {
        unified: '1F926-1F3FE-200D-2642-FE0F',
        sheet: [38, 32]
      },
      {
        unified: '1F926-1F3FF-200D-2642-FE0F',
        sheet: [38, 33]
      }
    ],
    shortName: 'man-facepalming'
  },
  {
    name: 'Butterfly',
    unified: '1F98B',
    keywords: [
      'animal',
      'insect',
      'nature',
      'caterpillar'
    ],
    sheet: [42, 44],
    shortName: 'butterfly'
  },
  {
    name: 'Heavy Division Sign',
    unified: '2797',
    keywords: [
      'divide',
      'math',
      'calculation'
    ],
    sheet: [56, 35],
    shortName: 'heavy_division_sign'
  },
  {
    name: 'Guatemala Flag',
    unified: '1F1EC-1F1F9',
    sheet: [2, 10],
    shortName: 'flag-gt'
  },
  {
    name: 'Honey Pot',
    unified: '1F36F',
    keywords: [
      'bees',
      'sweet',
      'kitchen'
    ],
    sheet: [7, 7],
    shortName: 'honey_pot'
  },
  {
    name: 'Bug',
    unified: '1F41B',
    keywords: [
      'animal',
      'insect',
      'nature',
      'worm'
    ],
    sheet: [11, 47],
    shortName: 'bug'
  },
  {
    name: 'Electric Light Bulb',
    unified: '1F4A1',
    keywords: [
      'light',
      'electricity',
      'idea'
    ],
    sheet: [25, 45],
    shortName: 'bulb'
  },
  {
    name: 'Roller Skate',
    unified: '1F6FC',
    sheet: [36, 54],
    shortName: 'roller_skate'
  },
  {
    name: 'Robot Face',
    unified: '1F916',
    sheet: [37, 29],
    shortName: 'robot_face'
  },
  {
    name: 'Woman Facepalming',
    unified: '1F926-200D-2640-FE0F',
    sheet: [38, 22],
    skinVariations: [
      {
        unified: '1F926-1F3FB-200D-2640-FE0F',
        sheet: [38, 23]
      },
      {
        unified: '1F926-1F3FC-200D-2640-FE0F',
        sheet: [38, 24]
      },
      {
        unified: '1F926-1F3FD-200D-2640-FE0F',
        sheet: [38, 25]
      },
      {
        unified: '1F926-1F3FE-200D-2640-FE0F',
        sheet: [38, 26]
      },
      {
        unified: '1F926-1F3FF-200D-2640-FE0F',
        sheet: [38, 27]
      }
    ],
    shortName: 'woman-facepalming'
  },
  {
    name: 'Infinity',
    unified: '267E-FE0F',
    keywords: ['forever'],
    sheet: [54, 44],
    shortName: 'infinity'
  },
  {
    name: 'Guam Flag',
    unified: '1F1EC-1F1FA',
    sheet: [2, 11],
    shortName: 'flag-gu'
  },
  {
    name: 'Baby Bottle',
    unified: '1F37C',
    keywords: [
      'food',
      'container',
      'milk'
    ],
    sheet: [7, 20],
    shortName: 'baby_bottle'
  },
  {
    name: 'Ant',
    unified: '1F41C',
    keywords: [
      'animal',
      'insect',
      'nature',
      'bug'
    ],
    sheet: [11, 48],
    shortName: 'ant'
  },
  {
    name: 'Electric Torch',
    unified: '1F526',
    keywords: [
      'dark',
      'camping',
      'sight',
      'night'
    ],
    sheet: [28, 8],
    shortName: 'flashlight'
  },
  {
    name: 'Smiling Cat Face with Open Mouth',
    unified: '1F63A',
    keywords: [
      'animal',
      'cats',
      'happy',
      'smile'
    ],
    sheet: [31, 32],
    shortName: 'smiley_cat'
  },
  {
    name: 'Bus Stop',
    unified: '1F68F',
    keywords: [
      'transportation',
      'wait'
    ],
    sheet: [34, 7],
    shortName: 'busstop'
  },
  {
    name: 'Shrug',
    unified: '1F937',
    sheet: [39, 57],
    skinVariations: [
      {
        unified: '1F937-1F3FB',
        sheet: [40, 0]
      },
      {
        unified: '1F937-1F3FC',
        sheet: [40, 1]
      },
      {
        unified: '1F937-1F3FD',
        sheet: [40, 2]
      },
      {
        unified: '1F937-1F3FE',
        sheet: [40, 3]
      },
      {
        unified: '1F937-1F3FF',
        sheet: [40, 4]
      }
    ],
    shortName: 'shrug'
  },
  {
    name: 'Double Exclamation Mark',
    unified: '203C-FE0F',
    keywords: [
      'exclamation',
      'surprise'
    ],
    sheet: [53, 16],
    shortName: 'bangbang'
  },
  {
    name: 'Guinea-Bissau Flag',
    unified: '1F1EC-1F1FC',
    sheet: [2, 12],
    shortName: 'flag-gw'
  },
  {
    name: 'Izakaya Lantern',
    unified: '1F3EE',
    keywords: [
      'light',
      'paper',
      'halloween',
      'spooky'
    ],
    sheet: [10, 55],
    shortNames: ['lantern'],
    shortName: 'izakaya_lantern'
  },
  {
    name: 'Honeybee',
    unified: '1F41D',
    sheet: [11, 49],
    shortNames: ['honeybee'],
    shortName: 'bee'
  },
  {
    name: 'Grinning Cat Face with Smiling Eyes',
    unified: '1F638',
    keywords: [
      'animal',
      'cats',
      'smile'
    ],
    sheet: [31, 30],
    shortName: 'smile_cat'
  },
  {
    name: 'Motorway',
    unified: '1F6E3-FE0F',
    keywords: [
      'road',
      'cupertino',
      'interstate',
      'highway'
    ],
    sheet: [36, 38],
    shortName: 'motorway'
  },
  {
    name: 'Man Shrugging',
    unified: '1F937-200D-2642-FE0F',
    sheet: [39, 51],
    skinVariations: [
      {
        unified: '1F937-1F3FB-200D-2642-FE0F',
        sheet: [39, 52]
      },
      {
        unified: '1F937-1F3FC-200D-2642-FE0F',
        sheet: [39, 53]
      },
      {
        unified: '1F937-1F3FD-200D-2642-FE0F',
        sheet: [39, 54]
      },
      {
        unified: '1F937-1F3FE-200D-2642-FE0F',
        sheet: [39, 55]
      },
      {
        unified: '1F937-1F3FF-200D-2642-FE0F',
        sheet: [39, 56]
      }
    ],
    shortName: 'man-shrugging'
  },
  {
    name: 'Glass of Milk',
    unified: '1F95B',
    sheet: [41, 50],
    shortName: 'glass_of_milk'
  },
  {
    name: 'Exclamation Question Mark',
    unified: '2049-FE0F',
    keywords: [
      'wat',
      'punctuation',
      'surprise'
    ],
    sheet: [53, 17],
    shortName: 'interrobang'
  },
  {
    name: 'Guyana Flag',
    unified: '1F1EC-1F1FE',
    sheet: [2, 13],
    shortName: 'flag-gy'
  },
  {
    name: 'Cat Face with Tears of Joy',
    unified: '1F639',
    keywords: [
      'animal',
      'cats',
      'haha',
      'happy',
      'tears'
    ],
    sheet: [31, 31],
    shortName: 'joy_cat'
  },
  {
    name: 'Railway Track',
    unified: '1F6E4-FE0F',
    keywords: [
      'train',
      'transportation'
    ],
    sheet: [36, 39],
    shortName: 'railway_track'
  },
  {
    name: 'Woman Shrugging',
    unified: '1F937-200D-2640-FE0F',
    sheet: [39, 45],
    skinVariations: [
      {
        unified: '1F937-1F3FB-200D-2640-FE0F',
        sheet: [39, 46]
      },
      {
        unified: '1F937-1F3FC-200D-2640-FE0F',
        sheet: [39, 47]
      },
      {
        unified: '1F937-1F3FD-200D-2640-FE0F',
        sheet: [39, 48]
      },
      {
        unified: '1F937-1F3FE-200D-2640-FE0F',
        sheet: [39, 49]
      },
      {
        unified: '1F937-1F3FF-200D-2640-FE0F',
        sheet: [39, 50]
      }
    ],
    shortName: 'woman-shrugging'
  },
  {
    name: 'Diya Lamp',
    unified: '1FA94',
    sheet: [52, 36],
    shortName: 'diya_lamp'
  },
  {
    name: 'Hot Beverage',
    unified: '2615',
    keywords: [
      'beverage',
      'caffeine',
      'latte',
      'espresso'
    ],
    sheet: [54, 5],
    shortName: 'coffee'
  },
  {
    name: 'Black Question Mark Ornament',
    unified: '2753',
    keywords: ['doubt', 'confused'],
    sheet: [56, 27],
    shortName: 'question'
  },
  {
    name: 'Hong Kong Sar China Flag',
    unified: '1F1ED-1F1F0',
    sheet: [2, 14],
    shortName: 'flag-hk'
  },
  {
    name: 'Notebook with Decorative Cover',
    unified: '1F4D4',
    keywords: [
      'classroom',
      'notes',
      'record',
      'paper',
      'study'
    ],
    sheet: [26, 43],
    shortName: 'notebook_with_decorative_cover'
  },
  {
    name: 'Smiling Cat Face with Heart-Shaped Eyes',
    unified: '1F63B',
    keywords: [
      'animal',
      'love',
      'like',
      'affection',
      'cats',
      'valentines',
      'heart'
    ],
    sheet: [31, 33],
    shortName: 'heart_eyes_cat'
  },
  {
    name: 'Oil Drum',
    unified: '1F6E2-FE0F',
    keywords: ['barrell'],
    sheet: [36, 37],
    shortName: 'oil_drum'
  },
  {
    name: 'Health Worker',
    unified: '1F9D1-200D-2695-FE0F',
    sheet: [48, 19],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-2695-FE0F',
        sheet: [48, 20]
      },
      {
        unified: '1F9D1-1F3FC-200D-2695-FE0F',
        sheet: [48, 21]
      },
      {
        unified: '1F9D1-1F3FD-200D-2695-FE0F',
        sheet: [48, 22]
      },
      {
        unified: '1F9D1-1F3FE-200D-2695-FE0F',
        sheet: [48, 23]
      },
      {
        unified: '1F9D1-1F3FF-200D-2695-FE0F',
        sheet: [48, 24]
      }
    ],
    shortName: 'health_worker'
  },
  {
    name: 'Beetle',
    unified: '1FAB2',
    keywords: [
      'animal',
      'insect',
      'nature',
      'ladybug'
    ],
    sheet: [53, 1],
    shortName: 'beetle'
  },
  {
    name: 'Teapot',
    unified: '1FAD6',
    sheet: [53, 15],
    shortName: 'teapot'
  },
  {
    name: 'White Question Mark Ornament',
    unified: '2754',
    keywords: [
      'doubts',
      'gray',
      'huh',
      'confused'
    ],
    sheet: [56, 28],
    shortName: 'grey_question'
  },
  {
    name: 'Heard & Mcdonald Islands Flag',
    unified: '1F1ED-1F1F2',
    sheet: [2, 15],
    shortName: 'flag-hm'
  },
  {
    name: 'Teacup Without Handle',
    unified: '1F375',
    keywords: [
      'drink',
      'bowl',
      'breakfast',
      'green',
      'british'
    ],
    sheet: [7, 13],
    shortName: 'tea'
  },
  {
    name: 'Male Doctor',
    unified: '1F468-200D-2695-FE0F',
    sheet: [16, 52],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-2695-FE0F',
        sheet: [16, 53]
      },
      {
        unified: '1F468-1F3FC-200D-2695-FE0F',
        sheet: [16, 54]
      },
      {
        unified: '1F468-1F3FD-200D-2695-FE0F',
        sheet: [16, 55]
      },
      {
        unified: '1F468-1F3FE-200D-2695-FE0F',
        sheet: [16, 56]
      },
      {
        unified: '1F468-1F3FF-200D-2695-FE0F',
        sheet: [16, 57]
      }
    ],
    shortName: 'male-doctor'
  },
  {
    name: 'Closed Book',
    unified: '1F4D5',
    keywords: [
      'read',
      'library',
      'knowledge',
      'textbook',
      'learn'
    ],
    sheet: [26, 44],
    shortName: 'closed_book'
  },
  {
    name: 'Cat Face with Wry Smile',
    unified: '1F63C',
    keywords: [
      'animal',
      'cats',
      'smirk'
    ],
    sheet: [31, 34],
    shortName: 'smirk_cat'
  },
  {
    name: 'Cricket',
    unified: '1F997',
    keywords: ['sports'],
    sheet: [42, 56],
    shortName: 'cricket'
  },
  {
    name: 'Fuel Pump',
    unified: '26FD',
    keywords: [
      'gas station',
      'petroleum'
    ],
    sheet: [55, 43],
    shortName: 'fuelpump'
  },
  {
    name: 'White Exclamation Mark Ornament',
    unified: '2755',
    keywords: [
      'surprise',
      'punctuation',
      'gray',
      'wow',
      'warning'
    ],
    sheet: [56, 29],
    shortName: 'grey_exclamation'
  },
  {
    name: 'Honduras Flag',
    unified: '1F1ED-1F1F3',
    sheet: [2, 16],
    shortName: 'flag-hn'
  },
  {
    name: 'Sake Bottle and Cup',
    unified: '1F376',
    keywords: [
      'wine',
      'drink',
      'drunk',
      'beverage',
      'japanese',
      'alcohol',
      'booze'
    ],
    sheet: [7, 14],
    shortName: 'sake'
  },
  {
    name: 'Female Doctor',
    unified: '1F469-200D-2695-FE0F',
    sheet: [19, 40],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-2695-FE0F',
        sheet: [19, 41]
      },
      {
        unified: '1F469-1F3FC-200D-2695-FE0F',
        sheet: [19, 42]
      },
      {
        unified: '1F469-1F3FD-200D-2695-FE0F',
        sheet: [19, 43]
      },
      {
        unified: '1F469-1F3FE-200D-2695-FE0F',
        sheet: [19, 44]
      },
      {
        unified: '1F469-1F3FF-200D-2695-FE0F',
        sheet: [19, 45]
      }
    ],
    shortName: 'female-doctor'
  },
  {
    name: 'Open Book',
    unified: '1F4D6',
    sheet: [26, 45],
    shortNames: ['open_book'],
    shortName: 'book'
  },
  {
    name: 'Kissing Cat Face with Closed Eyes',
    unified: '1F63D',
    keywords: [
      'animal',
      'cats',
      'kiss'
    ],
    sheet: [31, 35],
    shortName: 'kissing_cat'
  },
  {
    name: 'Police Cars Revolving Light',
    unified: '1F6A8',
    keywords: [
      'police',
      'ambulance',
      '911',
      'emergency',
      'alert',
      'error',
      'pinged',
      'law',
      'legal'
    ],
    sheet: [34, 49],
    shortName: 'rotating_light'
  },
  {
    name: 'Cockroach',
    unified: '1FAB3',
    sheet: [53, 2],
    shortName: 'cockroach'
  },
  {
    name: 'Heavy Exclamation Mark Symbol',
    unified: '2757',
    keywords: [
      'heavy_exclamation_mark',
      'danger',
      'surprise',
      'punctuation',
      'wow',
      'warning'
    ],
    sheet: [56, 30],
    shortNames: [
      'heavy_exclamation_mark'
    ],
    shortName: 'exclamation'
  },
  {
    name: 'Croatia Flag',
    unified: '1F1ED-1F1F7',
    sheet: [2, 17],
    shortName: 'flag-hr'
  },
  {
    name: 'Bottle with Popping Cork',
    unified: '1F37E',
    keywords: [
      'drink',
      'wine',
      'bottle',
      'celebration'
    ],
    sheet: [7, 22],
    shortName: 'champagne'
  },
  {
    name: 'Green Book',
    unified: '1F4D7',
    keywords: [
      'read',
      'library',
      'knowledge',
      'study'
    ],
    sheet: [26, 46],
    shortName: 'green_book'
  },
  {
    name: 'Spider',
    unified: '1F577-FE0F',
    keywords: ['animal', 'arachnid'],
    sheet: [29, 32],
    shortName: 'spider'
  },
  {
    name: 'Weary Cat Face',
    unified: '1F640',
    keywords: [
      'animal',
      'cats',
      'munch',
      'scared',
      'scream'
    ],
    sheet: [31, 38],
    shortName: 'scream_cat'
  },
  {
    name: 'Horizontal Traffic Light',
    unified: '1F6A5',
    keywords: [
      'transportation',
      'signal'
    ],
    sheet: [34, 46],
    shortName: 'traffic_light'
  },
  {
    name: 'Student',
    unified: '1F9D1-200D-1F393',
    sheet: [46, 1],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F393',
        sheet: [46, 2]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F393',
        sheet: [46, 3]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F393',
        sheet: [46, 4]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F393',
        sheet: [46, 5]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F393',
        sheet: [46, 6]
      }
    ],
    shortName: 'student'
  },
  {
    name: 'Wavy Dash',
    unified: '3030-FE0F',
    keywords: [
      'draw',
      'line',
      'moustache',
      'mustache',
      'squiggle',
      'scribble'
    ],
    sheet: [56, 48],
    shortName: 'wavy_dash'
  },
  {
    name: 'Haiti Flag',
    unified: '1F1ED-1F1F9',
    sheet: [2, 18],
    shortName: 'flag-ht'
  },
  {
    name: 'Wine Glass',
    unified: '1F377',
    keywords: [
      'drink',
      'beverage',
      'drunk',
      'alcohol',
      'booze'
    ],
    sheet: [7, 15],
    shortName: 'wine_glass'
  },
  {
    name: 'Male Student',
    unified: '1F468-200D-1F393',
    sheet: [14, 45],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F393',
        sheet: [14, 46]
      },
      {
        unified: '1F468-1F3FC-200D-1F393',
        sheet: [14, 47]
      },
      {
        unified: '1F468-1F3FD-200D-1F393',
        sheet: [14, 48]
      },
      {
        unified: '1F468-1F3FE-200D-1F393',
        sheet: [14, 49]
      },
      {
        unified: '1F468-1F3FF-200D-1F393',
        sheet: [14, 50]
      }
    ],
    shortName: 'male-student'
  },
  {
    name: 'Currency Exchange',
    unified: '1F4B1',
    keywords: [
      'money',
      'sales',
      'dollar',
      'travel'
    ],
    sheet: [26, 8],
    shortName: 'currency_exchange'
  },
  {
    name: 'Blue Book',
    unified: '1F4D8',
    keywords: [
      'read',
      'library',
      'knowledge',
      'learn',
      'study'
    ],
    sheet: [26, 47],
    shortName: 'blue_book'
  },
  {
    name: 'Spider Web',
    unified: '1F578-FE0F',
    keywords: [
      'animal',
      'insect',
      'arachnid',
      'silk'
    ],
    sheet: [29, 33],
    shortName: 'spider_web'
  },
  {
    name: 'Crying Cat Face',
    unified: '1F63F',
    keywords: [
      'animal',
      'tears',
      'weep',
      'sad',
      'cats',
      'upset',
      'cry'
    ],
    sheet: [31, 37],
    shortName: 'crying_cat_face'
  },
  {
    name: 'Vertical Traffic Light',
    unified: '1F6A6',
    keywords: [
      'transportation',
      'driving'
    ],
    sheet: [34, 47],
    shortName: 'vertical_traffic_light'
  },
  {
    name: 'Hungary Flag',
    unified: '1F1ED-1F1FA',
    sheet: [2, 19],
    shortName: 'flag-hu'
  },
  {
    name: 'Cocktail Glass',
    unified: '1F378',
    keywords: [
      'drink',
      'drunk',
      'alcohol',
      'beverage',
      'booze',
      'mojito'
    ],
    sheet: [7, 16],
    shortName: 'cocktail'
  },
  {
    name: 'Female Student',
    unified: '1F469-200D-1F393',
    sheet: [17, 38],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F393',
        sheet: [17, 39]
      },
      {
        unified: '1F469-1F3FC-200D-1F393',
        sheet: [17, 40]
      },
      {
        unified: '1F469-1F3FD-200D-1F393',
        sheet: [17, 41]
      },
      {
        unified: '1F469-1F3FE-200D-1F393',
        sheet: [17, 42]
      },
      {
        unified: '1F469-1F3FF-200D-1F393',
        sheet: [17, 43]
      }
    ],
    shortName: 'female-student'
  },
  {
    name: 'Heavy Dollar Sign',
    unified: '1F4B2',
    keywords: [
      'money',
      'sales',
      'payment',
      'currency',
      'buck'
    ],
    sheet: [26, 9],
    shortName: 'heavy_dollar_sign'
  },
  {
    name: 'Orange Book',
    unified: '1F4D9',
    keywords: [
      'read',
      'library',
      'knowledge',
      'textbook',
      'study'
    ],
    sheet: [26, 48],
    shortName: 'orange_book'
  },
  {
    name: 'Pouting Cat Face',
    unified: '1F63E',
    keywords: ['animal', 'cats'],
    sheet: [31, 36],
    shortName: 'pouting_cat'
  },
  {
    name: 'Octagonal Sign',
    unified: '1F6D1',
    sheet: [36, 30],
    shortName: 'octagonal_sign'
  },
  {
    name: 'Scorpion',
    unified: '1F982',
    keywords: ['animal', 'arachnid'],
    sheet: [42, 35],
    shortName: 'scorpion'
  },
  {
    name: 'Canary Islands Flag',
    unified: '1F1EE-1F1E8',
    sheet: [2, 20],
    shortName: 'flag-ic'
  },
  {
    name: 'Tropical Drink',
    unified: '1F379',
    keywords: [
      'beverage',
      'cocktail',
      'summer',
      'beach',
      'alcohol',
      'booze',
      'mojito'
    ],
    sheet: [7, 17],
    shortName: 'tropical_drink'
  },
  {
    name: 'Books',
    unified: '1F4DA',
    keywords: [
      'literature',
      'library',
      'study'
    ],
    sheet: [26, 49],
    shortName: 'books'
  },
  {
    name: 'See-No-Evil Monkey',
    unified: '1F648',
    keywords: [
      'monkey',
      'animal',
      'nature',
      'haha'
    ],
    sheet: [32, 39],
    shortName: 'see_no_evil'
  },
  {
    name: 'Construction Sign',
    unified: '1F6A7',
    keywords: [
      'wip',
      'progress',
      'caution',
      'warning'
    ],
    sheet: [34, 48],
    shortName: 'construction'
  },
  {
    name: 'Mosquito',
    unified: '1F99F',
    keywords: [
      'animal',
      'nature',
      'insect',
      'malaria'
    ],
    sheet: [43, 6],
    shortName: 'mosquito'
  },
  {
    name: 'Teacher',
    unified: '1F9D1-200D-1F3EB',
    sheet: [46, 19],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F3EB',
        sheet: [46, 20]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F3EB',
        sheet: [46, 21]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F3EB',
        sheet: [46, 22]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F3EB',
        sheet: [46, 23]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F3EB',
        sheet: [46, 24]
      }
    ],
    shortName: 'teacher'
  },
  {
    name: 'Medical Symbol',
    unified: '2695-FE0F',
    sheet: [54, 49],
    hidden: ['apple'],
    shortNames: ['staff_of_aesculapius'],
    shortName: 'medical_symbol'
  },
  {
    name: 'Indonesia Flag',
    unified: '1F1EE-1F1E9',
    sheet: [2, 21],
    shortName: 'flag-id'
  },
  {
    name: 'Beer Mug',
    unified: '1F37A',
    keywords: [
      'relax',
      'beverage',
      'drink',
      'drunk',
      'party',
      'pub',
      'summer',
      'alcohol',
      'booze'
    ],
    sheet: [7, 18],
    shortName: 'beer'
  },
  {
    name: 'Male Teacher',
    unified: '1F468-200D-1F3EB',
    sheet: [15, 5],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F3EB',
        sheet: [15, 6]
      },
      {
        unified: '1F468-1F3FC-200D-1F3EB',
        sheet: [15, 7]
      },
      {
        unified: '1F468-1F3FD-200D-1F3EB',
        sheet: [15, 8]
      },
      {
        unified: '1F468-1F3FE-200D-1F3EB',
        sheet: [15, 9]
      },
      {
        unified: '1F468-1F3FF-200D-1F3EB',
        sheet: [15, 10]
      }
    ],
    shortName: 'male-teacher'
  },
  {
    name: 'Notebook',
    unified: '1F4D3',
    keywords: [
      'stationery',
      'record',
      'notes',
      'paper',
      'study'
    ],
    sheet: [26, 42],
    shortName: 'notebook'
  },
  {
    name: 'Hear-No-Evil Monkey',
    unified: '1F649',
    keywords: [
      'animal',
      'monkey',
      'nature'
    ],
    sheet: [32, 40],
    shortName: 'hear_no_evil'
  },
  {
    name: 'Fly',
    unified: '1FAB0',
    sheet: [52, 57],
    shortName: 'fly'
  },
  {
    name: 'Black Universal Recycling Symbol',
    unified: '267B-FE0F',
    keywords: [
      'arrow',
      'environment',
      'garbage',
      'trash'
    ],
    sheet: [54, 43],
    shortName: 'recycle'
  },
  {
    name: 'Anchor',
    unified: '2693',
    keywords: [
      'ship',
      'ferry',
      'sea',
      'boat'
    ],
    sheet: [54, 47],
    shortName: 'anchor'
  },
  {
    name: 'Ireland Flag',
    unified: '1F1EE-1F1EA',
    sheet: [2, 22],
    shortName: 'flag-ie'
  },
  {
    name: 'Clinking Beer Mugs',
    unified: '1F37B',
    keywords: [
      'relax',
      'beverage',
      'drink',
      'drunk',
      'party',
      'pub',
      'summer',
      'alcohol',
      'booze'
    ],
    sheet: [7, 19],
    shortName: 'beers'
  },
  {
    name: 'Female Teacher',
    unified: '1F469-200D-1F3EB',
    sheet: [17, 56],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F3EB',
        sheet: [17, 57]
      },
      {
        unified: '1F469-1F3FC-200D-1F3EB',
        sheet: [18, 0]
      },
      {
        unified: '1F469-1F3FD-200D-1F3EB',
        sheet: [18, 1]
      },
      {
        unified: '1F469-1F3FE-200D-1F3EB',
        sheet: [18, 2]
      },
      {
        unified: '1F469-1F3FF-200D-1F3EB',
        sheet: [18, 3]
      }
    ],
    shortName: 'female-teacher'
  },
  {
    name: 'Ledger',
    unified: '1F4D2',
    keywords: ['notes', 'paper'],
    sheet: [26, 41],
    shortName: 'ledger'
  },
  {
    name: 'Speak-No-Evil Monkey',
    unified: '1F64A',
    keywords: [
      'monkey',
      'animal',
      'nature',
      'omg'
    ],
    sheet: [32, 41],
    shortName: 'speak_no_evil'
  },
  {
    name: 'Worm',
    unified: '1FAB1',
    sheet: [53, 0],
    shortName: 'worm'
  },
  {
    name: 'Fleur De Lis',
    unified: '269C-FE0F',
    keywords: ['decorative', 'scout'],
    sheet: [54, 54],
    shortName: 'fleur_de_lis'
  },
  {
    name: 'Sailboat',
    unified: '26F5',
    sheet: [55, 21],
    shortNames: ['sailboat'],
    shortName: 'boat'
  },
  {
    name: 'Israel Flag',
    unified: '1F1EE-1F1F1',
    sheet: [2, 23],
    shortName: 'flag-il'
  },
  {
    name: 'Kiss Mark',
    unified: '1F48B',
    keywords: [
      'face',
      'lips',
      'love',
      'like',
      'affection',
      'valentines'
    ],
    sheet: [25, 23],
    shortName: 'kiss'
  },
  {
    name: 'Page with Curl',
    unified: '1F4C3',
    keywords: [
      'documents',
      'office',
      'paper'
    ],
    sheet: [26, 26],
    shortName: 'page_with_curl'
  },
  {
    name: 'Trident Emblem',
    unified: '1F531',
    keywords: ['weapon', 'spear'],
    sheet: [28, 19],
    shortName: 'trident'
  },
  {
    name: 'Canoe',
    unified: '1F6F6',
    keywords: [
      'boat',
      'paddle',
      'water',
      'ship'
    ],
    sheet: [36, 48],
    shortName: 'canoe'
  },
  {
    name: 'Clinking Glasses',
    unified: '1F942',
    keywords: [
      'beverage',
      'drink',
      'party',
      'alcohol',
      'celebrate',
      'cheers',
      'wine',
      'champagne',
      'toast'
    ],
    sheet: [41, 26],
    shortName: 'clinking_glasses'
  },
  {
    name: 'Microbe',
    unified: '1F9A0',
    keywords: [
      'amoeba',
      'bacteria',
      'germs'
    ],
    sheet: [43, 7],
    shortName: 'microbe'
  },
  {
    name: 'Judge',
    unified: '1F9D1-200D-2696-FE0F',
    sheet: [48, 25],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-2696-FE0F',
        sheet: [48, 26]
      },
      {
        unified: '1F9D1-1F3FC-200D-2696-FE0F',
        sheet: [48, 27]
      },
      {
        unified: '1F9D1-1F3FD-200D-2696-FE0F',
        sheet: [48, 28]
      },
      {
        unified: '1F9D1-1F3FE-200D-2696-FE0F',
        sheet: [48, 29]
      },
      {
        unified: '1F9D1-1F3FF-200D-2696-FE0F',
        sheet: [48, 30]
      }
    ],
    shortName: 'judge'
  },
  {
    name: 'Isle of Man Flag',
    unified: '1F1EE-1F1F2',
    sheet: [2, 24],
    shortName: 'flag-im'
  },
  {
    name: 'Male Judge',
    unified: '1F468-200D-2696-FE0F',
    sheet: [17, 0],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-2696-FE0F',
        sheet: [17, 1]
      },
      {
        unified: '1F468-1F3FC-200D-2696-FE0F',
        sheet: [17, 2]
      },
      {
        unified: '1F468-1F3FD-200D-2696-FE0F',
        sheet: [17, 3]
      },
      {
        unified: '1F468-1F3FE-200D-2696-FE0F',
        sheet: [17, 4]
      },
      {
        unified: '1F468-1F3FF-200D-2696-FE0F',
        sheet: [17, 5]
      }
    ],
    shortName: 'male-judge'
  },
  {
    name: 'Love Letter',
    unified: '1F48C',
    keywords: [
      'email',
      'like',
      'affection',
      'envelope',
      'valentines'
    ],
    sheet: [25, 24],
    shortName: 'love_letter'
  },
  {
    name: 'Bouquet',
    unified: '1F490',
    keywords: [
      'flowers',
      'nature',
      'spring'
    ],
    sheet: [25, 28],
    shortName: 'bouquet'
  },
  {
    name: 'Name Badge',
    unified: '1F4DB',
    keywords: ['fire', 'forbid'],
    sheet: [26, 50],
    shortName: 'name_badge'
  },
  {
    name: 'Scroll',
    unified: '1F4DC',
    keywords: [
      'documents',
      'ancient',
      'history',
      'paper'
    ],
    sheet: [26, 51],
    shortName: 'scroll'
  },
  {
    name: 'Speedboat',
    unified: '1F6A4',
    keywords: [
      'ship',
      'transportation',
      'vehicle',
      'summer'
    ],
    sheet: [34, 45],
    shortName: 'speedboat'
  },
  {
    name: 'Tumbler Glass',
    unified: '1F943',
    keywords: [
      'drink',
      'beverage',
      'drunk',
      'alcohol',
      'liquor',
      'booze',
      'bourbon',
      'scotch',
      'whisky',
      'glass',
      'shot'
    ],
    sheet: [41, 27],
    shortName: 'tumbler_glass'
  },
  {
    name: 'India Flag',
    unified: '1F1EE-1F1F3',
    sheet: [2, 25],
    shortName: 'flag-in'
  },
  {
    name: 'Cherry Blossom',
    unified: '1F338',
    keywords: [
      'nature',
      'plant',
      'spring',
      'flower'
    ],
    sheet: [6, 10],
    shortName: 'cherry_blossom'
  },
  {
    name: 'Female Judge',
    unified: '1F469-200D-2696-FE0F',
    sheet: [19, 46],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-2696-FE0F',
        sheet: [19, 47]
      },
      {
        unified: '1F469-1F3FC-200D-2696-FE0F',
        sheet: [19, 48]
      },
      {
        unified: '1F469-1F3FD-200D-2696-FE0F',
        sheet: [19, 49]
      },
      {
        unified: '1F469-1F3FE-200D-2696-FE0F',
        sheet: [19, 50]
      },
      {
        unified: '1F469-1F3FF-200D-2696-FE0F',
        sheet: [19, 51]
      }
    ],
    shortName: 'female-judge'
  },
  {
    name: 'Heart with Arrow',
    unified: '1F498',
    keywords: [
      'love',
      'like',
      'heart',
      'affection',
      'valentines'
    ],
    sheet: [25, 36],
    shortName: 'cupid'
  },
  {
    name: 'Page Facing Up',
    unified: '1F4C4',
    keywords: [
      'documents',
      'office',
      'paper',
      'information'
    ],
    sheet: [26, 27],
    shortName: 'page_facing_up'
  },
  {
    name: 'Japanese Symbol for Beginner',
    unified: '1F530',
    keywords: ['badge', 'shield'],
    sheet: [28, 18],
    shortName: 'beginner'
  },
  {
    name: 'Passenger Ship',
    unified: '1F6F3-FE0F',
    keywords: [
      'yacht',
      'cruise',
      'ferry'
    ],
    sheet: [36, 45],
    shortName: 'passenger_ship'
  },
  {
    name: 'Cup with Straw',
    unified: '1F964',
    keywords: ['drink', 'soda'],
    sheet: [42, 1],
    shortName: 'cup_with_straw'
  },
  {
    name: 'British Indian Ocean Territory Flag',
    unified: '1F1EE-1F1F4',
    sheet: [2, 26],
    shortName: 'flag-io'
  },
  {
    name: 'Heart with Ribbon',
    unified: '1F49D',
    keywords: ['love', 'valentines'],
    sheet: [25, 41],
    shortName: 'gift_heart'
  },
  {
    name: 'White Flower',
    unified: '1F4AE',
    keywords: ['japanese', 'spring'],
    sheet: [26, 5],
    shortName: 'white_flower'
  },
  {
    name: 'Newspaper',
    unified: '1F4F0',
    keywords: ['press', 'headline'],
    sheet: [27, 13],
    shortName: 'newspaper'
  },
  {
    name: 'Bubble Tea',
    unified: '1F9CB',
    sheet: [44, 37],
    shortName: 'bubble_tea'
  },
  {
    name: 'Farmer',
    unified: '1F9D1-200D-1F33E',
    sheet: [45, 35],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F33E',
        sheet: [45, 36]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F33E',
        sheet: [45, 37]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F33E',
        sheet: [45, 38]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F33E',
        sheet: [45, 39]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F33E',
        sheet: [45, 40]
      }
    ],
    shortName: 'farmer'
  },
  {
    name: 'Ferry',
    unified: '26F4-FE0F',
    keywords: ['boat', 'ship', 'yacht'],
    sheet: [55, 20],
    shortName: 'ferry'
  },
  {
    name: 'Heavy Large Circle',
    unified: '2B55',
    keywords: ['circle', 'round'],
    sheet: [56, 47],
    shortName: 'o'
  },
  {
    name: 'Iraq Flag',
    unified: '1F1EE-1F1F6',
    sheet: [2, 27],
    shortName: 'flag-iq'
  },
  {
    name: 'Rosette',
    unified: '1F3F5-FE0F',
    keywords: [
      'flower',
      'decoration',
      'military'
    ],
    sheet: [11, 8],
    shortName: 'rosette'
  },
  {
    name: 'Male Farmer',
    unified: '1F468-200D-1F33E',
    sheet: [14, 27],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F33E',
        sheet: [14, 28]
      },
      {
        unified: '1F468-1F3FC-200D-1F33E',
        sheet: [14, 29]
      },
      {
        unified: '1F468-1F3FD-200D-1F33E',
        sheet: [14, 30]
      },
      {
        unified: '1F468-1F3FE-200D-1F33E',
        sheet: [14, 31]
      },
      {
        unified: '1F468-1F3FF-200D-1F33E',
        sheet: [14, 32]
      }
    ],
    shortName: 'male-farmer'
  },
  {
    name: 'Sparkling Heart',
    unified: '1F496',
    keywords: [
      'love',
      'like',
      'affection',
      'valentines'
    ],
    sheet: [25, 34],
    shortName: 'sparkling_heart'
  },
  {
    name: 'Rolled Up Newspaper',
    unified: '1F5DE-FE0F',
    sheet: [30, 20],
    shortName: 'rolled_up_newspaper'
  },
  {
    name: 'Motor Boat',
    unified: '1F6E5-FE0F',
    keywords: ['ship'],
    sheet: [36, 40],
    shortName: 'motor_boat'
  },
  {
    name: 'Beverage Box',
    unified: '1F9C3',
    sheet: [44, 29],
    shortName: 'beverage_box'
  },
  {
    name: 'White Heavy Check Mark',
    unified: '2705',
    keywords: [
      'green-square',
      'ok',
      'agree',
      'vote',
      'election',
      'answer',
      'tick'
    ],
    sheet: [55, 45],
    shortName: 'white_check_mark'
  },
  {
    name: 'Iran Flag',
    unified: '1F1EE-1F1F7',
    sheet: [2, 28],
    shortName: 'flag-ir'
  },
  {
    name: 'Rose',
    unified: '1F339',
    keywords: [
      'flowers',
      'valentines',
      'love',
      'spring'
    ],
    sheet: [6, 11],
    shortName: 'rose'
  },
  {
    name: 'Female Farmer',
    unified: '1F469-200D-1F33E',
    sheet: [17, 20],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F33E',
        sheet: [17, 21]
      },
      {
        unified: '1F469-1F3FC-200D-1F33E',
        sheet: [17, 22]
      },
      {
        unified: '1F469-1F3FD-200D-1F33E',
        sheet: [17, 23]
      },
      {
        unified: '1F469-1F3FE-200D-1F33E',
        sheet: [17, 24]
      },
      {
        unified: '1F469-1F3FF-200D-1F33E',
        sheet: [17, 25]
      }
    ],
    shortName: 'female-farmer'
  },
  {
    name: 'Growing Heart',
    unified: '1F497',
    keywords: [
      'like',
      'love',
      'affection',
      'valentines',
      'pink'
    ],
    sheet: [25, 35],
    shortName: 'heartpulse'
  },
  {
    name: 'Bookmark Tabs',
    unified: '1F4D1',
    keywords: [
      'favorite',
      'save',
      'order',
      'tidy'
    ],
    sheet: [26, 40],
    shortName: 'bookmark_tabs'
  },
  {
    name: 'Ship',
    unified: '1F6A2',
    keywords: [
      'transportation',
      'titanic',
      'deploy'
    ],
    sheet: [34, 26],
    shortName: 'ship'
  },
  {
    name: 'Mate Drink',
    unified: '1F9C9',
    sheet: [44, 35],
    shortName: 'mate_drink'
  },
  {
    name: 'Ballot Box with Check',
    unified: '2611-FE0F',
    keywords: [
      'ok',
      'agree',
      'confirm',
      'black-square',
      'vote',
      'election',
      'yes',
      'tick'
    ],
    sheet: [54, 3],
    shortName: 'ballot_box_with_check'
  },
  {
    name: 'Iceland Flag',
    unified: '1F1EE-1F1F8',
    sheet: [2, 29],
    shortName: 'flag-is'
  },
  {
    name: 'Beating Heart',
    unified: '1F493',
    keywords: [
      'love',
      'like',
      'affection',
      'valentines',
      'pink',
      'heart'
    ],
    sheet: [25, 31],
    shortName: 'heartbeat'
  },
  {
    name: 'Bookmark',
    unified: '1F516',
    keywords: [
      'favorite',
      'label',
      'save'
    ],
    sheet: [27, 50],
    shortName: 'bookmark'
  },
  {
    name: 'Wilted Flower',
    unified: '1F940',
    keywords: [
      'plant',
      'nature',
      'flower'
    ],
    sheet: [41, 24],
    shortName: 'wilted_flower'
  },
  {
    name: 'Ice Cube',
    unified: '1F9CA',
    sheet: [44, 36],
    shortName: 'ice_cube'
  },
  {
    name: 'Cook',
    unified: '1F9D1-200D-1F373',
    sheet: [45, 41],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F373',
        sheet: [45, 42]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F373',
        sheet: [45, 43]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F373',
        sheet: [45, 44]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F373',
        sheet: [45, 45]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F373',
        sheet: [45, 46]
      }
    ],
    shortName: 'cook'
  },
  {
    name: 'Airplane',
    unified: '2708-FE0F',
    keywords: [
      'vehicle',
      'transportation',
      'flight',
      'fly'
    ],
    sheet: [55, 46],
    shortName: 'airplane'
  },
  {
    name: 'Heavy Check Mark',
    unified: '2714-FE0F',
    keywords: [
      'ok',
      'nike',
      'answer',
      'yes',
      'tick'
    ],
    sheet: [56, 16],
    shortName: 'heavy_check_mark'
  },
  {
    name: 'Italy Flag',
    unified: '1F1EE-1F1F9',
    keywords: [
      'italy',
      'flag',
      'nation',
      'country',
      'banner'
    ],
    sheet: [2, 30],
    shortNames: ['flag-it'],
    shortName: 'it'
  },
  {
    name: 'Hibiscus',
    unified: '1F33A',
    keywords: [
      'plant',
      'vegetable',
      'flowers',
      'beach'
    ],
    sheet: [6, 12],
    shortName: 'hibiscus'
  },
  {
    name: 'Label',
    unified: '1F3F7-FE0F',
    keywords: ['sale', 'tag'],
    sheet: [11, 9],
    shortName: 'label'
  },
  {
    name: 'Male Cook',
    unified: '1F468-200D-1F373',
    sheet: [14, 33],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F373',
        sheet: [14, 34]
      },
      {
        unified: '1F468-1F3FC-200D-1F373',
        sheet: [14, 35]
      },
      {
        unified: '1F468-1F3FD-200D-1F373',
        sheet: [14, 36]
      },
      {
        unified: '1F468-1F3FE-200D-1F373',
        sheet: [14, 37]
      },
      {
        unified: '1F468-1F3FF-200D-1F373',
        sheet: [14, 38]
      }
    ],
    shortName: 'male-cook'
  },
  {
    name: 'Revolving Hearts',
    unified: '1F49E',
    keywords: [
      'love',
      'like',
      'affection',
      'valentines'
    ],
    sheet: [25, 42],
    shortName: 'revolving_hearts'
  },
  {
    name: 'Small Airplane',
    unified: '1F6E9-FE0F',
    keywords: [
      'flight',
      'transportation',
      'fly',
      'vehicle'
    ],
    sheet: [36, 41],
    shortName: 'small_airplane'
  },
  {
    name: 'Chopsticks',
    unified: '1F962',
    keywords: ['food'],
    sheet: [41, 57],
    shortName: 'chopsticks'
  },
  {
    name: 'Cross Mark',
    unified: '274C',
    keywords: [
      'no',
      'delete',
      'remove',
      'cancel',
      'red'
    ],
    sheet: [56, 25],
    shortName: 'x'
  },
  {
    name: 'Jersey Flag',
    unified: '1F1EF-1F1EA',
    sheet: [2, 31],
    shortName: 'flag-je'
  },
  {
    name: 'Sunflower',
    unified: '1F33B',
    keywords: [
      'nature',
      'plant',
      'fall'
    ],
    sheet: [6, 13],
    shortName: 'sunflower'
  },
  {
    name: 'Knife Fork Plate',
    unified: '1F37D-FE0F',
    sheet: [7, 21],
    shortName: 'knife_fork_plate'
  },
  {
    name: 'Female Cook',
    unified: '1F469-200D-1F373',
    sheet: [17, 26],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F373',
        sheet: [17, 27]
      },
      {
        unified: '1F469-1F3FC-200D-1F373',
        sheet: [17, 28]
      },
      {
        unified: '1F469-1F3FD-200D-1F373',
        sheet: [17, 29]
      },
      {
        unified: '1F469-1F3FE-200D-1F373',
        sheet: [17, 30]
      },
      {
        unified: '1F469-1F3FF-200D-1F373',
        sheet: [17, 31]
      }
    ],
    shortName: 'female-cook'
  },
  {
    name: 'Two Hearts',
    unified: '1F495',
    keywords: [
      'love',
      'like',
      'affection',
      'valentines',
      'heart'
    ],
    sheet: [25, 33],
    shortName: 'two_hearts'
  },
  {
    name: 'Money Bag',
    unified: '1F4B0',
    keywords: [
      'dollar',
      'payment',
      'coins',
      'sale'
    ],
    sheet: [26, 7],
    shortName: 'moneybag'
  },
  {
    name: 'Airplane Departure',
    unified: '1F6EB',
    sheet: [36, 42],
    shortName: 'airplane_departure'
  },
  {
    name: 'Negative Squared Cross Mark',
    unified: '274E',
    keywords: [
      'x',
      'green-square',
      'no',
      'deny'
    ],
    sheet: [56, 26],
    shortName: 'negative_squared_cross_mark'
  },
  {
    name: 'Jamaica Flag',
    unified: '1F1EF-1F1F2',
    sheet: [2, 32],
    shortName: 'flag-jm'
  },
  {
    name: 'Blossom',
    unified: '1F33C',
    keywords: [
      'nature',
      'flowers',
      'yellow'
    ],
    sheet: [6, 14],
    shortName: 'blossom'
  },
  {
    name: 'Fork and Knife',
    unified: '1F374',
    keywords: ['cutlery', 'kitchen'],
    sheet: [7, 12],
    shortName: 'fork_and_knife'
  },
  {
    name: 'Heart Decoration',
    unified: '1F49F',
    keywords: [
      'purple-square',
      'love',
      'like'
    ],
    sheet: [25, 43],
    shortName: 'heart_decoration'
  },
  {
    name: 'Airplane Arriving',
    unified: '1F6EC',
    sheet: [36, 43],
    shortName: 'airplane_arriving'
  },
  {
    name: 'Mechanic',
    unified: '1F9D1-200D-1F527',
    sheet: [46, 43],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F527',
        sheet: [46, 44]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F527',
        sheet: [46, 45]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F527',
        sheet: [46, 46]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F527',
        sheet: [46, 47]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F527',
        sheet: [46, 48]
      }
    ],
    shortName: 'mechanic'
  },
  {
    name: 'Coin',
    unified: '1FA99',
    sheet: [52, 41],
    shortName: 'coin'
  },
  {
    name: 'Curly Loop',
    unified: '27B0',
    keywords: [
      'scribble',
      'draw',
      'shape',
      'squiggle'
    ],
    sheet: [56, 37],
    shortName: 'curly_loop'
  },
  {
    name: 'Jordan Flag',
    unified: '1F1EF-1F1F4',
    sheet: [2, 33],
    shortName: 'flag-jo'
  },
  {
    name: 'Tulip',
    unified: '1F337',
    keywords: [
      'flowers',
      'plant',
      'nature',
      'summer',
      'spring'
    ],
    sheet: [6, 9],
    shortName: 'tulip'
  },
  {
    name: 'Male Mechanic',
    unified: '1F468-200D-1F527',
    sheet: [15, 44],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F527',
        sheet: [15, 45]
      },
      {
        unified: '1F468-1F3FC-200D-1F527',
        sheet: [15, 46]
      },
      {
        unified: '1F468-1F3FD-200D-1F527',
        sheet: [15, 47]
      },
      {
        unified: '1F468-1F3FE-200D-1F527',
        sheet: [15, 48]
      },
      {
        unified: '1F468-1F3FF-200D-1F527',
        sheet: [15, 49]
      }
    ],
    shortName: 'male-mechanic'
  },
  {
    name: 'Banknote with Yen Sign',
    unified: '1F4B4',
    keywords: [
      'money',
      'sales',
      'japanese',
      'dollar',
      'currency'
    ],
    sheet: [26, 11],
    shortName: 'yen'
  },
  {
    name: 'Spoon',
    unified: '1F944',
    keywords: [
      'cutlery',
      'kitchen',
      'tableware'
    ],
    sheet: [41, 28],
    shortName: 'spoon'
  },
  {
    name: 'Parachute',
    unified: '1FA82',
    sheet: [52, 27],
    shortName: 'parachute'
  },
  {
    name: 'Heavy Heart Exclamation Mark Ornament',
    unified: '2763-FE0F',
    sheet: [56, 31],
    shortName: 'heavy_heart_exclamation_mark_ornament'
  },
  {
    name: 'Double Curly Loop',
    unified: '27BF',
    keywords: ['tape', 'cassette'],
    sheet: [56, 38],
    shortName: 'loop'
  },
  {
    name: 'Japan Flag',
    unified: '1F1EF-1F1F5',
    keywords: [
      'japanese',
      'nation',
      'flag',
      'country',
      'banner'
    ],
    sheet: [2, 34],
    shortNames: ['flag-jp'],
    shortName: 'jp'
  },
  {
    name: 'Seedling',
    unified: '1F331',
    keywords: [
      'plant',
      'nature',
      'grass',
      'lawn',
      'spring'
    ],
    sheet: [6, 3],
    shortName: 'seedling'
  },
  {
    name: 'Female Mechanic',
    unified: '1F469-200D-1F527',
    sheet: [18, 32],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F527',
        sheet: [18, 33]
      },
      {
        unified: '1F469-1F3FC-200D-1F527',
        sheet: [18, 34]
      },
      {
        unified: '1F469-1F3FD-200D-1F527',
        sheet: [18, 35]
      },
      {
        unified: '1F469-1F3FE-200D-1F527',
        sheet: [18, 36]
      },
      {
        unified: '1F469-1F3FF-200D-1F527',
        sheet: [18, 37]
      }
    ],
    shortName: 'female-mechanic'
  },
  {
    name: 'Broken Heart',
    unified: '1F494',
    text: '</3',
    emoticons: ['</3'],
    keywords: [
      'sad',
      'sorry',
      'break',
      'heart',
      'heartbreak'
    ],
    sheet: [25, 32],
    shortName: 'broken_heart'
  },
  {
    name: 'Banknote with Dollar Sign',
    unified: '1F4B5',
    keywords: [
      'money',
      'sales',
      'bill',
      'currency'
    ],
    sheet: [26, 12],
    shortName: 'dollar'
  },
  {
    name: 'Seat',
    unified: '1F4BA',
    keywords: [
      'sit',
      'airplane',
      'transport',
      'bus',
      'flight',
      'fly'
    ],
    sheet: [26, 17],
    shortName: 'seat'
  },
  {
    name: 'Hocho',
    unified: '1F52A',
    keywords: [
      'knife',
      'blade',
      'cutlery',
      'kitchen',
      'weapon'
    ],
    sheet: [28, 12],
    shortNames: ['knife'],
    shortName: 'hocho'
  },
  {
    name: 'Part Alternation Mark',
    unified: '303D-FE0F',
    keywords: [
      'graph',
      'presentation',
      'stats',
      'business',
      'economics',
      'bad'
    ],
    sheet: [56, 49],
    shortName: 'part_alternation_mark'
  },
  {
    name: 'Kenya Flag',
    unified: '1F1F0-1F1EA',
    sheet: [2, 35],
    shortName: 'flag-ke'
  },
  {
    name: 'Amphora',
    unified: '1F3FA',
    keywords: ['vase', 'jar'],
    sheet: [11, 12],
    shortName: 'amphora'
  },
  {
    name: 'Banknote with Euro Sign',
    unified: '1F4B6',
    keywords: [
      'money',
      'sales',
      'dollar',
      'currency'
    ],
    sheet: [26, 13],
    shortName: 'euro'
  },
  {
    name: 'Helicopter',
    unified: '1F681',
    keywords: [
      'transportation',
      'vehicle',
      'fly'
    ],
    sheet: [33, 51],
    shortName: 'helicopter'
  },
  {
    name: 'Factory Worker',
    unified: '1F9D1-200D-1F3ED',
    sheet: [46, 25],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F3ED',
        sheet: [46, 26]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F3ED',
        sheet: [46, 27]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F3ED',
        sheet: [46, 28]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F3ED',
        sheet: [46, 29]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F3ED',
        sheet: [46, 30]
      }
    ],
    shortName: 'factory_worker'
  },
  {
    name: 'Potted Plant',
    unified: '1FAB4',
    sheet: [53, 3],
    shortName: 'potted_plant'
  },
  {
    name: 'Eight Spoked Asterisk',
    unified: '2733-FE0F',
    keywords: [
      'star',
      'sparkle',
      'green-square'
    ],
    sheet: [56, 21],
    shortName: 'eight_spoked_asterisk'
  },
  {
    name: 'Heavy Black Heart',
    unified: '2764-FE0F',
    text: '<3',
    emoticons: ['<3'],
    keywords: [
      'love',
      'like',
      'valentines'
    ],
    sheet: [56, 32],
    shortName: 'heart'
  },
  {
    name: 'Kyrgyzstan Flag',
    unified: '1F1F0-1F1EC',
    sheet: [2, 36],
    shortName: 'flag-kg'
  },
  {
    name: 'Evergreen Tree',
    unified: '1F332',
    keywords: ['plant', 'nature'],
    sheet: [6, 4],
    shortName: 'evergreen_tree'
  },
  {
    name: 'Male Factory Worker',
    unified: '1F468-200D-1F3ED',
    sheet: [15, 11],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F3ED',
        sheet: [15, 12]
      },
      {
        unified: '1F468-1F3FC-200D-1F3ED',
        sheet: [15, 13]
      },
      {
        unified: '1F468-1F3FD-200D-1F3ED',
        sheet: [15, 14]
      },
      {
        unified: '1F468-1F3FE-200D-1F3ED',
        sheet: [15, 15]
      },
      {
        unified: '1F468-1F3FF-200D-1F3ED',
        sheet: [15, 16]
      }
    ],
    shortName: 'male-factory-worker'
  },
  {
    name: 'Banknote with Pound Sign',
    unified: '1F4B7',
    keywords: [
      'british',
      'sterling',
      'money',
      'sales',
      'bills',
      'uk',
      'england',
      'currency'
    ],
    sheet: [26, 14],
    shortName: 'pound'
  },
  {
    name: 'Suspension Railway',
    unified: '1F69F',
    keywords: [
      'vehicle',
      'transportation'
    ],
    sheet: [34, 23],
    shortName: 'suspension_railway'
  },
  {
    name: 'Orange Heart',
    unified: '1F9E1',
    keywords: [
      'love',
      'like',
      'affection',
      'valentines'
    ],
    sheet: [51, 44],
    shortName: 'orange_heart'
  },
  {
    name: 'Eight Pointed Black Star',
    unified: '2734-FE0F',
    keywords: [
      'orange-square',
      'shape',
      'polygon'
    ],
    sheet: [56, 22],
    shortName: 'eight_pointed_black_star'
  },
  {
    name: 'Cambodia Flag',
    unified: '1F1F0-1F1ED',
    sheet: [2, 37],
    shortName: 'flag-kh'
  },
  {
    name: 'Deciduous Tree',
    unified: '1F333',
    keywords: ['plant', 'nature'],
    sheet: [6, 5],
    shortName: 'deciduous_tree'
  },
  {
    name: 'Female Factory Worker',
    unified: '1F469-200D-1F3ED',
    sheet: [18, 4],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F3ED',
        sheet: [18, 5]
      },
      {
        unified: '1F469-1F3FC-200D-1F3ED',
        sheet: [18, 6]
      },
      {
        unified: '1F469-1F3FD-200D-1F3ED',
        sheet: [18, 7]
      },
      {
        unified: '1F469-1F3FE-200D-1F3ED',
        sheet: [18, 8]
      },
      {
        unified: '1F469-1F3FF-200D-1F3ED',
        sheet: [18, 9]
      }
    ],
    shortName: 'female-factory-worker'
  },
  {
    name: 'Yellow Heart',
    unified: '1F49B',
    text: '<3',
    keywords: [
      'love',
      'like',
      'affection',
      'valentines'
    ],
    sheet: [25, 39],
    shortName: 'yellow_heart'
  },
  {
    name: 'Money with Wings',
    unified: '1F4B8',
    keywords: [
      'dollar',
      'bills',
      'payment',
      'sale'
    ],
    sheet: [26, 15],
    shortName: 'money_with_wings'
  },
  {
    name: 'Mountain Cableway',
    unified: '1F6A0',
    keywords: [
      'transportation',
      'vehicle',
      'ski'
    ],
    sheet: [34, 24],
    shortName: 'mountain_cableway'
  },
  {
    name: 'Sparkle',
    unified: '2747-FE0F',
    keywords: [
      'stars',
      'green-square',
      'awesome',
      'good',
      'fireworks'
    ],
    sheet: [56, 24],
    shortName: 'sparkle'
  },
  {
    name: 'Copyright Sign',
    unified: '00A9-FE0F',
    keywords: [
      'ip',
      'license',
      'circle',
      'law',
      'legal'
    ],
    sheet: [0, 12],
    hidden: ['facebook'],
    shortName: 'copyright'
  },
  {
    name: 'Kiribati Flag',
    unified: '1F1F0-1F1EE',
    sheet: [2, 38],
    shortName: 'flag-ki'
  },
  {
    name: 'Palm Tree',
    unified: '1F334',
    keywords: [
      'plant',
      'vegetable',
      'nature',
      'summer',
      'beach',
      'mojito',
      'tropical'
    ],
    sheet: [6, 6],
    shortName: 'palm_tree'
  },
  {
    name: 'Green Heart',
    unified: '1F49A',
    text: '<3',
    keywords: [
      'love',
      'like',
      'affection',
      'valentines'
    ],
    sheet: [25, 38],
    shortName: 'green_heart'
  },
  {
    name: 'Credit Card',
    unified: '1F4B3',
    keywords: [
      'money',
      'sales',
      'dollar',
      'bill',
      'payment',
      'shopping'
    ],
    sheet: [26, 10],
    shortName: 'credit_card'
  },
  {
    name: 'Aerial Tramway',
    unified: '1F6A1',
    keywords: [
      'transportation',
      'vehicle',
      'ski'
    ],
    sheet: [34, 25],
    shortName: 'aerial_tramway'
  },
  {
    name: 'Office Worker',
    unified: '1F9D1-200D-1F4BC',
    sheet: [46, 37],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F4BC',
        sheet: [46, 38]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F4BC',
        sheet: [46, 39]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F4BC',
        sheet: [46, 40]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F4BC',
        sheet: [46, 41]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F4BC',
        sheet: [46, 42]
      }
    ],
    shortName: 'office_worker'
  },
  {
    name: 'Registered Sign',
    unified: '00AE-FE0F',
    keywords: ['alphabet', 'circle'],
    sheet: [0, 13],
    hidden: ['facebook'],
    shortName: 'registered'
  },
  {
    name: 'Comoros Flag',
    unified: '1F1F0-1F1F2',
    sheet: [2, 39],
    shortName: 'flag-km'
  },
  {
    name: 'Cactus',
    unified: '1F335',
    keywords: [
      'vegetable',
      'plant',
      'nature'
    ],
    sheet: [6, 7],
    shortName: 'cactus'
  },
  {
    name: 'Male Office Worker',
    unified: '1F468-200D-1F4BC',
    sheet: [15, 38],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F4BC',
        sheet: [15, 39]
      },
      {
        unified: '1F468-1F3FC-200D-1F4BC',
        sheet: [15, 40]
      },
      {
        unified: '1F468-1F3FD-200D-1F4BC',
        sheet: [15, 41]
      },
      {
        unified: '1F468-1F3FE-200D-1F4BC',
        sheet: [15, 42]
      },
      {
        unified: '1F468-1F3FF-200D-1F4BC',
        sheet: [15, 43]
      }
    ],
    shortName: 'male-office-worker'
  },
  {
    name: 'Blue Heart',
    unified: '1F499',
    text: '<3',
    keywords: [
      'love',
      'like',
      'affection',
      'valentines'
    ],
    sheet: [25, 37],
    shortName: 'blue_heart'
  },
  {
    name: 'Satellite',
    unified: '1F6F0-FE0F',
    keywords: [
      'communication',
      'future',
      'radio',
      'space'
    ],
    sheet: [36, 44],
    shortName: 'satellite'
  },
  {
    name: 'Receipt',
    unified: '1F9FE',
    keywords: [
      'accounting',
      'expenses'
    ],
    sheet: [52, 15],
    shortName: 'receipt'
  },
  {
    name: 'St. Kitts & Nevis Flag',
    unified: '1F1F0-1F1F3',
    sheet: [2, 40],
    shortName: 'flag-kn'
  },
  {
    name: 'Ear of Rice',
    unified: '1F33E',
    keywords: ['nature', 'plant'],
    sheet: [6, 16],
    shortName: 'ear_of_rice'
  },
  {
    name: 'Female Office Worker',
    unified: '1F469-200D-1F4BC',
    sheet: [18, 26],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F4BC',
        sheet: [18, 27]
      },
      {
        unified: '1F469-1F3FC-200D-1F4BC',
        sheet: [18, 28]
      },
      {
        unified: '1F469-1F3FD-200D-1F4BC',
        sheet: [18, 29]
      },
      {
        unified: '1F469-1F3FE-200D-1F4BC',
        sheet: [18, 30]
      },
      {
        unified: '1F469-1F3FF-200D-1F4BC',
        sheet: [18, 31]
      }
    ],
    shortName: 'female-office-worker'
  },
  {
    name: 'Purple Heart',
    unified: '1F49C',
    text: '<3',
    keywords: [
      'love',
      'like',
      'affection',
      'valentines'
    ],
    sheet: [25, 40],
    shortName: 'purple_heart'
  },
  {
    name: 'Chart with Upwards Trend and Yen Sign',
    unified: '1F4B9',
    keywords: [
      'green-square',
      'graph',
      'presentation',
      'stats'
    ],
    sheet: [26, 16],
    shortName: 'chart'
  },
  {
    name: 'Rocket',
    unified: '1F680',
    keywords: [
      'launch',
      'ship',
      'staffmode',
      'NASA',
      'outer space',
      'outer_space',
      'fly'
    ],
    sheet: [33, 50],
    shortName: 'rocket'
  },
  {
    name: 'Trade Mark Sign',
    unified: '2122-FE0F',
    keywords: [
      'trademark',
      'brand',
      'law',
      'legal'
    ],
    sheet: [53, 18],
    shortName: 'tm'
  },
  {
    name: 'Hash Key',
    unified: '0023-FE0F-20E3',
    keywords: [
      'symbol',
      'blue-square',
      'twitter'
    ],
    sheet: [0, 0],
    hidden: ['facebook'],
    shortName: 'hash'
  },
  {
    name: 'North Korea Flag',
    unified: '1F1F0-1F1F5',
    sheet: [2, 41],
    shortName: 'flag-kp'
  },
  {
    name: 'Herb',
    unified: '1F33F',
    keywords: [
      'vegetable',
      'plant',
      'medicine',
      'weed',
      'grass',
      'lawn'
    ],
    sheet: [6, 17],
    shortName: 'herb'
  },
  {
    name: 'Flying Saucer',
    unified: '1F6F8',
    keywords: [
      'transportation',
      'vehicle',
      'ufo'
    ],
    sheet: [36, 50],
    shortName: 'flying_saucer'
  },
  {
    name: 'Brown Heart',
    unified: '1F90E',
    sheet: [37, 16],
    shortName: 'brown_heart'
  },
  {
    name: 'Scientist',
    unified: '1F9D1-200D-1F52C',
    sheet: [46, 49],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F52C',
        sheet: [46, 50]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F52C',
        sheet: [46, 51]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F52C',
        sheet: [46, 52]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F52C',
        sheet: [46, 53]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F52C',
        sheet: [46, 54]
      }
    ],
    shortName: 'scientist'
  },
  {
    name: 'Envelope',
    unified: '2709-FE0F',
    keywords: [
      'letter',
      'postal',
      'inbox',
      'communication'
    ],
    sheet: [55, 47],
    shortNames: ['envelope'],
    shortName: 'email'
  },
  {
    name: 'Keycap Star',
    unified: '002A-FE0F-20E3',
    sheet: [0, 1],
    hidden: ['facebook'],
    shortName: 'keycap_star'
  },
  {
    name: 'South Korea Flag',
    unified: '1F1F0-1F1F7',
    keywords: [
      'south',
      'korea',
      'nation',
      'flag',
      'country',
      'banner'
    ],
    sheet: [2, 42],
    shortNames: ['flag-kr'],
    shortName: 'kr'
  },
  {
    name: 'Male Scientist',
    unified: '1F468-200D-1F52C',
    sheet: [15, 50],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F52C',
        sheet: [15, 51]
      },
      {
        unified: '1F468-1F3FC-200D-1F52C',
        sheet: [15, 52]
      },
      {
        unified: '1F468-1F3FD-200D-1F52C',
        sheet: [15, 53]
      },
      {
        unified: '1F468-1F3FE-200D-1F52C',
        sheet: [15, 54]
      },
      {
        unified: '1F468-1F3FF-200D-1F52C',
        sheet: [15, 55]
      }
    ],
    shortName: 'male-scientist'
  },
  {
    name: 'E-Mail Symbol',
    unified: '1F4E7',
    keywords: [
      'communication',
      'inbox'
    ],
    sheet: [27, 4],
    shortName: 'e-mail'
  },
  {
    name: 'Black Heart',
    unified: '1F5A4',
    keywords: ['evil'],
    sheet: [30, 6],
    shortName: 'black_heart'
  },
  {
    name: 'Bellhop Bell',
    unified: '1F6CE-FE0F',
    keywords: ['service'],
    sheet: [36, 27],
    shortName: 'bellhop_bell'
  },
  {
    name: 'Shamrock',
    unified: '2618-FE0F',
    keywords: [
      'vegetable',
      'plant',
      'nature',
      'irish',
      'clover'
    ],
    sheet: [54, 6],
    shortName: 'shamrock'
  },
  {
    name: 'Keycap 0',
    unified: '0030-FE0F-20E3',
    keywords: [
      '0',
      'numbers',
      'blue-square',
      'null'
    ],
    sheet: [0, 2],
    hidden: ['facebook'],
    shortName: 'zero'
  },
  {
    name: 'Kuwait Flag',
    unified: '1F1F0-1F1FC',
    sheet: [2, 43],
    shortName: 'flag-kw'
  },
  {
    name: 'Four Leaf Clover',
    unified: '1F340',
    keywords: [
      'vegetable',
      'plant',
      'nature',
      'lucky',
      'irish'
    ],
    sheet: [6, 18],
    shortName: 'four_leaf_clover'
  },
  {
    name: 'Female Scientist',
    unified: '1F469-200D-1F52C',
    sheet: [18, 38],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F52C',
        sheet: [18, 39]
      },
      {
        unified: '1F469-1F3FC-200D-1F52C',
        sheet: [18, 40]
      },
      {
        unified: '1F469-1F3FD-200D-1F52C',
        sheet: [18, 41]
      },
      {
        unified: '1F469-1F3FE-200D-1F52C',
        sheet: [18, 42]
      },
      {
        unified: '1F469-1F3FF-200D-1F52C',
        sheet: [18, 43]
      }
    ],
    shortName: 'female-scientist'
  },
  {
    name: 'Incoming Envelope',
    unified: '1F4E8',
    keywords: ['email', 'inbox'],
    sheet: [27, 5],
    shortName: 'incoming_envelope'
  },
  {
    name: 'White Heart',
    unified: '1F90D',
    sheet: [37, 15],
    shortName: 'white_heart'
  },
  {
    name: 'Luggage',
    unified: '1F9F3',
    keywords: ['packing', 'travel'],
    sheet: [52, 4],
    shortName: 'luggage'
  },
  {
    name: 'Keycap 1',
    unified: '0031-FE0F-20E3',
    keywords: [
      'blue-square',
      'numbers',
      '1'
    ],
    sheet: [0, 3],
    hidden: ['facebook'],
    shortName: 'one'
  },
  {
    name: 'Cayman Islands Flag',
    unified: '1F1F0-1F1FE',
    sheet: [2, 44],
    shortName: 'flag-ky'
  },
  {
    name: 'Maple Leaf',
    unified: '1F341',
    keywords: [
      'nature',
      'plant',
      'vegetable',
      'ca',
      'fall'
    ],
    sheet: [6, 19],
    shortName: 'maple_leaf'
  },
  {
    name: 'Hundred Points Symbol',
    unified: '1F4AF',
    keywords: [
      'score',
      'perfect',
      'numbers',
      'century',
      'exam',
      'quiz',
      'test',
      'pass',
      'hundred'
    ],
    sheet: [26, 6],
    shortName: '100'
  },
  {
    name: 'Envelope with Downwards Arrow Above',
    unified: '1F4E9',
    keywords: [
      'email',
      'communication'
    ],
    sheet: [27, 6],
    shortName: 'envelope_with_arrow'
  },
  {
    name: 'Technologist',
    unified: '1F9D1-200D-1F4BB',
    sheet: [46, 31],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F4BB',
        sheet: [46, 32]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F4BB',
        sheet: [46, 33]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F4BB',
        sheet: [46, 34]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F4BB',
        sheet: [46, 35]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F4BB',
        sheet: [46, 36]
      }
    ],
    shortName: 'technologist'
  },
  {
    name: 'Hourglass',
    unified: '231B',
    keywords: [
      'time',
      'clock',
      'oldschool',
      'limit',
      'exam',
      'quiz',
      'test'
    ],
    sheet: [53, 29],
    shortName: 'hourglass'
  },
  {
    name: 'Keycap 2',
    unified: '0032-FE0F-20E3',
    keywords: [
      'numbers',
      '2',
      'prime',
      'blue-square'
    ],
    sheet: [0, 4],
    hidden: ['facebook'],
    shortName: 'two'
  },
  {
    name: 'Kazakhstan Flag',
    unified: '1F1F0-1F1FF',
    sheet: [2, 45],
    shortName: 'flag-kz'
  },
  {
    name: 'Fallen Leaf',
    unified: '1F342',
    keywords: [
      'nature',
      'plant',
      'vegetable',
      'leaves'
    ],
    sheet: [6, 20],
    shortName: 'fallen_leaf'
  },
  {
    name: 'Male Technologist',
    unified: '1F468-200D-1F4BB',
    sheet: [15, 32],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F4BB',
        sheet: [15, 33]
      },
      {
        unified: '1F468-1F3FC-200D-1F4BB',
        sheet: [15, 34]
      },
      {
        unified: '1F468-1F3FD-200D-1F4BB',
        sheet: [15, 35]
      },
      {
        unified: '1F468-1F3FE-200D-1F4BB',
        sheet: [15, 36]
      },
      {
        unified: '1F468-1F3FF-200D-1F4BB',
        sheet: [15, 37]
      }
    ],
    shortName: 'male-technologist'
  },
  {
    name: 'Anger Symbol',
    unified: '1F4A2',
    keywords: ['angry', 'mad'],
    sheet: [25, 46],
    shortName: 'anger'
  },
  {
    name: 'Outbox Tray',
    unified: '1F4E4',
    keywords: ['inbox', 'email'],
    sheet: [27, 1],
    shortName: 'outbox_tray'
  },
  {
    name: 'Hourglass with Flowing Sand',
    unified: '23F3',
    keywords: [
      'oldschool',
      'time',
      'countdown'
    ],
    sheet: [53, 42],
    shortName: 'hourglass_flowing_sand'
  },
  {
    name: 'Keycap 3',
    unified: '0033-FE0F-20E3',
    keywords: [
      '3',
      'numbers',
      'prime',
      'blue-square'
    ],
    sheet: [0, 5],
    hidden: ['facebook'],
    shortName: 'three'
  },
  {
    name: 'Laos Flag',
    unified: '1F1F1-1F1E6',
    sheet: [2, 46],
    shortName: 'flag-la'
  },
  {
    name: 'Leaf Fluttering in Wind',
    unified: '1F343',
    keywords: [
      'nature',
      'plant',
      'tree',
      'vegetable',
      'grass',
      'lawn',
      'spring'
    ],
    sheet: [6, 21],
    shortName: 'leaves'
  },
  {
    name: 'Female Technologist',
    unified: '1F469-200D-1F4BB',
    sheet: [18, 20],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F4BB',
        sheet: [18, 21]
      },
      {
        unified: '1F469-1F3FC-200D-1F4BB',
        sheet: [18, 22]
      },
      {
        unified: '1F469-1F3FD-200D-1F4BB',
        sheet: [18, 23]
      },
      {
        unified: '1F469-1F3FE-200D-1F4BB',
        sheet: [18, 24]
      },
      {
        unified: '1F469-1F3FF-200D-1F4BB',
        sheet: [18, 25]
      }
    ],
    shortName: 'female-technologist'
  },
  {
    name: 'Collision Symbol',
    unified: '1F4A5',
    keywords: [
      'bomb',
      'explode',
      'explosion',
      'collision',
      'blown'
    ],
    sheet: [25, 49],
    shortNames: ['collision'],
    shortName: 'boom'
  },
  {
    name: 'Inbox Tray',
    unified: '1F4E5',
    keywords: ['email', 'documents'],
    sheet: [27, 2],
    shortName: 'inbox_tray'
  },
  {
    name: 'Watch',
    unified: '231A',
    keywords: ['time', 'accessories'],
    sheet: [53, 28],
    shortName: 'watch'
  },
  {
    name: 'Keycap 4',
    unified: '0034-FE0F-20E3',
    keywords: [
      '4',
      'numbers',
      'blue-square'
    ],
    sheet: [0, 6],
    hidden: ['facebook'],
    shortName: 'four'
  },
  {
    name: 'Lebanon Flag',
    unified: '1F1F1-1F1E7',
    sheet: [2, 47],
    shortName: 'flag-lb'
  },
  {
    name: 'Dizzy Symbol',
    unified: '1F4AB',
    keywords: [
      'star',
      'sparkle',
      'shoot',
      'magic'
    ],
    sheet: [26, 2],
    shortName: 'dizzy'
  },
  {
    name: 'Package',
    unified: '1F4E6',
    keywords: [
      'mail',
      'gift',
      'cardboard',
      'box',
      'moving'
    ],
    sheet: [27, 3],
    shortName: 'package'
  },
  {
    name: 'Singer',
    unified: '1F9D1-200D-1F3A4',
    sheet: [46, 7],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F3A4',
        sheet: [46, 8]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F3A4',
        sheet: [46, 9]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F3A4',
        sheet: [46, 10]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F3A4',
        sheet: [46, 11]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F3A4',
        sheet: [46, 12]
      }
    ],
    shortName: 'singer'
  },
  {
    name: 'Alarm Clock',
    unified: '23F0',
    keywords: ['time', 'wake'],
    sheet: [53, 39],
    shortName: 'alarm_clock'
  },
  {
    name: 'Keycap 5',
    unified: '0035-FE0F-20E3',
    keywords: [
      '5',
      'numbers',
      'blue-square',
      'prime'
    ],
    sheet: [0, 7],
    hidden: ['facebook'],
    shortName: 'five'
  },
  {
    name: 'St. Lucia Flag',
    unified: '1F1F1-1F1E8',
    sheet: [2, 48],
    shortName: 'flag-lc'
  },
  {
    name: 'Male Singer',
    unified: '1F468-200D-1F3A4',
    sheet: [14, 51],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F3A4',
        sheet: [14, 52]
      },
      {
        unified: '1F468-1F3FC-200D-1F3A4',
        sheet: [14, 53]
      },
      {
        unified: '1F468-1F3FD-200D-1F3A4',
        sheet: [14, 54]
      },
      {
        unified: '1F468-1F3FE-200D-1F3A4',
        sheet: [14, 55]
      },
      {
        unified: '1F468-1F3FF-200D-1F3A4',
        sheet: [14, 56]
      }
    ],
    shortName: 'male-singer'
  },
  {
    name: 'Splashing Sweat Symbol',
    unified: '1F4A6',
    keywords: ['water', 'drip', 'oops'],
    sheet: [25, 50],
    shortName: 'sweat_drops'
  },
  {
    name: 'Closed Mailbox with Raised Flag',
    unified: '1F4EB',
    keywords: [
      'email',
      'inbox',
      'communication'
    ],
    sheet: [27, 8],
    shortName: 'mailbox'
  },
  {
    name: 'Stopwatch',
    unified: '23F1-FE0F',
    keywords: ['time', 'deadline'],
    sheet: [53, 40],
    shortName: 'stopwatch'
  },
  {
    name: 'Keycap 6',
    unified: '0036-FE0F-20E3',
    keywords: [
      '6',
      'numbers',
      'blue-square'
    ],
    sheet: [0, 8],
    hidden: ['facebook'],
    shortName: 'six'
  },
  {
    name: 'Liechtenstein Flag',
    unified: '1F1F1-1F1EE',
    sheet: [2, 49],
    shortName: 'flag-li'
  },
  {
    name: 'Female Singer',
    unified: '1F469-200D-1F3A4',
    sheet: [17, 44],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F3A4',
        sheet: [17, 45]
      },
      {
        unified: '1F469-1F3FC-200D-1F3A4',
        sheet: [17, 46]
      },
      {
        unified: '1F469-1F3FD-200D-1F3A4',
        sheet: [17, 47]
      },
      {
        unified: '1F469-1F3FE-200D-1F3A4',
        sheet: [17, 48]
      },
      {
        unified: '1F469-1F3FF-200D-1F3A4',
        sheet: [17, 49]
      }
    ],
    shortName: 'female-singer'
  },
  {
    name: 'Dash Symbol',
    unified: '1F4A8',
    keywords: [
      'wind',
      'air',
      'fast',
      'shoo',
      'fart',
      'smoke',
      'puff'
    ],
    sheet: [25, 52],
    shortName: 'dash'
  },
  {
    name: 'Closed Mailbox with Lowered Flag',
    unified: '1F4EA',
    keywords: [
      'email',
      'communication',
      'inbox'
    ],
    sheet: [27, 7],
    shortName: 'mailbox_closed'
  },
  {
    name: 'Timer Clock',
    unified: '23F2-FE0F',
    keywords: ['alarm'],
    sheet: [53, 41],
    shortName: 'timer_clock'
  },
  {
    name: 'Keycap 7',
    unified: '0037-FE0F-20E3',
    keywords: [
      '7',
      'numbers',
      'blue-square',
      'prime'
    ],
    sheet: [0, 9],
    hidden: ['facebook'],
    shortName: 'seven'
  },
  {
    name: 'Sri Lanka Flag',
    unified: '1F1F1-1F1F0',
    sheet: [2, 50],
    shortName: 'flag-lk'
  },
  {
    name: 'Open Mailbox with Raised Flag',
    unified: '1F4EC',
    keywords: [
      'email',
      'inbox',
      'communication'
    ],
    sheet: [27, 9],
    shortName: 'mailbox_with_mail'
  },
  {
    name: 'Mantelpiece Clock',
    unified: '1F570-FE0F',
    keywords: ['time'],
    sheet: [29, 5],
    shortName: 'mantelpiece_clock'
  },
  {
    name: 'Hole',
    unified: '1F573-FE0F',
    keywords: ['embarrassing'],
    sheet: [29, 6],
    shortName: 'hole'
  },
  {
    name: 'Artist',
    unified: '1F9D1-200D-1F3A8',
    sheet: [46, 13],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F3A8',
        sheet: [46, 14]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F3A8',
        sheet: [46, 15]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F3A8',
        sheet: [46, 16]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F3A8',
        sheet: [46, 17]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F3A8',
        sheet: [46, 18]
      }
    ],
    shortName: 'artist'
  },
  {
    name: 'Keycap 8',
    unified: '0038-FE0F-20E3',
    keywords: [
      '8',
      'blue-square',
      'numbers'
    ],
    sheet: [0, 10],
    hidden: ['facebook'],
    shortName: 'eight'
  },
  {
    name: 'Liberia Flag',
    unified: '1F1F1-1F1F7',
    sheet: [2, 51],
    shortName: 'flag-lr'
  },
  {
    name: 'Male Artist',
    unified: '1F468-200D-1F3A8',
    sheet: [14, 57],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F3A8',
        sheet: [15, 0]
      },
      {
        unified: '1F468-1F3FC-200D-1F3A8',
        sheet: [15, 1]
      },
      {
        unified: '1F468-1F3FD-200D-1F3A8',
        sheet: [15, 2]
      },
      {
        unified: '1F468-1F3FE-200D-1F3A8',
        sheet: [15, 3]
      },
      {
        unified: '1F468-1F3FF-200D-1F3A8',
        sheet: [15, 4]
      }
    ],
    shortName: 'male-artist'
  },
  {
    name: 'Bomb',
    unified: '1F4A3',
    keywords: [
      'boom',
      'explode',
      'explosion',
      'terrorism'
    ],
    sheet: [25, 47],
    shortName: 'bomb'
  },
  {
    name: 'Open Mailbox with Lowered Flag',
    unified: '1F4ED',
    keywords: ['email', 'inbox'],
    sheet: [27, 10],
    shortName: 'mailbox_with_no_mail'
  },
  {
    name: 'Clock Face Twelve Oclock',
    unified: '1F55B',
    keywords: [
      'time',
      'noon',
      'midnight',
      'midday',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 49],
    shortName: 'clock12'
  },
  {
    name: 'Keycap 9',
    unified: '0039-FE0F-20E3',
    keywords: [
      'blue-square',
      'numbers',
      '9'
    ],
    sheet: [0, 11],
    hidden: ['facebook'],
    shortName: 'nine'
  },
  {
    name: 'Lesotho Flag',
    unified: '1F1F1-1F1F8',
    sheet: [2, 52],
    shortName: 'flag-ls'
  },
  {
    name: 'Female Artist',
    unified: '1F469-200D-1F3A8',
    sheet: [17, 50],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F3A8',
        sheet: [17, 51]
      },
      {
        unified: '1F469-1F3FC-200D-1F3A8',
        sheet: [17, 52]
      },
      {
        unified: '1F469-1F3FD-200D-1F3A8',
        sheet: [17, 53]
      },
      {
        unified: '1F469-1F3FE-200D-1F3A8',
        sheet: [17, 54]
      },
      {
        unified: '1F469-1F3FF-200D-1F3A8',
        sheet: [17, 55]
      }
    ],
    shortName: 'female-artist'
  },
  {
    name: 'Speech Balloon',
    unified: '1F4AC',
    keywords: [
      'bubble',
      'words',
      'message',
      'talk',
      'chatting'
    ],
    sheet: [26, 3],
    shortName: 'speech_balloon'
  },
  {
    name: 'Postbox',
    unified: '1F4EE',
    keywords: [
      'email',
      'letter',
      'envelope'
    ],
    sheet: [27, 11],
    shortName: 'postbox'
  },
  {
    name: 'Clock Face Twelve-Thirty',
    unified: '1F567',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [29, 3],
    shortName: 'clock1230'
  },
  {
    name: 'Lithuania Flag',
    unified: '1F1F1-1F1F9',
    sheet: [2, 53],
    shortName: 'flag-lt'
  },
  {
    name: 'Eye in Speech Bubble',
    unified: '1F441-FE0F-200D-1F5E8-FE0F',
    sheet: [12, 28],
    hidden: ['twitter', 'facebook'],
    shortName: 'eye-in-speech-bubble'
  },
  {
    name: 'Keycap Ten',
    unified: '1F51F',
    keywords: [
      'numbers',
      '10',
      'blue-square'
    ],
    sheet: [28, 1],
    shortName: 'keycap_ten'
  },
  {
    name: 'Clock Face One Oclock',
    unified: '1F550',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 38],
    shortName: 'clock1'
  },
  {
    name: 'Ballot Box with Ballot',
    unified: '1F5F3-FE0F',
    sheet: [30, 25],
    shortName: 'ballot_box_with_ballot'
  },
  {
    name: 'Pilot',
    unified: '1F9D1-200D-2708-FE0F',
    sheet: [48, 31],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-2708-FE0F',
        sheet: [48, 32]
      },
      {
        unified: '1F9D1-1F3FC-200D-2708-FE0F',
        sheet: [48, 33]
      },
      {
        unified: '1F9D1-1F3FD-200D-2708-FE0F',
        sheet: [48, 34]
      },
      {
        unified: '1F9D1-1F3FE-200D-2708-FE0F',
        sheet: [48, 35]
      },
      {
        unified: '1F9D1-1F3FF-200D-2708-FE0F',
        sheet: [48, 36]
      }
    ],
    shortName: 'pilot'
  },
  {
    name: 'Luxembourg Flag',
    unified: '1F1F1-1F1FA',
    sheet: [2, 54],
    shortName: 'flag-lu'
  },
  {
    name: 'Male Pilot',
    unified: '1F468-200D-2708-FE0F',
    sheet: [17, 6],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-2708-FE0F',
        sheet: [17, 7]
      },
      {
        unified: '1F468-1F3FC-200D-2708-FE0F',
        sheet: [17, 8]
      },
      {
        unified: '1F468-1F3FD-200D-2708-FE0F',
        sheet: [17, 9]
      },
      {
        unified: '1F468-1F3FE-200D-2708-FE0F',
        sheet: [17, 10]
      },
      {
        unified: '1F468-1F3FF-200D-2708-FE0F',
        sheet: [17, 11]
      }
    ],
    shortName: 'male-pilot'
  },
  {
    name: 'Input Symbol for Latin Capital Letters',
    unified: '1F520',
    keywords: [
      'alphabet',
      'words',
      'blue-square'
    ],
    sheet: [28, 2],
    shortName: 'capital_abcd'
  },
  {
    name: 'Clock Face One-Thirty',
    unified: '1F55C',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 50],
    shortName: 'clock130'
  },
  {
    name: 'Left Speech Bubble',
    unified: '1F5E8-FE0F',
    keywords: [
      'words',
      'message',
      'talk',
      'chatting'
    ],
    sheet: [30, 23],
    shortName: 'left_speech_bubble'
  },
  {
    name: 'Pencil',
    unified: '270F-FE0F',
    keywords: [
      'stationery',
      'write',
      'paper',
      'writing',
      'school',
      'study'
    ],
    sheet: [56, 14],
    shortName: 'pencil2'
  },
  {
    name: 'Latvia Flag',
    unified: '1F1F1-1F1FB',
    sheet: [2, 55],
    shortName: 'flag-lv'
  },
  {
    name: 'Female Pilot',
    unified: '1F469-200D-2708-FE0F',
    sheet: [19, 52],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-2708-FE0F',
        sheet: [19, 53]
      },
      {
        unified: '1F469-1F3FC-200D-2708-FE0F',
        sheet: [19, 54]
      },
      {
        unified: '1F469-1F3FD-200D-2708-FE0F',
        sheet: [19, 55]
      },
      {
        unified: '1F469-1F3FE-200D-2708-FE0F',
        sheet: [19, 56]
      },
      {
        unified: '1F469-1F3FF-200D-2708-FE0F',
        sheet: [19, 57]
      }
    ],
    shortName: 'female-pilot'
  },
  {
    name: 'Input Symbol for Latin Small Letters',
    unified: '1F521',
    keywords: [
      'blue-square',
      'alphabet'
    ],
    sheet: [28, 3],
    shortName: 'abcd'
  },
  {
    name: 'Clock Face Two Oclock',
    unified: '1F551',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 39],
    shortName: 'clock2'
  },
  {
    name: 'Right Anger Bubble',
    unified: '1F5EF-FE0F',
    keywords: [
      'caption',
      'speech',
      'thinking',
      'mad'
    ],
    sheet: [30, 24],
    shortName: 'right_anger_bubble'
  },
  {
    name: 'Black Nib',
    unified: '2712-FE0F',
    keywords: [
      'pen',
      'stationery',
      'writing',
      'write'
    ],
    sheet: [56, 15],
    shortName: 'black_nib'
  },
  {
    name: 'Libya Flag',
    unified: '1F1F1-1F1FE',
    sheet: [2, 56],
    shortName: 'flag-ly'
  },
  {
    name: 'Thought Balloon',
    unified: '1F4AD',
    keywords: [
      'bubble',
      'cloud',
      'speech',
      'thinking',
      'dream'
    ],
    sheet: [26, 4],
    shortName: 'thought_balloon'
  },
  {
    name: 'Input Symbol for Numbers',
    unified: '1F522',
    keywords: [
      'numbers',
      'blue-square'
    ],
    sheet: [28, 4],
    shortName: '1234'
  },
  {
    name: 'Clock Face Two-Thirty',
    unified: '1F55D',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 51],
    shortName: 'clock230'
  },
  {
    name: 'Lower Left Fountain Pen',
    unified: '1F58B-FE0F',
    sheet: [29, 43],
    shortName: 'lower_left_fountain_pen'
  },
  {
    name: 'Astronaut',
    unified: '1F9D1-200D-1F680',
    sheet: [46, 55],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F680',
        sheet: [46, 56]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F680',
        sheet: [46, 57]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F680',
        sheet: [47, 0]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F680',
        sheet: [47, 1]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F680',
        sheet: [47, 2]
      }
    ],
    shortName: 'astronaut'
  },
  {
    name: 'Morocco Flag',
    unified: '1F1F2-1F1E6',
    sheet: [2, 57],
    shortName: 'flag-ma'
  },
  {
    name: 'Male Astronaut',
    unified: '1F468-200D-1F680',
    sheet: [15, 56],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F680',
        sheet: [15, 57]
      },
      {
        unified: '1F468-1F3FC-200D-1F680',
        sheet: [16, 0]
      },
      {
        unified: '1F468-1F3FD-200D-1F680',
        sheet: [16, 1]
      },
      {
        unified: '1F468-1F3FE-200D-1F680',
        sheet: [16, 2]
      },
      {
        unified: '1F468-1F3FF-200D-1F680',
        sheet: [16, 3]
      }
    ],
    shortName: 'male-astronaut'
  },
  {
    name: 'Sleeping Symbol',
    unified: '1F4A4',
    keywords: [
      'sleepy',
      'tired',
      'dream'
    ],
    sheet: [25, 48],
    shortName: 'zzz'
  },
  {
    name: 'Input Symbol for Symbols',
    unified: '1F523',
    keywords: [
      'blue-square',
      'music',
      'note',
      'ampersand',
      'percent',
      'glyphs',
      'characters'
    ],
    sheet: [28, 5],
    shortName: 'symbols'
  },
  {
    name: 'Clock Face Three Oclock',
    unified: '1F552',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 40],
    shortName: 'clock3'
  },
  {
    name: 'Lower Left Ballpoint Pen',
    unified: '1F58A-FE0F',
    sheet: [29, 42],
    shortName: 'lower_left_ballpoint_pen'
  },
  {
    name: 'Monaco Flag',
    unified: '1F1F2-1F1E8',
    sheet: [3, 0],
    shortName: 'flag-mc'
  },
  {
    name: 'Female Astronaut',
    unified: '1F469-200D-1F680',
    sheet: [18, 44],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F680',
        sheet: [18, 45]
      },
      {
        unified: '1F469-1F3FC-200D-1F680',
        sheet: [18, 46]
      },
      {
        unified: '1F469-1F3FD-200D-1F680',
        sheet: [18, 47]
      },
      {
        unified: '1F469-1F3FE-200D-1F680',
        sheet: [18, 48]
      },
      {
        unified: '1F469-1F3FF-200D-1F680',
        sheet: [18, 49]
      }
    ],
    shortName: 'female-astronaut'
  },
  {
    name: 'Input Symbol for Latin Letters',
    unified: '1F524',
    keywords: [
      'blue-square',
      'alphabet'
    ],
    sheet: [28, 6],
    shortName: 'abc'
  },
  {
    name: 'Clock Face Three-Thirty',
    unified: '1F55E',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 52],
    shortName: 'clock330'
  },
  {
    name: 'Lower Left Paintbrush',
    unified: '1F58C-FE0F',
    sheet: [29, 44],
    shortName: 'lower_left_paintbrush'
  },
  {
    name: 'Negative Squared Latin Capital Letter a',
    unified: '1F170-FE0F',
    keywords: [
      'red-square',
      'alphabet',
      'letter'
    ],
    sheet: [0, 16],
    shortName: 'a'
  },
  {
    name: 'Moldova Flag',
    unified: '1F1F2-1F1E9',
    sheet: [3, 1],
    shortName: 'flag-md'
  },
  {
    name: 'Clock Face Four Oclock',
    unified: '1F553',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 41],
    shortName: 'clock4'
  },
  {
    name: 'Lower Left Crayon',
    unified: '1F58D-FE0F',
    sheet: [29, 45],
    shortName: 'lower_left_crayon'
  },
  {
    name: 'Firefighter',
    unified: '1F9D1-200D-1F692',
    sheet: [47, 3],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F692',
        sheet: [47, 4]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F692',
        sheet: [47, 5]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F692',
        sheet: [47, 6]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F692',
        sheet: [47, 7]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F692',
        sheet: [47, 8]
      }
    ],
    shortName: 'firefighter'
  },
  {
    name: 'Negative Squared Ab',
    unified: '1F18E',
    keywords: [
      'red-square',
      'alphabet'
    ],
    sheet: [0, 20],
    shortName: 'ab'
  },
  {
    name: 'Montenegro Flag',
    unified: '1F1F2-1F1EA',
    sheet: [3, 2],
    shortName: 'flag-me'
  },
  {
    name: 'Male Firefighter',
    unified: '1F468-200D-1F692',
    sheet: [16, 4],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F692',
        sheet: [16, 5]
      },
      {
        unified: '1F468-1F3FC-200D-1F692',
        sheet: [16, 6]
      },
      {
        unified: '1F468-1F3FD-200D-1F692',
        sheet: [16, 7]
      },
      {
        unified: '1F468-1F3FE-200D-1F692',
        sheet: [16, 8]
      },
      {
        unified: '1F468-1F3FF-200D-1F692',
        sheet: [16, 9]
      }
    ],
    shortName: 'male-firefighter'
  },
  {
    name: 'Memo',
    unified: '1F4DD',
    keywords: [
      'write',
      'documents',
      'stationery',
      'pencil',
      'paper',
      'writing',
      'legal',
      'exam',
      'quiz',
      'test',
      'study',
      'compose'
    ],
    sheet: [26, 52],
    shortNames: ['pencil'],
    shortName: 'memo'
  },
  {
    name: 'Clock Face Four-Thirty',
    unified: '1F55F',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 53],
    shortName: 'clock430'
  },
  {
    name: 'Negative Squared Latin Capital Letter B',
    unified: '1F171-FE0F',
    keywords: [
      'red-square',
      'alphabet',
      'letter'
    ],
    sheet: [0, 17],
    shortName: 'b'
  },
  {
    name: 'St. Martin Flag',
    unified: '1F1F2-1F1EB',
    sheet: [3, 3],
    shortName: 'flag-mf'
  },
  {
    name: 'Female Firefighter',
    unified: '1F469-200D-1F692',
    sheet: [18, 50],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F692',
        sheet: [18, 51]
      },
      {
        unified: '1F469-1F3FC-200D-1F692',
        sheet: [18, 52]
      },
      {
        unified: '1F469-1F3FD-200D-1F692',
        sheet: [18, 53]
      },
      {
        unified: '1F469-1F3FE-200D-1F692',
        sheet: [18, 54]
      },
      {
        unified: '1F469-1F3FF-200D-1F692',
        sheet: [18, 55]
      }
    ],
    shortName: 'female-firefighter'
  },
  {
    name: 'Briefcase',
    unified: '1F4BC',
    keywords: [
      'business',
      'documents',
      'work',
      'law',
      'legal',
      'job',
      'career'
    ],
    sheet: [26, 19],
    shortName: 'briefcase'
  },
  {
    name: 'Clock Face Five Oclock',
    unified: '1F554',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 42],
    shortName: 'clock5'
  },
  {
    name: 'Squared Cl',
    unified: '1F191',
    keywords: [
      'alphabet',
      'words',
      'red-square'
    ],
    sheet: [0, 21],
    shortName: 'cl'
  },
  {
    name: 'Madagascar Flag',
    unified: '1F1F2-1F1EC',
    sheet: [3, 4],
    shortName: 'flag-mg'
  },
  {
    name: 'Police Officer',
    unified: '1F46E',
    sheet: [21, 43],
    skinVariations: [
      {
        unified: '1F46E-1F3FB',
        sheet: [21, 44]
      },
      {
        unified: '1F46E-1F3FC',
        sheet: [21, 45]
      },
      {
        unified: '1F46E-1F3FD',
        sheet: [21, 46]
      },
      {
        unified: '1F46E-1F3FE',
        sheet: [21, 47]
      },
      {
        unified: '1F46E-1F3FF',
        sheet: [21, 48]
      }
    ],
    shortName: 'cop',
    obsoletedBy: '1F46E-200D-2642-FE0F'
  },
  {
    name: 'File Folder',
    unified: '1F4C1',
    keywords: [
      'documents',
      'business',
      'office'
    ],
    sheet: [26, 24],
    shortName: 'file_folder'
  },
  {
    name: 'Clock Face Five-Thirty',
    unified: '1F560',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 54],
    shortName: 'clock530'
  },
  {
    name: 'Squared Cool',
    unified: '1F192',
    keywords: ['words', 'blue-square'],
    sheet: [0, 22],
    shortName: 'cool'
  },
  {
    name: 'Marshall Islands Flag',
    unified: '1F1F2-1F1ED',
    sheet: [3, 5],
    shortName: 'flag-mh'
  },
  {
    name: 'Male Police Officer',
    unified: '1F46E-200D-2642-FE0F',
    obsoletes: '1F46E',
    sheet: [21, 37],
    skinVariations: [
      {
        unified: '1F46E-1F3FB-200D-2642-FE0F',
        sheet: [21, 38]
      },
      {
        unified: '1F46E-1F3FC-200D-2642-FE0F',
        sheet: [21, 39]
      },
      {
        unified: '1F46E-1F3FD-200D-2642-FE0F',
        sheet: [21, 40]
      },
      {
        unified: '1F46E-1F3FE-200D-2642-FE0F',
        sheet: [21, 41]
      },
      {
        unified: '1F46E-1F3FF-200D-2642-FE0F',
        sheet: [21, 42]
      }
    ],
    shortName: 'male-police-officer'
  },
  {
    name: 'Open File Folder',
    unified: '1F4C2',
    keywords: ['documents', 'load'],
    sheet: [26, 25],
    shortName: 'open_file_folder'
  },
  {
    name: 'Clock Face Six Oclock',
    unified: '1F555',
    keywords: [
      'time',
      'late',
      'early',
      'schedule',
      'dawn',
      'dusk'
    ],
    sheet: [28, 43],
    shortName: 'clock6'
  },
  {
    name: 'Squared Free',
    unified: '1F193',
    keywords: ['blue-square', 'words'],
    sheet: [0, 23],
    shortName: 'free'
  },
  {
    name: 'North Macedonia Flag',
    unified: '1F1F2-1F1F0',
    sheet: [3, 6],
    shortName: 'flag-mk'
  },
  {
    name: 'Female Police Officer',
    unified: '1F46E-200D-2640-FE0F',
    sheet: [21, 31],
    skinVariations: [
      {
        unified: '1F46E-1F3FB-200D-2640-FE0F',
        sheet: [21, 32]
      },
      {
        unified: '1F46E-1F3FC-200D-2640-FE0F',
        sheet: [21, 33]
      },
      {
        unified: '1F46E-1F3FD-200D-2640-FE0F',
        sheet: [21, 34]
      },
      {
        unified: '1F46E-1F3FE-200D-2640-FE0F',
        sheet: [21, 35]
      },
      {
        unified: '1F46E-1F3FF-200D-2640-FE0F',
        sheet: [21, 36]
      }
    ],
    shortName: 'female-police-officer'
  },
  {
    name: 'Clock Face Six-Thirty',
    unified: '1F561',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 55],
    shortName: 'clock630'
  },
  {
    name: 'Card Index Dividers',
    unified: '1F5C2-FE0F',
    keywords: [
      'organizing',
      'business',
      'stationery'
    ],
    sheet: [30, 12],
    shortName: 'card_index_dividers'
  },
  {
    name: 'Mali Flag',
    unified: '1F1F2-1F1F1',
    sheet: [3, 7],
    shortName: 'flag-ml'
  },
  {
    name: 'Calendar',
    unified: '1F4C5',
    keywords: ['calendar', 'schedule'],
    sheet: [26, 28],
    shortName: 'date'
  },
  {
    name: 'Clock Face Seven Oclock',
    unified: '1F556',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 44],
    shortName: 'clock7'
  },
  {
    name: 'Sleuth or Spy',
    unified: '1F575-FE0F',
    sheet: [29, 25],
    skinVariations: [
      {
        unified: '1F575-1F3FB',
        sheet: [29, 26]
      },
      {
        unified: '1F575-1F3FC',
        sheet: [29, 27]
      },
      {
        unified: '1F575-1F3FD',
        sheet: [29, 28]
      },
      {
        unified: '1F575-1F3FE',
        sheet: [29, 29]
      },
      {
        unified: '1F575-1F3FF',
        sheet: [29, 30]
      }
    ],
    shortName: 'sleuth_or_spy',
    obsoletedBy: '1F575-FE0F-200D-2642-FE0F'
  },
  {
    name: 'Information Source',
    unified: '2139-FE0F',
    keywords: [
      'blue-square',
      'alphabet',
      'letter'
    ],
    sheet: [53, 19],
    shortName: 'information_source'
  },
  {
    name: 'Squared Id',
    unified: '1F194',
    keywords: [
      'purple-square',
      'words'
    ],
    sheet: [0, 24],
    shortName: 'id'
  },
  {
    name: 'Myanmar (burma) Flag',
    unified: '1F1F2-1F1F2',
    sheet: [3, 8],
    shortName: 'flag-mm'
  },
  {
    name: 'Tear-off Calendar',
    unified: '1F4C6',
    keywords: [
      'schedule',
      'date',
      'planning'
    ],
    sheet: [26, 29],
    shortName: 'calendar'
  },
  {
    name: 'Clock Face Seven-Thirty',
    unified: '1F562',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 56],
    shortName: 'clock730'
  },
  {
    name: 'Male Detective',
    unified: '1F575-FE0F-200D-2642-FE0F',
    obsoletes: '1F575-FE0F',
    sheet: [29, 19],
    hidden: ['facebook'],
    skinVariations: [
      {
        unified: '1F575-1F3FB-200D-2642-FE0F',
        sheet: [29, 20]
      },
      {
        unified: '1F575-1F3FC-200D-2642-FE0F',
        sheet: [29, 21]
      },
      {
        unified: '1F575-1F3FD-200D-2642-FE0F',
        sheet: [29, 22]
      },
      {
        unified: '1F575-1F3FE-200D-2642-FE0F',
        sheet: [29, 23]
      },
      {
        unified: '1F575-1F3FF-200D-2642-FE0F',
        sheet: [29, 24]
      }
    ],
    shortName: 'male-detective'
  },
  {
    name: 'Mongolia Flag',
    unified: '1F1F2-1F1F3',
    sheet: [3, 9],
    shortName: 'flag-mn'
  },
  {
    name: 'Clock Face Eight Oclock',
    unified: '1F557',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 45],
    shortName: 'clock8'
  },
  {
    name: 'Female Detective',
    unified: '1F575-FE0F-200D-2640-FE0F',
    sheet: [29, 13],
    hidden: ['facebook'],
    skinVariations: [
      {
        unified: '1F575-1F3FB-200D-2640-FE0F',
        sheet: [29, 14]
      },
      {
        unified: '1F575-1F3FC-200D-2640-FE0F',
        sheet: [29, 15]
      },
      {
        unified: '1F575-1F3FD-200D-2640-FE0F',
        sheet: [29, 16]
      },
      {
        unified: '1F575-1F3FE-200D-2640-FE0F',
        sheet: [29, 17]
      },
      {
        unified: '1F575-1F3FF-200D-2640-FE0F',
        sheet: [29, 18]
      }
    ],
    shortName: 'female-detective'
  },
  {
    name: 'Spiral Note Pad',
    unified: '1F5D2-FE0F',
    sheet: [30, 16],
    shortName: 'spiral_note_pad'
  },
  {
    name: 'Circled Latin Capital Letter M',
    unified: '24C2-FE0F',
    keywords: [
      'alphabet',
      'blue-circle',
      'letter'
    ],
    sheet: [53, 46],
    shortName: 'm'
  },
  {
    name: 'Squared New',
    unified: '1F195',
    keywords: [
      'blue-square',
      'words',
      'start'
    ],
    sheet: [0, 25],
    shortName: 'new'
  },
  {
    name: 'Macao Sar China Flag',
    unified: '1F1F2-1F1F4',
    sheet: [3, 10],
    shortName: 'flag-mo'
  },
  {
    name: 'Guardsman',
    unified: '1F482',
    keywords: [
      'uk',
      'gb',
      'british',
      'male',
      'guy',
      'royal'
    ],
    sheet: [24, 23],
    skinVariations: [
      {
        unified: '1F482-1F3FB',
        sheet: [24, 24]
      },
      {
        unified: '1F482-1F3FC',
        sheet: [24, 25]
      },
      {
        unified: '1F482-1F3FD',
        sheet: [24, 26]
      },
      {
        unified: '1F482-1F3FE',
        sheet: [24, 27]
      },
      {
        unified: '1F482-1F3FF',
        sheet: [24, 28]
      }
    ],
    shortName: 'guardsman',
    obsoletedBy: '1F482-200D-2642-FE0F'
  },
  {
    name: 'Clock Face Eight-Thirty',
    unified: '1F563',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 57],
    shortName: 'clock830'
  },
  {
    name: 'Spiral Calendar Pad',
    unified: '1F5D3-FE0F',
    sheet: [30, 17],
    shortName: 'spiral_calendar_pad'
  },
  {
    name: 'Squared Ng',
    unified: '1F196',
    keywords: [
      'blue-square',
      'words',
      'shape',
      'icon'
    ],
    sheet: [0, 26],
    shortName: 'ng'
  },
  {
    name: 'Northern Mariana Islands Flag',
    unified: '1F1F2-1F1F5',
    sheet: [3, 11],
    shortName: 'flag-mp'
  },
  {
    name: 'Male Guard',
    unified: '1F482-200D-2642-FE0F',
    obsoletes: '1F482',
    sheet: [24, 17],
    skinVariations: [
      {
        unified: '1F482-1F3FB-200D-2642-FE0F',
        sheet: [24, 18]
      },
      {
        unified: '1F482-1F3FC-200D-2642-FE0F',
        sheet: [24, 19]
      },
      {
        unified: '1F482-1F3FD-200D-2642-FE0F',
        sheet: [24, 20]
      },
      {
        unified: '1F482-1F3FE-200D-2642-FE0F',
        sheet: [24, 21]
      },
      {
        unified: '1F482-1F3FF-200D-2642-FE0F',
        sheet: [24, 22]
      }
    ],
    shortName: 'male-guard'
  },
  {
    name: 'Card Index',
    unified: '1F4C7',
    keywords: [
      'business',
      'stationery'
    ],
    sheet: [26, 30],
    shortName: 'card_index'
  },
  {
    name: 'Clock Face Nine Oclock',
    unified: '1F558',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 46],
    shortName: 'clock9'
  },
  {
    name: 'Negative Squared Latin Capital Letter O',
    unified: '1F17E-FE0F',
    keywords: [
      'alphabet',
      'red-square',
      'letter'
    ],
    sheet: [0, 18],
    shortName: 'o2'
  },
  {
    name: 'Martinique Flag',
    unified: '1F1F2-1F1F6',
    sheet: [3, 12],
    shortName: 'flag-mq'
  },
  {
    name: 'Female Guard',
    unified: '1F482-200D-2640-FE0F',
    sheet: [24, 11],
    skinVariations: [
      {
        unified: '1F482-1F3FB-200D-2640-FE0F',
        sheet: [24, 12]
      },
      {
        unified: '1F482-1F3FC-200D-2640-FE0F',
        sheet: [24, 13]
      },
      {
        unified: '1F482-1F3FD-200D-2640-FE0F',
        sheet: [24, 14]
      },
      {
        unified: '1F482-1F3FE-200D-2640-FE0F',
        sheet: [24, 15]
      },
      {
        unified: '1F482-1F3FF-200D-2640-FE0F',
        sheet: [24, 16]
      }
    ],
    shortName: 'female-guard'
  },
  {
    name: 'Chart with Upwards Trend',
    unified: '1F4C8',
    keywords: [
      'graph',
      'presentation',
      'stats',
      'recovery',
      'business',
      'economics',
      'money',
      'sales',
      'good',
      'success'
    ],
    sheet: [26, 31],
    shortName: 'chart_with_upwards_trend'
  },
  {
    name: 'Clock Face Nine-Thirty',
    unified: '1F564',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [29, 0],
    shortName: 'clock930'
  },
  {
    name: 'Squared Ok',
    unified: '1F197',
    keywords: [
      'good',
      'agree',
      'yes',
      'blue-square'
    ],
    sheet: [0, 27],
    shortName: 'ok'
  },
  {
    name: 'Mauritania Flag',
    unified: '1F1F2-1F1F7',
    sheet: [3, 13],
    shortName: 'flag-mr'
  },
  {
    name: 'Chart with Downwards Trend',
    unified: '1F4C9',
    keywords: [
      'graph',
      'presentation',
      'stats',
      'recession',
      'business',
      'economics',
      'money',
      'sales',
      'bad',
      'failure'
    ],
    sheet: [26, 32],
    shortName: 'chart_with_downwards_trend'
  },
  {
    name: 'Clock Face Ten Oclock',
    unified: '1F559',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 47],
    shortName: 'clock10'
  },
  {
    name: 'Ninja',
    unified: '1F977',
    sheet: [42, 20],
    skinVariations: [
      {
        unified: '1F977-1F3FB',
        sheet: [42, 21]
      },
      {
        unified: '1F977-1F3FC',
        sheet: [42, 22]
      },
      {
        unified: '1F977-1F3FD',
        sheet: [42, 23]
      },
      {
        unified: '1F977-1F3FE',
        sheet: [42, 24]
      },
      {
        unified: '1F977-1F3FF',
        sheet: [42, 25]
      }
    ],
    shortName: 'ninja'
  },
  {
    name: 'Negative Squared Latin Capital Letter P',
    unified: '1F17F-FE0F',
    keywords: [
      'cars',
      'blue-square',
      'alphabet',
      'letter'
    ],
    sheet: [0, 19],
    shortName: 'parking'
  },
  {
    name: 'Montserrat Flag',
    unified: '1F1F2-1F1F8',
    sheet: [3, 14],
    shortName: 'flag-ms'
  },
  {
    name: 'Construction Worker',
    unified: '1F477',
    sheet: [23, 26],
    skinVariations: [
      {
        unified: '1F477-1F3FB',
        sheet: [23, 27]
      },
      {
        unified: '1F477-1F3FC',
        sheet: [23, 28]
      },
      {
        unified: '1F477-1F3FD',
        sheet: [23, 29]
      },
      {
        unified: '1F477-1F3FE',
        sheet: [23, 30]
      },
      {
        unified: '1F477-1F3FF',
        sheet: [23, 31]
      }
    ],
    shortName: 'construction_worker',
    obsoletedBy: '1F477-200D-2642-FE0F'
  },
  {
    name: 'Bar Chart',
    unified: '1F4CA',
    keywords: [
      'graph',
      'presentation',
      'stats'
    ],
    sheet: [26, 33],
    shortName: 'bar_chart'
  },
  {
    name: 'Clock Face Ten-Thirty',
    unified: '1F565',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [29, 1],
    shortName: 'clock1030'
  },
  {
    name: 'Squared Sos',
    unified: '1F198',
    keywords: [
      'help',
      'red-square',
      'words',
      'emergency',
      '911'
    ],
    sheet: [0, 28],
    shortName: 'sos'
  },
  {
    name: 'Malta Flag',
    unified: '1F1F2-1F1F9',
    sheet: [3, 15],
    shortName: 'flag-mt'
  },
  {
    name: 'Male Construction Worker',
    unified: '1F477-200D-2642-FE0F',
    obsoletes: '1F477',
    sheet: [23, 20],
    skinVariations: [
      {
        unified: '1F477-1F3FB-200D-2642-FE0F',
        sheet: [23, 21]
      },
      {
        unified: '1F477-1F3FC-200D-2642-FE0F',
        sheet: [23, 22]
      },
      {
        unified: '1F477-1F3FD-200D-2642-FE0F',
        sheet: [23, 23]
      },
      {
        unified: '1F477-1F3FE-200D-2642-FE0F',
        sheet: [23, 24]
      },
      {
        unified: '1F477-1F3FF-200D-2642-FE0F',
        sheet: [23, 25]
      }
    ],
    shortName: 'male-construction-worker'
  },
  {
    name: 'Clipboard',
    unified: '1F4CB',
    keywords: [
      'stationery',
      'documents'
    ],
    sheet: [26, 34],
    shortName: 'clipboard'
  },
  {
    name: 'Clock Face Eleven Oclock',
    unified: '1F55A',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [28, 48],
    shortName: 'clock11'
  },
  {
    name: 'Squared Up with Exclamation Mark',
    unified: '1F199',
    keywords: [
      'blue-square',
      'above',
      'high'
    ],
    sheet: [0, 29],
    shortName: 'up'
  },
  {
    name: 'Mauritius Flag',
    unified: '1F1F2-1F1FA',
    sheet: [3, 16],
    shortName: 'flag-mu'
  },
  {
    name: 'Female Construction Worker',
    unified: '1F477-200D-2640-FE0F',
    sheet: [23, 14],
    skinVariations: [
      {
        unified: '1F477-1F3FB-200D-2640-FE0F',
        sheet: [23, 15]
      },
      {
        unified: '1F477-1F3FC-200D-2640-FE0F',
        sheet: [23, 16]
      },
      {
        unified: '1F477-1F3FD-200D-2640-FE0F',
        sheet: [23, 17]
      },
      {
        unified: '1F477-1F3FE-200D-2640-FE0F',
        sheet: [23, 18]
      },
      {
        unified: '1F477-1F3FF-200D-2640-FE0F',
        sheet: [23, 19]
      }
    ],
    shortName: 'female-construction-worker'
  },
  {
    name: 'Pushpin',
    unified: '1F4CC',
    keywords: [
      'stationery',
      'mark',
      'here'
    ],
    sheet: [26, 35],
    shortName: 'pushpin'
  },
  {
    name: 'Clock Face Eleven-Thirty',
    unified: '1F566',
    keywords: [
      'time',
      'late',
      'early',
      'schedule'
    ],
    sheet: [29, 2],
    shortName: 'clock1130'
  },
  {
    name: 'Squared Vs',
    unified: '1F19A',
    keywords: [
      'words',
      'orange-square'
    ],
    sheet: [0, 30],
    shortName: 'vs'
  },
  {
    name: 'Maldives Flag',
    unified: '1F1F2-1F1FB',
    sheet: [3, 17],
    shortName: 'flag-mv'
  },
  {
    name: 'New Moon Symbol',
    unified: '1F311',
    keywords: [
      'nature',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep'
    ],
    sheet: [5, 31],
    shortName: 'new_moon'
  },
  {
    name: 'Round Pushpin',
    unified: '1F4CD',
    keywords: [
      'stationery',
      'location',
      'map',
      'here'
    ],
    sheet: [26, 36],
    shortName: 'round_pushpin'
  },
  {
    name: 'Prince',
    unified: '1F934',
    keywords: [
      'boy',
      'man',
      'male',
      'crown',
      'royal',
      'king'
    ],
    sheet: [39, 15],
    skinVariations: [
      {
        unified: '1F934-1F3FB',
        sheet: [39, 16]
      },
      {
        unified: '1F934-1F3FC',
        sheet: [39, 17]
      },
      {
        unified: '1F934-1F3FD',
        sheet: [39, 18]
      },
      {
        unified: '1F934-1F3FE',
        sheet: [39, 19]
      },
      {
        unified: '1F934-1F3FF',
        sheet: [39, 20]
      }
    ],
    shortName: 'prince'
  },
  {
    name: 'Malawi Flag',
    unified: '1F1F2-1F1FC',
    sheet: [3, 18],
    shortName: 'flag-mw'
  },
  {
    name: 'Squared Katakana Koko',
    unified: '1F201',
    keywords: [
      'blue-square',
      'here',
      'katakana',
      'japanese',
      'destination'
    ],
    sheet: [4, 57],
    shortName: 'koko'
  },
  {
    name: 'Waxing Crescent Moon Symbol',
    unified: '1F312',
    keywords: [
      'nature',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep'
    ],
    sheet: [5, 32],
    shortName: 'waxing_crescent_moon'
  },
  {
    name: 'Princess',
    unified: '1F478',
    keywords: [
      'girl',
      'woman',
      'female',
      'blond',
      'crown',
      'royal',
      'queen'
    ],
    sheet: [23, 32],
    skinVariations: [
      {
        unified: '1F478-1F3FB',
        sheet: [23, 33]
      },
      {
        unified: '1F478-1F3FC',
        sheet: [23, 34]
      },
      {
        unified: '1F478-1F3FD',
        sheet: [23, 35]
      },
      {
        unified: '1F478-1F3FE',
        sheet: [23, 36]
      },
      {
        unified: '1F478-1F3FF',
        sheet: [23, 37]
      }
    ],
    shortName: 'princess'
  },
  {
    name: 'Paperclip',
    unified: '1F4CE',
    keywords: [
      'documents',
      'stationery'
    ],
    sheet: [26, 37],
    shortName: 'paperclip'
  },
  {
    name: 'Mexico Flag',
    unified: '1F1F2-1F1FD',
    sheet: [3, 19],
    shortName: 'flag-mx'
  },
  {
    name: 'Squared Katakana Sa',
    unified: '1F202-FE0F',
    keywords: [
      'japanese',
      'blue-square',
      'katakana'
    ],
    sheet: [5, 0],
    shortName: 'sa'
  },
  {
    name: 'First Quarter Moon Symbol',
    unified: '1F313',
    keywords: [
      'nature',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep'
    ],
    sheet: [5, 33],
    shortName: 'first_quarter_moon'
  },
  {
    name: 'Man with Turban',
    unified: '1F473',
    keywords: [
      'male',
      'indian',
      'hinduism',
      'arabs'
    ],
    sheet: [22, 48],
    skinVariations: [
      {
        unified: '1F473-1F3FB',
        sheet: [22, 49]
      },
      {
        unified: '1F473-1F3FC',
        sheet: [22, 50]
      },
      {
        unified: '1F473-1F3FD',
        sheet: [22, 51]
      },
      {
        unified: '1F473-1F3FE',
        sheet: [22, 52]
      },
      {
        unified: '1F473-1F3FF',
        sheet: [22, 53]
      }
    ],
    shortName: 'man_with_turban',
    obsoletedBy: '1F473-200D-2642-FE0F'
  },
  {
    name: 'Linked Paperclips',
    unified: '1F587-FE0F',
    sheet: [29, 41],
    shortName: 'linked_paperclips'
  },
  {
    name: 'Malaysia Flag',
    unified: '1F1F2-1F1FE',
    sheet: [3, 20],
    shortName: 'flag-my'
  },
  {
    name: 'Squared Cjk Unified Ideograph-6708',
    unified: '1F237-FE0F',
    keywords: [
      'chinese',
      'month',
      'moon',
      'japanese',
      'orange-square',
      'kanji'
    ],
    sheet: [5, 8],
    shortName: 'u6708'
  },
  {
    name: 'Waxing Gibbous Moon Symbol',
    unified: '1F314',
    sheet: [5, 34],
    shortNames: ['waxing_gibbous_moon'],
    shortName: 'moon'
  },
  {
    name: 'Man Wearing Turban',
    unified: '1F473-200D-2642-FE0F',
    obsoletes: '1F473',
    sheet: [22, 42],
    skinVariations: [
      {
        unified: '1F473-1F3FB-200D-2642-FE0F',
        sheet: [22, 43]
      },
      {
        unified: '1F473-1F3FC-200D-2642-FE0F',
        sheet: [22, 44]
      },
      {
        unified: '1F473-1F3FD-200D-2642-FE0F',
        sheet: [22, 45]
      },
      {
        unified: '1F473-1F3FE-200D-2642-FE0F',
        sheet: [22, 46]
      },
      {
        unified: '1F473-1F3FF-200D-2642-FE0F',
        sheet: [22, 47]
      }
    ],
    shortName: 'man-wearing-turban'
  },
  {
    name: 'Straight Ruler',
    unified: '1F4CF',
    keywords: [
      'stationery',
      'calculate',
      'length',
      'math',
      'school',
      'drawing',
      'architect',
      'sketch'
    ],
    sheet: [26, 38],
    shortName: 'straight_ruler'
  },
  {
    name: 'Mozambique Flag',
    unified: '1F1F2-1F1FF',
    sheet: [3, 21],
    shortName: 'flag-mz'
  },
  {
    name: 'Squared Cjk Unified Ideograph-6709',
    unified: '1F236',
    keywords: [
      'orange-square',
      'chinese',
      'have',
      'kanji'
    ],
    sheet: [5, 7],
    shortName: 'u6709'
  },
  {
    name: 'Full Moon Symbol',
    unified: '1F315',
    keywords: [
      'nature',
      'yellow',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep'
    ],
    sheet: [5, 35],
    shortName: 'full_moon'
  },
  {
    name: 'Woman Wearing Turban',
    unified: '1F473-200D-2640-FE0F',
    sheet: [22, 36],
    skinVariations: [
      {
        unified: '1F473-1F3FB-200D-2640-FE0F',
        sheet: [22, 37]
      },
      {
        unified: '1F473-1F3FC-200D-2640-FE0F',
        sheet: [22, 38]
      },
      {
        unified: '1F473-1F3FD-200D-2640-FE0F',
        sheet: [22, 39]
      },
      {
        unified: '1F473-1F3FE-200D-2640-FE0F',
        sheet: [22, 40]
      },
      {
        unified: '1F473-1F3FF-200D-2640-FE0F',
        sheet: [22, 41]
      }
    ],
    shortName: 'woman-wearing-turban'
  },
  {
    name: 'Triangular Ruler',
    unified: '1F4D0',
    keywords: [
      'stationery',
      'math',
      'architect',
      'sketch'
    ],
    sheet: [26, 39],
    shortName: 'triangular_ruler'
  },
  {
    name: 'Namibia Flag',
    unified: '1F1F3-1F1E6',
    sheet: [3, 22],
    shortName: 'flag-na'
  },
  {
    name: 'Squared Cjk Unified Ideograph-6307',
    unified: '1F22F',
    keywords: [
      'chinese',
      'point',
      'green-square',
      'kanji'
    ],
    sheet: [5, 2],
    shortName: 'u6307'
  },
  {
    name: 'Waning Gibbous Moon Symbol',
    unified: '1F316',
    keywords: [
      'nature',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep',
      'waxing_gibbous_moon'
    ],
    sheet: [5, 36],
    shortName: 'waning_gibbous_moon'
  },
  {
    name: 'Man with Gua Pi Mao',
    unified: '1F472',
    keywords: [
      'male',
      'boy',
      'chinese'
    ],
    sheet: [22, 30],
    skinVariations: [
      {
        unified: '1F472-1F3FB',
        sheet: [22, 31]
      },
      {
        unified: '1F472-1F3FC',
        sheet: [22, 32]
      },
      {
        unified: '1F472-1F3FD',
        sheet: [22, 33]
      },
      {
        unified: '1F472-1F3FE',
        sheet: [22, 34]
      },
      {
        unified: '1F472-1F3FF',
        sheet: [22, 35]
      }
    ],
    shortName: 'man_with_gua_pi_mao'
  },
  {
    name: 'Black Scissors',
    unified: '2702-FE0F',
    keywords: ['stationery', 'cut'],
    sheet: [55, 44],
    shortName: 'scissors'
  },
  {
    name: 'New Caledonia Flag',
    unified: '1F1F3-1F1E8',
    sheet: [3, 23],
    shortName: 'flag-nc'
  },
  {
    name: 'Circled Ideograph Advantage',
    unified: '1F250',
    keywords: [
      'chinese',
      'kanji',
      'obtain',
      'get',
      'circle'
    ],
    sheet: [5, 12],
    shortName: 'ideograph_advantage'
  },
  {
    name: 'Last Quarter Moon Symbol',
    unified: '1F317',
    keywords: [
      'nature',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep'
    ],
    sheet: [5, 37],
    shortName: 'last_quarter_moon'
  },
  {
    name: 'Card File Box',
    unified: '1F5C3-FE0F',
    keywords: [
      'business',
      'stationery'
    ],
    sheet: [30, 13],
    shortName: 'card_file_box'
  },
  {
    name: 'Person with Headscarf',
    unified: '1F9D5',
    sheet: [49, 3],
    skinVariations: [
      {
        unified: '1F9D5-1F3FB',
        sheet: [49, 4]
      },
      {
        unified: '1F9D5-1F3FC',
        sheet: [49, 5]
      },
      {
        unified: '1F9D5-1F3FD',
        sheet: [49, 6]
      },
      {
        unified: '1F9D5-1F3FE',
        sheet: [49, 7]
      },
      {
        unified: '1F9D5-1F3FF',
        sheet: [49, 8]
      }
    ],
    shortName: 'person_with_headscarf'
  },
  {
    name: 'Niger Flag',
    unified: '1F1F3-1F1EA',
    sheet: [3, 24],
    shortName: 'flag-ne'
  },
  {
    name: 'Squared Cjk Unified Ideograph-5272',
    unified: '1F239',
    keywords: [
      'cut',
      'divide',
      'chinese',
      'kanji',
      'pink-square'
    ],
    sheet: [5, 10],
    shortName: 'u5272'
  },
  {
    name: 'Waning Crescent Moon Symbol',
    unified: '1F318',
    keywords: [
      'nature',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep'
    ],
    sheet: [5, 38],
    shortName: 'waning_crescent_moon'
  },
  {
    name: 'File Cabinet',
    unified: '1F5C4-FE0F',
    keywords: ['filing', 'organizing'],
    sheet: [30, 14],
    shortName: 'file_cabinet'
  },
  {
    name: 'Norfolk Island Flag',
    unified: '1F1F3-1F1EB',
    sheet: [3, 25],
    shortName: 'flag-nf'
  },
  {
    name: 'Squared Cjk Unified Ideograph-7121',
    unified: '1F21A',
    keywords: [
      'nothing',
      'chinese',
      'kanji',
      'japanese',
      'orange-square'
    ],
    sheet: [5, 1],
    shortName: 'u7121'
  },
  {
    name: 'Crescent Moon',
    unified: '1F319',
    keywords: [
      'night',
      'sleep',
      'sky',
      'evening',
      'magic'
    ],
    sheet: [5, 39],
    shortName: 'crescent_moon'
  },
  {
    name: 'Wastebasket',
    unified: '1F5D1-FE0F',
    keywords: [
      'bin',
      'trash',
      'rubbish',
      'garbage',
      'toss'
    ],
    sheet: [30, 15],
    shortName: 'wastebasket'
  },
  {
    name: 'Man in Tuxedo',
    unified: '1F935-200D-2642-FE0F',
    keywords: [
      'couple',
      'marriage',
      'wedding',
      'groom'
    ],
    sheet: [39, 27],
    skinVariations: [
      {
        unified: '1F935-1F3FB-200D-2642-FE0F',
        sheet: [39, 28]
      },
      {
        unified: '1F935-1F3FC-200D-2642-FE0F',
        sheet: [39, 29]
      },
      {
        unified: '1F935-1F3FD-200D-2642-FE0F',
        sheet: [39, 30]
      },
      {
        unified: '1F935-1F3FE-200D-2642-FE0F',
        sheet: [39, 31]
      },
      {
        unified: '1F935-1F3FF-200D-2642-FE0F',
        sheet: [39, 32]
      }
    ],
    shortName: 'man_in_tuxedo'
  },
  {
    name: 'Nigeria Flag',
    unified: '1F1F3-1F1EC',
    sheet: [3, 26],
    shortName: 'flag-ng'
  },
  {
    name: 'Squared Cjk Unified Ideograph-7981',
    unified: '1F232',
    keywords: [
      'kanji',
      'japanese',
      'chinese',
      'forbidden',
      'limit',
      'restricted',
      'red-square'
    ],
    sheet: [5, 3],
    shortName: 'u7981'
  },
  {
    name: 'New Moon with Face',
    unified: '1F31A',
    keywords: [
      'nature',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep'
    ],
    sheet: [5, 40],
    shortName: 'new_moon_with_face'
  },
  {
    name: 'Lock',
    unified: '1F512',
    keywords: [
      'security',
      'password',
      'padlock'
    ],
    sheet: [27, 46],
    shortName: 'lock'
  },
  {
    name: 'Woman in Tuxedo',
    unified: '1F935-200D-2640-FE0F',
    sheet: [39, 21],
    skinVariations: [
      {
        unified: '1F935-1F3FB-200D-2640-FE0F',
        sheet: [39, 22]
      },
      {
        unified: '1F935-1F3FC-200D-2640-FE0F',
        sheet: [39, 23]
      },
      {
        unified: '1F935-1F3FD-200D-2640-FE0F',
        sheet: [39, 24]
      },
      {
        unified: '1F935-1F3FE-200D-2640-FE0F',
        sheet: [39, 25]
      },
      {
        unified: '1F935-1F3FF-200D-2640-FE0F',
        sheet: [39, 26]
      }
    ],
    shortName: 'woman_in_tuxedo'
  },
  {
    name: 'Nicaragua Flag',
    unified: '1F1F3-1F1EE',
    sheet: [3, 27],
    shortName: 'flag-ni'
  },
  {
    name: 'Circled Ideograph Accept',
    unified: '1F251',
    keywords: [
      'ok',
      'good',
      'chinese',
      'kanji',
      'agree',
      'yes',
      'orange-circle'
    ],
    sheet: [5, 13],
    shortName: 'accept'
  },
  {
    name: 'First Quarter Moon with Face',
    unified: '1F31B',
    keywords: [
      'nature',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep'
    ],
    sheet: [5, 41],
    shortName: 'first_quarter_moon_with_face'
  },
  {
    name: 'Bride with Veil',
    unified: '1F470',
    keywords: [
      'couple',
      'marriage',
      'wedding',
      'woman',
      'bride'
    ],
    sheet: [22, 6],
    skinVariations: [
      {
        unified: '1F470-1F3FB',
        sheet: [22, 7]
      },
      {
        unified: '1F470-1F3FC',
        sheet: [22, 8]
      },
      {
        unified: '1F470-1F3FD',
        sheet: [22, 9]
      },
      {
        unified: '1F470-1F3FE',
        sheet: [22, 10]
      },
      {
        unified: '1F470-1F3FF',
        sheet: [22, 11]
      }
    ],
    shortName: 'bride_with_veil'
  },
  {
    name: 'Open Lock',
    unified: '1F513',
    keywords: ['privacy', 'security'],
    sheet: [27, 47],
    shortName: 'unlock'
  },
  {
    name: 'Netherlands Flag',
    unified: '1F1F3-1F1F1',
    sheet: [3, 28],
    shortName: 'flag-nl'
  },
  {
    name: 'Squared Cjk Unified Ideograph-7533',
    unified: '1F238',
    keywords: [
      'chinese',
      'japanese',
      'kanji',
      'orange-square'
    ],
    sheet: [5, 9],
    shortName: 'u7533'
  },
  {
    name: 'Last Quarter Moon with Face',
    unified: '1F31C',
    keywords: [
      'nature',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep'
    ],
    sheet: [5, 42],
    shortName: 'last_quarter_moon_with_face'
  },
  {
    name: 'Man with Veil',
    unified: '1F470-200D-2642-FE0F',
    sheet: [22, 0],
    skinVariations: [
      {
        unified: '1F470-1F3FB-200D-2642-FE0F',
        sheet: [22, 1]
      },
      {
        unified: '1F470-1F3FC-200D-2642-FE0F',
        sheet: [22, 2]
      },
      {
        unified: '1F470-1F3FD-200D-2642-FE0F',
        sheet: [22, 3]
      },
      {
        unified: '1F470-1F3FE-200D-2642-FE0F',
        sheet: [22, 4]
      },
      {
        unified: '1F470-1F3FF-200D-2642-FE0F',
        sheet: [22, 5]
      }
    ],
    shortName: 'man_with_veil'
  },
  {
    name: 'Lock with Ink Pen',
    unified: '1F50F',
    keywords: ['security', 'secret'],
    sheet: [27, 43],
    shortName: 'lock_with_ink_pen'
  },
  {
    name: 'Norway Flag',
    unified: '1F1F3-1F1F4',
    sheet: [3, 29],
    shortName: 'flag-no'
  },
  {
    name: 'Squared Cjk Unified Ideograph-5408',
    unified: '1F234',
    keywords: [
      'japanese',
      'chinese',
      'join',
      'kanji',
      'red-square'
    ],
    sheet: [5, 5],
    shortName: 'u5408'
  },
  {
    name: 'Thermometer',
    unified: '1F321-FE0F',
    keywords: [
      'weather',
      'temperature',
      'hot',
      'cold'
    ],
    sheet: [5, 47],
    shortName: 'thermometer'
  },
  {
    name: 'Woman with Veil',
    unified: '1F470-200D-2640-FE0F',
    sheet: [21, 52],
    skinVariations: [
      {
        unified: '1F470-1F3FB-200D-2640-FE0F',
        sheet: [21, 53]
      },
      {
        unified: '1F470-1F3FC-200D-2640-FE0F',
        sheet: [21, 54]
      },
      {
        unified: '1F470-1F3FD-200D-2640-FE0F',
        sheet: [21, 55]
      },
      {
        unified: '1F470-1F3FE-200D-2640-FE0F',
        sheet: [21, 56]
      },
      {
        unified: '1F470-1F3FF-200D-2640-FE0F',
        sheet: [21, 57]
      }
    ],
    shortName: 'woman_with_veil'
  },
  {
    name: 'Closed Lock with Key',
    unified: '1F510',
    keywords: ['security', 'privacy'],
    sheet: [27, 44],
    shortName: 'closed_lock_with_key'
  },
  {
    name: 'Nepal Flag',
    unified: '1F1F3-1F1F5',
    sheet: [3, 30],
    shortName: 'flag-np'
  },
  {
    name: 'Squared Cjk Unified Ideograph-7a7a',
    unified: '1F233',
    keywords: [
      'kanji',
      'japanese',
      'chinese',
      'empty',
      'sky',
      'blue-square'
    ],
    sheet: [5, 4],
    shortName: 'u7a7a'
  },
  {
    name: 'Key',
    unified: '1F511',
    keywords: [
      'lock',
      'door',
      'password'
    ],
    sheet: [27, 45],
    shortName: 'key'
  },
  {
    name: 'Pregnant Woman',
    unified: '1F930',
    keywords: ['baby'],
    sheet: [38, 49],
    skinVariations: [
      {
        unified: '1F930-1F3FB',
        sheet: [38, 50]
      },
      {
        unified: '1F930-1F3FC',
        sheet: [38, 51]
      },
      {
        unified: '1F930-1F3FD',
        sheet: [38, 52]
      },
      {
        unified: '1F930-1F3FE',
        sheet: [38, 53]
      },
      {
        unified: '1F930-1F3FF',
        sheet: [38, 54]
      }
    ],
    shortName: 'pregnant_woman'
  },
  {
    name: 'Black Sun with Rays',
    unified: '2600-FE0F',
    keywords: [
      'weather',
      'nature',
      'brightness',
      'summer',
      'beach',
      'spring'
    ],
    sheet: [53, 55],
    shortName: 'sunny'
  },
  {
    name: 'Nauru Flag',
    unified: '1F1F3-1F1F7',
    sheet: [3, 31],
    shortName: 'flag-nr'
  },
  {
    name: 'Full Moon with Face',
    unified: '1F31D',
    keywords: [
      'nature',
      'twilight',
      'planet',
      'space',
      'night',
      'evening',
      'sleep'
    ],
    sheet: [5, 43],
    shortName: 'full_moon_with_face'
  },
  {
    name: 'Old Key',
    unified: '1F5DD-FE0F',
    keywords: [
      'lock',
      'door',
      'password'
    ],
    sheet: [30, 19],
    shortName: 'old_key'
  },
  {
    name: 'Breast-Feeding',
    unified: '1F931',
    sheet: [38, 55],
    skinVariations: [
      {
        unified: '1F931-1F3FB',
        sheet: [38, 56]
      },
      {
        unified: '1F931-1F3FC',
        sheet: [38, 57]
      },
      {
        unified: '1F931-1F3FD',
        sheet: [39, 0]
      },
      {
        unified: '1F931-1F3FE',
        sheet: [39, 1]
      },
      {
        unified: '1F931-1F3FF',
        sheet: [39, 2]
      }
    ],
    shortName: 'breast-feeding'
  },
  {
    name: 'Circled Ideograph Congratulation',
    unified: '3297-FE0F',
    keywords: [
      'chinese',
      'kanji',
      'japanese',
      'red-circle'
    ],
    sheet: [56, 50],
    shortName: 'congratulations'
  },
  {
    name: 'Niue Flag',
    unified: '1F1F3-1F1FA',
    sheet: [3, 32],
    shortName: 'flag-nu'
  },
  {
    name: 'Sun with Face',
    unified: '1F31E',
    keywords: [
      'nature',
      'morning',
      'sky'
    ],
    sheet: [5, 44],
    shortName: 'sun_with_face'
  },
  {
    name: 'Woman Feeding Baby',
    unified: '1F469-200D-1F37C',
    sheet: [17, 32],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F37C',
        sheet: [17, 33]
      },
      {
        unified: '1F469-1F3FC-200D-1F37C',
        sheet: [17, 34]
      },
      {
        unified: '1F469-1F3FD-200D-1F37C',
        sheet: [17, 35]
      },
      {
        unified: '1F469-1F3FE-200D-1F37C',
        sheet: [17, 36]
      },
      {
        unified: '1F469-1F3FF-200D-1F37C',
        sheet: [17, 37]
      }
    ],
    shortName: 'woman_feeding_baby'
  },
  {
    name: 'Hammer',
    unified: '1F528',
    keywords: [
      'tools',
      'build',
      'create'
    ],
    sheet: [28, 10],
    shortName: 'hammer'
  },
  {
    name: 'Circled Ideograph Secret',
    unified: '3299-FE0F',
    keywords: [
      'privacy',
      'chinese',
      'sshh',
      'kanji',
      'red-circle'
    ],
    sheet: [56, 51],
    shortName: 'secret'
  },
  {
    name: 'New Zealand Flag',
    unified: '1F1F3-1F1FF',
    sheet: [3, 33],
    shortName: 'flag-nz'
  },
  {
    name: 'Squared Cjk Unified Ideograph-55b6',
    unified: '1F23A',
    keywords: [
      'japanese',
      'opening hours',
      'orange-square'
    ],
    sheet: [5, 11],
    shortName: 'u55b6'
  },
  {
    name: 'Man Feeding Baby',
    unified: '1F468-200D-1F37C',
    sheet: [14, 39],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F37C',
        sheet: [14, 40]
      },
      {
        unified: '1F468-1F3FC-200D-1F37C',
        sheet: [14, 41]
      },
      {
        unified: '1F468-1F3FD-200D-1F37C',
        sheet: [14, 42]
      },
      {
        unified: '1F468-1F3FE-200D-1F37C',
        sheet: [14, 43]
      },
      {
        unified: '1F468-1F3FF-200D-1F37C',
        sheet: [14, 44]
      }
    ],
    shortName: 'man_feeding_baby'
  },
  {
    name: 'Ringed Planet',
    unified: '1FA90',
    sheet: [52, 32],
    shortName: 'ringed_planet'
  },
  {
    name: 'Axe',
    unified: '1FA93',
    sheet: [52, 35],
    shortName: 'axe'
  },
  {
    name: 'Oman Flag',
    unified: '1F1F4-1F1F2',
    sheet: [3, 34],
    shortName: 'flag-om'
  },
  {
    name: 'Squared Cjk Unified Ideograph-6e80',
    unified: '1F235',
    keywords: [
      'full',
      'chinese',
      'japanese',
      'red-square',
      'kanji'
    ],
    sheet: [5, 6],
    shortName: 'u6e80'
  },
  {
    name: 'Person Feeding Baby',
    unified: '1F9D1-200D-1F37C',
    sheet: [45, 47],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F37C',
        sheet: [45, 48]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F37C',
        sheet: [45, 49]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F37C',
        sheet: [45, 50]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F37C',
        sheet: [45, 51]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F37C',
        sheet: [45, 52]
      }
    ],
    shortName: 'person_feeding_baby'
  },
  {
    name: 'Pick',
    unified: '26CF-FE0F',
    keywords: ['tools', 'dig'],
    sheet: [55, 10],
    shortName: 'pick'
  },
  {
    name: 'White Medium Star',
    unified: '2B50',
    keywords: ['night', 'yellow'],
    sheet: [56, 46],
    shortName: 'star'
  },
  {
    name: 'Panama Flag',
    unified: '1F1F5-1F1E6',
    sheet: [3, 35],
    shortName: 'flag-pa'
  },
  {
    name: 'Glowing Star',
    unified: '1F31F',
    keywords: [
      'night',
      'sparkle',
      'awesome',
      'good',
      'magic'
    ],
    sheet: [5, 45],
    shortName: 'star2'
  },
  {
    name: 'Baby Angel',
    unified: '1F47C',
    keywords: [
      'heaven',
      'wings',
      'halo'
    ],
    sheet: [23, 41],
    skinVariations: [
      {
        unified: '1F47C-1F3FB',
        sheet: [23, 42]
      },
      {
        unified: '1F47C-1F3FC',
        sheet: [23, 43]
      },
      {
        unified: '1F47C-1F3FD',
        sheet: [23, 44]
      },
      {
        unified: '1F47C-1F3FE',
        sheet: [23, 45]
      },
      {
        unified: '1F47C-1F3FF',
        sheet: [23, 46]
      }
    ],
    shortName: 'angel'
  },
  {
    name: 'Large Red Circle',
    unified: '1F534',
    keywords: [
      'shape',
      'error',
      'danger'
    ],
    sheet: [28, 22],
    shortName: 'red_circle'
  },
  {
    name: 'Hammer and Pick',
    unified: '2692-FE0F',
    keywords: [
      'tools',
      'build',
      'create'
    ],
    sheet: [54, 46],
    shortName: 'hammer_and_pick'
  },
  {
    name: 'Peru Flag',
    unified: '1F1F5-1F1EA',
    sheet: [3, 36],
    shortName: 'flag-pe'
  },
  {
    name: 'Shooting Star',
    unified: '1F320',
    keywords: ['night', 'photo'],
    sheet: [5, 46],
    shortName: 'stars'
  },
  {
    name: 'Father Christmas',
    unified: '1F385',
    keywords: [
      'festival',
      'man',
      'male',
      'xmas',
      'father christmas'
    ],
    sheet: [7, 29],
    skinVariations: [
      {
        unified: '1F385-1F3FB',
        sheet: [7, 30]
      },
      {
        unified: '1F385-1F3FC',
        sheet: [7, 31]
      },
      {
        unified: '1F385-1F3FD',
        sheet: [7, 32]
      },
      {
        unified: '1F385-1F3FE',
        sheet: [7, 33]
      },
      {
        unified: '1F385-1F3FF',
        sheet: [7, 34]
      }
    ],
    shortName: 'santa'
  },
  {
    name: 'Hammer and Wrench',
    unified: '1F6E0-FE0F',
    keywords: [
      'tools',
      'build',
      'create'
    ],
    sheet: [36, 35],
    shortName: 'hammer_and_wrench'
  },
  {
    name: 'Large Orange Circle',
    unified: '1F7E0',
    sheet: [36, 55],
    shortName: 'large_orange_circle'
  },
  {
    name: 'French Polynesia Flag',
    unified: '1F1F5-1F1EB',
    sheet: [3, 37],
    shortName: 'flag-pf'
  },
  {
    name: 'Milky Way',
    unified: '1F30C',
    keywords: [
      'photo',
      'space',
      'stars'
    ],
    sheet: [5, 26],
    shortName: 'milky_way'
  },
  {
    name: 'Dagger Knife',
    unified: '1F5E1-FE0F',
    sheet: [30, 21],
    shortName: 'dagger_knife'
  },
  {
    name: 'Large Yellow Circle',
    unified: '1F7E1',
    sheet: [36, 56],
    shortName: 'large_yellow_circle'
  },
  {
    name: 'Mother Christmas',
    unified: '1F936',
    keywords: [
      'woman',
      'female',
      'xmas',
      'mother christmas'
    ],
    sheet: [39, 39],
    skinVariations: [
      {
        unified: '1F936-1F3FB',
        sheet: [39, 40]
      },
      {
        unified: '1F936-1F3FC',
        sheet: [39, 41]
      },
      {
        unified: '1F936-1F3FD',
        sheet: [39, 42]
      },
      {
        unified: '1F936-1F3FE',
        sheet: [39, 43]
      },
      {
        unified: '1F936-1F3FF',
        sheet: [39, 44]
      }
    ],
    shortNames: ['mother_christmas'],
    shortName: 'mrs_claus'
  },
  {
    name: 'Papua New Guinea Flag',
    unified: '1F1F5-1F1EC',
    sheet: [3, 38],
    shortName: 'flag-pg'
  },
  {
    name: 'Large Green Circle',
    unified: '1F7E2',
    sheet: [36, 57],
    shortName: 'large_green_circle'
  },
  {
    name: 'Mx Claus',
    unified: '1F9D1-200D-1F384',
    sheet: [45, 53],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F384',
        sheet: [45, 54]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F384',
        sheet: [45, 55]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F384',
        sheet: [45, 56]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F384',
        sheet: [45, 57]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F384',
        sheet: [46, 0]
      }
    ],
    shortName: 'mx_claus'
  },
  {
    name: 'Cloud',
    unified: '2601-FE0F',
    keywords: ['weather', 'sky'],
    sheet: [53, 56],
    shortName: 'cloud'
  },
  {
    name: 'Crossed Swords',
    unified: '2694-FE0F',
    keywords: ['weapon'],
    sheet: [54, 48],
    shortName: 'crossed_swords'
  },
  {
    name: 'Philippines Flag',
    unified: '1F1F5-1F1ED',
    sheet: [3, 39],
    shortName: 'flag-ph'
  },
  {
    name: 'Pistol',
    unified: '1F52B',
    keywords: [
      'violence',
      'weapon',
      'pistol',
      'revolver'
    ],
    sheet: [28, 13],
    shortName: 'gun'
  },
  {
    name: 'Large Blue Circle',
    unified: '1F535',
    keywords: [
      'shape',
      'icon',
      'button'
    ],
    sheet: [28, 23],
    shortName: 'large_blue_circle'
  },
  {
    name: 'Superhero',
    unified: '1F9B8',
    sheet: [43, 49],
    skinVariations: [
      {
        unified: '1F9B8-1F3FB',
        sheet: [43, 50]
      },
      {
        unified: '1F9B8-1F3FC',
        sheet: [43, 51]
      },
      {
        unified: '1F9B8-1F3FD',
        sheet: [43, 52]
      },
      {
        unified: '1F9B8-1F3FE',
        sheet: [43, 53]
      },
      {
        unified: '1F9B8-1F3FF',
        sheet: [43, 54]
      }
    ],
    shortName: 'superhero'
  },
  {
    name: 'Sun Behind Cloud',
    unified: '26C5',
    keywords: [
      'weather',
      'nature',
      'cloudy',
      'morning',
      'fall',
      'spring'
    ],
    sheet: [55, 7],
    shortName: 'partly_sunny'
  },
  {
    name: 'Pakistan Flag',
    unified: '1F1F5-1F1F0',
    sheet: [3, 40],
    shortName: 'flag-pk'
  },
  {
    name: 'Large Purple Circle',
    unified: '1F7E3',
    sheet: [37, 0],
    shortName: 'large_purple_circle'
  },
  {
    name: 'Male Superhero',
    unified: '1F9B8-200D-2642-FE0F',
    sheet: [43, 43],
    skinVariations: [
      {
        unified: '1F9B8-1F3FB-200D-2642-FE0F',
        sheet: [43, 44]
      },
      {
        unified: '1F9B8-1F3FC-200D-2642-FE0F',
        sheet: [43, 45]
      },
      {
        unified: '1F9B8-1F3FD-200D-2642-FE0F',
        sheet: [43, 46]
      },
      {
        unified: '1F9B8-1F3FE-200D-2642-FE0F',
        sheet: [43, 47]
      },
      {
        unified: '1F9B8-1F3FF-200D-2642-FE0F',
        sheet: [43, 48]
      }
    ],
    shortName: 'male_superhero'
  },
  {
    name: 'Boomerang',
    unified: '1FA83',
    sheet: [52, 28],
    shortName: 'boomerang'
  },
  {
    name: 'Thunder Cloud and Rain',
    unified: '26C8-FE0F',
    sheet: [55, 8],
    shortName: 'thunder_cloud_and_rain'
  },
  {
    name: 'Poland Flag',
    unified: '1F1F5-1F1F1',
    sheet: [3, 41],
    shortName: 'flag-pl'
  },
  {
    name: 'Mostly Sunny',
    unified: '1F324-FE0F',
    sheet: [5, 48],
    shortNames: ['sun_small_cloud'],
    shortName: 'mostly_sunny'
  },
  {
    name: 'Bow and Arrow',
    unified: '1F3F9',
    keywords: ['sports'],
    sheet: [11, 11],
    shortName: 'bow_and_arrow'
  },
  {
    name: 'Large Brown Circle',
    unified: '1F7E4',
    sheet: [37, 1],
    shortName: 'large_brown_circle'
  },
  {
    name: 'Female Superhero',
    unified: '1F9B8-200D-2640-FE0F',
    sheet: [43, 37],
    skinVariations: [
      {
        unified: '1F9B8-1F3FB-200D-2640-FE0F',
        sheet: [43, 38]
      },
      {
        unified: '1F9B8-1F3FC-200D-2640-FE0F',
        sheet: [43, 39]
      },
      {
        unified: '1F9B8-1F3FD-200D-2640-FE0F',
        sheet: [43, 40]
      },
      {
        unified: '1F9B8-1F3FE-200D-2640-FE0F',
        sheet: [43, 41]
      },
      {
        unified: '1F9B8-1F3FF-200D-2640-FE0F',
        sheet: [43, 42]
      }
    ],
    shortName: 'female_superhero'
  },
  {
    name: 'St. Pierre & Miquelon Flag',
    unified: '1F1F5-1F1F2',
    sheet: [3, 42],
    shortName: 'flag-pm'
  },
  {
    name: 'Barely Sunny',
    unified: '1F325-FE0F',
    sheet: [5, 49],
    shortNames: ['sun_behind_cloud'],
    shortName: 'barely_sunny'
  },
  {
    name: 'Shield',
    unified: '1F6E1-FE0F',
    keywords: [
      'protection',
      'security'
    ],
    sheet: [36, 36],
    shortName: 'shield'
  },
  {
    name: 'Supervillain',
    unified: '1F9B9',
    sheet: [44, 9],
    skinVariations: [
      {
        unified: '1F9B9-1F3FB',
        sheet: [44, 10]
      },
      {
        unified: '1F9B9-1F3FC',
        sheet: [44, 11]
      },
      {
        unified: '1F9B9-1F3FD',
        sheet: [44, 12]
      },
      {
        unified: '1F9B9-1F3FE',
        sheet: [44, 13]
      },
      {
        unified: '1F9B9-1F3FF',
        sheet: [44, 14]
      }
    ],
    shortName: 'supervillain'
  },
  {
    name: 'Medium Black Circle',
    unified: '26AB',
    keywords: [
      'shape',
      'button',
      'round'
    ],
    sheet: [55, 1],
    shortName: 'black_circle'
  },
  {
    name: 'Pitcairn Islands Flag',
    unified: '1F1F5-1F1F3',
    sheet: [3, 43],
    shortName: 'flag-pn'
  },
  {
    name: 'Partly Sunny Rain',
    unified: '1F326-FE0F',
    sheet: [5, 50],
    shortNames: ['sun_behind_rain_cloud'],
    shortName: 'partly_sunny_rain'
  },
  {
    name: 'Male Supervillain',
    unified: '1F9B9-200D-2642-FE0F',
    sheet: [44, 3],
    skinVariations: [
      {
        unified: '1F9B9-1F3FB-200D-2642-FE0F',
        sheet: [44, 4]
      },
      {
        unified: '1F9B9-1F3FC-200D-2642-FE0F',
        sheet: [44, 5]
      },
      {
        unified: '1F9B9-1F3FD-200D-2642-FE0F',
        sheet: [44, 6]
      },
      {
        unified: '1F9B9-1F3FE-200D-2642-FE0F',
        sheet: [44, 7]
      },
      {
        unified: '1F9B9-1F3FF-200D-2642-FE0F',
        sheet: [44, 8]
      }
    ],
    shortName: 'male_supervillain'
  },
  {
    name: 'Carpentry Saw',
    unified: '1FA9A',
    sheet: [52, 42],
    shortName: 'carpentry_saw'
  },
  {
    name: 'Medium White Circle',
    unified: '26AA',
    keywords: ['shape', 'round'],
    sheet: [55, 0],
    shortName: 'white_circle'
  },
  {
    name: 'Puerto Rico Flag',
    unified: '1F1F5-1F1F7',
    sheet: [3, 44],
    shortName: 'flag-pr'
  },
  {
    name: 'Rain Cloud',
    unified: '1F327-FE0F',
    sheet: [5, 51],
    shortName: 'rain_cloud'
  },
  {
    name: 'Wrench',
    unified: '1F527',
    keywords: [
      'tools',
      'diy',
      'ikea',
      'fix',
      'maintainer'
    ],
    sheet: [28, 9],
    shortName: 'wrench'
  },
  {
    name: 'Large Red Square',
    unified: '1F7E5',
    sheet: [37, 2],
    shortName: 'large_red_square'
  },
  {
    name: 'Female Supervillain',
    unified: '1F9B9-200D-2640-FE0F',
    sheet: [43, 55],
    skinVariations: [
      {
        unified: '1F9B9-1F3FB-200D-2640-FE0F',
        sheet: [43, 56]
      },
      {
        unified: '1F9B9-1F3FC-200D-2640-FE0F',
        sheet: [43, 57]
      },
      {
        unified: '1F9B9-1F3FD-200D-2640-FE0F',
        sheet: [44, 0]
      },
      {
        unified: '1F9B9-1F3FE-200D-2640-FE0F',
        sheet: [44, 1]
      },
      {
        unified: '1F9B9-1F3FF-200D-2640-FE0F',
        sheet: [44, 2]
      }
    ],
    shortName: 'female_supervillain'
  },
  {
    name: 'Palestinian Territories Flag',
    unified: '1F1F5-1F1F8',
    sheet: [3, 45],
    shortName: 'flag-ps'
  },
  {
    name: 'Snow Cloud',
    unified: '1F328-FE0F',
    sheet: [5, 52],
    shortName: 'snow_cloud'
  },
  {
    name: 'Large Orange Square',
    unified: '1F7E7',
    sheet: [37, 4],
    shortName: 'large_orange_square'
  },
  {
    name: 'Mage',
    unified: '1F9D9',
    sheet: [50, 17],
    skinVariations: [
      {
        unified: '1F9D9-1F3FB',
        sheet: [50, 18]
      },
      {
        unified: '1F9D9-1F3FC',
        sheet: [50, 19]
      },
      {
        unified: '1F9D9-1F3FD',
        sheet: [50, 20]
      },
      {
        unified: '1F9D9-1F3FE',
        sheet: [50, 21]
      },
      {
        unified: '1F9D9-1F3FF',
        sheet: [50, 22]
      }
    ],
    shortName: 'mage',
    obsoletedBy: '1F9D9-200D-2640-FE0F'
  },
  {
    name: 'Screwdriver',
    unified: '1FA9B',
    sheet: [52, 43],
    shortName: 'screwdriver'
  },
  {
    name: 'Portugal Flag',
    unified: '1F1F5-1F1F9',
    sheet: [3, 46],
    shortName: 'flag-pt'
  },
  {
    name: 'Lightning',
    unified: '1F329-FE0F',
    sheet: [5, 53],
    shortNames: ['lightning_cloud'],
    shortName: 'lightning'
  },
  {
    name: 'Nut and Bolt',
    unified: '1F529',
    keywords: ['handy', 'tools', 'fix'],
    sheet: [28, 11],
    shortName: 'nut_and_bolt'
  },
  {
    name: 'Large Yellow Square',
    unified: '1F7E8',
    sheet: [37, 5],
    shortName: 'large_yellow_square'
  },
  {
    name: 'Male Mage',
    unified: '1F9D9-200D-2642-FE0F',
    sheet: [50, 11],
    skinVariations: [
      {
        unified: '1F9D9-1F3FB-200D-2642-FE0F',
        sheet: [50, 12]
      },
      {
        unified: '1F9D9-1F3FC-200D-2642-FE0F',
        sheet: [50, 13]
      },
      {
        unified: '1F9D9-1F3FD-200D-2642-FE0F',
        sheet: [50, 14]
      },
      {
        unified: '1F9D9-1F3FE-200D-2642-FE0F',
        sheet: [50, 15]
      },
      {
        unified: '1F9D9-1F3FF-200D-2642-FE0F',
        sheet: [50, 16]
      }
    ],
    shortName: 'male_mage'
  },
  {
    name: 'Palau Flag',
    unified: '1F1F5-1F1FC',
    sheet: [3, 47],
    shortName: 'flag-pw'
  },
  {
    name: 'Tornado',
    unified: '1F32A-FE0F',
    keywords: [
      'weather',
      'cyclone',
      'twister'
    ],
    sheet: [5, 54],
    shortNames: ['tornado_cloud'],
    shortName: 'tornado'
  },
  {
    name: 'Large Green Square',
    unified: '1F7E9',
    sheet: [37, 6],
    shortName: 'large_green_square'
  },
  {
    name: 'Female Mage',
    unified: '1F9D9-200D-2640-FE0F',
    obsoletes: '1F9D9',
    sheet: [50, 5],
    skinVariations: [
      {
        unified: '1F9D9-1F3FB-200D-2640-FE0F',
        sheet: [50, 6]
      },
      {
        unified: '1F9D9-1F3FC-200D-2640-FE0F',
        sheet: [50, 7]
      },
      {
        unified: '1F9D9-1F3FD-200D-2640-FE0F',
        sheet: [50, 8]
      },
      {
        unified: '1F9D9-1F3FE-200D-2640-FE0F',
        sheet: [50, 9]
      },
      {
        unified: '1F9D9-1F3FF-200D-2640-FE0F',
        sheet: [50, 10]
      }
    ],
    shortName: 'female_mage'
  },
  {
    name: 'Gear',
    unified: '2699-FE0F',
    keywords: ['cog'],
    sheet: [54, 52],
    shortName: 'gear'
  },
  {
    name: 'Paraguay Flag',
    unified: '1F1F5-1F1FE',
    sheet: [3, 48],
    shortName: 'flag-py'
  },
  {
    name: 'Fog',
    unified: '1F32B-FE0F',
    keywords: ['weather'],
    sheet: [5, 55],
    shortName: 'fog'
  },
  {
    name: 'Compression',
    unified: '1F5DC-FE0F',
    sheet: [30, 18],
    shortName: 'compression'
  },
  {
    name: 'Large Blue Square',
    unified: '1F7E6',
    sheet: [37, 3],
    shortName: 'large_blue_square'
  },
  {
    name: 'Fairy',
    unified: '1F9DA',
    sheet: [50, 35],
    skinVariations: [
      {
        unified: '1F9DA-1F3FB',
        sheet: [50, 36]
      },
      {
        unified: '1F9DA-1F3FC',
        sheet: [50, 37]
      },
      {
        unified: '1F9DA-1F3FD',
        sheet: [50, 38]
      },
      {
        unified: '1F9DA-1F3FE',
        sheet: [50, 39]
      },
      {
        unified: '1F9DA-1F3FF',
        sheet: [50, 40]
      }
    ],
    shortName: 'fairy',
    obsoletedBy: '1F9DA-200D-2640-FE0F'
  },
  {
    name: 'Qatar Flag',
    unified: '1F1F6-1F1E6',
    sheet: [3, 49],
    shortName: 'flag-qa'
  },
  {
    name: 'Wind Blowing Face',
    unified: '1F32C-FE0F',
    sheet: [5, 56],
    shortName: 'wind_blowing_face'
  },
  {
    name: 'Large Purple Square',
    unified: '1F7EA',
    sheet: [37, 7],
    shortName: 'large_purple_square'
  },
  {
    name: 'Male Fairy',
    unified: '1F9DA-200D-2642-FE0F',
    sheet: [50, 29],
    skinVariations: [
      {
        unified: '1F9DA-1F3FB-200D-2642-FE0F',
        sheet: [50, 30]
      },
      {
        unified: '1F9DA-1F3FC-200D-2642-FE0F',
        sheet: [50, 31]
      },
      {
        unified: '1F9DA-1F3FD-200D-2642-FE0F',
        sheet: [50, 32]
      },
      {
        unified: '1F9DA-1F3FE-200D-2642-FE0F',
        sheet: [50, 33]
      },
      {
        unified: '1F9DA-1F3FF-200D-2642-FE0F',
        sheet: [50, 34]
      }
    ],
    shortName: 'male_fairy'
  },
  {
    name: 'Scales',
    unified: '2696-FE0F',
    sheet: [54, 50],
    shortName: 'scales'
  },
  {
    name: 'Réunion Flag',
    unified: '1F1F7-1F1EA',
    sheet: [3, 50],
    shortName: 'flag-re'
  },
  {
    name: 'Cyclone',
    unified: '1F300',
    keywords: [
      'weather',
      'swirl',
      'blue',
      'cloud',
      'vortex',
      'spiral',
      'whirlpool',
      'spin',
      'tornado',
      'hurricane',
      'typhoon'
    ],
    sheet: [5, 14],
    shortName: 'cyclone'
  },
  {
    name: 'Large Brown Square',
    unified: '1F7EB',
    sheet: [37, 8],
    shortName: 'large_brown_square'
  },
  {
    name: 'Probing Cane',
    unified: '1F9AF',
    sheet: [43, 22],
    shortName: 'probing_cane'
  },
  {
    name: 'Female Fairy',
    unified: '1F9DA-200D-2640-FE0F',
    obsoletes: '1F9DA',
    sheet: [50, 23],
    skinVariations: [
      {
        unified: '1F9DA-1F3FB-200D-2640-FE0F',
        sheet: [50, 24]
      },
      {
        unified: '1F9DA-1F3FC-200D-2640-FE0F',
        sheet: [50, 25]
      },
      {
        unified: '1F9DA-1F3FD-200D-2640-FE0F',
        sheet: [50, 26]
      },
      {
        unified: '1F9DA-1F3FE-200D-2640-FE0F',
        sheet: [50, 27]
      },
      {
        unified: '1F9DA-1F3FF-200D-2640-FE0F',
        sheet: [50, 28]
      }
    ],
    shortName: 'female_fairy'
  },
  {
    name: 'Romania Flag',
    unified: '1F1F7-1F1F4',
    sheet: [3, 51],
    shortName: 'flag-ro'
  },
  {
    name: 'Rainbow',
    unified: '1F308',
    keywords: [
      'nature',
      'happy',
      'unicorn_face',
      'photo',
      'sky',
      'spring'
    ],
    sheet: [5, 22],
    shortName: 'rainbow'
  },
  {
    name: 'Link Symbol',
    unified: '1F517',
    keywords: ['rings', 'url'],
    sheet: [27, 51],
    shortName: 'link'
  },
  {
    name: 'Vampire',
    unified: '1F9DB',
    sheet: [50, 53],
    skinVariations: [
      {
        unified: '1F9DB-1F3FB',
        sheet: [50, 54]
      },
      {
        unified: '1F9DB-1F3FC',
        sheet: [50, 55]
      },
      {
        unified: '1F9DB-1F3FD',
        sheet: [50, 56]
      },
      {
        unified: '1F9DB-1F3FE',
        sheet: [50, 57]
      },
      {
        unified: '1F9DB-1F3FF',
        sheet: [51, 0]
      }
    ],
    shortName: 'vampire',
    obsoletedBy: '1F9DB-200D-2640-FE0F'
  },
  {
    name: 'Black Large Square',
    unified: '2B1B',
    keywords: [
      'shape',
      'icon',
      'button'
    ],
    sheet: [56, 44],
    shortName: 'black_large_square'
  },
  {
    name: 'Serbia Flag',
    unified: '1F1F7-1F1F8',
    sheet: [3, 52],
    shortName: 'flag-rs'
  },
  {
    name: 'Closed Umbrella',
    unified: '1F302',
    keywords: [
      'weather',
      'rain',
      'drizzle'
    ],
    sheet: [5, 16],
    shortName: 'closed_umbrella'
  },
  {
    name: 'Male Vampire',
    unified: '1F9DB-200D-2642-FE0F',
    sheet: [50, 47],
    skinVariations: [
      {
        unified: '1F9DB-1F3FB-200D-2642-FE0F',
        sheet: [50, 48]
      },
      {
        unified: '1F9DB-1F3FC-200D-2642-FE0F',
        sheet: [50, 49]
      },
      {
        unified: '1F9DB-1F3FD-200D-2642-FE0F',
        sheet: [50, 50]
      },
      {
        unified: '1F9DB-1F3FE-200D-2642-FE0F',
        sheet: [50, 51]
      },
      {
        unified: '1F9DB-1F3FF-200D-2642-FE0F',
        sheet: [50, 52]
      }
    ],
    shortName: 'male_vampire'
  },
  {
    name: 'Chains',
    unified: '26D3-FE0F',
    keywords: ['lock', 'arrest'],
    sheet: [55, 12],
    shortName: 'chains'
  },
  {
    name: 'White Large Square',
    unified: '2B1C',
    keywords: [
      'shape',
      'icon',
      'stone',
      'button'
    ],
    sheet: [56, 45],
    shortName: 'white_large_square'
  },
  {
    name: 'Russia Flag',
    unified: '1F1F7-1F1FA',
    keywords: [
      'russian',
      'federation',
      'flag',
      'nation',
      'country',
      'banner'
    ],
    sheet: [3, 53],
    shortNames: ['flag-ru'],
    shortName: 'ru'
  },
  {
    name: 'Female Vampire',
    unified: '1F9DB-200D-2640-FE0F',
    obsoletes: '1F9DB',
    sheet: [50, 41],
    skinVariations: [
      {
        unified: '1F9DB-1F3FB-200D-2640-FE0F',
        sheet: [50, 42]
      },
      {
        unified: '1F9DB-1F3FC-200D-2640-FE0F',
        sheet: [50, 43]
      },
      {
        unified: '1F9DB-1F3FD-200D-2640-FE0F',
        sheet: [50, 44]
      },
      {
        unified: '1F9DB-1F3FE-200D-2640-FE0F',
        sheet: [50, 45]
      },
      {
        unified: '1F9DB-1F3FF-200D-2640-FE0F',
        sheet: [50, 46]
      }
    ],
    shortName: 'female_vampire'
  },
  {
    name: 'Hook',
    unified: '1FA9D',
    sheet: [52, 45],
    shortName: 'hook'
  },
  {
    name: 'Black Medium Square',
    unified: '25FC-FE0F',
    keywords: [
      'shape',
      'button',
      'icon'
    ],
    sheet: [53, 52],
    shortName: 'black_medium_square'
  },
  {
    name: 'Umbrella',
    unified: '2602-FE0F',
    keywords: [
      'rainy',
      'weather',
      'spring'
    ],
    sheet: [53, 57],
    shortName: 'umbrella'
  },
  {
    name: 'Rwanda Flag',
    unified: '1F1F7-1F1FC',
    sheet: [3, 54],
    shortName: 'flag-rw'
  },
  {
    name: 'Merperson',
    unified: '1F9DC',
    sheet: [51, 13],
    skinVariations: [
      {
        unified: '1F9DC-1F3FB',
        sheet: [51, 14]
      },
      {
        unified: '1F9DC-1F3FC',
        sheet: [51, 15]
      },
      {
        unified: '1F9DC-1F3FD',
        sheet: [51, 16]
      },
      {
        unified: '1F9DC-1F3FE',
        sheet: [51, 17]
      },
      {
        unified: '1F9DC-1F3FF',
        sheet: [51, 18]
      }
    ],
    shortName: 'merperson',
    obsoletedBy: '1F9DC-200D-2642-FE0F'
  },
  {
    name: 'Toolbox',
    unified: '1F9F0',
    keywords: [
      'tools',
      'diy',
      'fix',
      'maintainer',
      'mechanic'
    ],
    sheet: [52, 1],
    shortName: 'toolbox'
  },
  {
    name: 'White Medium Square',
    unified: '25FB-FE0F',
    keywords: [
      'shape',
      'stone',
      'icon'
    ],
    sheet: [53, 51],
    shortName: 'white_medium_square'
  },
  {
    name: 'Umbrella with Rain Drops',
    unified: '2614',
    sheet: [54, 4],
    shortName: 'umbrella_with_rain_drops'
  },
  {
    name: 'Saudi Arabia Flag',
    unified: '1F1F8-1F1E6',
    sheet: [3, 55],
    shortName: 'flag-sa'
  },
  {
    name: 'Merman',
    unified: '1F9DC-200D-2642-FE0F',
    obsoletes: '1F9DC',
    keywords: ['man', 'male', 'triton'],
    sheet: [51, 7],
    skinVariations: [
      {
        unified: '1F9DC-1F3FB-200D-2642-FE0F',
        sheet: [51, 8]
      },
      {
        unified: '1F9DC-1F3FC-200D-2642-FE0F',
        sheet: [51, 9]
      },
      {
        unified: '1F9DC-1F3FD-200D-2642-FE0F',
        sheet: [51, 10]
      },
      {
        unified: '1F9DC-1F3FE-200D-2642-FE0F',
        sheet: [51, 11]
      },
      {
        unified: '1F9DC-1F3FF-200D-2642-FE0F',
        sheet: [51, 12]
      }
    ],
    shortName: 'merman'
  },
  {
    name: 'Magnet',
    unified: '1F9F2',
    keywords: [
      'attraction',
      'magnetic'
    ],
    sheet: [52, 3],
    shortName: 'magnet'
  },
  {
    name: 'Black Medium Small Square',
    unified: '25FE',
    keywords: [
      'icon',
      'shape',
      'button'
    ],
    sheet: [53, 54],
    shortName: 'black_medium_small_square'
  },
  {
    name: 'Umbrella on Ground',
    unified: '26F1-FE0F',
    sheet: [55, 17],
    shortName: 'umbrella_on_ground'
  },
  {
    name: 'Solomon Islands Flag',
    unified: '1F1F8-1F1E7',
    sheet: [3, 56],
    shortName: 'flag-sb'
  },
  {
    name: 'Mermaid',
    unified: '1F9DC-200D-2640-FE0F',
    keywords: [
      'woman',
      'female',
      'merwoman',
      'ariel'
    ],
    sheet: [51, 1],
    skinVariations: [
      {
        unified: '1F9DC-1F3FB-200D-2640-FE0F',
        sheet: [51, 2]
      },
      {
        unified: '1F9DC-1F3FC-200D-2640-FE0F',
        sheet: [51, 3]
      },
      {
        unified: '1F9DC-1F3FD-200D-2640-FE0F',
        sheet: [51, 4]
      },
      {
        unified: '1F9DC-1F3FE-200D-2640-FE0F',
        sheet: [51, 5]
      },
      {
        unified: '1F9DC-1F3FF-200D-2640-FE0F',
        sheet: [51, 6]
      }
    ],
    shortName: 'mermaid'
  },
  {
    name: 'Ladder',
    unified: '1FA9C',
    sheet: [52, 44],
    shortName: 'ladder'
  },
  {
    name: 'White Medium Small Square',
    unified: '25FD',
    keywords: [
      'shape',
      'stone',
      'icon',
      'button'
    ],
    sheet: [53, 53],
    shortName: 'white_medium_small_square'
  },
  {
    name: 'High Voltage Sign',
    unified: '26A1',
    keywords: [
      'thunder',
      'weather',
      'lightning bolt',
      'fast'
    ],
    sheet: [54, 56],
    shortName: 'zap'
  },
  {
    name: 'Seychelles Flag',
    unified: '1F1F8-1F1E8',
    sheet: [3, 57],
    shortName: 'flag-sc'
  },
  {
    name: 'Elf',
    unified: '1F9DD',
    sheet: [51, 31],
    skinVariations: [
      {
        unified: '1F9DD-1F3FB',
        sheet: [51, 32]
      },
      {
        unified: '1F9DD-1F3FC',
        sheet: [51, 33]
      },
      {
        unified: '1F9DD-1F3FD',
        sheet: [51, 34]
      },
      {
        unified: '1F9DD-1F3FE',
        sheet: [51, 35]
      },
      {
        unified: '1F9DD-1F3FF',
        sheet: [51, 36]
      }
    ],
    shortName: 'elf',
    obsoletedBy: '1F9DD-200D-2642-FE0F'
  },
  {
    name: 'Black Small Square',
    unified: '25AA-FE0F',
    keywords: ['shape', 'icon'],
    sheet: [53, 47],
    shortName: 'black_small_square'
  },
  {
    name: 'Alembic',
    unified: '2697-FE0F',
    keywords: [
      'distilling',
      'science',
      'experiment',
      'chemistry'
    ],
    sheet: [54, 51],
    shortName: 'alembic'
  },
  {
    name: 'Snowflake',
    unified: '2744-FE0F',
    keywords: [
      'winter',
      'season',
      'cold',
      'weather',
      'christmas',
      'xmas'
    ],
    sheet: [56, 23],
    shortName: 'snowflake'
  },
  {
    name: 'Sudan Flag',
    unified: '1F1F8-1F1E9',
    sheet: [4, 0],
    shortName: 'flag-sd'
  },
  {
    name: 'Male Elf',
    unified: '1F9DD-200D-2642-FE0F',
    obsoletes: '1F9DD',
    sheet: [51, 25],
    skinVariations: [
      {
        unified: '1F9DD-1F3FB-200D-2642-FE0F',
        sheet: [51, 26]
      },
      {
        unified: '1F9DD-1F3FC-200D-2642-FE0F',
        sheet: [51, 27]
      },
      {
        unified: '1F9DD-1F3FD-200D-2642-FE0F',
        sheet: [51, 28]
      },
      {
        unified: '1F9DD-1F3FE-200D-2642-FE0F',
        sheet: [51, 29]
      },
      {
        unified: '1F9DD-1F3FF-200D-2642-FE0F',
        sheet: [51, 30]
      }
    ],
    shortName: 'male_elf'
  },
  {
    name: 'Test Tube',
    unified: '1F9EA',
    keywords: [
      'chemistry',
      'experiment',
      'lab',
      'science'
    ],
    sheet: [51, 53],
    shortName: 'test_tube'
  },
  {
    name: 'White Small Square',
    unified: '25AB-FE0F',
    keywords: ['shape', 'icon'],
    sheet: [53, 48],
    shortName: 'white_small_square'
  },
  {
    name: 'Snowman',
    unified: '2603-FE0F',
    keywords: [
      'winter',
      'season',
      'cold',
      'weather',
      'christmas',
      'xmas',
      'frozen',
      'without_snow'
    ],
    sheet: [54, 0],
    shortName: 'snowman'
  },
  {
    name: 'Sweden Flag',
    unified: '1F1F8-1F1EA',
    sheet: [4, 1],
    shortName: 'flag-se'
  },
  {
    name: 'Large Orange Diamond',
    unified: '1F536',
    keywords: ['shape', 'jewel', 'gem'],
    sheet: [28, 24],
    shortName: 'large_orange_diamond'
  },
  {
    name: 'Female Elf',
    unified: '1F9DD-200D-2640-FE0F',
    sheet: [51, 19],
    skinVariations: [
      {
        unified: '1F9DD-1F3FB-200D-2640-FE0F',
        sheet: [51, 20]
      },
      {
        unified: '1F9DD-1F3FC-200D-2640-FE0F',
        sheet: [51, 21]
      },
      {
        unified: '1F9DD-1F3FD-200D-2640-FE0F',
        sheet: [51, 22]
      },
      {
        unified: '1F9DD-1F3FE-200D-2640-FE0F',
        sheet: [51, 23]
      },
      {
        unified: '1F9DD-1F3FF-200D-2640-FE0F',
        sheet: [51, 24]
      }
    ],
    shortName: 'female_elf'
  },
  {
    name: 'Petri Dish',
    unified: '1F9EB',
    keywords: [
      'bacteria',
      'biology',
      'culture',
      'lab'
    ],
    sheet: [51, 54],
    shortName: 'petri_dish'
  },
  {
    name: 'Snowman Without Snow',
    unified: '26C4',
    sheet: [55, 6],
    shortName: 'snowman_without_snow'
  },
  {
    name: 'Singapore Flag',
    unified: '1F1F8-1F1EC',
    sheet: [4, 2],
    shortName: 'flag-sg'
  },
  {
    name: 'Large Blue Diamond',
    unified: '1F537',
    keywords: ['shape', 'jewel', 'gem'],
    sheet: [28, 25],
    shortName: 'large_blue_diamond'
  },
  {
    name: 'Genie',
    unified: '1F9DE',
    sheet: [51, 39],
    shortName: 'genie',
    obsoletedBy: '1F9DE-200D-2642-FE0F'
  },
  {
    name: 'Dna Double Helix',
    unified: '1F9EC',
    keywords: [
      'biologist',
      'genetics',
      'life'
    ],
    sheet: [51, 55],
    shortName: 'dna'
  },
  {
    name: 'Comet',
    unified: '2604-FE0F',
    keywords: ['space'],
    sheet: [54, 1],
    shortName: 'comet'
  },
  {
    name: 'St. Helena Flag',
    unified: '1F1F8-1F1ED',
    sheet: [4, 3],
    shortName: 'flag-sh'
  },
  {
    name: 'Fire',
    unified: '1F525',
    keywords: ['hot', 'cook', 'flame'],
    sheet: [28, 7],
    shortName: 'fire'
  },
  {
    name: 'Microscope',
    unified: '1F52C',
    keywords: [
      'laboratory',
      'experiment',
      'zoomin',
      'science',
      'study'
    ],
    sheet: [28, 14],
    shortName: 'microscope'
  },
  {
    name: 'Small Orange Diamond',
    unified: '1F538',
    keywords: ['shape', 'jewel', 'gem'],
    sheet: [28, 26],
    shortName: 'small_orange_diamond'
  },
  {
    name: 'Male Genie',
    unified: '1F9DE-200D-2642-FE0F',
    obsoletes: '1F9DE',
    sheet: [51, 38],
    shortName: 'male_genie'
  },
  {
    name: 'Slovenia Flag',
    unified: '1F1F8-1F1EE',
    sheet: [4, 4],
    shortName: 'flag-si'
  },
  {
    name: 'Droplet',
    unified: '1F4A7',
    keywords: [
      'water',
      'drip',
      'faucet',
      'spring'
    ],
    sheet: [25, 51],
    shortName: 'droplet'
  },
  {
    name: 'Telescope',
    unified: '1F52D',
    keywords: [
      'stars',
      'space',
      'zoom',
      'science',
      'astronomy'
    ],
    sheet: [28, 15],
    shortName: 'telescope'
  },
  {
    name: 'Small Blue Diamond',
    unified: '1F539',
    keywords: ['shape', 'jewel', 'gem'],
    sheet: [28, 27],
    shortName: 'small_blue_diamond'
  },
  {
    name: 'Female Genie',
    unified: '1F9DE-200D-2640-FE0F',
    sheet: [51, 37],
    shortName: 'female_genie'
  },
  {
    name: 'Svalbard & Jan Mayen Flag',
    unified: '1F1F8-1F1EF',
    sheet: [4, 5],
    shortName: 'flag-sj'
  },
  {
    name: 'Water Wave',
    unified: '1F30A',
    keywords: [
      'sea',
      'water',
      'wave',
      'nature',
      'tsunami',
      'disaster'
    ],
    sheet: [5, 24],
    shortName: 'ocean'
  },
  {
    name: 'Satellite Antenna',
    unified: '1F4E1',
    sheet: [26, 56],
    shortName: 'satellite_antenna'
  },
  {
    name: 'Up-Pointing Red Triangle',
    unified: '1F53A',
    keywords: [
      'shape',
      'direction',
      'up',
      'top'
    ],
    sheet: [28, 28],
    shortName: 'small_red_triangle'
  },
  {
    name: 'Zombie',
    unified: '1F9DF',
    sheet: [51, 42],
    shortName: 'zombie',
    obsoletedBy: '1F9DF-200D-2642-FE0F'
  },
  {
    name: 'Slovakia Flag',
    unified: '1F1F8-1F1F0',
    sheet: [4, 6],
    shortName: 'flag-sk'
  },
  {
    name: 'Syringe',
    unified: '1F489',
    keywords: [
      'health',
      'hospital',
      'drugs',
      'blood',
      'medicine',
      'needle',
      'doctor',
      'nurse'
    ],
    sheet: [25, 21],
    shortName: 'syringe'
  },
  {
    name: 'Down-Pointing Red Triangle',
    unified: '1F53B',
    keywords: [
      'shape',
      'direction',
      'bottom'
    ],
    sheet: [28, 29],
    shortName: 'small_red_triangle_down'
  },
  {
    name: 'Male Zombie',
    unified: '1F9DF-200D-2642-FE0F',
    obsoletes: '1F9DF',
    sheet: [51, 41],
    shortName: 'male_zombie'
  },
  {
    name: 'Sierra Leone Flag',
    unified: '1F1F8-1F1F1',
    sheet: [4, 7],
    shortName: 'flag-sl'
  },
  {
    name: 'Diamond Shape with a Dot Inside',
    unified: '1F4A0',
    keywords: [
      'jewel',
      'blue',
      'gem',
      'crystal',
      'fancy'
    ],
    sheet: [25, 44],
    shortName: 'diamond_shape_with_a_dot_inside'
  },
  {
    name: 'Female Zombie',
    unified: '1F9DF-200D-2640-FE0F',
    sheet: [51, 40],
    shortName: 'female_zombie'
  },
  {
    name: 'Drop of Blood',
    unified: '1FA78',
    sheet: [52, 22],
    shortName: 'drop_of_blood'
  },
  {
    name: 'San Marino Flag',
    unified: '1F1F8-1F1F2',
    sheet: [4, 8],
    shortName: 'flag-sm'
  },
  {
    name: 'Face Massage',
    unified: '1F486',
    sheet: [24, 54],
    skinVariations: [
      {
        unified: '1F486-1F3FB',
        sheet: [24, 55]
      },
      {
        unified: '1F486-1F3FC',
        sheet: [24, 56]
      },
      {
        unified: '1F486-1F3FD',
        sheet: [24, 57]
      },
      {
        unified: '1F486-1F3FE',
        sheet: [25, 0]
      },
      {
        unified: '1F486-1F3FF',
        sheet: [25, 1]
      }
    ],
    shortName: 'massage',
    obsoletedBy: '1F486-200D-2640-FE0F'
  },
  {
    name: 'Pill',
    unified: '1F48A',
    keywords: [
      'health',
      'medicine',
      'doctor',
      'pharmacy',
      'drug'
    ],
    sheet: [25, 22],
    shortName: 'pill'
  },
  {
    name: 'Radio Button',
    unified: '1F518',
    keywords: [
      'input',
      'old',
      'music',
      'circle'
    ],
    sheet: [27, 52],
    shortName: 'radio_button'
  },
  {
    name: 'Senegal Flag',
    unified: '1F1F8-1F1F3',
    sheet: [4, 9],
    shortName: 'flag-sn'
  },
  {
    name: 'Man Getting Massage',
    unified: '1F486-200D-2642-FE0F',
    sheet: [24, 48],
    skinVariations: [
      {
        unified: '1F486-1F3FB-200D-2642-FE0F',
        sheet: [24, 49]
      },
      {
        unified: '1F486-1F3FC-200D-2642-FE0F',
        sheet: [24, 50]
      },
      {
        unified: '1F486-1F3FD-200D-2642-FE0F',
        sheet: [24, 51]
      },
      {
        unified: '1F486-1F3FE-200D-2642-FE0F',
        sheet: [24, 52]
      },
      {
        unified: '1F486-1F3FF-200D-2642-FE0F',
        sheet: [24, 53]
      }
    ],
    shortName: 'man-getting-massage'
  },
  {
    name: 'White Square Button',
    unified: '1F533',
    keywords: ['shape', 'input'],
    sheet: [28, 21],
    shortName: 'white_square_button'
  },
  {
    name: 'Adhesive Bandage',
    unified: '1FA79',
    sheet: [52, 23],
    shortName: 'adhesive_bandage'
  },
  {
    name: 'Somalia Flag',
    unified: '1F1F8-1F1F4',
    sheet: [4, 10],
    shortName: 'flag-so'
  },
  {
    name: 'Woman Getting Massage',
    unified: '1F486-200D-2640-FE0F',
    obsoletes: '1F486',
    sheet: [24, 42],
    skinVariations: [
      {
        unified: '1F486-1F3FB-200D-2640-FE0F',
        sheet: [24, 43]
      },
      {
        unified: '1F486-1F3FC-200D-2640-FE0F',
        sheet: [24, 44]
      },
      {
        unified: '1F486-1F3FD-200D-2640-FE0F',
        sheet: [24, 45]
      },
      {
        unified: '1F486-1F3FE-200D-2640-FE0F',
        sheet: [24, 46]
      },
      {
        unified: '1F486-1F3FF-200D-2640-FE0F',
        sheet: [24, 47]
      }
    ],
    shortName: 'woman-getting-massage'
  },
  {
    name: 'Black Square Button',
    unified: '1F532',
    keywords: [
      'shape',
      'input',
      'frame'
    ],
    sheet: [28, 20],
    shortName: 'black_square_button'
  },
  {
    name: 'Stethoscope',
    unified: '1FA7A',
    sheet: [52, 24],
    shortName: 'stethoscope'
  },
  {
    name: 'Suriname Flag',
    unified: '1F1F8-1F1F7',
    sheet: [4, 11],
    shortName: 'flag-sr'
  },
  {
    name: 'Haircut',
    unified: '1F487',
    sheet: [25, 14],
    skinVariations: [
      {
        unified: '1F487-1F3FB',
        sheet: [25, 15]
      },
      {
        unified: '1F487-1F3FC',
        sheet: [25, 16]
      },
      {
        unified: '1F487-1F3FD',
        sheet: [25, 17]
      },
      {
        unified: '1F487-1F3FE',
        sheet: [25, 18]
      },
      {
        unified: '1F487-1F3FF',
        sheet: [25, 19]
      }
    ],
    shortName: 'haircut',
    obsoletedBy: '1F487-200D-2640-FE0F'
  },
  {
    name: 'Door',
    unified: '1F6AA',
    keywords: [
      'house',
      'entry',
      'exit'
    ],
    sheet: [34, 51],
    shortName: 'door'
  },
  {
    name: 'South Sudan Flag',
    unified: '1F1F8-1F1F8',
    sheet: [4, 12],
    shortName: 'flag-ss'
  },
  {
    name: 'Man Getting Haircut',
    unified: '1F487-200D-2642-FE0F',
    sheet: [25, 8],
    skinVariations: [
      {
        unified: '1F487-1F3FB-200D-2642-FE0F',
        sheet: [25, 9]
      },
      {
        unified: '1F487-1F3FC-200D-2642-FE0F',
        sheet: [25, 10]
      },
      {
        unified: '1F487-1F3FD-200D-2642-FE0F',
        sheet: [25, 11]
      },
      {
        unified: '1F487-1F3FE-200D-2642-FE0F',
        sheet: [25, 12]
      },
      {
        unified: '1F487-1F3FF-200D-2642-FE0F',
        sheet: [25, 13]
      }
    ],
    shortName: 'man-getting-haircut'
  },
  {
    name: 'Elevator',
    unified: '1F6D7',
    sheet: [36, 34],
    shortName: 'elevator'
  },
  {
    name: 'São Tomé & Príncipe Flag',
    unified: '1F1F8-1F1F9',
    sheet: [4, 13],
    shortName: 'flag-st'
  },
  {
    name: 'Woman Getting Haircut',
    unified: '1F487-200D-2640-FE0F',
    obsoletes: '1F487',
    sheet: [25, 2],
    skinVariations: [
      {
        unified: '1F487-1F3FB-200D-2640-FE0F',
        sheet: [25, 3]
      },
      {
        unified: '1F487-1F3FC-200D-2640-FE0F',
        sheet: [25, 4]
      },
      {
        unified: '1F487-1F3FD-200D-2640-FE0F',
        sheet: [25, 5]
      },
      {
        unified: '1F487-1F3FE-200D-2640-FE0F',
        sheet: [25, 6]
      },
      {
        unified: '1F487-1F3FF-200D-2640-FE0F',
        sheet: [25, 7]
      }
    ],
    shortName: 'woman-getting-haircut'
  },
  {
    name: 'Mirror',
    unified: '1FA9E',
    sheet: [52, 46],
    shortName: 'mirror'
  },
  {
    name: 'El Salvador Flag',
    unified: '1F1F8-1F1FB',
    sheet: [4, 14],
    shortName: 'flag-sv'
  },
  {
    name: 'Pedestrian',
    unified: '1F6B6',
    sheet: [35, 51],
    skinVariations: [
      {
        unified: '1F6B6-1F3FB',
        sheet: [35, 52]
      },
      {
        unified: '1F6B6-1F3FC',
        sheet: [35, 53]
      },
      {
        unified: '1F6B6-1F3FD',
        sheet: [35, 54]
      },
      {
        unified: '1F6B6-1F3FE',
        sheet: [35, 55]
      },
      {
        unified: '1F6B6-1F3FF',
        sheet: [35, 56]
      }
    ],
    shortName: 'walking',
    obsoletedBy: '1F6B6-200D-2642-FE0F'
  },
  {
    name: 'Window',
    unified: '1FA9F',
    sheet: [52, 47],
    shortName: 'window'
  },
  {
    name: 'Sint Maarten Flag',
    unified: '1F1F8-1F1FD',
    sheet: [4, 15],
    shortName: 'flag-sx'
  },
  {
    name: 'Man Walking',
    unified: '1F6B6-200D-2642-FE0F',
    obsoletes: '1F6B6',
    sheet: [35, 45],
    skinVariations: [
      {
        unified: '1F6B6-1F3FB-200D-2642-FE0F',
        sheet: [35, 46]
      },
      {
        unified: '1F6B6-1F3FC-200D-2642-FE0F',
        sheet: [35, 47]
      },
      {
        unified: '1F6B6-1F3FD-200D-2642-FE0F',
        sheet: [35, 48]
      },
      {
        unified: '1F6B6-1F3FE-200D-2642-FE0F',
        sheet: [35, 49]
      },
      {
        unified: '1F6B6-1F3FF-200D-2642-FE0F',
        sheet: [35, 50]
      }
    ],
    shortName: 'man-walking'
  },
  {
    name: 'Bed',
    unified: '1F6CF-FE0F',
    keywords: ['sleep', 'rest'],
    sheet: [36, 28],
    shortName: 'bed'
  },
  {
    name: 'Syria Flag',
    unified: '1F1F8-1F1FE',
    sheet: [4, 16],
    shortName: 'flag-sy'
  },
  {
    name: 'Woman Walking',
    unified: '1F6B6-200D-2640-FE0F',
    sheet: [35, 39],
    skinVariations: [
      {
        unified: '1F6B6-1F3FB-200D-2640-FE0F',
        sheet: [35, 40]
      },
      {
        unified: '1F6B6-1F3FC-200D-2640-FE0F',
        sheet: [35, 41]
      },
      {
        unified: '1F6B6-1F3FD-200D-2640-FE0F',
        sheet: [35, 42]
      },
      {
        unified: '1F6B6-1F3FE-200D-2640-FE0F',
        sheet: [35, 43]
      },
      {
        unified: '1F6B6-1F3FF-200D-2640-FE0F',
        sheet: [35, 44]
      }
    ],
    shortName: 'woman-walking'
  },
  {
    name: 'Couch and Lamp',
    unified: '1F6CB-FE0F',
    keywords: ['read', 'chill'],
    sheet: [36, 19],
    shortName: 'couch_and_lamp'
  },
  {
    name: 'Eswatini Flag',
    unified: '1F1F8-1F1FF',
    sheet: [4, 17],
    shortName: 'flag-sz'
  },
  {
    name: 'Standing Person',
    unified: '1F9CD',
    sheet: [44, 50],
    skinVariations: [
      {
        unified: '1F9CD-1F3FB',
        sheet: [44, 51]
      },
      {
        unified: '1F9CD-1F3FC',
        sheet: [44, 52]
      },
      {
        unified: '1F9CD-1F3FD',
        sheet: [44, 53]
      },
      {
        unified: '1F9CD-1F3FE',
        sheet: [44, 54]
      },
      {
        unified: '1F9CD-1F3FF',
        sheet: [44, 55]
      }
    ],
    shortName: 'standing_person'
  },
  {
    name: 'Chair',
    unified: '1FA91',
    sheet: [52, 33],
    shortName: 'chair'
  },
  {
    name: 'Tristan Da Cunha Flag',
    unified: '1F1F9-1F1E6',
    sheet: [4, 18],
    shortName: 'flag-ta'
  },
  {
    name: 'Toilet',
    unified: '1F6BD',
    keywords: [
      'restroom',
      'wc',
      'washroom',
      'bathroom',
      'potty'
    ],
    sheet: [36, 5],
    shortName: 'toilet'
  },
  {
    name: 'Man Standing',
    unified: '1F9CD-200D-2642-FE0F',
    sheet: [44, 44],
    skinVariations: [
      {
        unified: '1F9CD-1F3FB-200D-2642-FE0F',
        sheet: [44, 45]
      },
      {
        unified: '1F9CD-1F3FC-200D-2642-FE0F',
        sheet: [44, 46]
      },
      {
        unified: '1F9CD-1F3FD-200D-2642-FE0F',
        sheet: [44, 47]
      },
      {
        unified: '1F9CD-1F3FE-200D-2642-FE0F',
        sheet: [44, 48]
      },
      {
        unified: '1F9CD-1F3FF-200D-2642-FE0F',
        sheet: [44, 49]
      }
    ],
    shortName: 'man_standing'
  },
  {
    name: 'Turks & Caicos Islands Flag',
    unified: '1F1F9-1F1E8',
    sheet: [4, 19],
    shortName: 'flag-tc'
  },
  {
    name: 'Woman Standing',
    unified: '1F9CD-200D-2640-FE0F',
    sheet: [44, 38],
    skinVariations: [
      {
        unified: '1F9CD-1F3FB-200D-2640-FE0F',
        sheet: [44, 39]
      },
      {
        unified: '1F9CD-1F3FC-200D-2640-FE0F',
        sheet: [44, 40]
      },
      {
        unified: '1F9CD-1F3FD-200D-2640-FE0F',
        sheet: [44, 41]
      },
      {
        unified: '1F9CD-1F3FE-200D-2640-FE0F',
        sheet: [44, 42]
      },
      {
        unified: '1F9CD-1F3FF-200D-2640-FE0F',
        sheet: [44, 43]
      }
    ],
    shortName: 'woman_standing'
  },
  {
    name: 'Plunger',
    unified: '1FAA0',
    sheet: [52, 48],
    shortName: 'plunger'
  },
  {
    name: 'Chad Flag',
    unified: '1F1F9-1F1E9',
    sheet: [4, 20],
    shortName: 'flag-td'
  },
  {
    name: 'Shower',
    unified: '1F6BF',
    keywords: [
      'clean',
      'water',
      'bathroom'
    ],
    sheet: [36, 7],
    shortName: 'shower'
  },
  {
    name: 'Kneeling Person',
    unified: '1F9CE',
    sheet: [45, 10],
    skinVariations: [
      {
        unified: '1F9CE-1F3FB',
        sheet: [45, 11]
      },
      {
        unified: '1F9CE-1F3FC',
        sheet: [45, 12]
      },
      {
        unified: '1F9CE-1F3FD',
        sheet: [45, 13]
      },
      {
        unified: '1F9CE-1F3FE',
        sheet: [45, 14]
      },
      {
        unified: '1F9CE-1F3FF',
        sheet: [45, 15]
      }
    ],
    shortName: 'kneeling_person'
  },
  {
    name: 'French Southern Territories Flag',
    unified: '1F1F9-1F1EB',
    sheet: [4, 21],
    shortName: 'flag-tf'
  },
  {
    name: 'Bathtub',
    unified: '1F6C1',
    keywords: [
      'clean',
      'shower',
      'bathroom'
    ],
    sheet: [36, 14],
    shortName: 'bathtub'
  },
  {
    name: 'Man Kneeling',
    unified: '1F9CE-200D-2642-FE0F',
    sheet: [45, 4],
    skinVariations: [
      {
        unified: '1F9CE-1F3FB-200D-2642-FE0F',
        sheet: [45, 5]
      },
      {
        unified: '1F9CE-1F3FC-200D-2642-FE0F',
        sheet: [45, 6]
      },
      {
        unified: '1F9CE-1F3FD-200D-2642-FE0F',
        sheet: [45, 7]
      },
      {
        unified: '1F9CE-1F3FE-200D-2642-FE0F',
        sheet: [45, 8]
      },
      {
        unified: '1F9CE-1F3FF-200D-2642-FE0F',
        sheet: [45, 9]
      }
    ],
    shortName: 'man_kneeling'
  },
  {
    name: 'Togo Flag',
    unified: '1F1F9-1F1EC',
    sheet: [4, 22],
    shortName: 'flag-tg'
  },
  {
    name: 'Woman Kneeling',
    unified: '1F9CE-200D-2640-FE0F',
    sheet: [44, 56],
    skinVariations: [
      {
        unified: '1F9CE-1F3FB-200D-2640-FE0F',
        sheet: [44, 57]
      },
      {
        unified: '1F9CE-1F3FC-200D-2640-FE0F',
        sheet: [45, 0]
      },
      {
        unified: '1F9CE-1F3FD-200D-2640-FE0F',
        sheet: [45, 1]
      },
      {
        unified: '1F9CE-1F3FE-200D-2640-FE0F',
        sheet: [45, 2]
      },
      {
        unified: '1F9CE-1F3FF-200D-2640-FE0F',
        sheet: [45, 3]
      }
    ],
    shortName: 'woman_kneeling'
  },
  {
    name: 'Mouse Trap',
    unified: '1FAA4',
    sheet: [52, 52],
    shortName: 'mouse_trap'
  },
  {
    name: 'Thailand Flag',
    unified: '1F1F9-1F1ED',
    sheet: [4, 23],
    shortName: 'flag-th'
  },
  {
    name: 'Person with Probing Cane',
    unified: '1F9D1-200D-1F9AF',
    sheet: [47, 35],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F9AF',
        sheet: [47, 36]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F9AF',
        sheet: [47, 37]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F9AF',
        sheet: [47, 38]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F9AF',
        sheet: [47, 39]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F9AF',
        sheet: [47, 40]
      }
    ],
    shortName: 'person_with_probing_cane'
  },
  {
    name: 'Razor',
    unified: '1FA92',
    sheet: [52, 34],
    shortName: 'razor'
  },
  {
    name: 'Tajikistan Flag',
    unified: '1F1F9-1F1EF',
    sheet: [4, 24],
    shortName: 'flag-tj'
  },
  {
    name: 'Man with Probing Cane',
    unified: '1F468-200D-1F9AF',
    sheet: [16, 10],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F9AF',
        sheet: [16, 11]
      },
      {
        unified: '1F468-1F3FC-200D-1F9AF',
        sheet: [16, 12]
      },
      {
        unified: '1F468-1F3FD-200D-1F9AF',
        sheet: [16, 13]
      },
      {
        unified: '1F468-1F3FE-200D-1F9AF',
        sheet: [16, 14]
      },
      {
        unified: '1F468-1F3FF-200D-1F9AF',
        sheet: [16, 15]
      }
    ],
    shortName: 'man_with_probing_cane'
  },
  {
    name: 'Lotion Bottle',
    unified: '1F9F4',
    keywords: [
      'moisturizer',
      'sunscreen'
    ],
    sheet: [52, 5],
    shortName: 'lotion_bottle'
  },
  {
    name: 'Tokelau Flag',
    unified: '1F1F9-1F1F0',
    sheet: [4, 25],
    shortName: 'flag-tk'
  },
  {
    name: 'Woman with Probing Cane',
    unified: '1F469-200D-1F9AF',
    sheet: [18, 56],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F9AF',
        sheet: [18, 57]
      },
      {
        unified: '1F469-1F3FC-200D-1F9AF',
        sheet: [19, 0]
      },
      {
        unified: '1F469-1F3FD-200D-1F9AF',
        sheet: [19, 1]
      },
      {
        unified: '1F469-1F3FE-200D-1F9AF',
        sheet: [19, 2]
      },
      {
        unified: '1F469-1F3FF-200D-1F9AF',
        sheet: [19, 3]
      }
    ],
    shortName: 'woman_with_probing_cane'
  },
  {
    name: 'Safety Pin',
    unified: '1F9F7',
    keywords: ['diaper'],
    sheet: [52, 8],
    shortName: 'safety_pin'
  },
  {
    name: 'Timor-Leste Flag',
    unified: '1F1F9-1F1F1',
    sheet: [4, 26],
    shortName: 'flag-tl'
  },
  {
    name: 'Person in Motorized Wheelchair',
    unified: '1F9D1-200D-1F9BC',
    sheet: [48, 7],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F9BC',
        sheet: [48, 8]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F9BC',
        sheet: [48, 9]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F9BC',
        sheet: [48, 10]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F9BC',
        sheet: [48, 11]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F9BC',
        sheet: [48, 12]
      }
    ],
    shortName: 'person_in_motorized_wheelchair'
  },
  {
    name: 'Broom',
    unified: '1F9F9',
    keywords: [
      'cleaning',
      'sweeping',
      'witch'
    ],
    sheet: [52, 10],
    shortName: 'broom'
  },
  {
    name: 'Turkmenistan Flag',
    unified: '1F1F9-1F1F2',
    sheet: [4, 27],
    shortName: 'flag-tm'
  },
  {
    name: 'Man in Motorized Wheelchair',
    unified: '1F468-200D-1F9BC',
    sheet: [16, 40],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F9BC',
        sheet: [16, 41]
      },
      {
        unified: '1F468-1F3FC-200D-1F9BC',
        sheet: [16, 42]
      },
      {
        unified: '1F468-1F3FD-200D-1F9BC',
        sheet: [16, 43]
      },
      {
        unified: '1F468-1F3FE-200D-1F9BC',
        sheet: [16, 44]
      },
      {
        unified: '1F468-1F3FF-200D-1F9BC',
        sheet: [16, 45]
      }
    ],
    shortName: 'man_in_motorized_wheelchair'
  },
  {
    name: 'Basket',
    unified: '1F9FA',
    keywords: ['laundry'],
    sheet: [52, 11],
    shortName: 'basket'
  },
  {
    name: 'Tunisia Flag',
    unified: '1F1F9-1F1F3',
    sheet: [4, 28],
    shortName: 'flag-tn'
  },
  {
    name: 'Woman in Motorized Wheelchair',
    unified: '1F469-200D-1F9BC',
    sheet: [19, 28],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F9BC',
        sheet: [19, 29]
      },
      {
        unified: '1F469-1F3FC-200D-1F9BC',
        sheet: [19, 30]
      },
      {
        unified: '1F469-1F3FD-200D-1F9BC',
        sheet: [19, 31]
      },
      {
        unified: '1F469-1F3FE-200D-1F9BC',
        sheet: [19, 32]
      },
      {
        unified: '1F469-1F3FF-200D-1F9BC',
        sheet: [19, 33]
      }
    ],
    shortName: 'woman_in_motorized_wheelchair'
  },
  {
    name: 'Roll of Paper',
    unified: '1F9FB',
    sheet: [52, 12],
    shortName: 'roll_of_paper'
  },
  {
    name: 'Tonga Flag',
    unified: '1F1F9-1F1F4',
    sheet: [4, 29],
    shortName: 'flag-to'
  },
  {
    name: 'Person in Manual Wheelchair',
    unified: '1F9D1-200D-1F9BD',
    sheet: [48, 13],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F9BD',
        sheet: [48, 14]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F9BD',
        sheet: [48, 15]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F9BD',
        sheet: [48, 16]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F9BD',
        sheet: [48, 17]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F9BD',
        sheet: [48, 18]
      }
    ],
    shortName: 'person_in_manual_wheelchair'
  },
  {
    name: 'Bucket',
    unified: '1FAA3',
    sheet: [52, 51],
    shortName: 'bucket'
  },
  {
    name: 'Turkey Flag',
    unified: '1F1F9-1F1F7',
    sheet: [4, 30],
    shortName: 'flag-tr'
  },
  {
    name: 'Man in Manual Wheelchair',
    unified: '1F468-200D-1F9BD',
    sheet: [16, 46],
    skinVariations: [
      {
        unified: '1F468-1F3FB-200D-1F9BD',
        sheet: [16, 47]
      },
      {
        unified: '1F468-1F3FC-200D-1F9BD',
        sheet: [16, 48]
      },
      {
        unified: '1F468-1F3FD-200D-1F9BD',
        sheet: [16, 49]
      },
      {
        unified: '1F468-1F3FE-200D-1F9BD',
        sheet: [16, 50]
      },
      {
        unified: '1F468-1F3FF-200D-1F9BD',
        sheet: [16, 51]
      }
    ],
    shortName: 'man_in_manual_wheelchair'
  },
  {
    name: 'Bar of Soap',
    unified: '1F9FC',
    keywords: [
      'bar',
      'bathing',
      'cleaning',
      'lather'
    ],
    sheet: [52, 13],
    shortName: 'soap'
  },
  {
    name: 'Trinidad & Tobago Flag',
    unified: '1F1F9-1F1F9',
    sheet: [4, 31],
    shortName: 'flag-tt'
  },
  {
    name: 'Woman in Manual Wheelchair',
    unified: '1F469-200D-1F9BD',
    sheet: [19, 34],
    skinVariations: [
      {
        unified: '1F469-1F3FB-200D-1F9BD',
        sheet: [19, 35]
      },
      {
        unified: '1F469-1F3FC-200D-1F9BD',
        sheet: [19, 36]
      },
      {
        unified: '1F469-1F3FD-200D-1F9BD',
        sheet: [19, 37]
      },
      {
        unified: '1F469-1F3FE-200D-1F9BD',
        sheet: [19, 38]
      },
      {
        unified: '1F469-1F3FF-200D-1F9BD',
        sheet: [19, 39]
      }
    ],
    shortName: 'woman_in_manual_wheelchair'
  },
  {
    name: 'Toothbrush',
    unified: '1FAA5',
    sheet: [52, 53],
    shortName: 'toothbrush'
  },
  {
    name: 'Tuvalu Flag',
    unified: '1F1F9-1F1FB',
    sheet: [4, 32],
    shortName: 'flag-tv'
  },
  {
    name: 'Runner',
    unified: '1F3C3',
    sheet: [8, 50],
    skinVariations: [
      {
        unified: '1F3C3-1F3FB',
        sheet: [8, 51]
      },
      {
        unified: '1F3C3-1F3FC',
        sheet: [8, 52]
      },
      {
        unified: '1F3C3-1F3FD',
        sheet: [8, 53]
      },
      {
        unified: '1F3C3-1F3FE',
        sheet: [8, 54]
      },
      {
        unified: '1F3C3-1F3FF',
        sheet: [8, 55]
      }
    ],
    shortNames: ['running'],
    shortName: 'runner',
    obsoletedBy: '1F3C3-200D-2642-FE0F'
  },
  {
    name: 'Sponge',
    unified: '1F9FD',
    keywords: [
      'absorbing',
      'cleaning',
      'porous'
    ],
    sheet: [52, 14],
    shortName: 'sponge'
  },
  {
    name: 'Taiwan Flag',
    unified: '1F1F9-1F1FC',
    sheet: [4, 33],
    shortName: 'flag-tw'
  },
  {
    name: 'Man Running',
    unified: '1F3C3-200D-2642-FE0F',
    obsoletes: '1F3C3',
    sheet: [8, 44],
    skinVariations: [
      {
        unified: '1F3C3-1F3FB-200D-2642-FE0F',
        sheet: [8, 45]
      },
      {
        unified: '1F3C3-1F3FC-200D-2642-FE0F',
        sheet: [8, 46]
      },
      {
        unified: '1F3C3-1F3FD-200D-2642-FE0F',
        sheet: [8, 47]
      },
      {
        unified: '1F3C3-1F3FE-200D-2642-FE0F',
        sheet: [8, 48]
      },
      {
        unified: '1F3C3-1F3FF-200D-2642-FE0F',
        sheet: [8, 49]
      }
    ],
    shortName: 'man-running'
  },
  {
    name: 'Fire Extinguisher',
    unified: '1F9EF',
    keywords: ['quench'],
    sheet: [52, 0],
    shortName: 'fire_extinguisher'
  },
  {
    name: 'Tanzania Flag',
    unified: '1F1F9-1F1FF',
    sheet: [4, 34],
    shortName: 'flag-tz'
  },
  {
    name: 'Woman Running',
    unified: '1F3C3-200D-2640-FE0F',
    sheet: [8, 38],
    skinVariations: [
      {
        unified: '1F3C3-1F3FB-200D-2640-FE0F',
        sheet: [8, 39]
      },
      {
        unified: '1F3C3-1F3FC-200D-2640-FE0F',
        sheet: [8, 40]
      },
      {
        unified: '1F3C3-1F3FD-200D-2640-FE0F',
        sheet: [8, 41]
      },
      {
        unified: '1F3C3-1F3FE-200D-2640-FE0F',
        sheet: [8, 42]
      },
      {
        unified: '1F3C3-1F3FF-200D-2640-FE0F',
        sheet: [8, 43]
      }
    ],
    shortName: 'woman-running'
  },
  {
    name: 'Shopping Trolley',
    unified: '1F6D2',
    sheet: [36, 31],
    shortName: 'shopping_trolley'
  },
  {
    name: 'Ukraine Flag',
    unified: '1F1FA-1F1E6',
    sheet: [4, 35],
    shortName: 'flag-ua'
  },
  {
    name: 'Dancer',
    unified: '1F483',
    keywords: [
      'female',
      'girl',
      'woman',
      'fun'
    ],
    sheet: [24, 29],
    skinVariations: [
      {
        unified: '1F483-1F3FB',
        sheet: [24, 30]
      },
      {
        unified: '1F483-1F3FC',
        sheet: [24, 31]
      },
      {
        unified: '1F483-1F3FD',
        sheet: [24, 32]
      },
      {
        unified: '1F483-1F3FE',
        sheet: [24, 33]
      },
      {
        unified: '1F483-1F3FF',
        sheet: [24, 34]
      }
    ],
    shortName: 'dancer'
  },
  {
    name: 'Smoking Symbol',
    unified: '1F6AC',
    keywords: [
      'kills',
      'tobacco',
      'cigarette',
      'joint',
      'smoke'
    ],
    sheet: [34, 53],
    shortName: 'smoking'
  },
  {
    name: 'Uganda Flag',
    unified: '1F1FA-1F1EC',
    sheet: [4, 36],
    shortName: 'flag-ug'
  },
  {
    name: 'Man Dancing',
    unified: '1F57A',
    keywords: [
      'male',
      'boy',
      'fun',
      'dancer'
    ],
    sheet: [29, 35],
    skinVariations: [
      {
        unified: '1F57A-1F3FB',
        sheet: [29, 36]
      },
      {
        unified: '1F57A-1F3FC',
        sheet: [29, 37]
      },
      {
        unified: '1F57A-1F3FD',
        sheet: [29, 38]
      },
      {
        unified: '1F57A-1F3FE',
        sheet: [29, 39]
      },
      {
        unified: '1F57A-1F3FF',
        sheet: [29, 40]
      }
    ],
    shortName: 'man_dancing'
  },
  {
    name: 'Coffin',
    unified: '26B0-FE0F',
    keywords: [
      'vampire',
      'dead',
      'die',
      'death',
      'rip',
      'graveyard',
      'cemetery',
      'casket',
      'funeral',
      'box'
    ],
    sheet: [55, 2],
    shortName: 'coffin'
  },
  {
    name: 'U.s. Outlying Islands Flag',
    unified: '1F1FA-1F1F2',
    sheet: [4, 37],
    shortName: 'flag-um'
  },
  {
    name: 'Man in Business Suit Levitating',
    unified: '1F574-FE0F',
    sheet: [29, 7],
    skinVariations: [
      {
        unified: '1F574-1F3FB',
        sheet: [29, 8]
      },
      {
        unified: '1F574-1F3FC',
        sheet: [29, 9]
      },
      {
        unified: '1F574-1F3FD',
        sheet: [29, 10]
      },
      {
        unified: '1F574-1F3FE',
        sheet: [29, 11]
      },
      {
        unified: '1F574-1F3FF',
        sheet: [29, 12]
      }
    ],
    shortName: 'man_in_business_suit_levitating'
  },
  {
    name: 'Headstone',
    unified: '1FAA6',
    sheet: [52, 54],
    shortName: 'headstone'
  },
  {
    name: 'United Nations Flag',
    unified: '1F1FA-1F1F3',
    sheet: [4, 38],
    shortName: 'flag-un'
  },
  {
    name: 'Woman with Bunny Ears',
    unified: '1F46F',
    sheet: [21, 51],
    shortName: 'dancers',
    obsoletedBy: '1F46F-200D-2640-FE0F'
  },
  {
    name: 'Funeral Urn',
    unified: '26B1-FE0F',
    keywords: [
      'dead',
      'die',
      'death',
      'rip',
      'ashes'
    ],
    sheet: [55, 3],
    shortName: 'funeral_urn'
  },
  {
    name: 'United States Flag',
    unified: '1F1FA-1F1F8',
    keywords: [
      'united',
      'states',
      'america',
      'flag',
      'nation',
      'country',
      'banner'
    ],
    sheet: [4, 39],
    shortNames: ['flag-us'],
    shortName: 'us'
  },
  {
    name: 'Man with Bunny Ears Partying',
    unified: '1F46F-200D-2642-FE0F',
    sheet: [21, 50],
    shortName: 'man-with-bunny-ears-partying'
  },
  {
    name: 'Moyai',
    unified: '1F5FF',
    keywords: [
      'rock',
      'easter island',
      'moai'
    ],
    sheet: [30, 31],
    shortName: 'moyai'
  },
  {
    name: 'Uruguay Flag',
    unified: '1F1FA-1F1FE',
    sheet: [4, 40],
    shortName: 'flag-uy'
  },
  {
    name: 'Woman with Bunny Ears Partying',
    unified: '1F46F-200D-2640-FE0F',
    obsoletes: '1F46F',
    sheet: [21, 49],
    shortName: 'woman-with-bunny-ears-partying'
  },
  {
    name: 'Placard',
    unified: '1FAA7',
    sheet: [52, 55],
    shortName: 'placard'
  },
  {
    name: 'Uzbekistan Flag',
    unified: '1F1FA-1F1FF',
    sheet: [4, 41],
    shortName: 'flag-uz'
  },
  {
    name: 'Person in Steamy Room',
    unified: '1F9D6',
    sheet: [49, 21],
    skinVariations: [
      {
        unified: '1F9D6-1F3FB',
        sheet: [49, 22]
      },
      {
        unified: '1F9D6-1F3FC',
        sheet: [49, 23]
      },
      {
        unified: '1F9D6-1F3FD',
        sheet: [49, 24]
      },
      {
        unified: '1F9D6-1F3FE',
        sheet: [49, 25]
      },
      {
        unified: '1F9D6-1F3FF',
        sheet: [49, 26]
      }
    ],
    shortName: 'person_in_steamy_room',
    obsoletedBy: '1F9D6-200D-2642-FE0F'
  },
  {
    name: 'Vatican City Flag',
    unified: '1F1FB-1F1E6',
    sheet: [4, 42],
    shortName: 'flag-va'
  },
  {
    name: 'Man in Steamy Room',
    unified: '1F9D6-200D-2642-FE0F',
    obsoletes: '1F9D6',
    keywords: [
      'male',
      'man',
      'spa',
      'steamroom',
      'sauna'
    ],
    sheet: [49, 15],
    skinVariations: [
      {
        unified: '1F9D6-1F3FB-200D-2642-FE0F',
        sheet: [49, 16]
      },
      {
        unified: '1F9D6-1F3FC-200D-2642-FE0F',
        sheet: [49, 17]
      },
      {
        unified: '1F9D6-1F3FD-200D-2642-FE0F',
        sheet: [49, 18]
      },
      {
        unified: '1F9D6-1F3FE-200D-2642-FE0F',
        sheet: [49, 19]
      },
      {
        unified: '1F9D6-1F3FF-200D-2642-FE0F',
        sheet: [49, 20]
      }
    ],
    shortName: 'man_in_steamy_room'
  },
  {
    name: 'St. Vincent & Grenadines Flag',
    unified: '1F1FB-1F1E8',
    sheet: [4, 43],
    shortName: 'flag-vc'
  },
  {
    name: 'Woman in Steamy Room',
    unified: '1F9D6-200D-2640-FE0F',
    keywords: [
      'female',
      'woman',
      'spa',
      'steamroom',
      'sauna'
    ],
    sheet: [49, 9],
    skinVariations: [
      {
        unified: '1F9D6-1F3FB-200D-2640-FE0F',
        sheet: [49, 10]
      },
      {
        unified: '1F9D6-1F3FC-200D-2640-FE0F',
        sheet: [49, 11]
      },
      {
        unified: '1F9D6-1F3FD-200D-2640-FE0F',
        sheet: [49, 12]
      },
      {
        unified: '1F9D6-1F3FE-200D-2640-FE0F',
        sheet: [49, 13]
      },
      {
        unified: '1F9D6-1F3FF-200D-2640-FE0F',
        sheet: [49, 14]
      }
    ],
    shortName: 'woman_in_steamy_room'
  },
  {
    name: 'Venezuela Flag',
    unified: '1F1FB-1F1EA',
    sheet: [4, 44],
    shortName: 'flag-ve'
  },
  {
    name: 'Person Climbing',
    unified: '1F9D7',
    sheet: [49, 39],
    skinVariations: [
      {
        unified: '1F9D7-1F3FB',
        sheet: [49, 40]
      },
      {
        unified: '1F9D7-1F3FC',
        sheet: [49, 41]
      },
      {
        unified: '1F9D7-1F3FD',
        sheet: [49, 42]
      },
      {
        unified: '1F9D7-1F3FE',
        sheet: [49, 43]
      },
      {
        unified: '1F9D7-1F3FF',
        sheet: [49, 44]
      }
    ],
    shortName: 'person_climbing',
    obsoletedBy: '1F9D7-200D-2640-FE0F'
  },
  {
    name: 'British Virgin Islands Flag',
    unified: '1F1FB-1F1EC',
    sheet: [4, 45],
    shortName: 'flag-vg'
  },
  {
    name: 'Man Climbing',
    unified: '1F9D7-200D-2642-FE0F',
    sheet: [49, 33],
    skinVariations: [
      {
        unified: '1F9D7-1F3FB-200D-2642-FE0F',
        sheet: [49, 34]
      },
      {
        unified: '1F9D7-1F3FC-200D-2642-FE0F',
        sheet: [49, 35]
      },
      {
        unified: '1F9D7-1F3FD-200D-2642-FE0F',
        sheet: [49, 36]
      },
      {
        unified: '1F9D7-1F3FE-200D-2642-FE0F',
        sheet: [49, 37]
      },
      {
        unified: '1F9D7-1F3FF-200D-2642-FE0F',
        sheet: [49, 38]
      }
    ],
    shortName: 'man_climbing'
  },
  {
    name: 'U.s. Virgin Islands Flag',
    unified: '1F1FB-1F1EE',
    sheet: [4, 46],
    shortName: 'flag-vi'
  },
  {
    name: 'Woman Climbing',
    unified: '1F9D7-200D-2640-FE0F',
    obsoletes: '1F9D7',
    sheet: [49, 27],
    skinVariations: [
      {
        unified: '1F9D7-1F3FB-200D-2640-FE0F',
        sheet: [49, 28]
      },
      {
        unified: '1F9D7-1F3FC-200D-2640-FE0F',
        sheet: [49, 29]
      },
      {
        unified: '1F9D7-1F3FD-200D-2640-FE0F',
        sheet: [49, 30]
      },
      {
        unified: '1F9D7-1F3FE-200D-2640-FE0F',
        sheet: [49, 31]
      },
      {
        unified: '1F9D7-1F3FF-200D-2640-FE0F',
        sheet: [49, 32]
      }
    ],
    shortName: 'woman_climbing'
  },
  {
    name: 'Vietnam Flag',
    unified: '1F1FB-1F1F3',
    sheet: [4, 47],
    shortName: 'flag-vn'
  },
  {
    name: 'Fencer',
    unified: '1F93A',
    sheet: [40, 41],
    shortName: 'fencer'
  },
  {
    name: 'Vanuatu Flag',
    unified: '1F1FB-1F1FA',
    sheet: [4, 48],
    shortName: 'flag-vu'
  },
  {
    name: 'Horse Racing',
    unified: '1F3C7',
    keywords: [
      'animal',
      'betting',
      'competition',
      'gambling',
      'luck'
    ],
    sheet: [9, 18],
    skinVariations: [
      {
        unified: '1F3C7-1F3FB',
        sheet: [9, 19]
      },
      {
        unified: '1F3C7-1F3FC',
        sheet: [9, 20]
      },
      {
        unified: '1F3C7-1F3FD',
        sheet: [9, 21]
      },
      {
        unified: '1F3C7-1F3FE',
        sheet: [9, 22]
      },
      {
        unified: '1F3C7-1F3FF',
        sheet: [9, 23]
      }
    ],
    shortName: 'horse_racing'
  },
  {
    name: 'Wallis & Futuna Flag',
    unified: '1F1FC-1F1EB',
    sheet: [4, 49],
    shortName: 'flag-wf'
  },
  {
    name: 'Skier',
    unified: '26F7-FE0F',
    keywords: [
      'sports',
      'winter',
      'snow'
    ],
    sheet: [55, 22],
    shortName: 'skier'
  },
  {
    name: 'Samoa Flag',
    unified: '1F1FC-1F1F8',
    sheet: [4, 50],
    shortName: 'flag-ws'
  },
  {
    name: 'Snowboarder',
    unified: '1F3C2',
    keywords: ['sports', 'winter'],
    sheet: [8, 32],
    skinVariations: [
      {
        unified: '1F3C2-1F3FB',
        sheet: [8, 33]
      },
      {
        unified: '1F3C2-1F3FC',
        sheet: [8, 34]
      },
      {
        unified: '1F3C2-1F3FD',
        sheet: [8, 35]
      },
      {
        unified: '1F3C2-1F3FE',
        sheet: [8, 36]
      },
      {
        unified: '1F3C2-1F3FF',
        sheet: [8, 37]
      }
    ],
    shortName: 'snowboarder'
  },
  {
    name: 'Kosovo Flag',
    unified: '1F1FD-1F1F0',
    sheet: [4, 51],
    shortName: 'flag-xk'
  },
  {
    name: 'Golfer',
    unified: '1F3CC-FE0F',
    sheet: [10, 16],
    skinVariations: [
      {
        unified: '1F3CC-1F3FB',
        sheet: [10, 17]
      },
      {
        unified: '1F3CC-1F3FC',
        sheet: [10, 18]
      },
      {
        unified: '1F3CC-1F3FD',
        sheet: [10, 19]
      },
      {
        unified: '1F3CC-1F3FE',
        sheet: [10, 20]
      },
      {
        unified: '1F3CC-1F3FF',
        sheet: [10, 21]
      }
    ],
    shortName: 'golfer',
    obsoletedBy: '1F3CC-FE0F-200D-2642-FE0F'
  },
  {
    name: 'Yemen Flag',
    unified: '1F1FE-1F1EA',
    sheet: [4, 52],
    shortName: 'flag-ye'
  },
  {
    name: 'Man Golfing',
    unified: '1F3CC-FE0F-200D-2642-FE0F',
    obsoletes: '1F3CC-FE0F',
    sheet: [10, 10],
    hidden: ['facebook'],
    skinVariations: [
      {
        unified: '1F3CC-1F3FB-200D-2642-FE0F',
        sheet: [10, 11]
      },
      {
        unified: '1F3CC-1F3FC-200D-2642-FE0F',
        sheet: [10, 12]
      },
      {
        unified: '1F3CC-1F3FD-200D-2642-FE0F',
        sheet: [10, 13]
      },
      {
        unified: '1F3CC-1F3FE-200D-2642-FE0F',
        sheet: [10, 14]
      },
      {
        unified: '1F3CC-1F3FF-200D-2642-FE0F',
        sheet: [10, 15]
      }
    ],
    shortName: 'man-golfing'
  },
  {
    name: 'Mayotte Flag',
    unified: '1F1FE-1F1F9',
    sheet: [4, 53],
    shortName: 'flag-yt'
  },
  {
    name: 'Woman Golfing',
    unified: '1F3CC-FE0F-200D-2640-FE0F',
    sheet: [10, 4],
    hidden: ['facebook'],
    skinVariations: [
      {
        unified: '1F3CC-1F3FB-200D-2640-FE0F',
        sheet: [10, 5]
      },
      {
        unified: '1F3CC-1F3FC-200D-2640-FE0F',
        sheet: [10, 6]
      },
      {
        unified: '1F3CC-1F3FD-200D-2640-FE0F',
        sheet: [10, 7]
      },
      {
        unified: '1F3CC-1F3FE-200D-2640-FE0F',
        sheet: [10, 8]
      },
      {
        unified: '1F3CC-1F3FF-200D-2640-FE0F',
        sheet: [10, 9]
      }
    ],
    shortName: 'woman-golfing'
  },
  {
    name: 'South Africa Flag',
    unified: '1F1FF-1F1E6',
    sheet: [4, 54],
    shortName: 'flag-za'
  },
  {
    name: 'Surfer',
    unified: '1F3C4',
    sheet: [9, 10],
    skinVariations: [
      {
        unified: '1F3C4-1F3FB',
        sheet: [9, 11]
      },
      {
        unified: '1F3C4-1F3FC',
        sheet: [9, 12]
      },
      {
        unified: '1F3C4-1F3FD',
        sheet: [9, 13]
      },
      {
        unified: '1F3C4-1F3FE',
        sheet: [9, 14]
      },
      {
        unified: '1F3C4-1F3FF',
        sheet: [9, 15]
      }
    ],
    shortName: 'surfer',
    obsoletedBy: '1F3C4-200D-2642-FE0F'
  },
  {
    name: 'Zambia Flag',
    unified: '1F1FF-1F1F2',
    sheet: [4, 55],
    shortName: 'flag-zm'
  },
  {
    name: 'Man Surfing',
    unified: '1F3C4-200D-2642-FE0F',
    obsoletes: '1F3C4',
    sheet: [9, 4],
    skinVariations: [
      {
        unified: '1F3C4-1F3FB-200D-2642-FE0F',
        sheet: [9, 5]
      },
      {
        unified: '1F3C4-1F3FC-200D-2642-FE0F',
        sheet: [9, 6]
      },
      {
        unified: '1F3C4-1F3FD-200D-2642-FE0F',
        sheet: [9, 7]
      },
      {
        unified: '1F3C4-1F3FE-200D-2642-FE0F',
        sheet: [9, 8]
      },
      {
        unified: '1F3C4-1F3FF-200D-2642-FE0F',
        sheet: [9, 9]
      }
    ],
    shortName: 'man-surfing'
  },
  {
    name: 'Zimbabwe Flag',
    unified: '1F1FF-1F1FC',
    sheet: [4, 56],
    shortName: 'flag-zw'
  },
  {
    name: 'Woman Surfing',
    unified: '1F3C4-200D-2640-FE0F',
    sheet: [8, 56],
    skinVariations: [
      {
        unified: '1F3C4-1F3FB-200D-2640-FE0F',
        sheet: [8, 57]
      },
      {
        unified: '1F3C4-1F3FC-200D-2640-FE0F',
        sheet: [9, 0]
      },
      {
        unified: '1F3C4-1F3FD-200D-2640-FE0F',
        sheet: [9, 1]
      },
      {
        unified: '1F3C4-1F3FE-200D-2640-FE0F',
        sheet: [9, 2]
      },
      {
        unified: '1F3C4-1F3FF-200D-2640-FE0F',
        sheet: [9, 3]
      }
    ],
    shortName: 'woman-surfing'
  },
  {
    name: 'England Flag',
    unified: '1F3F4-E0067-E0062-E0065-E006E-E0067-E007F',
    sheet: [11, 4],
    shortName: 'flag-england'
  },
  {
    name: 'Rowboat',
    unified: '1F6A3',
    sheet: [34, 39],
    skinVariations: [
      {
        unified: '1F6A3-1F3FB',
        sheet: [34, 40]
      },
      {
        unified: '1F6A3-1F3FC',
        sheet: [34, 41]
      },
      {
        unified: '1F6A3-1F3FD',
        sheet: [34, 42]
      },
      {
        unified: '1F6A3-1F3FE',
        sheet: [34, 43]
      },
      {
        unified: '1F6A3-1F3FF',
        sheet: [34, 44]
      }
    ],
    shortName: 'rowboat',
    obsoletedBy: '1F6A3-200D-2642-FE0F'
  },
  {
    name: 'Scotland Flag',
    unified: '1F3F4-E0067-E0062-E0073-E0063-E0074-E007F',
    sheet: [11, 5],
    shortName: 'flag-scotland'
  },
  {
    name: 'Man Rowing Boat',
    unified: '1F6A3-200D-2642-FE0F',
    obsoletes: '1F6A3',
    sheet: [34, 33],
    skinVariations: [
      {
        unified: '1F6A3-1F3FB-200D-2642-FE0F',
        sheet: [34, 34]
      },
      {
        unified: '1F6A3-1F3FC-200D-2642-FE0F',
        sheet: [34, 35]
      },
      {
        unified: '1F6A3-1F3FD-200D-2642-FE0F',
        sheet: [34, 36]
      },
      {
        unified: '1F6A3-1F3FE-200D-2642-FE0F',
        sheet: [34, 37]
      },
      {
        unified: '1F6A3-1F3FF-200D-2642-FE0F',
        sheet: [34, 38]
      }
    ],
    shortName: 'man-rowing-boat'
  },
  {
    name: 'Wales Flag',
    unified: '1F3F4-E0067-E0062-E0077-E006C-E0073-E007F',
    sheet: [11, 6],
    shortName: 'flag-wales'
  },
  {
    name: 'Woman Rowing Boat',
    unified: '1F6A3-200D-2640-FE0F',
    sheet: [34, 27],
    skinVariations: [
      {
        unified: '1F6A3-1F3FB-200D-2640-FE0F',
        sheet: [34, 28]
      },
      {
        unified: '1F6A3-1F3FC-200D-2640-FE0F',
        sheet: [34, 29]
      },
      {
        unified: '1F6A3-1F3FD-200D-2640-FE0F',
        sheet: [34, 30]
      },
      {
        unified: '1F6A3-1F3FE-200D-2640-FE0F',
        sheet: [34, 31]
      },
      {
        unified: '1F6A3-1F3FF-200D-2640-FE0F',
        sheet: [34, 32]
      }
    ],
    shortName: 'woman-rowing-boat'
  },
  {
    name: 'Swimmer',
    unified: '1F3CA',
    sheet: [9, 38],
    skinVariations: [
      {
        unified: '1F3CA-1F3FB',
        sheet: [9, 39]
      },
      {
        unified: '1F3CA-1F3FC',
        sheet: [9, 40]
      },
      {
        unified: '1F3CA-1F3FD',
        sheet: [9, 41]
      },
      {
        unified: '1F3CA-1F3FE',
        sheet: [9, 42]
      },
      {
        unified: '1F3CA-1F3FF',
        sheet: [9, 43]
      }
    ],
    shortName: 'swimmer',
    obsoletedBy: '1F3CA-200D-2642-FE0F'
  },
  {
    name: 'Man Swimming',
    unified: '1F3CA-200D-2642-FE0F',
    obsoletes: '1F3CA',
    sheet: [9, 32],
    skinVariations: [
      {
        unified: '1F3CA-1F3FB-200D-2642-FE0F',
        sheet: [9, 33]
      },
      {
        unified: '1F3CA-1F3FC-200D-2642-FE0F',
        sheet: [9, 34]
      },
      {
        unified: '1F3CA-1F3FD-200D-2642-FE0F',
        sheet: [9, 35]
      },
      {
        unified: '1F3CA-1F3FE-200D-2642-FE0F',
        sheet: [9, 36]
      },
      {
        unified: '1F3CA-1F3FF-200D-2642-FE0F',
        sheet: [9, 37]
      }
    ],
    shortName: 'man-swimming'
  },
  {
    name: 'Woman Swimming',
    unified: '1F3CA-200D-2640-FE0F',
    sheet: [9, 26],
    skinVariations: [
      {
        unified: '1F3CA-1F3FB-200D-2640-FE0F',
        sheet: [9, 27]
      },
      {
        unified: '1F3CA-1F3FC-200D-2640-FE0F',
        sheet: [9, 28]
      },
      {
        unified: '1F3CA-1F3FD-200D-2640-FE0F',
        sheet: [9, 29]
      },
      {
        unified: '1F3CA-1F3FE-200D-2640-FE0F',
        sheet: [9, 30]
      },
      {
        unified: '1F3CA-1F3FF-200D-2640-FE0F',
        sheet: [9, 31]
      }
    ],
    shortName: 'woman-swimming'
  },
  {
    name: 'Person with Ball',
    unified: '26F9-FE0F',
    sheet: [55, 36],
    skinVariations: [
      {
        unified: '26F9-1F3FB',
        sheet: [55, 37]
      },
      {
        unified: '26F9-1F3FC',
        sheet: [55, 38]
      },
      {
        unified: '26F9-1F3FD',
        sheet: [55, 39]
      },
      {
        unified: '26F9-1F3FE',
        sheet: [55, 40]
      },
      {
        unified: '26F9-1F3FF',
        sheet: [55, 41]
      }
    ],
    shortName: 'person_with_ball',
    obsoletedBy: '26F9-FE0F-200D-2642-FE0F'
  },
  {
    name: 'Man Bouncing Ball',
    unified: '26F9-FE0F-200D-2642-FE0F',
    obsoletes: '26F9-FE0F',
    sheet: [55, 30],
    hidden: ['facebook'],
    skinVariations: [
      {
        unified: '26F9-1F3FB-200D-2642-FE0F',
        sheet: [55, 31]
      },
      {
        unified: '26F9-1F3FC-200D-2642-FE0F',
        sheet: [55, 32]
      },
      {
        unified: '26F9-1F3FD-200D-2642-FE0F',
        sheet: [55, 33]
      },
      {
        unified: '26F9-1F3FE-200D-2642-FE0F',
        sheet: [55, 34]
      },
      {
        unified: '26F9-1F3FF-200D-2642-FE0F',
        sheet: [55, 35]
      }
    ],
    shortName: 'man-bouncing-ball'
  },
  {
    name: 'Woman Bouncing Ball',
    unified: '26F9-FE0F-200D-2640-FE0F',
    sheet: [55, 24],
    hidden: ['facebook'],
    skinVariations: [
      {
        unified: '26F9-1F3FB-200D-2640-FE0F',
        sheet: [55, 25]
      },
      {
        unified: '26F9-1F3FC-200D-2640-FE0F',
        sheet: [55, 26]
      },
      {
        unified: '26F9-1F3FD-200D-2640-FE0F',
        sheet: [55, 27]
      },
      {
        unified: '26F9-1F3FE-200D-2640-FE0F',
        sheet: [55, 28]
      },
      {
        unified: '26F9-1F3FF-200D-2640-FE0F',
        sheet: [55, 29]
      }
    ],
    shortName: 'woman-bouncing-ball'
  },
  {
    name: 'Weight Lifter',
    unified: '1F3CB-FE0F',
    sheet: [9, 56],
    skinVariations: [
      {
        unified: '1F3CB-1F3FB',
        sheet: [9, 57]
      },
      {
        unified: '1F3CB-1F3FC',
        sheet: [10, 0]
      },
      {
        unified: '1F3CB-1F3FD',
        sheet: [10, 1]
      },
      {
        unified: '1F3CB-1F3FE',
        sheet: [10, 2]
      },
      {
        unified: '1F3CB-1F3FF',
        sheet: [10, 3]
      }
    ],
    shortName: 'weight_lifter',
    obsoletedBy: '1F3CB-FE0F-200D-2642-FE0F'
  },
  {
    name: 'Man Lifting Weights',
    unified: '1F3CB-FE0F-200D-2642-FE0F',
    obsoletes: '1F3CB-FE0F',
    sheet: [9, 50],
    hidden: ['facebook'],
    skinVariations: [
      {
        unified: '1F3CB-1F3FB-200D-2642-FE0F',
        sheet: [9, 51]
      },
      {
        unified: '1F3CB-1F3FC-200D-2642-FE0F',
        sheet: [9, 52]
      },
      {
        unified: '1F3CB-1F3FD-200D-2642-FE0F',
        sheet: [9, 53]
      },
      {
        unified: '1F3CB-1F3FE-200D-2642-FE0F',
        sheet: [9, 54]
      },
      {
        unified: '1F3CB-1F3FF-200D-2642-FE0F',
        sheet: [9, 55]
      }
    ],
    shortName: 'man-lifting-weights'
  },
  {
    name: 'Woman Lifting Weights',
    unified: '1F3CB-FE0F-200D-2640-FE0F',
    sheet: [9, 44],
    hidden: ['facebook'],
    skinVariations: [
      {
        unified: '1F3CB-1F3FB-200D-2640-FE0F',
        sheet: [9, 45]
      },
      {
        unified: '1F3CB-1F3FC-200D-2640-FE0F',
        sheet: [9, 46]
      },
      {
        unified: '1F3CB-1F3FD-200D-2640-FE0F',
        sheet: [9, 47]
      },
      {
        unified: '1F3CB-1F3FE-200D-2640-FE0F',
        sheet: [9, 48]
      },
      {
        unified: '1F3CB-1F3FF-200D-2640-FE0F',
        sheet: [9, 49]
      }
    ],
    shortName: 'woman-lifting-weights'
  },
  {
    name: 'Bicyclist',
    unified: '1F6B4',
    sheet: [35, 15],
    skinVariations: [
      {
        unified: '1F6B4-1F3FB',
        sheet: [35, 16]
      },
      {
        unified: '1F6B4-1F3FC',
        sheet: [35, 17]
      },
      {
        unified: '1F6B4-1F3FD',
        sheet: [35, 18]
      },
      {
        unified: '1F6B4-1F3FE',
        sheet: [35, 19]
      },
      {
        unified: '1F6B4-1F3FF',
        sheet: [35, 20]
      }
    ],
    shortName: 'bicyclist',
    obsoletedBy: '1F6B4-200D-2642-FE0F'
  },
  {
    name: 'Man Biking',
    unified: '1F6B4-200D-2642-FE0F',
    obsoletes: '1F6B4',
    sheet: [35, 9],
    skinVariations: [
      {
        unified: '1F6B4-1F3FB-200D-2642-FE0F',
        sheet: [35, 10]
      },
      {
        unified: '1F6B4-1F3FC-200D-2642-FE0F',
        sheet: [35, 11]
      },
      {
        unified: '1F6B4-1F3FD-200D-2642-FE0F',
        sheet: [35, 12]
      },
      {
        unified: '1F6B4-1F3FE-200D-2642-FE0F',
        sheet: [35, 13]
      },
      {
        unified: '1F6B4-1F3FF-200D-2642-FE0F',
        sheet: [35, 14]
      }
    ],
    shortName: 'man-biking'
  },
  {
    name: 'Woman Biking',
    unified: '1F6B4-200D-2640-FE0F',
    sheet: [35, 3],
    skinVariations: [
      {
        unified: '1F6B4-1F3FB-200D-2640-FE0F',
        sheet: [35, 4]
      },
      {
        unified: '1F6B4-1F3FC-200D-2640-FE0F',
        sheet: [35, 5]
      },
      {
        unified: '1F6B4-1F3FD-200D-2640-FE0F',
        sheet: [35, 6]
      },
      {
        unified: '1F6B4-1F3FE-200D-2640-FE0F',
        sheet: [35, 7]
      },
      {
        unified: '1F6B4-1F3FF-200D-2640-FE0F',
        sheet: [35, 8]
      }
    ],
    shortName: 'woman-biking'
  },
  {
    name: 'Mountain Bicyclist',
    unified: '1F6B5',
    sheet: [35, 33],
    skinVariations: [
      {
        unified: '1F6B5-1F3FB',
        sheet: [35, 34]
      },
      {
        unified: '1F6B5-1F3FC',
        sheet: [35, 35]
      },
      {
        unified: '1F6B5-1F3FD',
        sheet: [35, 36]
      },
      {
        unified: '1F6B5-1F3FE',
        sheet: [35, 37]
      },
      {
        unified: '1F6B5-1F3FF',
        sheet: [35, 38]
      }
    ],
    shortName: 'mountain_bicyclist',
    obsoletedBy: '1F6B5-200D-2642-FE0F'
  },
  {
    name: 'Man Mountain Biking',
    unified: '1F6B5-200D-2642-FE0F',
    obsoletes: '1F6B5',
    sheet: [35, 27],
    skinVariations: [
      {
        unified: '1F6B5-1F3FB-200D-2642-FE0F',
        sheet: [35, 28]
      },
      {
        unified: '1F6B5-1F3FC-200D-2642-FE0F',
        sheet: [35, 29]
      },
      {
        unified: '1F6B5-1F3FD-200D-2642-FE0F',
        sheet: [35, 30]
      },
      {
        unified: '1F6B5-1F3FE-200D-2642-FE0F',
        sheet: [35, 31]
      },
      {
        unified: '1F6B5-1F3FF-200D-2642-FE0F',
        sheet: [35, 32]
      }
    ],
    shortName: 'man-mountain-biking'
  },
  {
    name: 'Woman Mountain Biking',
    unified: '1F6B5-200D-2640-FE0F',
    sheet: [35, 21],
    skinVariations: [
      {
        unified: '1F6B5-1F3FB-200D-2640-FE0F',
        sheet: [35, 22]
      },
      {
        unified: '1F6B5-1F3FC-200D-2640-FE0F',
        sheet: [35, 23]
      },
      {
        unified: '1F6B5-1F3FD-200D-2640-FE0F',
        sheet: [35, 24]
      },
      {
        unified: '1F6B5-1F3FE-200D-2640-FE0F',
        sheet: [35, 25]
      },
      {
        unified: '1F6B5-1F3FF-200D-2640-FE0F',
        sheet: [35, 26]
      }
    ],
    shortName: 'woman-mountain-biking'
  },
  {
    name: 'Person Doing Cartwheel',
    unified: '1F938',
    sheet: [40, 17],
    skinVariations: [
      {
        unified: '1F938-1F3FB',
        sheet: [40, 18]
      },
      {
        unified: '1F938-1F3FC',
        sheet: [40, 19]
      },
      {
        unified: '1F938-1F3FD',
        sheet: [40, 20]
      },
      {
        unified: '1F938-1F3FE',
        sheet: [40, 21]
      },
      {
        unified: '1F938-1F3FF',
        sheet: [40, 22]
      }
    ],
    shortName: 'person_doing_cartwheel'
  },
  {
    name: 'Man Cartwheeling',
    unified: '1F938-200D-2642-FE0F',
    sheet: [40, 11],
    skinVariations: [
      {
        unified: '1F938-1F3FB-200D-2642-FE0F',
        sheet: [40, 12]
      },
      {
        unified: '1F938-1F3FC-200D-2642-FE0F',
        sheet: [40, 13]
      },
      {
        unified: '1F938-1F3FD-200D-2642-FE0F',
        sheet: [40, 14]
      },
      {
        unified: '1F938-1F3FE-200D-2642-FE0F',
        sheet: [40, 15]
      },
      {
        unified: '1F938-1F3FF-200D-2642-FE0F',
        sheet: [40, 16]
      }
    ],
    shortName: 'man-cartwheeling'
  },
  {
    name: 'Woman Cartwheeling',
    unified: '1F938-200D-2640-FE0F',
    sheet: [40, 5],
    skinVariations: [
      {
        unified: '1F938-1F3FB-200D-2640-FE0F',
        sheet: [40, 6]
      },
      {
        unified: '1F938-1F3FC-200D-2640-FE0F',
        sheet: [40, 7]
      },
      {
        unified: '1F938-1F3FD-200D-2640-FE0F',
        sheet: [40, 8]
      },
      {
        unified: '1F938-1F3FE-200D-2640-FE0F',
        sheet: [40, 9]
      },
      {
        unified: '1F938-1F3FF-200D-2640-FE0F',
        sheet: [40, 10]
      }
    ],
    shortName: 'woman-cartwheeling'
  },
  {
    name: 'Wrestlers',
    unified: '1F93C',
    sheet: [40, 44],
    shortName: 'wrestlers'
  },
  {
    name: 'Man Wrestling',
    unified: '1F93C-200D-2642-FE0F',
    sheet: [40, 43],
    shortName: 'man-wrestling'
  },
  {
    name: 'Woman Wrestling',
    unified: '1F93C-200D-2640-FE0F',
    sheet: [40, 42],
    shortName: 'woman-wrestling'
  },
  {
    name: 'Water Polo',
    unified: '1F93D',
    sheet: [40, 57],
    skinVariations: [
      {
        unified: '1F93D-1F3FB',
        sheet: [41, 0]
      },
      {
        unified: '1F93D-1F3FC',
        sheet: [41, 1]
      },
      {
        unified: '1F93D-1F3FD',
        sheet: [41, 2]
      },
      {
        unified: '1F93D-1F3FE',
        sheet: [41, 3]
      },
      {
        unified: '1F93D-1F3FF',
        sheet: [41, 4]
      }
    ],
    shortName: 'water_polo'
  },
  {
    name: 'Man Playing Water Polo',
    unified: '1F93D-200D-2642-FE0F',
    sheet: [40, 51],
    skinVariations: [
      {
        unified: '1F93D-1F3FB-200D-2642-FE0F',
        sheet: [40, 52]
      },
      {
        unified: '1F93D-1F3FC-200D-2642-FE0F',
        sheet: [40, 53]
      },
      {
        unified: '1F93D-1F3FD-200D-2642-FE0F',
        sheet: [40, 54]
      },
      {
        unified: '1F93D-1F3FE-200D-2642-FE0F',
        sheet: [40, 55]
      },
      {
        unified: '1F93D-1F3FF-200D-2642-FE0F',
        sheet: [40, 56]
      }
    ],
    shortName: 'man-playing-water-polo'
  },
  {
    name: 'Woman Playing Water Polo',
    unified: '1F93D-200D-2640-FE0F',
    sheet: [40, 45],
    skinVariations: [
      {
        unified: '1F93D-1F3FB-200D-2640-FE0F',
        sheet: [40, 46]
      },
      {
        unified: '1F93D-1F3FC-200D-2640-FE0F',
        sheet: [40, 47]
      },
      {
        unified: '1F93D-1F3FD-200D-2640-FE0F',
        sheet: [40, 48]
      },
      {
        unified: '1F93D-1F3FE-200D-2640-FE0F',
        sheet: [40, 49]
      },
      {
        unified: '1F93D-1F3FF-200D-2640-FE0F',
        sheet: [40, 50]
      }
    ],
    shortName: 'woman-playing-water-polo'
  },
  {
    name: 'Handball',
    unified: '1F93E',
    sheet: [41, 17],
    skinVariations: [
      {
        unified: '1F93E-1F3FB',
        sheet: [41, 18]
      },
      {
        unified: '1F93E-1F3FC',
        sheet: [41, 19]
      },
      {
        unified: '1F93E-1F3FD',
        sheet: [41, 20]
      },
      {
        unified: '1F93E-1F3FE',
        sheet: [41, 21]
      },
      {
        unified: '1F93E-1F3FF',
        sheet: [41, 22]
      }
    ],
    shortName: 'handball'
  },
  {
    name: 'Man Playing Handball',
    unified: '1F93E-200D-2642-FE0F',
    sheet: [41, 11],
    skinVariations: [
      {
        unified: '1F93E-1F3FB-200D-2642-FE0F',
        sheet: [41, 12]
      },
      {
        unified: '1F93E-1F3FC-200D-2642-FE0F',
        sheet: [41, 13]
      },
      {
        unified: '1F93E-1F3FD-200D-2642-FE0F',
        sheet: [41, 14]
      },
      {
        unified: '1F93E-1F3FE-200D-2642-FE0F',
        sheet: [41, 15]
      },
      {
        unified: '1F93E-1F3FF-200D-2642-FE0F',
        sheet: [41, 16]
      }
    ],
    shortName: 'man-playing-handball'
  },
  {
    name: 'Woman Playing Handball',
    unified: '1F93E-200D-2640-FE0F',
    sheet: [41, 5],
    skinVariations: [
      {
        unified: '1F93E-1F3FB-200D-2640-FE0F',
        sheet: [41, 6]
      },
      {
        unified: '1F93E-1F3FC-200D-2640-FE0F',
        sheet: [41, 7]
      },
      {
        unified: '1F93E-1F3FD-200D-2640-FE0F',
        sheet: [41, 8]
      },
      {
        unified: '1F93E-1F3FE-200D-2640-FE0F',
        sheet: [41, 9]
      },
      {
        unified: '1F93E-1F3FF-200D-2640-FE0F',
        sheet: [41, 10]
      }
    ],
    shortName: 'woman-playing-handball'
  },
  {
    name: 'Juggling',
    unified: '1F939',
    sheet: [40, 35],
    skinVariations: [
      {
        unified: '1F939-1F3FB',
        sheet: [40, 36]
      },
      {
        unified: '1F939-1F3FC',
        sheet: [40, 37]
      },
      {
        unified: '1F939-1F3FD',
        sheet: [40, 38]
      },
      {
        unified: '1F939-1F3FE',
        sheet: [40, 39]
      },
      {
        unified: '1F939-1F3FF',
        sheet: [40, 40]
      }
    ],
    shortName: 'juggling'
  },
  {
    name: 'Man Juggling',
    unified: '1F939-200D-2642-FE0F',
    sheet: [40, 29],
    skinVariations: [
      {
        unified: '1F939-1F3FB-200D-2642-FE0F',
        sheet: [40, 30]
      },
      {
        unified: '1F939-1F3FC-200D-2642-FE0F',
        sheet: [40, 31]
      },
      {
        unified: '1F939-1F3FD-200D-2642-FE0F',
        sheet: [40, 32]
      },
      {
        unified: '1F939-1F3FE-200D-2642-FE0F',
        sheet: [40, 33]
      },
      {
        unified: '1F939-1F3FF-200D-2642-FE0F',
        sheet: [40, 34]
      }
    ],
    shortName: 'man-juggling'
  },
  {
    name: 'Woman Juggling',
    unified: '1F939-200D-2640-FE0F',
    sheet: [40, 23],
    skinVariations: [
      {
        unified: '1F939-1F3FB-200D-2640-FE0F',
        sheet: [40, 24]
      },
      {
        unified: '1F939-1F3FC-200D-2640-FE0F',
        sheet: [40, 25]
      },
      {
        unified: '1F939-1F3FD-200D-2640-FE0F',
        sheet: [40, 26]
      },
      {
        unified: '1F939-1F3FE-200D-2640-FE0F',
        sheet: [40, 27]
      },
      {
        unified: '1F939-1F3FF-200D-2640-FE0F',
        sheet: [40, 28]
      }
    ],
    shortName: 'woman-juggling'
  },
  {
    name: 'Person in Lotus Position',
    unified: '1F9D8',
    sheet: [49, 57],
    skinVariations: [
      {
        unified: '1F9D8-1F3FB',
        sheet: [50, 0]
      },
      {
        unified: '1F9D8-1F3FC',
        sheet: [50, 1]
      },
      {
        unified: '1F9D8-1F3FD',
        sheet: [50, 2]
      },
      {
        unified: '1F9D8-1F3FE',
        sheet: [50, 3]
      },
      {
        unified: '1F9D8-1F3FF',
        sheet: [50, 4]
      }
    ],
    shortName: 'person_in_lotus_position',
    obsoletedBy: '1F9D8-200D-2640-FE0F'
  },
  {
    name: 'Man in Lotus Position',
    unified: '1F9D8-200D-2642-FE0F',
    keywords: [
      'man',
      'male',
      'meditation',
      'yoga',
      'serenity',
      'zen',
      'mindfulness'
    ],
    sheet: [49, 51],
    skinVariations: [
      {
        unified: '1F9D8-1F3FB-200D-2642-FE0F',
        sheet: [49, 52]
      },
      {
        unified: '1F9D8-1F3FC-200D-2642-FE0F',
        sheet: [49, 53]
      },
      {
        unified: '1F9D8-1F3FD-200D-2642-FE0F',
        sheet: [49, 54]
      },
      {
        unified: '1F9D8-1F3FE-200D-2642-FE0F',
        sheet: [49, 55]
      },
      {
        unified: '1F9D8-1F3FF-200D-2642-FE0F',
        sheet: [49, 56]
      }
    ],
    shortName: 'man_in_lotus_position'
  },
  {
    name: 'Woman in Lotus Position',
    unified: '1F9D8-200D-2640-FE0F',
    obsoletes: '1F9D8',
    keywords: [
      'woman',
      'female',
      'meditation',
      'yoga',
      'serenity',
      'zen',
      'mindfulness'
    ],
    sheet: [49, 45],
    skinVariations: [
      {
        unified: '1F9D8-1F3FB-200D-2640-FE0F',
        sheet: [49, 46]
      },
      {
        unified: '1F9D8-1F3FC-200D-2640-FE0F',
        sheet: [49, 47]
      },
      {
        unified: '1F9D8-1F3FD-200D-2640-FE0F',
        sheet: [49, 48]
      },
      {
        unified: '1F9D8-1F3FE-200D-2640-FE0F',
        sheet: [49, 49]
      },
      {
        unified: '1F9D8-1F3FF-200D-2640-FE0F',
        sheet: [49, 50]
      }
    ],
    shortName: 'woman_in_lotus_position'
  },
  {
    name: 'Bath',
    unified: '1F6C0',
    keywords: [
      'clean',
      'shower',
      'bathroom'
    ],
    sheet: [36, 8],
    skinVariations: [
      {
        unified: '1F6C0-1F3FB',
        sheet: [36, 9]
      },
      {
        unified: '1F6C0-1F3FC',
        sheet: [36, 10]
      },
      {
        unified: '1F6C0-1F3FD',
        sheet: [36, 11]
      },
      {
        unified: '1F6C0-1F3FE',
        sheet: [36, 12]
      },
      {
        unified: '1F6C0-1F3FF',
        sheet: [36, 13]
      }
    ],
    shortName: 'bath'
  },
  {
    name: 'Sleeping Accommodation',
    unified: '1F6CC',
    sheet: [36, 20],
    skinVariations: [
      {
        unified: '1F6CC-1F3FB',
        sheet: [36, 21]
      },
      {
        unified: '1F6CC-1F3FC',
        sheet: [36, 22]
      },
      {
        unified: '1F6CC-1F3FD',
        sheet: [36, 23]
      },
      {
        unified: '1F6CC-1F3FE',
        sheet: [36, 24]
      },
      {
        unified: '1F6CC-1F3FF',
        sheet: [36, 25]
      }
    ],
    shortName: 'sleeping_accommodation'
  },
  {
    name: 'People Holding Hands',
    unified: '1F9D1-200D-1F91D-200D-1F9D1',
    sheet: [47, 9],
    skinVariations: [
      {
        unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB',
        sheet: [47, 10]
      },
      {
        unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC',
        sheet: [47, 11],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD',
        sheet: [47, 12],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE',
        sheet: [47, 13],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF',
        sheet: [47, 14],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB',
        sheet: [47, 15]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC',
        sheet: [47, 16]
      },
      {
        unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD',
        sheet: [47, 17],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE',
        sheet: [47, 18],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF',
        sheet: [47, 19],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB',
        sheet: [47, 20]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC',
        sheet: [47, 21]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD',
        sheet: [47, 22]
      },
      {
        unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE',
        sheet: [47, 23],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF',
        sheet: [47, 24],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB',
        sheet: [47, 25]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC',
        sheet: [47, 26]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD',
        sheet: [47, 27]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE',
        sheet: [47, 28]
      },
      {
        unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF',
        sheet: [47, 29],
        hidden: ['facebook']
      },
      {
        unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB',
        sheet: [47, 30]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC',
        sheet: [47, 31]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD',
        sheet: [47, 32]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE',
        sheet: [47, 33]
      },
      {
        unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF',
        sheet: [47, 34]
      }
    ],
    shortName: 'people_holding_hands'
  },
  {
    name: 'Two Women Holding Hands',
    unified: '1F46D',
    keywords: [
      'pair',
      'friendship',
      'couple',
      'love',
      'like',
      'female',
      'people',
      'human'
    ],
    sheet: [21, 5],
    skinVariations: [
      {
        unified: '1F46D-1F3FB',
        sheet: [21, 6]
      },
      {
        unified: '1F46D-1F3FC',
        sheet: [21, 7]
      },
      {
        unified: '1F46D-1F3FD',
        sheet: [21, 8]
      },
      {
        unified: '1F46D-1F3FE',
        sheet: [21, 9]
      },
      {
        unified: '1F46D-1F3FF',
        sheet: [21, 10]
      },
      {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC',
        sheet: [21, 11],
        hidden: ['facebook']
      },
      {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD',
        sheet: [21, 12],
        hidden: ['facebook']
      },
      {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE',
        sheet: [21, 13],
        hidden: ['facebook']
      },
      {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF',
        sheet: [21, 14],
        hidden: ['facebook']
      },
      {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB',
        sheet: [21, 15]
      },
      {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD',
        sheet: [21, 16],
        hidden: ['facebook']
      },
      {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE',
        sheet: [21, 17],
        hidden: ['facebook']
      },
      {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF',
        sheet: [21, 18],
        hidden: ['facebook']
      },
      {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB',
        sheet: [21, 19]
      },
      {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC',
        sheet: [21, 20]
      },
      {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE',
        sheet: [21, 21],
        hidden: ['facebook']
      },
      {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF',
        sheet: [21, 22],
        hidden: ['facebook']
      },
      {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB',
        sheet: [21, 23]
      },
      {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC',
        sheet: [21, 24]
      },
      {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD',
        sheet: [21, 25]
      },
      {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF',
        sheet: [21, 26],
        hidden: ['facebook']
      },
      {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB',
        sheet: [21, 27]
      },
      {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC',
        sheet: [21, 28]
      },
      {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD',
        sheet: [21, 29]
      },
      {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE',
        sheet: [21, 30]
      }
    ],
    shortNames: ['women_holding_hands'],
    shortName: 'two_women_holding_hands'
  },
  {
    name: 'Man and Woman Holding Hands',
    unified: '1F46B',
    keywords: [
      'pair',
      'people',
      'human',
      'love',
      'date',
      'dating',
      'like',
      'affection',
      'valentines',
      'marriage'
    ],
    sheet: [20, 11],
    skinVariations: [
      {
        unified: '1F46B-1F3FB',
        sheet: [20, 12]
      },
      {
        unified: '1F46B-1F3FC',
        sheet: [20, 13]
      },
      {
        unified: '1F46B-1F3FD',
        sheet: [20, 14]
      },
      {
        unified: '1F46B-1F3FE',
        sheet: [20, 15]
      },
      {
        unified: '1F46B-1F3FF',
        sheet: [20, 16]
      },
      {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC',
        sheet: [20, 17]
      },
      {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD',
        sheet: [20, 18]
      },
      {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE',
        sheet: [20, 19]
      },
      {
        unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF',
        sheet: [20, 20]
      },
      {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB',
        sheet: [20, 21]
      },
      {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD',
        sheet: [20, 22]
      },
      {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE',
        sheet: [20, 23]
      },
      {
        unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF',
        sheet: [20, 24]
      },
      {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB',
        sheet: [20, 25]
      },
      {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC',
        sheet: [20, 26]
      },
      {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE',
        sheet: [20, 27]
      },
      {
        unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF',
        sheet: [20, 28]
      },
      {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB',
        sheet: [20, 29]
      },
      {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC',
        sheet: [20, 30]
      },
      {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD',
        sheet: [20, 31]
      },
      {
        unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF',
        sheet: [20, 32]
      },
      {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB',
        sheet: [20, 33]
      },
      {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC',
        sheet: [20, 34]
      },
      {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD',
        sheet: [20, 35]
      },
      {
        unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE',
        sheet: [20, 36]
      }
    ],
    shortNames: [
      'man_and_woman_holding_hands',
      'woman_and_man_holding_hands'
    ],
    shortName: 'couple'
  },
  {
    name: 'Two Men Holding Hands',
    unified: '1F46C',
    keywords: [
      'pair',
      'couple',
      'love',
      'like',
      'bromance',
      'friendship',
      'people',
      'human'
    ],
    sheet: [20, 37],
    skinVariations: [
      {
        unified: '1F46C-1F3FB',
        sheet: [20, 38]
      },
      {
        unified: '1F46C-1F3FC',
        sheet: [20, 39]
      },
      {
        unified: '1F46C-1F3FD',
        sheet: [20, 40]
      },
      {
        unified: '1F46C-1F3FE',
        sheet: [20, 41]
      },
      {
        unified: '1F46C-1F3FF',
        sheet: [20, 42]
      },
      {
        unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC',
        sheet: [20, 43],
        hidden: ['facebook']
      },
      {
        unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD',
        sheet: [20, 44],
        hidden: ['facebook']
      },
      {
        unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE',
        sheet: [20, 45],
        hidden: ['facebook']
      },
      {
        unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF',
        sheet: [20, 46],
        hidden: ['facebook']
      },
      {
        unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB',
        sheet: [20, 47]
      },
      {
        unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD',
        sheet: [20, 48],
        hidden: ['facebook']
      },
      {
        unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE',
        sheet: [20, 49],
        hidden: ['facebook']
      },
      {
        unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF',
        sheet: [20, 50],
        hidden: ['facebook']
      },
      {
        unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB',
        sheet: [20, 51]
      },
      {
        unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC',
        sheet: [20, 52]
      },
      {
        unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE',
        sheet: [20, 53],
        hidden: ['facebook']
      },
      {
        unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF',
        sheet: [20, 54],
        hidden: ['facebook']
      },
      {
        unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB',
        sheet: [20, 55]
      },
      {
        unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC',
        sheet: [20, 56]
      },
      {
        unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD',
        sheet: [20, 57]
      },
      {
        unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF',
        sheet: [21, 0],
        hidden: ['facebook']
      },
      {
        unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB',
        sheet: [21, 1]
      },
      {
        unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC',
        sheet: [21, 2]
      },
      {
        unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD',
        sheet: [21, 3]
      },
      {
        unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE',
        sheet: [21, 4]
      }
    ],
    shortNames: ['men_holding_hands'],
    shortName: 'two_men_holding_hands'
  },
  {
    name: 'Kiss',
    unified: '1F48F',
    sheet: [25, 27],
    shortName: 'couplekiss',
    obsoletedBy: '1F469-200D-2764-FE0F-200D-1F48B-200D-1F468'
  },
  {
    name: 'Woman Kiss Man',
    unified: '1F469-200D-2764-FE0F-200D-1F48B-200D-1F468',
    obsoletes: '1F48F',
    sheet: [20, 2],
    shortName: 'woman-kiss-man'
  },
  {
    name: 'Man Kiss Man',
    unified: '1F468-200D-2764-FE0F-200D-1F48B-200D-1F468',
    sheet: [17, 13],
    shortName: 'man-kiss-man'
  },
  {
    name: 'Woman Kiss Woman',
    unified: '1F469-200D-2764-FE0F-200D-1F48B-200D-1F469',
    sheet: [20, 3],
    shortName: 'woman-kiss-woman'
  },
  {
    name: 'Couple with Heart',
    unified: '1F491',
    sheet: [25, 29],
    shortName: 'couple_with_heart',
    obsoletedBy: '1F469-200D-2764-FE0F-200D-1F468'
  },
  {
    name: 'Woman Heart Man',
    unified: '1F469-200D-2764-FE0F-200D-1F468',
    obsoletes: '1F491',
    sheet: [20, 0],
    shortName: 'woman-heart-man'
  },
  {
    name: 'Man Heart Man',
    unified: '1F468-200D-2764-FE0F-200D-1F468',
    sheet: [17, 12],
    shortName: 'man-heart-man'
  },
  {
    name: 'Woman Heart Woman',
    unified: '1F469-200D-2764-FE0F-200D-1F469',
    sheet: [20, 1],
    shortName: 'woman-heart-woman'
  },
  {
    name: 'Family',
    unified: '1F46A',
    sheet: [20, 10],
    shortNames: ['man-woman-boy'],
    shortName: 'family',
    obsoletedBy: '1F468-200D-1F469-200D-1F466'
  },
  {
    name: 'Man Woman Boy',
    unified: '1F468-200D-1F469-200D-1F466',
    obsoletes: '1F46A',
    sheet: [15, 27],
    shortNames: ['family'],
    shortName: 'man-woman-boy'
  },
  {
    name: 'Man Woman Girl',
    unified: '1F468-200D-1F469-200D-1F467',
    sheet: [15, 29],
    shortName: 'man-woman-girl'
  },
  {
    name: 'Man Woman Girl Boy',
    unified: '1F468-200D-1F469-200D-1F467-200D-1F466',
    sheet: [15, 30],
    shortName: 'man-woman-girl-boy'
  },
  {
    name: 'Man Woman Boy Boy',
    unified: '1F468-200D-1F469-200D-1F466-200D-1F466',
    sheet: [15, 28],
    shortName: 'man-woman-boy-boy'
  },
  {
    name: 'Man Woman Girl Girl',
    unified: '1F468-200D-1F469-200D-1F467-200D-1F467',
    sheet: [15, 31],
    shortName: 'man-woman-girl-girl'
  },
  {
    name: 'Man Man Boy',
    unified: '1F468-200D-1F468-200D-1F466',
    sheet: [15, 22],
    shortName: 'man-man-boy'
  },
  {
    name: 'Man Man Girl',
    unified: '1F468-200D-1F468-200D-1F467',
    sheet: [15, 24],
    shortName: 'man-man-girl'
  },
  {
    name: 'Man Man Girl Boy',
    unified: '1F468-200D-1F468-200D-1F467-200D-1F466',
    sheet: [15, 25],
    shortName: 'man-man-girl-boy'
  },
  {
    name: 'Man Man Boy Boy',
    unified: '1F468-200D-1F468-200D-1F466-200D-1F466',
    sheet: [15, 23],
    shortName: 'man-man-boy-boy'
  },
  {
    name: 'Man Man Girl Girl',
    unified: '1F468-200D-1F468-200D-1F467-200D-1F467',
    sheet: [15, 26],
    shortName: 'man-man-girl-girl'
  },
  {
    name: 'Woman Woman Boy',
    unified: '1F469-200D-1F469-200D-1F466',
    sheet: [18, 15],
    shortName: 'woman-woman-boy'
  },
  {
    name: 'Woman Woman Girl',
    unified: '1F469-200D-1F469-200D-1F467',
    sheet: [18, 17],
    shortName: 'woman-woman-girl'
  },
  {
    name: 'Woman Woman Girl Boy',
    unified: '1F469-200D-1F469-200D-1F467-200D-1F466',
    sheet: [18, 18],
    shortName: 'woman-woman-girl-boy'
  },
  {
    name: 'Woman Woman Boy Boy',
    unified: '1F469-200D-1F469-200D-1F466-200D-1F466',
    sheet: [18, 16],
    shortName: 'woman-woman-boy-boy'
  },
  {
    name: 'Woman Woman Girl Girl',
    unified: '1F469-200D-1F469-200D-1F467-200D-1F467',
    sheet: [18, 19],
    shortName: 'woman-woman-girl-girl'
  },
  {
    name: 'Man Boy',
    unified: '1F468-200D-1F466',
    sheet: [15, 18],
    shortName: 'man-boy'
  },
  {
    name: 'Man Boy Boy',
    unified: '1F468-200D-1F466-200D-1F466',
    sheet: [15, 17],
    shortName: 'man-boy-boy'
  },
  {
    name: 'Man Girl',
    unified: '1F468-200D-1F467',
    sheet: [15, 21],
    shortName: 'man-girl'
  },
  {
    name: 'Man Girl Boy',
    unified: '1F468-200D-1F467-200D-1F466',
    sheet: [15, 19],
    shortName: 'man-girl-boy'
  },
  {
    name: 'Man Girl Girl',
    unified: '1F468-200D-1F467-200D-1F467',
    sheet: [15, 20],
    shortName: 'man-girl-girl'
  },
  {
    name: 'Woman Boy',
    unified: '1F469-200D-1F466',
    sheet: [18, 11],
    shortName: 'woman-boy'
  },
  {
    name: 'Woman Boy Boy',
    unified: '1F469-200D-1F466-200D-1F466',
    sheet: [18, 10],
    shortName: 'woman-boy-boy'
  },
  {
    name: 'Woman Girl',
    unified: '1F469-200D-1F467',
    sheet: [18, 14],
    shortName: 'woman-girl'
  },
  {
    name: 'Woman Girl Boy',
    unified: '1F469-200D-1F467-200D-1F466',
    sheet: [18, 12],
    shortName: 'woman-girl-boy'
  },
  {
    name: 'Woman Girl Girl',
    unified: '1F469-200D-1F467-200D-1F467',
    sheet: [18, 13],
    shortName: 'woman-girl-girl'
  },
  {
    name: 'Speaking Head in Silhouette',
    unified: '1F5E3-FE0F',
    sheet: [30, 22],
    shortName: 'speaking_head_in_silhouette'
  },
  {
    name: 'Bust in Silhouette',
    unified: '1F464',
    keywords: [
      'user',
      'person',
      'human'
    ],
    sheet: [14, 13],
    shortName: 'bust_in_silhouette'
  },
  {
    name: 'Busts in Silhouette',
    unified: '1F465',
    keywords: [
      'user',
      'person',
      'human',
      'group',
      'team'
    ],
    sheet: [14, 14],
    shortName: 'busts_in_silhouette'
  },
  {
    name: 'People Hugging',
    unified: '1FAC2',
    sheet: [53, 8],
    shortName: 'people_hugging'
  },
  {
    name: 'Footprints',
    unified: '1F463',
    keywords: [
      'feet',
      'tracking',
      'walking',
      'beach'
    ],
    sheet: [14, 12],
    shortName: 'footprints'
  },
  {
    name: 'Man in Tuxedo',
    unified: '1F935',
    keywords: [
      'couple',
      'marriage',
      'wedding',
      'groom'
    ],
    sheet: [39, 33],
    skinVariations: [
      {
        unified: '1F935-1F3FB',
        sheet: [39, 34]
      },
      {
        unified: '1F935-1F3FC',
        sheet: [39, 35]
      },
      {
        unified: '1F935-1F3FD',
        sheet: [39, 36]
      },
      {
        unified: '1F935-1F3FE',
        sheet: [39, 37]
      },
      {
        unified: '1F935-1F3FF',
        sheet: [39, 38]
      }
    ],
    shortName: 'man_in_tuxedo'
  },
  {
    name: 'Lady Beetle',
    unified: '1F41E',
    keywords: [
      'animal',
      'insect',
      'nature',
      'ladybug'
    ],
    sheet: [11, 50],
    shortName: 'beetle'
  }
];
